import './index.css';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { defineComponent, inject, toRefs, ref, openBlock, createElementBlock, createElementVNode, normalizeClass, unref, toDisplayString, normalizeStyle, withDirectives, vShow, Fragment, renderList, createCommentVNode, computed, watch, watchEffect, onMounted, createTextVNode, pushScopeId, popScopeId, isRef, vModelText, reactive, readonly, provide, createVNode } from "vue";
const SKIN_TONE_NEUTRAL = "neutral";
const SKIN_TONE_LIGHT = "1f3fb";
const SKIN_TONE_MEDIUM_LIGHT = "1f3fc";
const SKIN_TONE_MEDIUM = "1f3fd";
const SKIN_TONE_MEDIUM_DARK = "1f3fe";
const SKIN_TONE_DARK = "1f3ff";
const SKIN_TONES = [
  SKIN_TONE_NEUTRAL,
  SKIN_TONE_LIGHT,
  SKIN_TONE_MEDIUM_LIGHT,
  SKIN_TONE_MEDIUM,
  SKIN_TONE_MEDIUM_DARK,
  SKIN_TONE_DARK
];
const DEFAULT_EMOJI = {
  n: [""],
  u: { u: "1f44b", x: 19, y: 27 },
  v: [
    { u: "1f44b-1f3fb", x: 20, y: 27 },
    { u: "1f44b-1f3fc", x: 21, y: 27 },
    { u: "1f44b-1f3fd", x: 22, y: 27 },
    { u: "1f44b-1f3fe", x: 23, y: 27 },
    { u: "1f44b-1f3ff", x: 24, y: 27 }
  ],
  r: { u: "1f44b", x: 19, y: 27 }
};
const EmojiWidth = 20;
const EmojiHeight = 20;
const STORE_KEY = Symbol("");
function unicodeToEmoji(unicode) {
  return unicode.split("-").map((hex) => parseInt(hex, 16)).map((hex) => String.fromCodePoint(hex)).join("");
}
function filterEmojis(emojiGroups, keyword, skinTone) {
  var _a;
  const _emojiGroups = [];
  for (const group of emojiGroups) {
    const _emojiInfos = [];
    for (const emojiInfo of group.emojis) {
      if (emojiInfo.n.join("").includes(keyword.toLocaleLowerCase())) {
        let result = emojiInfo.u;
        if (skinTone !== SKIN_TONE_NEUTRAL && Array.isArray(emojiInfo.v)) {
          const v_index = (_a = emojiInfo.v) == null ? void 0 : _a.findIndex((v) => v.u.includes(skinTone));
          if (v_index !== -1 && emojiInfo.v)
            result = emojiInfo.v[v_index];
        }
        _emojiInfos.push(__spreadProps(__spreadValues({}, emojiInfo), {
          r: result
        }));
      }
    }
    if (_emojiInfos.length)
      _emojiGroups.push(__spreadProps(__spreadValues({}, group), { emojis: _emojiInfos }));
  }
  return _emojiGroups;
}
function isMac() {
  var _a;
  const platform = ((_a = navigator == null ? void 0 : navigator.userAgentData) == null ? void 0 : _a.platform) || (navigator == null ? void 0 : navigator.platform) || "unknown";
  return platform.toUpperCase().includes("MAC");
}
var EmojiFooter_vue_vue_type_style_index_0_scoped_true_lang = "";
var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _hoisted_1$3 = { class: "emoji-footer" };
const _hoisted_2$2 = { class: "footer-left" };
const _hoisted_3$2 = { key: 0 };
const _hoisted_4$2 = {
  key: 0,
  class: "footer-right"
};
const _hoisted_5$2 = ["onClick"];
const _hoisted_6$2 = {
  key: 0,
  class: "checked"
};
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  setup(__props) {
    const platform = isMac() ? "is-mac" : "";
    const store = inject(STORE_KEY);
    const { currentEmoji, options, skinTone } = toRefs(store.state);
    const updateSkinTone = store.updateSkinTone;
    let skinToneOpen = ref(false);
    const toggleSkinToneState = (tone) => {
      if (skinToneOpen.value) {
        updateSkinTone(tone);
        skinToneOpen.value = false;
      } else {
        skinToneOpen.value = true;
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$3, [
        createElementVNode("div", _hoisted_2$2, [
          createElementVNode("span", {
            class: normalizeClass([unref(platform), "current-emoji"])
          }, [
            unref(options).native ? (openBlock(), createElementBlock("span", _hoisted_3$2, toDisplayString(unref(unicodeToEmoji)(unref(currentEmoji).r.u)), 1)) : (openBlock(), createElementBlock("div", {
              key: 1,
              class: "emoji-bg",
              style: normalizeStyle(`background-image: url(${unref(options).imgSrc}twemoji.png);
        background-position: ${unref(currentEmoji).r.x * -unref(EmojiWidth) * 1.5}px ${unref(currentEmoji).r.y * -unref(EmojiHeight) * 1.5}px;
        `)
            }, null, 4))
          ], 2),
          withDirectives(createElementVNode("span", { class: "emoji-desc" }, toDisplayString(unref(currentEmoji).n[0]), 513), [
            [vShow, !skinToneOpen.value]
          ])
        ]),
        unref(options).hasSkinTones ? (openBlock(), createElementBlock("div", _hoisted_4$2, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(unref(SKIN_TONES), (tone) => {
            return withDirectives((openBlock(), createElementBlock("div", {
              key: tone,
              style: normalizeStyle(`background-color:#${tone}`),
              class: normalizeClass(["toggle-button-" + tone, "toggle-button", tone === unref(skinTone) ? "toggle-button-select" : ""]),
              onClick: ($event) => toggleSkinToneState(tone)
            }, [
              tone === unref(skinTone) ? (openBlock(), createElementBlock("div", _hoisted_6$2)) : createCommentVNode("", true)
            ], 14, _hoisted_5$2)), [
              [vShow, skinToneOpen.value || tone === unref(skinTone)]
            ]);
          }), 128))
        ])) : createCommentVNode("", true)
      ]);
    };
  }
});
var __unplugin_components_2 = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["__scopeId", "data-v-8935a36a"]]);
var EmojiBody_vue_vue_type_style_index_0_scoped_true_lang = "";
const _withScopeId$1 = (n) => (pushScopeId("data-v-4ea24bf9"), n = n(), popScopeId(), n);
const _hoisted_1$2 = ["id"];
const _hoisted_2$1 = { class: "emojis-wrap" };
const _hoisted_3$1 = { flex: "~ wrap" };
const _hoisted_4$1 = ["onClick", "onMouseenter"];
const _hoisted_5$1 = { key: 0 };
const _hoisted_6$1 = /* @__PURE__ */ _withScopeId$1(() => /* @__PURE__ */ createElementVNode("div", { class: "emoji-spacing" }, null, -1));
const _hoisted_7$1 = {
  key: 1,
  class: "v3-no-result"
};
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  emits: ["select"],
  setup(__props, { emit: emits }) {
    const store = inject(STORE_KEY);
    const { options, activeGroup, staticText } = toRefs(store.state);
    const { updateEmoji, updateActiveGroup, saveRecentEmoji, clearRecentEmoji } = store;
    const state = store.state;
    const emojiGroups = computed(() => filterEmojis(state.emojiGroups, state.search, state.skinTone));
    const hasGroupNames = computed(() => state.options.hasGroupNames);
    const isSticky = computed(() => state.options.stickyGroupNames);
    const hoverEmoji = (emoji) => {
      updateEmoji(emoji);
    };
    const platform = isMac() ? "is-mac" : "";
    const selectEmoji = (emoji) => {
      emits("select", __spreadProps(__spreadValues({}, emoji), {
        t: state.skinTone,
        i: unicodeToEmoji(emoji.r.u),
        imgSrc: !options.value.native ? `${`${options.value.imgSrc}svg/${emoji.r.u}`}.svg` : ""
      }));
      saveRecentEmoji(emoji);
    };
    let doScroll = true;
    const bodyScroll = (e) => {
      for (let i = emojiGroups.value.length - 1; i >= 0; i--) {
        const group = emojiGroups.value[i];
        if (e.target.scrollTop >= group.y) {
          if (group.key !== activeGroup.value) {
            doScroll = false;
            updateActiveGroup(group.key);
            setTimeout(() => {
              doScroll = true;
            }, 50);
            break;
          } else {
            break;
          }
        }
      }
    };
    const emojiBody = ref();
    watch(() => state.activeGroup, () => {
      var _a;
      if (doScroll) {
        const target = (_a = emojiBody.value) == null ? void 0 : _a.querySelector(`#${state.activeGroup}`);
        if (target) {
          const parentNode = target.parentNode;
          parentNode.scrollTop = target.offsetTop;
        }
      }
    });
    watchEffect(() => {
      var _a;
      for (const group of emojiGroups.value) {
        const target = (_a = emojiBody.value) == null ? void 0 : _a.querySelector(`#${group.key}`);
        group.y = target.offsetTop;
      }
    }, {
      flush: "post"
    });
    onMounted(() => {
      if (emojiGroups.value[0].emojis.length > 0)
        updateActiveGroup(emojiGroups.value[0].key);
      else
        updateActiveGroup(emojiGroups.value[1].key);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "emojiBody",
        ref: emojiBody,
        class: normalizeClass([unref(platform), "emoji-body"]),
        onScroll: _cache[1] || (_cache[1] = ($event) => bodyScroll($event))
      }, [
        unref(emojiGroups).length ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(unref(emojiGroups), (group) => {
          return openBlock(), createElementBlock("div", {
            id: group.key,
            key: group.key,
            class: "emoji-group"
          }, [
            unref(hasGroupNames) ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(["group-name", unref(isSticky) ? `sticky` : ``])
            }, [
              createTextVNode(toDisplayString(group.title) + " ", 1),
              group.key === "recent_emojis" ? (openBlock(), createElementBlock("span", {
                key: 0,
                class: "c-btn",
                onClick: _cache[0] || (_cache[0] = (...args) => unref(clearRecentEmoji) && unref(clearRecentEmoji)(...args))
              }, toDisplayString(unref(staticText).clear_button), 1)) : createCommentVNode("", true)
            ], 2)) : createCommentVNode("", true),
            createElementVNode("div", _hoisted_2$1, [
              createElementVNode("div", _hoisted_3$1, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(group.emojis, (emoji) => {
                  return openBlock(), createElementBlock("div", {
                    key: emoji.r.u,
                    class: "emoji-block",
                    onClick: ($event) => selectEmoji(emoji),
                    onMouseenter: ($event) => hoverEmoji(emoji)
                  }, [
                    unref(state).options.native ? (openBlock(), createElementBlock("span", _hoisted_5$1, toDisplayString(unref(unicodeToEmoji)(emoji.r.u)), 1)) : (openBlock(), createElementBlock("div", {
                      key: 1,
                      class: "emoji-bg",
                      style: normalizeStyle(`background-image: url(${unref(options).imgSrc}twemoji.png);
              background-position: ${emoji.r.x * -unref(EmojiWidth)}px ${emoji.r.y * -unref(EmojiHeight)}px;
              `)
                    }, null, 4))
                  ], 40, _hoisted_4$1);
                }), 128))
              ])
            ]),
            _hoisted_6$1
          ], 8, _hoisted_1$2);
        }), 128)) : (openBlock(), createElementBlock("span", _hoisted_7$1, toDisplayString(unref(staticText).no_results), 1))
      ], 34);
    };
  }
});
var __unplugin_components_1 = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["__scopeId", "data-v-4ea24bf9"]]);
var EmojiHeader_vue_vue_type_style_index_0_scoped_true_lang = "";
const _withScopeId = (n) => (pushScopeId("data-v-69882c7a"), n = n(), popScopeId(), n);
const _hoisted_1$1 = {
  key: 0,
  class: "emoji-header"
};
const _hoisted_2 = {
  key: 0,
  class: "emoji-search"
};
const _hoisted_3 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("div", {
  "i-lucide-search": "",
  c: "#88888880"
}, null, -1));
const _hoisted_4 = ["placeholder"];
const _hoisted_5 = {
  key: 1,
  class: "emoji-groups"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  key: 2,
  class: "emoji-spacing"
};
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  setup(__props) {
    const store = inject(STORE_KEY);
    const { options, search, emojiGroups, activeGroup, staticText } = toRefs(store.state);
    const updateActiveGroup = store.updateActiveGroup;
    const updateSearch = store.updateSearch;
    const searchValue = computed({
      get: () => search.value,
      set: (value) => updateSearch(value)
    });
    return (_ctx, _cache) => {
      return unref(options).hasGroupIcons || unref(options).hasSearch ? (openBlock(), createElementBlock("div", _hoisted_1$1, [
        unref(options).hasSearch ? (openBlock(), createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          withDirectives(createElementVNode("input", {
            ref: "searchContainer",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(searchValue) ? searchValue.value = $event : null),
            type: "text",
            placeholder: unref(staticText).search_placeholder
          }, null, 8, _hoisted_4), [
            [vModelText, unref(searchValue)]
          ])
        ])) : createCommentVNode("", true),
        unref(options).hasGroupIcons ? (openBlock(), createElementBlock("div", _hoisted_5, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(unref(emojiGroups), (group) => {
            return openBlock(), createElementBlock("div", {
              key: group.key,
              class: "emoji-group",
              onClick: ($event) => group.emojis.length > 0 ? unref(updateActiveGroup)(group.key) : ""
            }, [
              unref(options).native ? (openBlock(), createElementBlock("span", {
                key: 0,
                class: normalizeClass(group.key === unref(activeGroup) && unref(searchValue) == "" ? "selected" : "")
              }, toDisplayString(unref(unicodeToEmoji)(group.u)), 3)) : (openBlock(), createElementBlock("img", {
                key: 1,
                class: normalizeClass(group.key === unref(activeGroup) && unref(searchValue) == "" ? "selected" : ""),
                src: `${unref(options).imgSrc}svg/${group.u}.svg`,
                alt: ""
              }, null, 10, _hoisted_7)),
              createElementVNode("div", {
                class: normalizeClass(["bottom-block", group.key === unref(activeGroup) && unref(searchValue) == "" ? "selected2" : ""])
              }, null, 2)
            ], 8, _hoisted_6);
          }), 128))
        ])) : createCommentVNode("", true),
        unref(options).hasGroupIcons ? (openBlock(), createElementBlock("div", _hoisted_8)) : createCommentVNode("", true)
      ])) : createCommentVNode("", true);
    };
  }
});
var __unplugin_components_0 = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["__scopeId", "data-v-69882c7a"]]);
var emojiGroupsEn = [
  {
    emojis: [],
    u: "1f551",
    title: "Recent Records",
    key: "recent_emojis"
  },
  {
    emojis: [
      {
        n: [
          "grinning face",
          "grinning"
        ],
        u: {
          u: "1f600",
          x: 0,
          y: 0
        }
      },
      {
        n: [
          "grinning face with smiling eyes",
          "grin"
        ],
        u: {
          u: "1f601",
          x: 1,
          y: 0
        }
      },
      {
        n: [
          "face with tears of joy",
          "joy"
        ],
        u: {
          u: "1f602",
          x: 2,
          y: 0
        }
      },
      {
        n: [
          "rolling on the floor laughing",
          "rolling_on_the_floor_laughing"
        ],
        u: {
          u: "1f923",
          x: 3,
          y: 0
        }
      },
      {
        n: [
          "smiling face with open mouth",
          "smiley"
        ],
        u: {
          u: "1f603",
          x: 4,
          y: 0
        }
      },
      {
        n: [
          "smiling face with open mouth and smiling eyes",
          "smile"
        ],
        u: {
          u: "1f604",
          x: 5,
          y: 0
        }
      },
      {
        n: [
          "smiling face with open mouth and cold sweat",
          "sweat_smile"
        ],
        u: {
          u: "1f605",
          x: 6,
          y: 0
        }
      },
      {
        n: [
          "smiling face with open mouth and tightly-closed eyes",
          "laughing",
          "satisfied"
        ],
        u: {
          u: "1f606",
          x: 7,
          y: 0
        }
      },
      {
        n: [
          "winking face",
          "wink"
        ],
        u: {
          u: "1f609",
          x: 8,
          y: 0
        }
      },
      {
        n: [
          "smiling face with smiling eyes",
          "blush"
        ],
        u: {
          u: "1f60a",
          x: 9,
          y: 0
        }
      },
      {
        n: [
          "face savouring delicious food",
          "yum"
        ],
        u: {
          u: "1f60b",
          x: 10,
          y: 0
        }
      },
      {
        n: [
          "smiling face with sunglasses",
          "sunglasses"
        ],
        u: {
          u: "1f60e",
          x: 11,
          y: 0
        }
      },
      {
        n: [
          "smiling face with heart-shaped eyes",
          "heart_eyes"
        ],
        u: {
          u: "1f60d",
          x: 12,
          y: 0
        }
      },
      {
        n: [
          "face throwing a kiss",
          "kissing_heart"
        ],
        u: {
          u: "1f618",
          x: 13,
          y: 0
        }
      },
      {
        n: [
          "kissing face",
          "kissing"
        ],
        u: {
          u: "1f617",
          x: 14,
          y: 0
        }
      },
      {
        n: [
          "kissing face with smiling eyes",
          "kissing_smiling_eyes"
        ],
        u: {
          u: "1f619",
          x: 15,
          y: 0
        }
      },
      {
        n: [
          "kissing face with closed eyes",
          "kissing_closed_eyes"
        ],
        u: {
          u: "1f61a",
          x: 16,
          y: 0
        }
      },
      {
        n: [
          "white smiling face",
          "relaxed"
        ],
        u: {
          u: "263a-fe0f",
          x: 17,
          y: 0
        }
      },
      {
        n: [
          "slightly smiling face",
          "slightly_smiling_face"
        ],
        u: {
          u: "1f642",
          x: 18,
          y: 0
        }
      },
      {
        n: [
          "hugging face",
          "hugging_face"
        ],
        u: {
          u: "1f917",
          x: 19,
          y: 0
        }
      },
      {
        n: [
          "grinning face with star eyes",
          "star-struck",
          "grinning_face_with_star_eyes"
        ],
        u: {
          u: "1f929",
          x: 20,
          y: 0
        }
      },
      {
        n: [
          "thinking face",
          "thinking_face"
        ],
        u: {
          u: "1f914",
          x: 21,
          y: 0
        }
      },
      {
        n: [
          "face with one eyebrow raised",
          "face_with_raised_eyebrow",
          "face_with_one_eyebrow_raised"
        ],
        u: {
          u: "1f928",
          x: 22,
          y: 0
        }
      },
      {
        n: [
          "neutral face",
          "neutral_face"
        ],
        u: {
          u: "1f610",
          x: 23,
          y: 0
        }
      },
      {
        n: [
          "expressionless face",
          "expressionless"
        ],
        u: {
          u: "1f611",
          x: 24,
          y: 0
        }
      },
      {
        n: [
          "face without mouth",
          "no_mouth"
        ],
        u: {
          u: "1f636",
          x: 25,
          y: 0
        }
      },
      {
        n: [
          "face with rolling eyes",
          "face_with_rolling_eyes"
        ],
        u: {
          u: "1f644",
          x: 26,
          y: 0
        }
      },
      {
        n: [
          "smirking face",
          "smirk"
        ],
        u: {
          u: "1f60f",
          x: 27,
          y: 0
        }
      },
      {
        n: [
          "persevering face",
          "persevere"
        ],
        u: {
          u: "1f623",
          x: 28,
          y: 0
        }
      },
      {
        n: [
          "disappointed but relieved face",
          "disappointed_relieved"
        ],
        u: {
          u: "1f625",
          x: 29,
          y: 0
        }
      },
      {
        n: [
          "face with open mouth",
          "open_mouth"
        ],
        u: {
          u: "1f62e",
          x: 30,
          y: 0
        }
      },
      {
        n: [
          "zipper-mouth face",
          "zipper_mouth_face"
        ],
        u: {
          u: "1f910",
          x: 31,
          y: 0
        }
      },
      {
        n: [
          "hushed face",
          "hushed"
        ],
        u: {
          u: "1f62f",
          x: 32,
          y: 0
        }
      },
      {
        n: [
          "sleepy face",
          "sleepy"
        ],
        u: {
          u: "1f62a",
          x: 33,
          y: 0
        }
      },
      {
        n: [
          "tired face",
          "tired_face"
        ],
        u: {
          u: "1f62b",
          x: 34,
          y: 0
        }
      },
      {
        n: [
          "sleeping face",
          "sleeping"
        ],
        u: {
          u: "1f634",
          x: 35,
          y: 0
        }
      },
      {
        n: [
          "relieved face",
          "relieved"
        ],
        u: {
          u: "1f60c",
          x: 36,
          y: 0
        }
      },
      {
        n: [
          "face with stuck-out tongue",
          "stuck_out_tongue"
        ],
        u: {
          u: "1f61b",
          x: 37,
          y: 0
        }
      },
      {
        n: [
          "face with stuck-out tongue and winking eye",
          "stuck_out_tongue_winking_eye"
        ],
        u: {
          u: "1f61c",
          x: 38,
          y: 0
        }
      },
      {
        n: [
          "face with stuck-out tongue and tightly-closed eyes",
          "stuck_out_tongue_closed_eyes"
        ],
        u: {
          u: "1f61d",
          x: 39,
          y: 0
        }
      },
      {
        n: [
          "drooling face",
          "drooling_face"
        ],
        u: {
          u: "1f924",
          x: 40,
          y: 0
        }
      },
      {
        n: [
          "unamused face",
          "unamused"
        ],
        u: {
          u: "1f612",
          x: 41,
          y: 0
        }
      },
      {
        n: [
          "face with cold sweat",
          "sweat"
        ],
        u: {
          u: "1f613",
          x: 42,
          y: 0
        }
      },
      {
        n: [
          "pensive face",
          "pensive"
        ],
        u: {
          u: "1f614",
          x: 43,
          y: 0
        }
      },
      {
        n: [
          "confused face",
          "confused"
        ],
        u: {
          u: "1f615",
          x: 44,
          y: 0
        }
      },
      {
        n: [
          "upside-down face",
          "upside_down_face"
        ],
        u: {
          u: "1f643",
          x: 45,
          y: 0
        }
      },
      {
        n: [
          "money-mouth face",
          "money_mouth_face"
        ],
        u: {
          u: "1f911",
          x: 46,
          y: 0
        }
      },
      {
        n: [
          "astonished face",
          "astonished"
        ],
        u: {
          u: "1f632",
          x: 47,
          y: 0
        }
      },
      {
        n: [
          "white_frowning_face"
        ],
        u: {
          u: "2639",
          x: 48,
          y: 0
        }
      },
      {
        n: [
          "slightly frowning face",
          "slightly_frowning_face"
        ],
        u: {
          u: "1f641",
          x: 49,
          y: 0
        }
      },
      {
        n: [
          "confounded face",
          "confounded"
        ],
        u: {
          u: "1f616",
          x: 0,
          y: 1
        }
      },
      {
        n: [
          "disappointed face",
          "disappointed"
        ],
        u: {
          u: "1f61e",
          x: 1,
          y: 1
        }
      },
      {
        n: [
          "worried face",
          "worried"
        ],
        u: {
          u: "1f61f",
          x: 2,
          y: 1
        }
      },
      {
        n: [
          "face with look of triumph",
          "triumph"
        ],
        u: {
          u: "1f624",
          x: 3,
          y: 1
        }
      },
      {
        n: [
          "crying face",
          "cry"
        ],
        u: {
          u: "1f622",
          x: 4,
          y: 1
        }
      },
      {
        n: [
          "loudly crying face",
          "sob"
        ],
        u: {
          u: "1f62d",
          x: 5,
          y: 1
        }
      },
      {
        n: [
          "frowning face with open mouth",
          "frowning"
        ],
        u: {
          u: "1f626",
          x: 6,
          y: 1
        }
      },
      {
        n: [
          "anguished face",
          "anguished"
        ],
        u: {
          u: "1f627",
          x: 7,
          y: 1
        }
      },
      {
        n: [
          "fearful face",
          "fearful"
        ],
        u: {
          u: "1f628",
          x: 8,
          y: 1
        }
      },
      {
        n: [
          "weary face",
          "weary"
        ],
        u: {
          u: "1f629",
          x: 9,
          y: 1
        }
      },
      {
        n: [
          "shocked face with exploding head",
          "exploding_head",
          "shocked_face_with_exploding_head"
        ],
        u: {
          u: "1f92f",
          x: 10,
          y: 1
        }
      },
      {
        n: [
          "grimacing face",
          "grimacing"
        ],
        u: {
          u: "1f62c",
          x: 11,
          y: 1
        }
      },
      {
        n: [
          "face with open mouth and cold sweat",
          "cold_sweat"
        ],
        u: {
          u: "1f630",
          x: 12,
          y: 1
        }
      },
      {
        n: [
          "face screaming in fear",
          "scream"
        ],
        u: {
          u: "1f631",
          x: 13,
          y: 1
        }
      },
      {
        n: [
          "flushed face",
          "flushed"
        ],
        u: {
          u: "1f633",
          x: 14,
          y: 1
        }
      },
      {
        n: [
          "grinning face with one large and one small eye",
          "zany_face",
          "grinning_face_with_one_large_and_one_small_eye"
        ],
        u: {
          u: "1f92a",
          x: 15,
          y: 1
        }
      },
      {
        n: [
          "dizzy face",
          "dizzy_face"
        ],
        u: {
          u: "1f635",
          x: 16,
          y: 1
        }
      },
      {
        n: [
          "pouting face",
          "rage"
        ],
        u: {
          u: "1f621",
          x: 17,
          y: 1
        }
      },
      {
        n: [
          "angry face",
          "angry"
        ],
        u: {
          u: "1f620",
          x: 18,
          y: 1
        }
      },
      {
        n: [
          "serious face with symbols covering mouth",
          "face_with_symbols_on_mouth",
          "serious_face_with_symbols_covering_mouth"
        ],
        u: {
          u: "1f92c",
          x: 19,
          y: 1
        }
      },
      {
        n: [
          "face with medical mask",
          "mask"
        ],
        u: {
          u: "1f637",
          x: 20,
          y: 1
        }
      },
      {
        n: [
          "face with thermometer",
          "face_with_thermometer"
        ],
        u: {
          u: "1f912",
          x: 21,
          y: 1
        }
      },
      {
        n: [
          "face with head-bandage",
          "face_with_head_bandage"
        ],
        u: {
          u: "1f915",
          x: 22,
          y: 1
        }
      },
      {
        n: [
          "nauseated face",
          "nauseated_face"
        ],
        u: {
          u: "1f922",
          x: 23,
          y: 1
        }
      },
      {
        n: [
          "face with open mouth vomiting",
          "face_vomiting",
          "face_with_open_mouth_vomiting"
        ],
        u: {
          u: "1f92e",
          x: 24,
          y: 1
        }
      },
      {
        n: [
          "sneezing face",
          "sneezing_face"
        ],
        u: {
          u: "1f927",
          x: 25,
          y: 1
        }
      },
      {
        n: [
          "smiling face with halo",
          "innocent"
        ],
        u: {
          u: "1f607",
          x: 26,
          y: 1
        }
      },
      {
        n: [
          "face with cowboy hat",
          "face_with_cowboy_hat"
        ],
        u: {
          u: "1f920",
          x: 27,
          y: 1
        }
      },
      {
        n: [
          "clown face",
          "clown_face"
        ],
        u: {
          u: "1f921",
          x: 28,
          y: 1
        }
      },
      {
        n: [
          "lying face",
          "lying_face"
        ],
        u: {
          u: "1f925",
          x: 29,
          y: 1
        }
      },
      {
        n: [
          "face with finger covering closed lips",
          "shushing_face",
          "face_with_finger_covering_closed_lips"
        ],
        u: {
          u: "1f92b",
          x: 30,
          y: 1
        }
      },
      {
        n: [
          "smiling face with smiling eyes and hand covering mouth",
          "face_with_hand_over_mouth",
          "smiling_face_with_smiling_eyes_and_hand_covering_mouth"
        ],
        u: {
          u: "1f92d",
          x: 31,
          y: 1
        }
      },
      {
        n: [
          "face with monocle",
          "face_with_monocle"
        ],
        u: {
          u: "1f9d0",
          x: 32,
          y: 1
        }
      },
      {
        n: [
          "nerd face",
          "nerd_face"
        ],
        u: {
          u: "1f913",
          x: 33,
          y: 1
        }
      },
      {
        n: [
          "smiling face with horns",
          "smiling_imp"
        ],
        u: {
          u: "1f608",
          x: 34,
          y: 1
        }
      },
      {
        n: [
          "imp"
        ],
        u: {
          u: "1f47f",
          x: 35,
          y: 1
        }
      },
      {
        n: [
          "japanese ogre",
          "japanese_ogre"
        ],
        u: {
          u: "1f479",
          x: 36,
          y: 1
        }
      },
      {
        n: [
          "japanese goblin",
          "japanese_goblin"
        ],
        u: {
          u: "1f47a",
          x: 37,
          y: 1
        }
      },
      {
        n: [
          "skull"
        ],
        u: {
          u: "1f480",
          x: 38,
          y: 1
        }
      },
      {
        n: [
          "skull_and_crossbones"
        ],
        u: {
          u: "2620",
          x: 39,
          y: 1
        }
      },
      {
        n: [
          "ghost"
        ],
        u: {
          u: "1f47b",
          x: 40,
          y: 1
        }
      },
      {
        n: [
          "extraterrestrial alien",
          "alien"
        ],
        u: {
          u: "1f47d",
          x: 41,
          y: 1
        }
      },
      {
        n: [
          "alien monster",
          "space_invader"
        ],
        u: {
          u: "1f47e",
          x: 42,
          y: 1
        }
      },
      {
        n: [
          "robot face",
          "robot_face"
        ],
        u: {
          u: "1f916",
          x: 43,
          y: 1
        }
      },
      {
        n: [
          "pile of poo",
          "hankey",
          "poop",
          "shit"
        ],
        u: {
          u: "1f4a9",
          x: 44,
          y: 1
        }
      },
      {
        n: [
          "smiling cat face with open mouth",
          "smiley_cat"
        ],
        u: {
          u: "1f63a",
          x: 45,
          y: 1
        }
      },
      {
        n: [
          "grinning cat face with smiling eyes",
          "smile_cat"
        ],
        u: {
          u: "1f638",
          x: 46,
          y: 1
        }
      },
      {
        n: [
          "cat face with tears of joy",
          "joy_cat"
        ],
        u: {
          u: "1f639",
          x: 47,
          y: 1
        }
      },
      {
        n: [
          "smiling cat face with heart-shaped eyes",
          "heart_eyes_cat"
        ],
        u: {
          u: "1f63b",
          x: 48,
          y: 1
        }
      },
      {
        n: [
          "cat face with wry smile",
          "smirk_cat"
        ],
        u: {
          u: "1f63c",
          x: 49,
          y: 1
        }
      },
      {
        n: [
          "kissing cat face with closed eyes",
          "kissing_cat"
        ],
        u: {
          u: "1f63d",
          x: 0,
          y: 2
        }
      },
      {
        n: [
          "weary cat face",
          "scream_cat"
        ],
        u: {
          u: "1f640",
          x: 1,
          y: 2
        }
      },
      {
        n: [
          "crying cat face",
          "crying_cat_face"
        ],
        u: {
          u: "1f63f",
          x: 2,
          y: 2
        }
      },
      {
        n: [
          "pouting cat face",
          "pouting_cat"
        ],
        u: {
          u: "1f63e",
          x: 3,
          y: 2
        }
      },
      {
        n: [
          "see-no-evil monkey",
          "see_no_evil"
        ],
        u: {
          u: "1f648",
          x: 4,
          y: 2
        }
      },
      {
        n: [
          "hear-no-evil monkey",
          "hear_no_evil"
        ],
        u: {
          u: "1f649",
          x: 5,
          y: 2
        }
      },
      {
        n: [
          "speak-no-evil monkey",
          "speak_no_evil"
        ],
        u: {
          u: "1f64a",
          x: 6,
          y: 2
        }
      },
      {
        n: [
          "baby"
        ],
        u: {
          u: "1f476",
          x: 7,
          y: 2
        },
        v: [
          {
            u: "1f476-1f3fb",
            x: 8,
            y: 2
          },
          {
            u: "1f476-1f3fc",
            x: 9,
            y: 2
          },
          {
            u: "1f476-1f3fd",
            x: 10,
            y: 2
          },
          {
            u: "1f476-1f3fe",
            x: 11,
            y: 2
          },
          {
            u: "1f476-1f3ff",
            x: 12,
            y: 2
          }
        ]
      },
      {
        n: [
          "child"
        ],
        u: {
          u: "1f9d2",
          x: 13,
          y: 2
        },
        v: [
          {
            u: "1f9d2-1f3fb",
            x: 14,
            y: 2
          },
          {
            u: "1f9d2-1f3fc",
            x: 15,
            y: 2
          },
          {
            u: "1f9d2-1f3fd",
            x: 16,
            y: 2
          },
          {
            u: "1f9d2-1f3fe",
            x: 17,
            y: 2
          },
          {
            u: "1f9d2-1f3ff",
            x: 18,
            y: 2
          }
        ]
      },
      {
        n: [
          "boy"
        ],
        u: {
          u: "1f466",
          x: 19,
          y: 2
        },
        v: [
          {
            u: "1f466-1f3fb",
            x: 20,
            y: 2
          },
          {
            u: "1f466-1f3fc",
            x: 21,
            y: 2
          },
          {
            u: "1f466-1f3fd",
            x: 22,
            y: 2
          },
          {
            u: "1f466-1f3fe",
            x: 23,
            y: 2
          },
          {
            u: "1f466-1f3ff",
            x: 24,
            y: 2
          }
        ]
      },
      {
        n: [
          "girl"
        ],
        u: {
          u: "1f467",
          x: 25,
          y: 2
        },
        v: [
          {
            u: "1f467-1f3fb",
            x: 26,
            y: 2
          },
          {
            u: "1f467-1f3fc",
            x: 27,
            y: 2
          },
          {
            u: "1f467-1f3fd",
            x: 28,
            y: 2
          },
          {
            u: "1f467-1f3fe",
            x: 29,
            y: 2
          },
          {
            u: "1f467-1f3ff",
            x: 30,
            y: 2
          }
        ]
      },
      {
        n: [
          "adult"
        ],
        u: {
          u: "1f9d1",
          x: 31,
          y: 2
        },
        v: [
          {
            u: "1f9d1-1f3fb",
            x: 32,
            y: 2
          },
          {
            u: "1f9d1-1f3fc",
            x: 33,
            y: 2
          },
          {
            u: "1f9d1-1f3fd",
            x: 34,
            y: 2
          },
          {
            u: "1f9d1-1f3fe",
            x: 35,
            y: 2
          },
          {
            u: "1f9d1-1f3ff",
            x: 36,
            y: 2
          }
        ]
      },
      {
        n: [
          "man"
        ],
        u: {
          u: "1f468",
          x: 37,
          y: 2
        },
        v: [
          {
            u: "1f468-1f3fb",
            x: 38,
            y: 2
          },
          {
            u: "1f468-1f3fc",
            x: 39,
            y: 2
          },
          {
            u: "1f468-1f3fd",
            x: 40,
            y: 2
          },
          {
            u: "1f468-1f3fe",
            x: 41,
            y: 2
          },
          {
            u: "1f468-1f3ff",
            x: 42,
            y: 2
          }
        ]
      },
      {
        n: [
          "woman"
        ],
        u: {
          u: "1f469",
          x: 43,
          y: 2
        },
        v: [
          {
            u: "1f469-1f3fb",
            x: 44,
            y: 2
          },
          {
            u: "1f469-1f3fc",
            x: 45,
            y: 2
          },
          {
            u: "1f469-1f3fd",
            x: 46,
            y: 2
          },
          {
            u: "1f469-1f3fe",
            x: 47,
            y: 2
          },
          {
            u: "1f469-1f3ff",
            x: 48,
            y: 2
          }
        ]
      },
      {
        n: [
          "older adult",
          "older_adult"
        ],
        u: {
          u: "1f9d3",
          x: 49,
          y: 2
        },
        v: [
          {
            u: "1f9d3-1f3fb",
            x: 0,
            y: 3
          },
          {
            u: "1f9d3-1f3fc",
            x: 1,
            y: 3
          },
          {
            u: "1f9d3-1f3fd",
            x: 2,
            y: 3
          },
          {
            u: "1f9d3-1f3fe",
            x: 3,
            y: 3
          },
          {
            u: "1f9d3-1f3ff",
            x: 4,
            y: 3
          }
        ]
      },
      {
        n: [
          "older man",
          "older_man"
        ],
        u: {
          u: "1f474",
          x: 5,
          y: 3
        },
        v: [
          {
            u: "1f474-1f3fb",
            x: 6,
            y: 3
          },
          {
            u: "1f474-1f3fc",
            x: 7,
            y: 3
          },
          {
            u: "1f474-1f3fd",
            x: 8,
            y: 3
          },
          {
            u: "1f474-1f3fe",
            x: 9,
            y: 3
          },
          {
            u: "1f474-1f3ff",
            x: 10,
            y: 3
          }
        ]
      },
      {
        n: [
          "older woman",
          "older_woman"
        ],
        u: {
          u: "1f475",
          x: 11,
          y: 3
        },
        v: [
          {
            u: "1f475-1f3fb",
            x: 12,
            y: 3
          },
          {
            u: "1f475-1f3fc",
            x: 13,
            y: 3
          },
          {
            u: "1f475-1f3fd",
            x: 14,
            y: 3
          },
          {
            u: "1f475-1f3fe",
            x: 15,
            y: 3
          },
          {
            u: "1f475-1f3ff",
            x: 16,
            y: 3
          }
        ]
      },
      {
        n: [
          "male-doctor"
        ],
        u: {
          u: "1f468-200d-2695-fe0f",
          x: 17,
          y: 3
        },
        v: [
          {
            u: "1f468-1f3fb-200d-2695-fe0f",
            x: 18,
            y: 3
          },
          {
            u: "1f468-1f3fc-200d-2695-fe0f",
            x: 19,
            y: 3
          },
          {
            u: "1f468-1f3fd-200d-2695-fe0f",
            x: 20,
            y: 3
          },
          {
            u: "1f468-1f3fe-200d-2695-fe0f",
            x: 21,
            y: 3
          },
          {
            u: "1f468-1f3ff-200d-2695-fe0f",
            x: 22,
            y: 3
          }
        ]
      },
      {
        n: [
          "female-doctor"
        ],
        u: {
          u: "1f469-200d-2695-fe0f",
          x: 23,
          y: 3
        },
        v: [
          {
            u: "1f469-1f3fb-200d-2695-fe0f",
            x: 24,
            y: 3
          },
          {
            u: "1f469-1f3fc-200d-2695-fe0f",
            x: 25,
            y: 3
          },
          {
            u: "1f469-1f3fd-200d-2695-fe0f",
            x: 26,
            y: 3
          },
          {
            u: "1f469-1f3fe-200d-2695-fe0f",
            x: 27,
            y: 3
          },
          {
            u: "1f469-1f3ff-200d-2695-fe0f",
            x: 28,
            y: 3
          }
        ]
      },
      {
        n: [
          "male-student"
        ],
        u: {
          u: "1f468-200d-1f393",
          x: 29,
          y: 3
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f393",
            x: 30,
            y: 3
          },
          {
            u: "1f468-1f3fc-200d-1f393",
            x: 31,
            y: 3
          },
          {
            u: "1f468-1f3fd-200d-1f393",
            x: 32,
            y: 3
          },
          {
            u: "1f468-1f3fe-200d-1f393",
            x: 33,
            y: 3
          },
          {
            u: "1f468-1f3ff-200d-1f393",
            x: 34,
            y: 3
          }
        ]
      },
      {
        n: [
          "female-student"
        ],
        u: {
          u: "1f469-200d-1f393",
          x: 35,
          y: 3
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f393",
            x: 36,
            y: 3
          },
          {
            u: "1f469-1f3fc-200d-1f393",
            x: 37,
            y: 3
          },
          {
            u: "1f469-1f3fd-200d-1f393",
            x: 38,
            y: 3
          },
          {
            u: "1f469-1f3fe-200d-1f393",
            x: 39,
            y: 3
          },
          {
            u: "1f469-1f3ff-200d-1f393",
            x: 40,
            y: 3
          }
        ]
      },
      {
        n: [
          "male-teacher"
        ],
        u: {
          u: "1f468-200d-1f3eb",
          x: 41,
          y: 3
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f3eb",
            x: 42,
            y: 3
          },
          {
            u: "1f468-1f3fc-200d-1f3eb",
            x: 43,
            y: 3
          },
          {
            u: "1f468-1f3fd-200d-1f3eb",
            x: 44,
            y: 3
          },
          {
            u: "1f468-1f3fe-200d-1f3eb",
            x: 45,
            y: 3
          },
          {
            u: "1f468-1f3ff-200d-1f3eb",
            x: 46,
            y: 3
          }
        ]
      },
      {
        n: [
          "female-teacher"
        ],
        u: {
          u: "1f469-200d-1f3eb",
          x: 47,
          y: 3
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f3eb",
            x: 48,
            y: 3
          },
          {
            u: "1f469-1f3fc-200d-1f3eb",
            x: 49,
            y: 3
          },
          {
            u: "1f469-1f3fd-200d-1f3eb",
            x: 0,
            y: 4
          },
          {
            u: "1f469-1f3fe-200d-1f3eb",
            x: 1,
            y: 4
          },
          {
            u: "1f469-1f3ff-200d-1f3eb",
            x: 2,
            y: 4
          }
        ]
      },
      {
        n: [
          "male-judge"
        ],
        u: {
          u: "1f468-200d-2696-fe0f",
          x: 3,
          y: 4
        },
        v: [
          {
            u: "1f468-1f3fb-200d-2696-fe0f",
            x: 4,
            y: 4
          },
          {
            u: "1f468-1f3fc-200d-2696-fe0f",
            x: 5,
            y: 4
          },
          {
            u: "1f468-1f3fd-200d-2696-fe0f",
            x: 6,
            y: 4
          },
          {
            u: "1f468-1f3fe-200d-2696-fe0f",
            x: 7,
            y: 4
          },
          {
            u: "1f468-1f3ff-200d-2696-fe0f",
            x: 8,
            y: 4
          }
        ]
      },
      {
        n: [
          "female-judge"
        ],
        u: {
          u: "1f469-200d-2696-fe0f",
          x: 9,
          y: 4
        },
        v: [
          {
            u: "1f469-1f3fb-200d-2696-fe0f",
            x: 10,
            y: 4
          },
          {
            u: "1f469-1f3fc-200d-2696-fe0f",
            x: 11,
            y: 4
          },
          {
            u: "1f469-1f3fd-200d-2696-fe0f",
            x: 12,
            y: 4
          },
          {
            u: "1f469-1f3fe-200d-2696-fe0f",
            x: 13,
            y: 4
          },
          {
            u: "1f469-1f3ff-200d-2696-fe0f",
            x: 14,
            y: 4
          }
        ]
      },
      {
        n: [
          "male-farmer"
        ],
        u: {
          u: "1f468-200d-1f33e",
          x: 15,
          y: 4
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f33e",
            x: 16,
            y: 4
          },
          {
            u: "1f468-1f3fc-200d-1f33e",
            x: 17,
            y: 4
          },
          {
            u: "1f468-1f3fd-200d-1f33e",
            x: 18,
            y: 4
          },
          {
            u: "1f468-1f3fe-200d-1f33e",
            x: 19,
            y: 4
          },
          {
            u: "1f468-1f3ff-200d-1f33e",
            x: 20,
            y: 4
          }
        ]
      },
      {
        n: [
          "female-farmer"
        ],
        u: {
          u: "1f469-200d-1f33e",
          x: 21,
          y: 4
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f33e",
            x: 22,
            y: 4
          },
          {
            u: "1f469-1f3fc-200d-1f33e",
            x: 23,
            y: 4
          },
          {
            u: "1f469-1f3fd-200d-1f33e",
            x: 24,
            y: 4
          },
          {
            u: "1f469-1f3fe-200d-1f33e",
            x: 25,
            y: 4
          },
          {
            u: "1f469-1f3ff-200d-1f33e",
            x: 26,
            y: 4
          }
        ]
      },
      {
        n: [
          "male-cook"
        ],
        u: {
          u: "1f468-200d-1f373",
          x: 27,
          y: 4
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f373",
            x: 28,
            y: 4
          },
          {
            u: "1f468-1f3fc-200d-1f373",
            x: 29,
            y: 4
          },
          {
            u: "1f468-1f3fd-200d-1f373",
            x: 30,
            y: 4
          },
          {
            u: "1f468-1f3fe-200d-1f373",
            x: 31,
            y: 4
          },
          {
            u: "1f468-1f3ff-200d-1f373",
            x: 32,
            y: 4
          }
        ]
      },
      {
        n: [
          "female-cook"
        ],
        u: {
          u: "1f469-200d-1f373",
          x: 33,
          y: 4
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f373",
            x: 34,
            y: 4
          },
          {
            u: "1f469-1f3fc-200d-1f373",
            x: 35,
            y: 4
          },
          {
            u: "1f469-1f3fd-200d-1f373",
            x: 36,
            y: 4
          },
          {
            u: "1f469-1f3fe-200d-1f373",
            x: 37,
            y: 4
          },
          {
            u: "1f469-1f3ff-200d-1f373",
            x: 38,
            y: 4
          }
        ]
      },
      {
        n: [
          "male-mechanic"
        ],
        u: {
          u: "1f468-200d-1f527",
          x: 39,
          y: 4
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f527",
            x: 40,
            y: 4
          },
          {
            u: "1f468-1f3fc-200d-1f527",
            x: 41,
            y: 4
          },
          {
            u: "1f468-1f3fd-200d-1f527",
            x: 42,
            y: 4
          },
          {
            u: "1f468-1f3fe-200d-1f527",
            x: 43,
            y: 4
          },
          {
            u: "1f468-1f3ff-200d-1f527",
            x: 44,
            y: 4
          }
        ]
      },
      {
        n: [
          "female-mechanic"
        ],
        u: {
          u: "1f469-200d-1f527",
          x: 45,
          y: 4
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f527",
            x: 46,
            y: 4
          },
          {
            u: "1f469-1f3fc-200d-1f527",
            x: 47,
            y: 4
          },
          {
            u: "1f469-1f3fd-200d-1f527",
            x: 48,
            y: 4
          },
          {
            u: "1f469-1f3fe-200d-1f527",
            x: 49,
            y: 4
          },
          {
            u: "1f469-1f3ff-200d-1f527",
            x: 0,
            y: 5
          }
        ]
      },
      {
        n: [
          "male-factory-worker"
        ],
        u: {
          u: "1f468-200d-1f3ed",
          x: 1,
          y: 5
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f3ed",
            x: 2,
            y: 5
          },
          {
            u: "1f468-1f3fc-200d-1f3ed",
            x: 3,
            y: 5
          },
          {
            u: "1f468-1f3fd-200d-1f3ed",
            x: 4,
            y: 5
          },
          {
            u: "1f468-1f3fe-200d-1f3ed",
            x: 5,
            y: 5
          },
          {
            u: "1f468-1f3ff-200d-1f3ed",
            x: 6,
            y: 5
          }
        ]
      },
      {
        n: [
          "female-factory-worker"
        ],
        u: {
          u: "1f469-200d-1f3ed",
          x: 7,
          y: 5
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f3ed",
            x: 8,
            y: 5
          },
          {
            u: "1f469-1f3fc-200d-1f3ed",
            x: 9,
            y: 5
          },
          {
            u: "1f469-1f3fd-200d-1f3ed",
            x: 10,
            y: 5
          },
          {
            u: "1f469-1f3fe-200d-1f3ed",
            x: 11,
            y: 5
          },
          {
            u: "1f469-1f3ff-200d-1f3ed",
            x: 12,
            y: 5
          }
        ]
      },
      {
        n: [
          "male-office-worker"
        ],
        u: {
          u: "1f468-200d-1f4bc",
          x: 13,
          y: 5
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f4bc",
            x: 14,
            y: 5
          },
          {
            u: "1f468-1f3fc-200d-1f4bc",
            x: 15,
            y: 5
          },
          {
            u: "1f468-1f3fd-200d-1f4bc",
            x: 16,
            y: 5
          },
          {
            u: "1f468-1f3fe-200d-1f4bc",
            x: 17,
            y: 5
          },
          {
            u: "1f468-1f3ff-200d-1f4bc",
            x: 18,
            y: 5
          }
        ]
      },
      {
        n: [
          "female-office-worker"
        ],
        u: {
          u: "1f469-200d-1f4bc",
          x: 19,
          y: 5
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f4bc",
            x: 20,
            y: 5
          },
          {
            u: "1f469-1f3fc-200d-1f4bc",
            x: 21,
            y: 5
          },
          {
            u: "1f469-1f3fd-200d-1f4bc",
            x: 22,
            y: 5
          },
          {
            u: "1f469-1f3fe-200d-1f4bc",
            x: 23,
            y: 5
          },
          {
            u: "1f469-1f3ff-200d-1f4bc",
            x: 24,
            y: 5
          }
        ]
      },
      {
        n: [
          "male-scientist"
        ],
        u: {
          u: "1f468-200d-1f52c",
          x: 25,
          y: 5
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f52c",
            x: 26,
            y: 5
          },
          {
            u: "1f468-1f3fc-200d-1f52c",
            x: 27,
            y: 5
          },
          {
            u: "1f468-1f3fd-200d-1f52c",
            x: 28,
            y: 5
          },
          {
            u: "1f468-1f3fe-200d-1f52c",
            x: 29,
            y: 5
          },
          {
            u: "1f468-1f3ff-200d-1f52c",
            x: 30,
            y: 5
          }
        ]
      },
      {
        n: [
          "female-scientist"
        ],
        u: {
          u: "1f469-200d-1f52c",
          x: 31,
          y: 5
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f52c",
            x: 32,
            y: 5
          },
          {
            u: "1f469-1f3fc-200d-1f52c",
            x: 33,
            y: 5
          },
          {
            u: "1f469-1f3fd-200d-1f52c",
            x: 34,
            y: 5
          },
          {
            u: "1f469-1f3fe-200d-1f52c",
            x: 35,
            y: 5
          },
          {
            u: "1f469-1f3ff-200d-1f52c",
            x: 36,
            y: 5
          }
        ]
      },
      {
        n: [
          "male-technologist"
        ],
        u: {
          u: "1f468-200d-1f4bb",
          x: 37,
          y: 5
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f4bb",
            x: 38,
            y: 5
          },
          {
            u: "1f468-1f3fc-200d-1f4bb",
            x: 39,
            y: 5
          },
          {
            u: "1f468-1f3fd-200d-1f4bb",
            x: 40,
            y: 5
          },
          {
            u: "1f468-1f3fe-200d-1f4bb",
            x: 41,
            y: 5
          },
          {
            u: "1f468-1f3ff-200d-1f4bb",
            x: 42,
            y: 5
          }
        ]
      },
      {
        n: [
          "female-technologist"
        ],
        u: {
          u: "1f469-200d-1f4bb",
          x: 43,
          y: 5
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f4bb",
            x: 44,
            y: 5
          },
          {
            u: "1f469-1f3fc-200d-1f4bb",
            x: 45,
            y: 5
          },
          {
            u: "1f469-1f3fd-200d-1f4bb",
            x: 46,
            y: 5
          },
          {
            u: "1f469-1f3fe-200d-1f4bb",
            x: 47,
            y: 5
          },
          {
            u: "1f469-1f3ff-200d-1f4bb",
            x: 48,
            y: 5
          }
        ]
      },
      {
        n: [
          "male-singer"
        ],
        u: {
          u: "1f468-200d-1f3a4",
          x: 49,
          y: 5
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f3a4",
            x: 0,
            y: 6
          },
          {
            u: "1f468-1f3fc-200d-1f3a4",
            x: 1,
            y: 6
          },
          {
            u: "1f468-1f3fd-200d-1f3a4",
            x: 2,
            y: 6
          },
          {
            u: "1f468-1f3fe-200d-1f3a4",
            x: 3,
            y: 6
          },
          {
            u: "1f468-1f3ff-200d-1f3a4",
            x: 4,
            y: 6
          }
        ]
      },
      {
        n: [
          "female-singer"
        ],
        u: {
          u: "1f469-200d-1f3a4",
          x: 5,
          y: 6
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f3a4",
            x: 6,
            y: 6
          },
          {
            u: "1f469-1f3fc-200d-1f3a4",
            x: 7,
            y: 6
          },
          {
            u: "1f469-1f3fd-200d-1f3a4",
            x: 8,
            y: 6
          },
          {
            u: "1f469-1f3fe-200d-1f3a4",
            x: 9,
            y: 6
          },
          {
            u: "1f469-1f3ff-200d-1f3a4",
            x: 10,
            y: 6
          }
        ]
      },
      {
        n: [
          "male-artist"
        ],
        u: {
          u: "1f468-200d-1f3a8",
          x: 11,
          y: 6
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f3a8",
            x: 12,
            y: 6
          },
          {
            u: "1f468-1f3fc-200d-1f3a8",
            x: 13,
            y: 6
          },
          {
            u: "1f468-1f3fd-200d-1f3a8",
            x: 14,
            y: 6
          },
          {
            u: "1f468-1f3fe-200d-1f3a8",
            x: 15,
            y: 6
          },
          {
            u: "1f468-1f3ff-200d-1f3a8",
            x: 16,
            y: 6
          }
        ]
      },
      {
        n: [
          "female-artist"
        ],
        u: {
          u: "1f469-200d-1f3a8",
          x: 17,
          y: 6
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f3a8",
            x: 18,
            y: 6
          },
          {
            u: "1f469-1f3fc-200d-1f3a8",
            x: 19,
            y: 6
          },
          {
            u: "1f469-1f3fd-200d-1f3a8",
            x: 20,
            y: 6
          },
          {
            u: "1f469-1f3fe-200d-1f3a8",
            x: 21,
            y: 6
          },
          {
            u: "1f469-1f3ff-200d-1f3a8",
            x: 22,
            y: 6
          }
        ]
      },
      {
        n: [
          "male-pilot"
        ],
        u: {
          u: "1f468-200d-2708-fe0f",
          x: 23,
          y: 6
        },
        v: [
          {
            u: "1f468-1f3fb-200d-2708-fe0f",
            x: 24,
            y: 6
          },
          {
            u: "1f468-1f3fc-200d-2708-fe0f",
            x: 25,
            y: 6
          },
          {
            u: "1f468-1f3fd-200d-2708-fe0f",
            x: 26,
            y: 6
          },
          {
            u: "1f468-1f3fe-200d-2708-fe0f",
            x: 27,
            y: 6
          },
          {
            u: "1f468-1f3ff-200d-2708-fe0f",
            x: 28,
            y: 6
          }
        ]
      },
      {
        n: [
          "female-pilot"
        ],
        u: {
          u: "1f469-200d-2708-fe0f",
          x: 29,
          y: 6
        },
        v: [
          {
            u: "1f469-1f3fb-200d-2708-fe0f",
            x: 30,
            y: 6
          },
          {
            u: "1f469-1f3fc-200d-2708-fe0f",
            x: 31,
            y: 6
          },
          {
            u: "1f469-1f3fd-200d-2708-fe0f",
            x: 32,
            y: 6
          },
          {
            u: "1f469-1f3fe-200d-2708-fe0f",
            x: 33,
            y: 6
          },
          {
            u: "1f469-1f3ff-200d-2708-fe0f",
            x: 34,
            y: 6
          }
        ]
      },
      {
        n: [
          "male-astronaut"
        ],
        u: {
          u: "1f468-200d-1f680",
          x: 35,
          y: 6
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f680",
            x: 36,
            y: 6
          },
          {
            u: "1f468-1f3fc-200d-1f680",
            x: 37,
            y: 6
          },
          {
            u: "1f468-1f3fd-200d-1f680",
            x: 38,
            y: 6
          },
          {
            u: "1f468-1f3fe-200d-1f680",
            x: 39,
            y: 6
          },
          {
            u: "1f468-1f3ff-200d-1f680",
            x: 40,
            y: 6
          }
        ]
      },
      {
        n: [
          "female-astronaut"
        ],
        u: {
          u: "1f469-200d-1f680",
          x: 41,
          y: 6
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f680",
            x: 42,
            y: 6
          },
          {
            u: "1f469-1f3fc-200d-1f680",
            x: 43,
            y: 6
          },
          {
            u: "1f469-1f3fd-200d-1f680",
            x: 44,
            y: 6
          },
          {
            u: "1f469-1f3fe-200d-1f680",
            x: 45,
            y: 6
          },
          {
            u: "1f469-1f3ff-200d-1f680",
            x: 46,
            y: 6
          }
        ]
      },
      {
        n: [
          "male-firefighter"
        ],
        u: {
          u: "1f468-200d-1f692",
          x: 47,
          y: 6
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f692",
            x: 48,
            y: 6
          },
          {
            u: "1f468-1f3fc-200d-1f692",
            x: 49,
            y: 6
          },
          {
            u: "1f468-1f3fd-200d-1f692",
            x: 0,
            y: 7
          },
          {
            u: "1f468-1f3fe-200d-1f692",
            x: 1,
            y: 7
          },
          {
            u: "1f468-1f3ff-200d-1f692",
            x: 2,
            y: 7
          }
        ]
      },
      {
        n: [
          "female-firefighter"
        ],
        u: {
          u: "1f469-200d-1f692",
          x: 3,
          y: 7
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f692",
            x: 4,
            y: 7
          },
          {
            u: "1f469-1f3fc-200d-1f692",
            x: 5,
            y: 7
          },
          {
            u: "1f469-1f3fd-200d-1f692",
            x: 6,
            y: 7
          },
          {
            u: "1f469-1f3fe-200d-1f692",
            x: 7,
            y: 7
          },
          {
            u: "1f469-1f3ff-200d-1f692",
            x: 8,
            y: 7
          }
        ]
      },
      {
        n: [
          "police officer",
          "cop"
        ],
        u: {
          u: "1f46e",
          x: 9,
          y: 7
        },
        v: [
          {
            u: "1f46e-1f3fb",
            x: 10,
            y: 7
          },
          {
            u: "1f46e-1f3fc",
            x: 11,
            y: 7
          },
          {
            u: "1f46e-1f3fd",
            x: 12,
            y: 7
          },
          {
            u: "1f46e-1f3fe",
            x: 13,
            y: 7
          },
          {
            u: "1f46e-1f3ff",
            x: 14,
            y: 7
          }
        ]
      },
      {
        n: [
          "male-police-officer"
        ],
        u: {
          u: "1f46e-200d-2642-fe0f",
          x: 15,
          y: 7
        },
        v: [
          {
            u: "1f46e-1f3fb-200d-2642-fe0f",
            x: 16,
            y: 7
          },
          {
            u: "1f46e-1f3fc-200d-2642-fe0f",
            x: 17,
            y: 7
          },
          {
            u: "1f46e-1f3fd-200d-2642-fe0f",
            x: 18,
            y: 7
          },
          {
            u: "1f46e-1f3fe-200d-2642-fe0f",
            x: 19,
            y: 7
          },
          {
            u: "1f46e-1f3ff-200d-2642-fe0f",
            x: 20,
            y: 7
          }
        ]
      },
      {
        n: [
          "female-police-officer"
        ],
        u: {
          u: "1f46e-200d-2640-fe0f",
          x: 21,
          y: 7
        },
        v: [
          {
            u: "1f46e-1f3fb-200d-2640-fe0f",
            x: 22,
            y: 7
          },
          {
            u: "1f46e-1f3fc-200d-2640-fe0f",
            x: 23,
            y: 7
          },
          {
            u: "1f46e-1f3fd-200d-2640-fe0f",
            x: 24,
            y: 7
          },
          {
            u: "1f46e-1f3fe-200d-2640-fe0f",
            x: 25,
            y: 7
          },
          {
            u: "1f46e-1f3ff-200d-2640-fe0f",
            x: 26,
            y: 7
          }
        ]
      },
      {
        n: [
          "sleuth_or_spy"
        ],
        u: {
          u: "1f575",
          x: 27,
          y: 7
        },
        v: [
          {
            u: "1f575-1f3fb",
            x: 28,
            y: 7
          },
          {
            u: "1f575-1f3fc",
            x: 29,
            y: 7
          },
          {
            u: "1f575-1f3fd",
            x: 30,
            y: 7
          },
          {
            u: "1f575-1f3fe",
            x: 31,
            y: 7
          },
          {
            u: "1f575-1f3ff",
            x: 32,
            y: 7
          }
        ]
      },
      {
        n: [
          "male-detective"
        ],
        u: {
          u: "1f575-fe0f-200d-2642-fe0f",
          x: 33,
          y: 7
        },
        v: [
          {
            u: "1f575-1f3fb-200d-2642-fe0f",
            x: 34,
            y: 7
          },
          {
            u: "1f575-1f3fc-200d-2642-fe0f",
            x: 35,
            y: 7
          },
          {
            u: "1f575-1f3fd-200d-2642-fe0f",
            x: 36,
            y: 7
          },
          {
            u: "1f575-1f3fe-200d-2642-fe0f",
            x: 37,
            y: 7
          },
          {
            u: "1f575-1f3ff-200d-2642-fe0f",
            x: 38,
            y: 7
          }
        ]
      },
      {
        n: [
          "female-detective"
        ],
        u: {
          u: "1f575-fe0f-200d-2640-fe0f",
          x: 39,
          y: 7
        },
        v: [
          {
            u: "1f575-1f3fb-200d-2640-fe0f",
            x: 40,
            y: 7
          },
          {
            u: "1f575-1f3fc-200d-2640-fe0f",
            x: 41,
            y: 7
          },
          {
            u: "1f575-1f3fd-200d-2640-fe0f",
            x: 42,
            y: 7
          },
          {
            u: "1f575-1f3fe-200d-2640-fe0f",
            x: 43,
            y: 7
          },
          {
            u: "1f575-1f3ff-200d-2640-fe0f",
            x: 44,
            y: 7
          }
        ]
      },
      {
        n: [
          "guardsman"
        ],
        u: {
          u: "1f482",
          x: 45,
          y: 7
        },
        v: [
          {
            u: "1f482-1f3fb",
            x: 46,
            y: 7
          },
          {
            u: "1f482-1f3fc",
            x: 47,
            y: 7
          },
          {
            u: "1f482-1f3fd",
            x: 48,
            y: 7
          },
          {
            u: "1f482-1f3fe",
            x: 49,
            y: 7
          },
          {
            u: "1f482-1f3ff",
            x: 0,
            y: 8
          }
        ]
      },
      {
        n: [
          "male-guard"
        ],
        u: {
          u: "1f482-200d-2642-fe0f",
          x: 1,
          y: 8
        },
        v: [
          {
            u: "1f482-1f3fb-200d-2642-fe0f",
            x: 2,
            y: 8
          },
          {
            u: "1f482-1f3fc-200d-2642-fe0f",
            x: 3,
            y: 8
          },
          {
            u: "1f482-1f3fd-200d-2642-fe0f",
            x: 4,
            y: 8
          },
          {
            u: "1f482-1f3fe-200d-2642-fe0f",
            x: 5,
            y: 8
          },
          {
            u: "1f482-1f3ff-200d-2642-fe0f",
            x: 6,
            y: 8
          }
        ]
      },
      {
        n: [
          "female-guard"
        ],
        u: {
          u: "1f482-200d-2640-fe0f",
          x: 7,
          y: 8
        },
        v: [
          {
            u: "1f482-1f3fb-200d-2640-fe0f",
            x: 8,
            y: 8
          },
          {
            u: "1f482-1f3fc-200d-2640-fe0f",
            x: 9,
            y: 8
          },
          {
            u: "1f482-1f3fd-200d-2640-fe0f",
            x: 10,
            y: 8
          },
          {
            u: "1f482-1f3fe-200d-2640-fe0f",
            x: 11,
            y: 8
          },
          {
            u: "1f482-1f3ff-200d-2640-fe0f",
            x: 12,
            y: 8
          }
        ]
      },
      {
        n: [
          "construction worker",
          "construction_worker"
        ],
        u: {
          u: "1f477",
          x: 13,
          y: 8
        },
        v: [
          {
            u: "1f477-1f3fb",
            x: 14,
            y: 8
          },
          {
            u: "1f477-1f3fc",
            x: 15,
            y: 8
          },
          {
            u: "1f477-1f3fd",
            x: 16,
            y: 8
          },
          {
            u: "1f477-1f3fe",
            x: 17,
            y: 8
          },
          {
            u: "1f477-1f3ff",
            x: 18,
            y: 8
          }
        ]
      },
      {
        n: [
          "male-construction-worker"
        ],
        u: {
          u: "1f477-200d-2642-fe0f",
          x: 19,
          y: 8
        },
        v: [
          {
            u: "1f477-1f3fb-200d-2642-fe0f",
            x: 20,
            y: 8
          },
          {
            u: "1f477-1f3fc-200d-2642-fe0f",
            x: 21,
            y: 8
          },
          {
            u: "1f477-1f3fd-200d-2642-fe0f",
            x: 22,
            y: 8
          },
          {
            u: "1f477-1f3fe-200d-2642-fe0f",
            x: 23,
            y: 8
          },
          {
            u: "1f477-1f3ff-200d-2642-fe0f",
            x: 24,
            y: 8
          }
        ]
      },
      {
        n: [
          "female-construction-worker"
        ],
        u: {
          u: "1f477-200d-2640-fe0f",
          x: 25,
          y: 8
        },
        v: [
          {
            u: "1f477-1f3fb-200d-2640-fe0f",
            x: 26,
            y: 8
          },
          {
            u: "1f477-1f3fc-200d-2640-fe0f",
            x: 27,
            y: 8
          },
          {
            u: "1f477-1f3fd-200d-2640-fe0f",
            x: 28,
            y: 8
          },
          {
            u: "1f477-1f3fe-200d-2640-fe0f",
            x: 29,
            y: 8
          },
          {
            u: "1f477-1f3ff-200d-2640-fe0f",
            x: 30,
            y: 8
          }
        ]
      },
      {
        n: [
          "prince"
        ],
        u: {
          u: "1f934",
          x: 31,
          y: 8
        },
        v: [
          {
            u: "1f934-1f3fb",
            x: 32,
            y: 8
          },
          {
            u: "1f934-1f3fc",
            x: 33,
            y: 8
          },
          {
            u: "1f934-1f3fd",
            x: 34,
            y: 8
          },
          {
            u: "1f934-1f3fe",
            x: 35,
            y: 8
          },
          {
            u: "1f934-1f3ff",
            x: 36,
            y: 8
          }
        ]
      },
      {
        n: [
          "princess"
        ],
        u: {
          u: "1f478",
          x: 37,
          y: 8
        },
        v: [
          {
            u: "1f478-1f3fb",
            x: 38,
            y: 8
          },
          {
            u: "1f478-1f3fc",
            x: 39,
            y: 8
          },
          {
            u: "1f478-1f3fd",
            x: 40,
            y: 8
          },
          {
            u: "1f478-1f3fe",
            x: 41,
            y: 8
          },
          {
            u: "1f478-1f3ff",
            x: 42,
            y: 8
          }
        ]
      },
      {
        n: [
          "man with turban",
          "man_with_turban"
        ],
        u: {
          u: "1f473",
          x: 43,
          y: 8
        },
        v: [
          {
            u: "1f473-1f3fb",
            x: 44,
            y: 8
          },
          {
            u: "1f473-1f3fc",
            x: 45,
            y: 8
          },
          {
            u: "1f473-1f3fd",
            x: 46,
            y: 8
          },
          {
            u: "1f473-1f3fe",
            x: 47,
            y: 8
          },
          {
            u: "1f473-1f3ff",
            x: 48,
            y: 8
          }
        ]
      },
      {
        n: [
          "man-wearing-turban"
        ],
        u: {
          u: "1f473-200d-2642-fe0f",
          x: 49,
          y: 8
        },
        v: [
          {
            u: "1f473-1f3fb-200d-2642-fe0f",
            x: 0,
            y: 9
          },
          {
            u: "1f473-1f3fc-200d-2642-fe0f",
            x: 1,
            y: 9
          },
          {
            u: "1f473-1f3fd-200d-2642-fe0f",
            x: 2,
            y: 9
          },
          {
            u: "1f473-1f3fe-200d-2642-fe0f",
            x: 3,
            y: 9
          },
          {
            u: "1f473-1f3ff-200d-2642-fe0f",
            x: 4,
            y: 9
          }
        ]
      },
      {
        n: [
          "woman-wearing-turban"
        ],
        u: {
          u: "1f473-200d-2640-fe0f",
          x: 5,
          y: 9
        },
        v: [
          {
            u: "1f473-1f3fb-200d-2640-fe0f",
            x: 6,
            y: 9
          },
          {
            u: "1f473-1f3fc-200d-2640-fe0f",
            x: 7,
            y: 9
          },
          {
            u: "1f473-1f3fd-200d-2640-fe0f",
            x: 8,
            y: 9
          },
          {
            u: "1f473-1f3fe-200d-2640-fe0f",
            x: 9,
            y: 9
          },
          {
            u: "1f473-1f3ff-200d-2640-fe0f",
            x: 10,
            y: 9
          }
        ]
      },
      {
        n: [
          "man with gua pi mao",
          "man_with_gua_pi_mao"
        ],
        u: {
          u: "1f472",
          x: 11,
          y: 9
        },
        v: [
          {
            u: "1f472-1f3fb",
            x: 12,
            y: 9
          },
          {
            u: "1f472-1f3fc",
            x: 13,
            y: 9
          },
          {
            u: "1f472-1f3fd",
            x: 14,
            y: 9
          },
          {
            u: "1f472-1f3fe",
            x: 15,
            y: 9
          },
          {
            u: "1f472-1f3ff",
            x: 16,
            y: 9
          }
        ]
      },
      {
        n: [
          "person with headscarf",
          "person_with_headscarf"
        ],
        u: {
          u: "1f9d5",
          x: 17,
          y: 9
        },
        v: [
          {
            u: "1f9d5-1f3fb",
            x: 18,
            y: 9
          },
          {
            u: "1f9d5-1f3fc",
            x: 19,
            y: 9
          },
          {
            u: "1f9d5-1f3fd",
            x: 20,
            y: 9
          },
          {
            u: "1f9d5-1f3fe",
            x: 21,
            y: 9
          },
          {
            u: "1f9d5-1f3ff",
            x: 22,
            y: 9
          }
        ]
      },
      {
        n: [
          "bearded person",
          "bearded_person"
        ],
        u: {
          u: "1f9d4",
          x: 23,
          y: 9
        },
        v: [
          {
            u: "1f9d4-1f3fb",
            x: 24,
            y: 9
          },
          {
            u: "1f9d4-1f3fc",
            x: 25,
            y: 9
          },
          {
            u: "1f9d4-1f3fd",
            x: 26,
            y: 9
          },
          {
            u: "1f9d4-1f3fe",
            x: 27,
            y: 9
          },
          {
            u: "1f9d4-1f3ff",
            x: 28,
            y: 9
          }
        ]
      },
      {
        n: [
          "person with blond hair",
          "person_with_blond_hair"
        ],
        u: {
          u: "1f471",
          x: 29,
          y: 9
        },
        v: [
          {
            u: "1f471-1f3fb",
            x: 30,
            y: 9
          },
          {
            u: "1f471-1f3fc",
            x: 31,
            y: 9
          },
          {
            u: "1f471-1f3fd",
            x: 32,
            y: 9
          },
          {
            u: "1f471-1f3fe",
            x: 33,
            y: 9
          },
          {
            u: "1f471-1f3ff",
            x: 34,
            y: 9
          }
        ]
      },
      {
        n: [
          "blond-haired-man"
        ],
        u: {
          u: "1f471-200d-2642-fe0f",
          x: 35,
          y: 9
        },
        v: [
          {
            u: "1f471-1f3fb-200d-2642-fe0f",
            x: 36,
            y: 9
          },
          {
            u: "1f471-1f3fc-200d-2642-fe0f",
            x: 37,
            y: 9
          },
          {
            u: "1f471-1f3fd-200d-2642-fe0f",
            x: 38,
            y: 9
          },
          {
            u: "1f471-1f3fe-200d-2642-fe0f",
            x: 39,
            y: 9
          },
          {
            u: "1f471-1f3ff-200d-2642-fe0f",
            x: 40,
            y: 9
          }
        ]
      },
      {
        n: [
          "blond-haired-woman"
        ],
        u: {
          u: "1f471-200d-2640-fe0f",
          x: 41,
          y: 9
        },
        v: [
          {
            u: "1f471-1f3fb-200d-2640-fe0f",
            x: 42,
            y: 9
          },
          {
            u: "1f471-1f3fc-200d-2640-fe0f",
            x: 43,
            y: 9
          },
          {
            u: "1f471-1f3fd-200d-2640-fe0f",
            x: 44,
            y: 9
          },
          {
            u: "1f471-1f3fe-200d-2640-fe0f",
            x: 45,
            y: 9
          },
          {
            u: "1f471-1f3ff-200d-2640-fe0f",
            x: 46,
            y: 9
          }
        ]
      },
      {
        n: [
          "man in tuxedo",
          "man_in_tuxedo"
        ],
        u: {
          u: "1f935",
          x: 47,
          y: 9
        },
        v: [
          {
            u: "1f935-1f3fb",
            x: 48,
            y: 9
          },
          {
            u: "1f935-1f3fc",
            x: 49,
            y: 9
          },
          {
            u: "1f935-1f3fd",
            x: 0,
            y: 10
          },
          {
            u: "1f935-1f3fe",
            x: 1,
            y: 10
          },
          {
            u: "1f935-1f3ff",
            x: 2,
            y: 10
          }
        ]
      },
      {
        n: [
          "bride with veil",
          "bride_with_veil"
        ],
        u: {
          u: "1f470",
          x: 3,
          y: 10
        },
        v: [
          {
            u: "1f470-1f3fb",
            x: 4,
            y: 10
          },
          {
            u: "1f470-1f3fc",
            x: 5,
            y: 10
          },
          {
            u: "1f470-1f3fd",
            x: 6,
            y: 10
          },
          {
            u: "1f470-1f3fe",
            x: 7,
            y: 10
          },
          {
            u: "1f470-1f3ff",
            x: 8,
            y: 10
          }
        ]
      },
      {
        n: [
          "pregnant woman",
          "pregnant_woman"
        ],
        u: {
          u: "1f930",
          x: 9,
          y: 10
        },
        v: [
          {
            u: "1f930-1f3fb",
            x: 10,
            y: 10
          },
          {
            u: "1f930-1f3fc",
            x: 11,
            y: 10
          },
          {
            u: "1f930-1f3fd",
            x: 12,
            y: 10
          },
          {
            u: "1f930-1f3fe",
            x: 13,
            y: 10
          },
          {
            u: "1f930-1f3ff",
            x: 14,
            y: 10
          }
        ]
      },
      {
        n: [
          "breast-feeding"
        ],
        u: {
          u: "1f931",
          x: 15,
          y: 10
        },
        v: [
          {
            u: "1f931-1f3fb",
            x: 16,
            y: 10
          },
          {
            u: "1f931-1f3fc",
            x: 17,
            y: 10
          },
          {
            u: "1f931-1f3fd",
            x: 18,
            y: 10
          },
          {
            u: "1f931-1f3fe",
            x: 19,
            y: 10
          },
          {
            u: "1f931-1f3ff",
            x: 20,
            y: 10
          }
        ]
      },
      {
        n: [
          "baby angel",
          "angel"
        ],
        u: {
          u: "1f47c",
          x: 21,
          y: 10
        },
        v: [
          {
            u: "1f47c-1f3fb",
            x: 22,
            y: 10
          },
          {
            u: "1f47c-1f3fc",
            x: 23,
            y: 10
          },
          {
            u: "1f47c-1f3fd",
            x: 24,
            y: 10
          },
          {
            u: "1f47c-1f3fe",
            x: 25,
            y: 10
          },
          {
            u: "1f47c-1f3ff",
            x: 26,
            y: 10
          }
        ]
      },
      {
        n: [
          "father christmas",
          "santa"
        ],
        u: {
          u: "1f385",
          x: 27,
          y: 10
        },
        v: [
          {
            u: "1f385-1f3fb",
            x: 28,
            y: 10
          },
          {
            u: "1f385-1f3fc",
            x: 29,
            y: 10
          },
          {
            u: "1f385-1f3fd",
            x: 30,
            y: 10
          },
          {
            u: "1f385-1f3fe",
            x: 31,
            y: 10
          },
          {
            u: "1f385-1f3ff",
            x: 32,
            y: 10
          }
        ]
      },
      {
        n: [
          "mother christmas",
          "mrs_claus",
          "mother_christmas"
        ],
        u: {
          u: "1f936",
          x: 33,
          y: 10
        },
        v: [
          {
            u: "1f936-1f3fb",
            x: 34,
            y: 10
          },
          {
            u: "1f936-1f3fc",
            x: 35,
            y: 10
          },
          {
            u: "1f936-1f3fd",
            x: 36,
            y: 10
          },
          {
            u: "1f936-1f3fe",
            x: 37,
            y: 10
          },
          {
            u: "1f936-1f3ff",
            x: 38,
            y: 10
          }
        ]
      },
      {
        n: [
          "mage"
        ],
        u: {
          u: "1f9d9",
          x: 39,
          y: 10
        },
        v: [
          {
            u: "1f9d9-1f3fb",
            x: 40,
            y: 10
          },
          {
            u: "1f9d9-1f3fc",
            x: 41,
            y: 10
          },
          {
            u: "1f9d9-1f3fd",
            x: 42,
            y: 10
          },
          {
            u: "1f9d9-1f3fe",
            x: 43,
            y: 10
          },
          {
            u: "1f9d9-1f3ff",
            x: 44,
            y: 10
          }
        ]
      },
      {
        n: [
          "female_mage"
        ],
        u: {
          u: "1f9d9-200d-2640-fe0f",
          x: 45,
          y: 10
        },
        v: [
          {
            u: "1f9d9-1f3fb-200d-2640-fe0f",
            x: 46,
            y: 10
          },
          {
            u: "1f9d9-1f3fc-200d-2640-fe0f",
            x: 47,
            y: 10
          },
          {
            u: "1f9d9-1f3fd-200d-2640-fe0f",
            x: 48,
            y: 10
          },
          {
            u: "1f9d9-1f3fe-200d-2640-fe0f",
            x: 49,
            y: 10
          },
          {
            u: "1f9d9-1f3ff-200d-2640-fe0f",
            x: 0,
            y: 11
          }
        ]
      },
      {
        n: [
          "male_mage"
        ],
        u: {
          u: "1f9d9-200d-2642-fe0f",
          x: 1,
          y: 11
        },
        v: [
          {
            u: "1f9d9-1f3fb-200d-2642-fe0f",
            x: 2,
            y: 11
          },
          {
            u: "1f9d9-1f3fc-200d-2642-fe0f",
            x: 3,
            y: 11
          },
          {
            u: "1f9d9-1f3fd-200d-2642-fe0f",
            x: 4,
            y: 11
          },
          {
            u: "1f9d9-1f3fe-200d-2642-fe0f",
            x: 5,
            y: 11
          },
          {
            u: "1f9d9-1f3ff-200d-2642-fe0f",
            x: 6,
            y: 11
          }
        ]
      },
      {
        n: [
          "fairy"
        ],
        u: {
          u: "1f9da",
          x: 7,
          y: 11
        },
        v: [
          {
            u: "1f9da-1f3fb",
            x: 8,
            y: 11
          },
          {
            u: "1f9da-1f3fc",
            x: 9,
            y: 11
          },
          {
            u: "1f9da-1f3fd",
            x: 10,
            y: 11
          },
          {
            u: "1f9da-1f3fe",
            x: 11,
            y: 11
          },
          {
            u: "1f9da-1f3ff",
            x: 12,
            y: 11
          }
        ]
      },
      {
        n: [
          "female_fairy"
        ],
        u: {
          u: "1f9da-200d-2640-fe0f",
          x: 13,
          y: 11
        },
        v: [
          {
            u: "1f9da-1f3fb-200d-2640-fe0f",
            x: 14,
            y: 11
          },
          {
            u: "1f9da-1f3fc-200d-2640-fe0f",
            x: 15,
            y: 11
          },
          {
            u: "1f9da-1f3fd-200d-2640-fe0f",
            x: 16,
            y: 11
          },
          {
            u: "1f9da-1f3fe-200d-2640-fe0f",
            x: 17,
            y: 11
          },
          {
            u: "1f9da-1f3ff-200d-2640-fe0f",
            x: 18,
            y: 11
          }
        ]
      },
      {
        n: [
          "male_fairy"
        ],
        u: {
          u: "1f9da-200d-2642-fe0f",
          x: 19,
          y: 11
        },
        v: [
          {
            u: "1f9da-1f3fb-200d-2642-fe0f",
            x: 20,
            y: 11
          },
          {
            u: "1f9da-1f3fc-200d-2642-fe0f",
            x: 21,
            y: 11
          },
          {
            u: "1f9da-1f3fd-200d-2642-fe0f",
            x: 22,
            y: 11
          },
          {
            u: "1f9da-1f3fe-200d-2642-fe0f",
            x: 23,
            y: 11
          },
          {
            u: "1f9da-1f3ff-200d-2642-fe0f",
            x: 24,
            y: 11
          }
        ]
      },
      {
        n: [
          "vampire"
        ],
        u: {
          u: "1f9db",
          x: 25,
          y: 11
        },
        v: [
          {
            u: "1f9db-1f3fb",
            x: 26,
            y: 11
          },
          {
            u: "1f9db-1f3fc",
            x: 27,
            y: 11
          },
          {
            u: "1f9db-1f3fd",
            x: 28,
            y: 11
          },
          {
            u: "1f9db-1f3fe",
            x: 29,
            y: 11
          },
          {
            u: "1f9db-1f3ff",
            x: 30,
            y: 11
          }
        ]
      },
      {
        n: [
          "female_vampire"
        ],
        u: {
          u: "1f9db-200d-2640-fe0f",
          x: 31,
          y: 11
        },
        v: [
          {
            u: "1f9db-1f3fb-200d-2640-fe0f",
            x: 32,
            y: 11
          },
          {
            u: "1f9db-1f3fc-200d-2640-fe0f",
            x: 33,
            y: 11
          },
          {
            u: "1f9db-1f3fd-200d-2640-fe0f",
            x: 34,
            y: 11
          },
          {
            u: "1f9db-1f3fe-200d-2640-fe0f",
            x: 35,
            y: 11
          },
          {
            u: "1f9db-1f3ff-200d-2640-fe0f",
            x: 36,
            y: 11
          }
        ]
      },
      {
        n: [
          "male_vampire"
        ],
        u: {
          u: "1f9db-200d-2642-fe0f",
          x: 37,
          y: 11
        },
        v: [
          {
            u: "1f9db-1f3fb-200d-2642-fe0f",
            x: 38,
            y: 11
          },
          {
            u: "1f9db-1f3fc-200d-2642-fe0f",
            x: 39,
            y: 11
          },
          {
            u: "1f9db-1f3fd-200d-2642-fe0f",
            x: 40,
            y: 11
          },
          {
            u: "1f9db-1f3fe-200d-2642-fe0f",
            x: 41,
            y: 11
          },
          {
            u: "1f9db-1f3ff-200d-2642-fe0f",
            x: 42,
            y: 11
          }
        ]
      },
      {
        n: [
          "merperson"
        ],
        u: {
          u: "1f9dc",
          x: 43,
          y: 11
        },
        v: [
          {
            u: "1f9dc-1f3fb",
            x: 44,
            y: 11
          },
          {
            u: "1f9dc-1f3fc",
            x: 45,
            y: 11
          },
          {
            u: "1f9dc-1f3fd",
            x: 46,
            y: 11
          },
          {
            u: "1f9dc-1f3fe",
            x: 47,
            y: 11
          },
          {
            u: "1f9dc-1f3ff",
            x: 48,
            y: 11
          }
        ]
      },
      {
        n: [
          "mermaid"
        ],
        u: {
          u: "1f9dc-200d-2640-fe0f",
          x: 49,
          y: 11
        },
        v: [
          {
            u: "1f9dc-1f3fb-200d-2640-fe0f",
            x: 0,
            y: 12
          },
          {
            u: "1f9dc-1f3fc-200d-2640-fe0f",
            x: 1,
            y: 12
          },
          {
            u: "1f9dc-1f3fd-200d-2640-fe0f",
            x: 2,
            y: 12
          },
          {
            u: "1f9dc-1f3fe-200d-2640-fe0f",
            x: 3,
            y: 12
          },
          {
            u: "1f9dc-1f3ff-200d-2640-fe0f",
            x: 4,
            y: 12
          }
        ]
      },
      {
        n: [
          "merman"
        ],
        u: {
          u: "1f9dc-200d-2642-fe0f",
          x: 5,
          y: 12
        },
        v: [
          {
            u: "1f9dc-1f3fb-200d-2642-fe0f",
            x: 6,
            y: 12
          },
          {
            u: "1f9dc-1f3fc-200d-2642-fe0f",
            x: 7,
            y: 12
          },
          {
            u: "1f9dc-1f3fd-200d-2642-fe0f",
            x: 8,
            y: 12
          },
          {
            u: "1f9dc-1f3fe-200d-2642-fe0f",
            x: 9,
            y: 12
          },
          {
            u: "1f9dc-1f3ff-200d-2642-fe0f",
            x: 10,
            y: 12
          }
        ]
      },
      {
        n: [
          "elf"
        ],
        u: {
          u: "1f9dd",
          x: 11,
          y: 12
        },
        v: [
          {
            u: "1f9dd-1f3fb",
            x: 12,
            y: 12
          },
          {
            u: "1f9dd-1f3fc",
            x: 13,
            y: 12
          },
          {
            u: "1f9dd-1f3fd",
            x: 14,
            y: 12
          },
          {
            u: "1f9dd-1f3fe",
            x: 15,
            y: 12
          },
          {
            u: "1f9dd-1f3ff",
            x: 16,
            y: 12
          }
        ]
      },
      {
        n: [
          "female_elf"
        ],
        u: {
          u: "1f9dd-200d-2640-fe0f",
          x: 17,
          y: 12
        },
        v: [
          {
            u: "1f9dd-1f3fb-200d-2640-fe0f",
            x: 18,
            y: 12
          },
          {
            u: "1f9dd-1f3fc-200d-2640-fe0f",
            x: 19,
            y: 12
          },
          {
            u: "1f9dd-1f3fd-200d-2640-fe0f",
            x: 20,
            y: 12
          },
          {
            u: "1f9dd-1f3fe-200d-2640-fe0f",
            x: 21,
            y: 12
          },
          {
            u: "1f9dd-1f3ff-200d-2640-fe0f",
            x: 22,
            y: 12
          }
        ]
      },
      {
        n: [
          "male_elf"
        ],
        u: {
          u: "1f9dd-200d-2642-fe0f",
          x: 23,
          y: 12
        },
        v: [
          {
            u: "1f9dd-1f3fb-200d-2642-fe0f",
            x: 24,
            y: 12
          },
          {
            u: "1f9dd-1f3fc-200d-2642-fe0f",
            x: 25,
            y: 12
          },
          {
            u: "1f9dd-1f3fd-200d-2642-fe0f",
            x: 26,
            y: 12
          },
          {
            u: "1f9dd-1f3fe-200d-2642-fe0f",
            x: 27,
            y: 12
          },
          {
            u: "1f9dd-1f3ff-200d-2642-fe0f",
            x: 28,
            y: 12
          }
        ]
      },
      {
        n: [
          "genie"
        ],
        u: {
          u: "1f9de",
          x: 29,
          y: 12
        }
      },
      {
        n: [
          "female_genie"
        ],
        u: {
          u: "1f9de-200d-2640-fe0f",
          x: 30,
          y: 12
        }
      },
      {
        n: [
          "male_genie"
        ],
        u: {
          u: "1f9de-200d-2642-fe0f",
          x: 31,
          y: 12
        }
      },
      {
        n: [
          "zombie"
        ],
        u: {
          u: "1f9df",
          x: 32,
          y: 12
        }
      },
      {
        n: [
          "female_zombie"
        ],
        u: {
          u: "1f9df-200d-2640-fe0f",
          x: 33,
          y: 12
        }
      },
      {
        n: [
          "male_zombie"
        ],
        u: {
          u: "1f9df-200d-2642-fe0f",
          x: 34,
          y: 12
        }
      },
      {
        n: [
          "person frowning",
          "person_frowning"
        ],
        u: {
          u: "1f64d",
          x: 35,
          y: 12
        },
        v: [
          {
            u: "1f64d-1f3fb",
            x: 36,
            y: 12
          },
          {
            u: "1f64d-1f3fc",
            x: 37,
            y: 12
          },
          {
            u: "1f64d-1f3fd",
            x: 38,
            y: 12
          },
          {
            u: "1f64d-1f3fe",
            x: 39,
            y: 12
          },
          {
            u: "1f64d-1f3ff",
            x: 40,
            y: 12
          }
        ]
      },
      {
        n: [
          "man-frowning"
        ],
        u: {
          u: "1f64d-200d-2642-fe0f",
          x: 41,
          y: 12
        },
        v: [
          {
            u: "1f64d-1f3fb-200d-2642-fe0f",
            x: 42,
            y: 12
          },
          {
            u: "1f64d-1f3fc-200d-2642-fe0f",
            x: 43,
            y: 12
          },
          {
            u: "1f64d-1f3fd-200d-2642-fe0f",
            x: 44,
            y: 12
          },
          {
            u: "1f64d-1f3fe-200d-2642-fe0f",
            x: 45,
            y: 12
          },
          {
            u: "1f64d-1f3ff-200d-2642-fe0f",
            x: 46,
            y: 12
          }
        ]
      },
      {
        n: [
          "woman-frowning"
        ],
        u: {
          u: "1f64d-200d-2640-fe0f",
          x: 47,
          y: 12
        },
        v: [
          {
            u: "1f64d-1f3fb-200d-2640-fe0f",
            x: 48,
            y: 12
          },
          {
            u: "1f64d-1f3fc-200d-2640-fe0f",
            x: 49,
            y: 12
          },
          {
            u: "1f64d-1f3fd-200d-2640-fe0f",
            x: 0,
            y: 13
          },
          {
            u: "1f64d-1f3fe-200d-2640-fe0f",
            x: 1,
            y: 13
          },
          {
            u: "1f64d-1f3ff-200d-2640-fe0f",
            x: 2,
            y: 13
          }
        ]
      },
      {
        n: [
          "person with pouting face",
          "person_with_pouting_face"
        ],
        u: {
          u: "1f64e",
          x: 3,
          y: 13
        },
        v: [
          {
            u: "1f64e-1f3fb",
            x: 4,
            y: 13
          },
          {
            u: "1f64e-1f3fc",
            x: 5,
            y: 13
          },
          {
            u: "1f64e-1f3fd",
            x: 6,
            y: 13
          },
          {
            u: "1f64e-1f3fe",
            x: 7,
            y: 13
          },
          {
            u: "1f64e-1f3ff",
            x: 8,
            y: 13
          }
        ]
      },
      {
        n: [
          "man-pouting"
        ],
        u: {
          u: "1f64e-200d-2642-fe0f",
          x: 9,
          y: 13
        },
        v: [
          {
            u: "1f64e-1f3fb-200d-2642-fe0f",
            x: 10,
            y: 13
          },
          {
            u: "1f64e-1f3fc-200d-2642-fe0f",
            x: 11,
            y: 13
          },
          {
            u: "1f64e-1f3fd-200d-2642-fe0f",
            x: 12,
            y: 13
          },
          {
            u: "1f64e-1f3fe-200d-2642-fe0f",
            x: 13,
            y: 13
          },
          {
            u: "1f64e-1f3ff-200d-2642-fe0f",
            x: 14,
            y: 13
          }
        ]
      },
      {
        n: [
          "woman-pouting"
        ],
        u: {
          u: "1f64e-200d-2640-fe0f",
          x: 15,
          y: 13
        },
        v: [
          {
            u: "1f64e-1f3fb-200d-2640-fe0f",
            x: 16,
            y: 13
          },
          {
            u: "1f64e-1f3fc-200d-2640-fe0f",
            x: 17,
            y: 13
          },
          {
            u: "1f64e-1f3fd-200d-2640-fe0f",
            x: 18,
            y: 13
          },
          {
            u: "1f64e-1f3fe-200d-2640-fe0f",
            x: 19,
            y: 13
          },
          {
            u: "1f64e-1f3ff-200d-2640-fe0f",
            x: 20,
            y: 13
          }
        ]
      },
      {
        n: [
          "face with no good gesture",
          "no_good"
        ],
        u: {
          u: "1f645",
          x: 21,
          y: 13
        },
        v: [
          {
            u: "1f645-1f3fb",
            x: 22,
            y: 13
          },
          {
            u: "1f645-1f3fc",
            x: 23,
            y: 13
          },
          {
            u: "1f645-1f3fd",
            x: 24,
            y: 13
          },
          {
            u: "1f645-1f3fe",
            x: 25,
            y: 13
          },
          {
            u: "1f645-1f3ff",
            x: 26,
            y: 13
          }
        ]
      },
      {
        n: [
          "man-gesturing-no"
        ],
        u: {
          u: "1f645-200d-2642-fe0f",
          x: 27,
          y: 13
        },
        v: [
          {
            u: "1f645-1f3fb-200d-2642-fe0f",
            x: 28,
            y: 13
          },
          {
            u: "1f645-1f3fc-200d-2642-fe0f",
            x: 29,
            y: 13
          },
          {
            u: "1f645-1f3fd-200d-2642-fe0f",
            x: 30,
            y: 13
          },
          {
            u: "1f645-1f3fe-200d-2642-fe0f",
            x: 31,
            y: 13
          },
          {
            u: "1f645-1f3ff-200d-2642-fe0f",
            x: 32,
            y: 13
          }
        ]
      },
      {
        n: [
          "woman-gesturing-no"
        ],
        u: {
          u: "1f645-200d-2640-fe0f",
          x: 33,
          y: 13
        },
        v: [
          {
            u: "1f645-1f3fb-200d-2640-fe0f",
            x: 34,
            y: 13
          },
          {
            u: "1f645-1f3fc-200d-2640-fe0f",
            x: 35,
            y: 13
          },
          {
            u: "1f645-1f3fd-200d-2640-fe0f",
            x: 36,
            y: 13
          },
          {
            u: "1f645-1f3fe-200d-2640-fe0f",
            x: 37,
            y: 13
          },
          {
            u: "1f645-1f3ff-200d-2640-fe0f",
            x: 38,
            y: 13
          }
        ]
      },
      {
        n: [
          "face with ok gesture",
          "ok_woman"
        ],
        u: {
          u: "1f646",
          x: 39,
          y: 13
        },
        v: [
          {
            u: "1f646-1f3fb",
            x: 40,
            y: 13
          },
          {
            u: "1f646-1f3fc",
            x: 41,
            y: 13
          },
          {
            u: "1f646-1f3fd",
            x: 42,
            y: 13
          },
          {
            u: "1f646-1f3fe",
            x: 43,
            y: 13
          },
          {
            u: "1f646-1f3ff",
            x: 44,
            y: 13
          }
        ]
      },
      {
        n: [
          "man-gesturing-ok"
        ],
        u: {
          u: "1f646-200d-2642-fe0f",
          x: 45,
          y: 13
        },
        v: [
          {
            u: "1f646-1f3fb-200d-2642-fe0f",
            x: 46,
            y: 13
          },
          {
            u: "1f646-1f3fc-200d-2642-fe0f",
            x: 47,
            y: 13
          },
          {
            u: "1f646-1f3fd-200d-2642-fe0f",
            x: 48,
            y: 13
          },
          {
            u: "1f646-1f3fe-200d-2642-fe0f",
            x: 49,
            y: 13
          },
          {
            u: "1f646-1f3ff-200d-2642-fe0f",
            x: 0,
            y: 14
          }
        ]
      },
      {
        n: [
          "woman-gesturing-ok"
        ],
        u: {
          u: "1f646-200d-2640-fe0f",
          x: 1,
          y: 14
        },
        v: [
          {
            u: "1f646-1f3fb-200d-2640-fe0f",
            x: 2,
            y: 14
          },
          {
            u: "1f646-1f3fc-200d-2640-fe0f",
            x: 3,
            y: 14
          },
          {
            u: "1f646-1f3fd-200d-2640-fe0f",
            x: 4,
            y: 14
          },
          {
            u: "1f646-1f3fe-200d-2640-fe0f",
            x: 5,
            y: 14
          },
          {
            u: "1f646-1f3ff-200d-2640-fe0f",
            x: 6,
            y: 14
          }
        ]
      },
      {
        n: [
          "information desk person",
          "information_desk_person"
        ],
        u: {
          u: "1f481",
          x: 7,
          y: 14
        },
        v: [
          {
            u: "1f481-1f3fb",
            x: 8,
            y: 14
          },
          {
            u: "1f481-1f3fc",
            x: 9,
            y: 14
          },
          {
            u: "1f481-1f3fd",
            x: 10,
            y: 14
          },
          {
            u: "1f481-1f3fe",
            x: 11,
            y: 14
          },
          {
            u: "1f481-1f3ff",
            x: 12,
            y: 14
          }
        ]
      },
      {
        n: [
          "man-tipping-hand"
        ],
        u: {
          u: "1f481-200d-2642-fe0f",
          x: 13,
          y: 14
        },
        v: [
          {
            u: "1f481-1f3fb-200d-2642-fe0f",
            x: 14,
            y: 14
          },
          {
            u: "1f481-1f3fc-200d-2642-fe0f",
            x: 15,
            y: 14
          },
          {
            u: "1f481-1f3fd-200d-2642-fe0f",
            x: 16,
            y: 14
          },
          {
            u: "1f481-1f3fe-200d-2642-fe0f",
            x: 17,
            y: 14
          },
          {
            u: "1f481-1f3ff-200d-2642-fe0f",
            x: 18,
            y: 14
          }
        ]
      },
      {
        n: [
          "woman-tipping-hand"
        ],
        u: {
          u: "1f481-200d-2640-fe0f",
          x: 19,
          y: 14
        },
        v: [
          {
            u: "1f481-1f3fb-200d-2640-fe0f",
            x: 20,
            y: 14
          },
          {
            u: "1f481-1f3fc-200d-2640-fe0f",
            x: 21,
            y: 14
          },
          {
            u: "1f481-1f3fd-200d-2640-fe0f",
            x: 22,
            y: 14
          },
          {
            u: "1f481-1f3fe-200d-2640-fe0f",
            x: 23,
            y: 14
          },
          {
            u: "1f481-1f3ff-200d-2640-fe0f",
            x: 24,
            y: 14
          }
        ]
      },
      {
        n: [
          "happy person raising one hand",
          "raising_hand"
        ],
        u: {
          u: "1f64b",
          x: 25,
          y: 14
        },
        v: [
          {
            u: "1f64b-1f3fb",
            x: 26,
            y: 14
          },
          {
            u: "1f64b-1f3fc",
            x: 27,
            y: 14
          },
          {
            u: "1f64b-1f3fd",
            x: 28,
            y: 14
          },
          {
            u: "1f64b-1f3fe",
            x: 29,
            y: 14
          },
          {
            u: "1f64b-1f3ff",
            x: 30,
            y: 14
          }
        ]
      },
      {
        n: [
          "man-raising-hand"
        ],
        u: {
          u: "1f64b-200d-2642-fe0f",
          x: 31,
          y: 14
        },
        v: [
          {
            u: "1f64b-1f3fb-200d-2642-fe0f",
            x: 32,
            y: 14
          },
          {
            u: "1f64b-1f3fc-200d-2642-fe0f",
            x: 33,
            y: 14
          },
          {
            u: "1f64b-1f3fd-200d-2642-fe0f",
            x: 34,
            y: 14
          },
          {
            u: "1f64b-1f3fe-200d-2642-fe0f",
            x: 35,
            y: 14
          },
          {
            u: "1f64b-1f3ff-200d-2642-fe0f",
            x: 36,
            y: 14
          }
        ]
      },
      {
        n: [
          "woman-raising-hand"
        ],
        u: {
          u: "1f64b-200d-2640-fe0f",
          x: 37,
          y: 14
        },
        v: [
          {
            u: "1f64b-1f3fb-200d-2640-fe0f",
            x: 38,
            y: 14
          },
          {
            u: "1f64b-1f3fc-200d-2640-fe0f",
            x: 39,
            y: 14
          },
          {
            u: "1f64b-1f3fd-200d-2640-fe0f",
            x: 40,
            y: 14
          },
          {
            u: "1f64b-1f3fe-200d-2640-fe0f",
            x: 41,
            y: 14
          },
          {
            u: "1f64b-1f3ff-200d-2640-fe0f",
            x: 42,
            y: 14
          }
        ]
      },
      {
        n: [
          "person bowing deeply",
          "bow"
        ],
        u: {
          u: "1f647",
          x: 43,
          y: 14
        },
        v: [
          {
            u: "1f647-1f3fb",
            x: 44,
            y: 14
          },
          {
            u: "1f647-1f3fc",
            x: 45,
            y: 14
          },
          {
            u: "1f647-1f3fd",
            x: 46,
            y: 14
          },
          {
            u: "1f647-1f3fe",
            x: 47,
            y: 14
          },
          {
            u: "1f647-1f3ff",
            x: 48,
            y: 14
          }
        ]
      },
      {
        n: [
          "man-bowing"
        ],
        u: {
          u: "1f647-200d-2642-fe0f",
          x: 49,
          y: 14
        },
        v: [
          {
            u: "1f647-1f3fb-200d-2642-fe0f",
            x: 0,
            y: 15
          },
          {
            u: "1f647-1f3fc-200d-2642-fe0f",
            x: 1,
            y: 15
          },
          {
            u: "1f647-1f3fd-200d-2642-fe0f",
            x: 2,
            y: 15
          },
          {
            u: "1f647-1f3fe-200d-2642-fe0f",
            x: 3,
            y: 15
          },
          {
            u: "1f647-1f3ff-200d-2642-fe0f",
            x: 4,
            y: 15
          }
        ]
      },
      {
        n: [
          "woman-bowing"
        ],
        u: {
          u: "1f647-200d-2640-fe0f",
          x: 5,
          y: 15
        },
        v: [
          {
            u: "1f647-1f3fb-200d-2640-fe0f",
            x: 6,
            y: 15
          },
          {
            u: "1f647-1f3fc-200d-2640-fe0f",
            x: 7,
            y: 15
          },
          {
            u: "1f647-1f3fd-200d-2640-fe0f",
            x: 8,
            y: 15
          },
          {
            u: "1f647-1f3fe-200d-2640-fe0f",
            x: 9,
            y: 15
          },
          {
            u: "1f647-1f3ff-200d-2640-fe0f",
            x: 10,
            y: 15
          }
        ]
      },
      {
        n: [
          "face palm",
          "face_palm"
        ],
        u: {
          u: "1f926",
          x: 11,
          y: 15
        },
        v: [
          {
            u: "1f926-1f3fb",
            x: 12,
            y: 15
          },
          {
            u: "1f926-1f3fc",
            x: 13,
            y: 15
          },
          {
            u: "1f926-1f3fd",
            x: 14,
            y: 15
          },
          {
            u: "1f926-1f3fe",
            x: 15,
            y: 15
          },
          {
            u: "1f926-1f3ff",
            x: 16,
            y: 15
          }
        ]
      },
      {
        n: [
          "man-facepalming"
        ],
        u: {
          u: "1f926-200d-2642-fe0f",
          x: 17,
          y: 15
        },
        v: [
          {
            u: "1f926-1f3fb-200d-2642-fe0f",
            x: 18,
            y: 15
          },
          {
            u: "1f926-1f3fc-200d-2642-fe0f",
            x: 19,
            y: 15
          },
          {
            u: "1f926-1f3fd-200d-2642-fe0f",
            x: 20,
            y: 15
          },
          {
            u: "1f926-1f3fe-200d-2642-fe0f",
            x: 21,
            y: 15
          },
          {
            u: "1f926-1f3ff-200d-2642-fe0f",
            x: 22,
            y: 15
          }
        ]
      },
      {
        n: [
          "woman-facepalming"
        ],
        u: {
          u: "1f926-200d-2640-fe0f",
          x: 23,
          y: 15
        },
        v: [
          {
            u: "1f926-1f3fb-200d-2640-fe0f",
            x: 24,
            y: 15
          },
          {
            u: "1f926-1f3fc-200d-2640-fe0f",
            x: 25,
            y: 15
          },
          {
            u: "1f926-1f3fd-200d-2640-fe0f",
            x: 26,
            y: 15
          },
          {
            u: "1f926-1f3fe-200d-2640-fe0f",
            x: 27,
            y: 15
          },
          {
            u: "1f926-1f3ff-200d-2640-fe0f",
            x: 28,
            y: 15
          }
        ]
      },
      {
        n: [
          "shrug"
        ],
        u: {
          u: "1f937",
          x: 29,
          y: 15
        },
        v: [
          {
            u: "1f937-1f3fb",
            x: 30,
            y: 15
          },
          {
            u: "1f937-1f3fc",
            x: 31,
            y: 15
          },
          {
            u: "1f937-1f3fd",
            x: 32,
            y: 15
          },
          {
            u: "1f937-1f3fe",
            x: 33,
            y: 15
          },
          {
            u: "1f937-1f3ff",
            x: 34,
            y: 15
          }
        ]
      },
      {
        n: [
          "man-shrugging"
        ],
        u: {
          u: "1f937-200d-2642-fe0f",
          x: 35,
          y: 15
        },
        v: [
          {
            u: "1f937-1f3fb-200d-2642-fe0f",
            x: 36,
            y: 15
          },
          {
            u: "1f937-1f3fc-200d-2642-fe0f",
            x: 37,
            y: 15
          },
          {
            u: "1f937-1f3fd-200d-2642-fe0f",
            x: 38,
            y: 15
          },
          {
            u: "1f937-1f3fe-200d-2642-fe0f",
            x: 39,
            y: 15
          },
          {
            u: "1f937-1f3ff-200d-2642-fe0f",
            x: 40,
            y: 15
          }
        ]
      },
      {
        n: [
          "woman-shrugging"
        ],
        u: {
          u: "1f937-200d-2640-fe0f",
          x: 41,
          y: 15
        },
        v: [
          {
            u: "1f937-1f3fb-200d-2640-fe0f",
            x: 42,
            y: 15
          },
          {
            u: "1f937-1f3fc-200d-2640-fe0f",
            x: 43,
            y: 15
          },
          {
            u: "1f937-1f3fd-200d-2640-fe0f",
            x: 44,
            y: 15
          },
          {
            u: "1f937-1f3fe-200d-2640-fe0f",
            x: 45,
            y: 15
          },
          {
            u: "1f937-1f3ff-200d-2640-fe0f",
            x: 46,
            y: 15
          }
        ]
      },
      {
        n: [
          "face massage",
          "massage"
        ],
        u: {
          u: "1f486",
          x: 47,
          y: 15
        },
        v: [
          {
            u: "1f486-1f3fb",
            x: 48,
            y: 15
          },
          {
            u: "1f486-1f3fc",
            x: 49,
            y: 15
          },
          {
            u: "1f486-1f3fd",
            x: 0,
            y: 16
          },
          {
            u: "1f486-1f3fe",
            x: 1,
            y: 16
          },
          {
            u: "1f486-1f3ff",
            x: 2,
            y: 16
          }
        ]
      },
      {
        n: [
          "man-getting-massage"
        ],
        u: {
          u: "1f486-200d-2642-fe0f",
          x: 3,
          y: 16
        },
        v: [
          {
            u: "1f486-1f3fb-200d-2642-fe0f",
            x: 4,
            y: 16
          },
          {
            u: "1f486-1f3fc-200d-2642-fe0f",
            x: 5,
            y: 16
          },
          {
            u: "1f486-1f3fd-200d-2642-fe0f",
            x: 6,
            y: 16
          },
          {
            u: "1f486-1f3fe-200d-2642-fe0f",
            x: 7,
            y: 16
          },
          {
            u: "1f486-1f3ff-200d-2642-fe0f",
            x: 8,
            y: 16
          }
        ]
      },
      {
        n: [
          "woman-getting-massage"
        ],
        u: {
          u: "1f486-200d-2640-fe0f",
          x: 9,
          y: 16
        },
        v: [
          {
            u: "1f486-1f3fb-200d-2640-fe0f",
            x: 10,
            y: 16
          },
          {
            u: "1f486-1f3fc-200d-2640-fe0f",
            x: 11,
            y: 16
          },
          {
            u: "1f486-1f3fd-200d-2640-fe0f",
            x: 12,
            y: 16
          },
          {
            u: "1f486-1f3fe-200d-2640-fe0f",
            x: 13,
            y: 16
          },
          {
            u: "1f486-1f3ff-200d-2640-fe0f",
            x: 14,
            y: 16
          }
        ]
      },
      {
        n: [
          "haircut"
        ],
        u: {
          u: "1f487",
          x: 15,
          y: 16
        },
        v: [
          {
            u: "1f487-1f3fb",
            x: 16,
            y: 16
          },
          {
            u: "1f487-1f3fc",
            x: 17,
            y: 16
          },
          {
            u: "1f487-1f3fd",
            x: 18,
            y: 16
          },
          {
            u: "1f487-1f3fe",
            x: 19,
            y: 16
          },
          {
            u: "1f487-1f3ff",
            x: 20,
            y: 16
          }
        ]
      },
      {
        n: [
          "man-getting-haircut"
        ],
        u: {
          u: "1f487-200d-2642-fe0f",
          x: 21,
          y: 16
        },
        v: [
          {
            u: "1f487-1f3fb-200d-2642-fe0f",
            x: 22,
            y: 16
          },
          {
            u: "1f487-1f3fc-200d-2642-fe0f",
            x: 23,
            y: 16
          },
          {
            u: "1f487-1f3fd-200d-2642-fe0f",
            x: 24,
            y: 16
          },
          {
            u: "1f487-1f3fe-200d-2642-fe0f",
            x: 25,
            y: 16
          },
          {
            u: "1f487-1f3ff-200d-2642-fe0f",
            x: 26,
            y: 16
          }
        ]
      },
      {
        n: [
          "woman-getting-haircut"
        ],
        u: {
          u: "1f487-200d-2640-fe0f",
          x: 27,
          y: 16
        },
        v: [
          {
            u: "1f487-1f3fb-200d-2640-fe0f",
            x: 28,
            y: 16
          },
          {
            u: "1f487-1f3fc-200d-2640-fe0f",
            x: 29,
            y: 16
          },
          {
            u: "1f487-1f3fd-200d-2640-fe0f",
            x: 30,
            y: 16
          },
          {
            u: "1f487-1f3fe-200d-2640-fe0f",
            x: 31,
            y: 16
          },
          {
            u: "1f487-1f3ff-200d-2640-fe0f",
            x: 32,
            y: 16
          }
        ]
      },
      {
        n: [
          "pedestrian",
          "walking"
        ],
        u: {
          u: "1f6b6",
          x: 33,
          y: 16
        },
        v: [
          {
            u: "1f6b6-1f3fb",
            x: 34,
            y: 16
          },
          {
            u: "1f6b6-1f3fc",
            x: 35,
            y: 16
          },
          {
            u: "1f6b6-1f3fd",
            x: 36,
            y: 16
          },
          {
            u: "1f6b6-1f3fe",
            x: 37,
            y: 16
          },
          {
            u: "1f6b6-1f3ff",
            x: 38,
            y: 16
          }
        ]
      },
      {
        n: [
          "man-walking"
        ],
        u: {
          u: "1f6b6-200d-2642-fe0f",
          x: 39,
          y: 16
        },
        v: [
          {
            u: "1f6b6-1f3fb-200d-2642-fe0f",
            x: 40,
            y: 16
          },
          {
            u: "1f6b6-1f3fc-200d-2642-fe0f",
            x: 41,
            y: 16
          },
          {
            u: "1f6b6-1f3fd-200d-2642-fe0f",
            x: 42,
            y: 16
          },
          {
            u: "1f6b6-1f3fe-200d-2642-fe0f",
            x: 43,
            y: 16
          },
          {
            u: "1f6b6-1f3ff-200d-2642-fe0f",
            x: 44,
            y: 16
          }
        ]
      },
      {
        n: [
          "woman-walking"
        ],
        u: {
          u: "1f6b6-200d-2640-fe0f",
          x: 45,
          y: 16
        },
        v: [
          {
            u: "1f6b6-1f3fb-200d-2640-fe0f",
            x: 46,
            y: 16
          },
          {
            u: "1f6b6-1f3fc-200d-2640-fe0f",
            x: 47,
            y: 16
          },
          {
            u: "1f6b6-1f3fd-200d-2640-fe0f",
            x: 48,
            y: 16
          },
          {
            u: "1f6b6-1f3fe-200d-2640-fe0f",
            x: 49,
            y: 16
          },
          {
            u: "1f6b6-1f3ff-200d-2640-fe0f",
            x: 0,
            y: 17
          }
        ]
      },
      {
        n: [
          "runner",
          "running"
        ],
        u: {
          u: "1f3c3",
          x: 1,
          y: 17
        },
        v: [
          {
            u: "1f3c3-1f3fb",
            x: 2,
            y: 17
          },
          {
            u: "1f3c3-1f3fc",
            x: 3,
            y: 17
          },
          {
            u: "1f3c3-1f3fd",
            x: 4,
            y: 17
          },
          {
            u: "1f3c3-1f3fe",
            x: 5,
            y: 17
          },
          {
            u: "1f3c3-1f3ff",
            x: 6,
            y: 17
          }
        ]
      },
      {
        n: [
          "man-running"
        ],
        u: {
          u: "1f3c3-200d-2642-fe0f",
          x: 7,
          y: 17
        },
        v: [
          {
            u: "1f3c3-1f3fb-200d-2642-fe0f",
            x: 8,
            y: 17
          },
          {
            u: "1f3c3-1f3fc-200d-2642-fe0f",
            x: 9,
            y: 17
          },
          {
            u: "1f3c3-1f3fd-200d-2642-fe0f",
            x: 10,
            y: 17
          },
          {
            u: "1f3c3-1f3fe-200d-2642-fe0f",
            x: 11,
            y: 17
          },
          {
            u: "1f3c3-1f3ff-200d-2642-fe0f",
            x: 12,
            y: 17
          }
        ]
      },
      {
        n: [
          "woman-running"
        ],
        u: {
          u: "1f3c3-200d-2640-fe0f",
          x: 13,
          y: 17
        },
        v: [
          {
            u: "1f3c3-1f3fb-200d-2640-fe0f",
            x: 14,
            y: 17
          },
          {
            u: "1f3c3-1f3fc-200d-2640-fe0f",
            x: 15,
            y: 17
          },
          {
            u: "1f3c3-1f3fd-200d-2640-fe0f",
            x: 16,
            y: 17
          },
          {
            u: "1f3c3-1f3fe-200d-2640-fe0f",
            x: 17,
            y: 17
          },
          {
            u: "1f3c3-1f3ff-200d-2640-fe0f",
            x: 18,
            y: 17
          }
        ]
      },
      {
        n: [
          "dancer"
        ],
        u: {
          u: "1f483",
          x: 19,
          y: 17
        },
        v: [
          {
            u: "1f483-1f3fb",
            x: 20,
            y: 17
          },
          {
            u: "1f483-1f3fc",
            x: 21,
            y: 17
          },
          {
            u: "1f483-1f3fd",
            x: 22,
            y: 17
          },
          {
            u: "1f483-1f3fe",
            x: 23,
            y: 17
          },
          {
            u: "1f483-1f3ff",
            x: 24,
            y: 17
          }
        ]
      },
      {
        n: [
          "man dancing",
          "man_dancing"
        ],
        u: {
          u: "1f57a",
          x: 25,
          y: 17
        },
        v: [
          {
            u: "1f57a-1f3fb",
            x: 26,
            y: 17
          },
          {
            u: "1f57a-1f3fc",
            x: 27,
            y: 17
          },
          {
            u: "1f57a-1f3fd",
            x: 28,
            y: 17
          },
          {
            u: "1f57a-1f3fe",
            x: 29,
            y: 17
          },
          {
            u: "1f57a-1f3ff",
            x: 30,
            y: 17
          }
        ]
      },
      {
        n: [
          "woman with bunny ears",
          "dancers"
        ],
        u: {
          u: "1f46f",
          x: 31,
          y: 17
        }
      },
      {
        n: [
          "man-with-bunny-ears-partying"
        ],
        u: {
          u: "1f46f-200d-2642-fe0f",
          x: 32,
          y: 17
        }
      },
      {
        n: [
          "woman-with-bunny-ears-partying"
        ],
        u: {
          u: "1f46f-200d-2640-fe0f",
          x: 33,
          y: 17
        }
      },
      {
        n: [
          "person in steamy room",
          "person_in_steamy_room"
        ],
        u: {
          u: "1f9d6",
          x: 34,
          y: 17
        },
        v: [
          {
            u: "1f9d6-1f3fb",
            x: 35,
            y: 17
          },
          {
            u: "1f9d6-1f3fc",
            x: 36,
            y: 17
          },
          {
            u: "1f9d6-1f3fd",
            x: 37,
            y: 17
          },
          {
            u: "1f9d6-1f3fe",
            x: 38,
            y: 17
          },
          {
            u: "1f9d6-1f3ff",
            x: 39,
            y: 17
          }
        ]
      },
      {
        n: [
          "woman_in_steamy_room"
        ],
        u: {
          u: "1f9d6-200d-2640-fe0f",
          x: 40,
          y: 17
        },
        v: [
          {
            u: "1f9d6-1f3fb-200d-2640-fe0f",
            x: 41,
            y: 17
          },
          {
            u: "1f9d6-1f3fc-200d-2640-fe0f",
            x: 42,
            y: 17
          },
          {
            u: "1f9d6-1f3fd-200d-2640-fe0f",
            x: 43,
            y: 17
          },
          {
            u: "1f9d6-1f3fe-200d-2640-fe0f",
            x: 44,
            y: 17
          },
          {
            u: "1f9d6-1f3ff-200d-2640-fe0f",
            x: 45,
            y: 17
          }
        ]
      },
      {
        n: [
          "man_in_steamy_room"
        ],
        u: {
          u: "1f9d6-200d-2642-fe0f",
          x: 46,
          y: 17
        },
        v: [
          {
            u: "1f9d6-1f3fb-200d-2642-fe0f",
            x: 47,
            y: 17
          },
          {
            u: "1f9d6-1f3fc-200d-2642-fe0f",
            x: 48,
            y: 17
          },
          {
            u: "1f9d6-1f3fd-200d-2642-fe0f",
            x: 49,
            y: 17
          },
          {
            u: "1f9d6-1f3fe-200d-2642-fe0f",
            x: 0,
            y: 18
          },
          {
            u: "1f9d6-1f3ff-200d-2642-fe0f",
            x: 1,
            y: 18
          }
        ]
      },
      {
        n: [
          "person climbing",
          "person_climbing"
        ],
        u: {
          u: "1f9d7",
          x: 2,
          y: 18
        },
        v: [
          {
            u: "1f9d7-1f3fb",
            x: 3,
            y: 18
          },
          {
            u: "1f9d7-1f3fc",
            x: 4,
            y: 18
          },
          {
            u: "1f9d7-1f3fd",
            x: 5,
            y: 18
          },
          {
            u: "1f9d7-1f3fe",
            x: 6,
            y: 18
          },
          {
            u: "1f9d7-1f3ff",
            x: 7,
            y: 18
          }
        ]
      },
      {
        n: [
          "woman_climbing"
        ],
        u: {
          u: "1f9d7-200d-2640-fe0f",
          x: 8,
          y: 18
        },
        v: [
          {
            u: "1f9d7-1f3fb-200d-2640-fe0f",
            x: 9,
            y: 18
          },
          {
            u: "1f9d7-1f3fc-200d-2640-fe0f",
            x: 10,
            y: 18
          },
          {
            u: "1f9d7-1f3fd-200d-2640-fe0f",
            x: 11,
            y: 18
          },
          {
            u: "1f9d7-1f3fe-200d-2640-fe0f",
            x: 12,
            y: 18
          },
          {
            u: "1f9d7-1f3ff-200d-2640-fe0f",
            x: 13,
            y: 18
          }
        ]
      },
      {
        n: [
          "man_climbing"
        ],
        u: {
          u: "1f9d7-200d-2642-fe0f",
          x: 14,
          y: 18
        },
        v: [
          {
            u: "1f9d7-1f3fb-200d-2642-fe0f",
            x: 15,
            y: 18
          },
          {
            u: "1f9d7-1f3fc-200d-2642-fe0f",
            x: 16,
            y: 18
          },
          {
            u: "1f9d7-1f3fd-200d-2642-fe0f",
            x: 17,
            y: 18
          },
          {
            u: "1f9d7-1f3fe-200d-2642-fe0f",
            x: 18,
            y: 18
          },
          {
            u: "1f9d7-1f3ff-200d-2642-fe0f",
            x: 19,
            y: 18
          }
        ]
      },
      {
        n: [
          "person in lotus position",
          "person_in_lotus_position"
        ],
        u: {
          u: "1f9d8",
          x: 20,
          y: 18
        },
        v: [
          {
            u: "1f9d8-1f3fb",
            x: 21,
            y: 18
          },
          {
            u: "1f9d8-1f3fc",
            x: 22,
            y: 18
          },
          {
            u: "1f9d8-1f3fd",
            x: 23,
            y: 18
          },
          {
            u: "1f9d8-1f3fe",
            x: 24,
            y: 18
          },
          {
            u: "1f9d8-1f3ff",
            x: 25,
            y: 18
          }
        ]
      },
      {
        n: [
          "woman_in_lotus_position"
        ],
        u: {
          u: "1f9d8-200d-2640-fe0f",
          x: 26,
          y: 18
        },
        v: [
          {
            u: "1f9d8-1f3fb-200d-2640-fe0f",
            x: 27,
            y: 18
          },
          {
            u: "1f9d8-1f3fc-200d-2640-fe0f",
            x: 28,
            y: 18
          },
          {
            u: "1f9d8-1f3fd-200d-2640-fe0f",
            x: 29,
            y: 18
          },
          {
            u: "1f9d8-1f3fe-200d-2640-fe0f",
            x: 30,
            y: 18
          },
          {
            u: "1f9d8-1f3ff-200d-2640-fe0f",
            x: 31,
            y: 18
          }
        ]
      },
      {
        n: [
          "man_in_lotus_position"
        ],
        u: {
          u: "1f9d8-200d-2642-fe0f",
          x: 32,
          y: 18
        },
        v: [
          {
            u: "1f9d8-1f3fb-200d-2642-fe0f",
            x: 33,
            y: 18
          },
          {
            u: "1f9d8-1f3fc-200d-2642-fe0f",
            x: 34,
            y: 18
          },
          {
            u: "1f9d8-1f3fd-200d-2642-fe0f",
            x: 35,
            y: 18
          },
          {
            u: "1f9d8-1f3fe-200d-2642-fe0f",
            x: 36,
            y: 18
          },
          {
            u: "1f9d8-1f3ff-200d-2642-fe0f",
            x: 37,
            y: 18
          }
        ]
      },
      {
        n: [
          "bath"
        ],
        u: {
          u: "1f6c0",
          x: 38,
          y: 18
        },
        v: [
          {
            u: "1f6c0-1f3fb",
            x: 39,
            y: 18
          },
          {
            u: "1f6c0-1f3fc",
            x: 40,
            y: 18
          },
          {
            u: "1f6c0-1f3fd",
            x: 41,
            y: 18
          },
          {
            u: "1f6c0-1f3fe",
            x: 42,
            y: 18
          },
          {
            u: "1f6c0-1f3ff",
            x: 43,
            y: 18
          }
        ]
      },
      {
        n: [
          "sleeping accommodation",
          "sleeping_accommodation"
        ],
        u: {
          u: "1f6cc",
          x: 44,
          y: 18
        },
        v: [
          {
            u: "1f6cc-1f3fb",
            x: 45,
            y: 18
          },
          {
            u: "1f6cc-1f3fc",
            x: 46,
            y: 18
          },
          {
            u: "1f6cc-1f3fd",
            x: 47,
            y: 18
          },
          {
            u: "1f6cc-1f3fe",
            x: 48,
            y: 18
          },
          {
            u: "1f6cc-1f3ff",
            x: 49,
            y: 18
          }
        ]
      },
      {
        n: [
          "man_in_business_suit_levitating"
        ],
        u: {
          u: "1f574",
          x: 0,
          y: 19
        },
        v: [
          {
            u: "1f574-1f3fb",
            x: 1,
            y: 19
          },
          {
            u: "1f574-1f3fc",
            x: 2,
            y: 19
          },
          {
            u: "1f574-1f3fd",
            x: 3,
            y: 19
          },
          {
            u: "1f574-1f3fe",
            x: 4,
            y: 19
          },
          {
            u: "1f574-1f3ff",
            x: 5,
            y: 19
          }
        ]
      },
      {
        n: [
          "speaking_head_in_silhouette"
        ],
        u: {
          u: "1f5e3",
          x: 6,
          y: 19
        }
      },
      {
        n: [
          "bust in silhouette",
          "bust_in_silhouette"
        ],
        u: {
          u: "1f464",
          x: 7,
          y: 19
        }
      },
      {
        n: [
          "busts in silhouette",
          "busts_in_silhouette"
        ],
        u: {
          u: "1f465",
          x: 8,
          y: 19
        }
      },
      {
        n: [
          "fencer"
        ],
        u: {
          u: "1f93a",
          x: 9,
          y: 19
        }
      },
      {
        n: [
          "horse racing",
          "horse_racing"
        ],
        u: {
          u: "1f3c7",
          x: 10,
          y: 19
        },
        v: [
          {
            u: "1f3c7-1f3fb",
            x: 11,
            y: 19
          },
          {
            u: "1f3c7-1f3fc",
            x: 12,
            y: 19
          },
          {
            u: "1f3c7-1f3fd",
            x: 13,
            y: 19
          },
          {
            u: "1f3c7-1f3fe",
            x: 14,
            y: 19
          },
          {
            u: "1f3c7-1f3ff",
            x: 15,
            y: 19
          }
        ]
      },
      {
        n: [
          "skier"
        ],
        u: {
          u: "26f7",
          x: 16,
          y: 19
        }
      },
      {
        n: [
          "snowboarder"
        ],
        u: {
          u: "1f3c2",
          x: 17,
          y: 19
        },
        v: [
          {
            u: "1f3c2-1f3fb",
            x: 18,
            y: 19
          },
          {
            u: "1f3c2-1f3fc",
            x: 19,
            y: 19
          },
          {
            u: "1f3c2-1f3fd",
            x: 20,
            y: 19
          },
          {
            u: "1f3c2-1f3fe",
            x: 21,
            y: 19
          },
          {
            u: "1f3c2-1f3ff",
            x: 22,
            y: 19
          }
        ]
      },
      {
        n: [
          "golfer"
        ],
        u: {
          u: "1f3cc",
          x: 23,
          y: 19
        },
        v: [
          {
            u: "1f3cc-1f3fb",
            x: 24,
            y: 19
          },
          {
            u: "1f3cc-1f3fc",
            x: 25,
            y: 19
          },
          {
            u: "1f3cc-1f3fd",
            x: 26,
            y: 19
          },
          {
            u: "1f3cc-1f3fe",
            x: 27,
            y: 19
          },
          {
            u: "1f3cc-1f3ff",
            x: 28,
            y: 19
          }
        ]
      },
      {
        n: [
          "man-golfing"
        ],
        u: {
          u: "1f3cc-fe0f-200d-2642-fe0f",
          x: 29,
          y: 19
        },
        v: [
          {
            u: "1f3cc-1f3fb-200d-2642-fe0f",
            x: 30,
            y: 19
          },
          {
            u: "1f3cc-1f3fc-200d-2642-fe0f",
            x: 31,
            y: 19
          },
          {
            u: "1f3cc-1f3fd-200d-2642-fe0f",
            x: 32,
            y: 19
          },
          {
            u: "1f3cc-1f3fe-200d-2642-fe0f",
            x: 33,
            y: 19
          },
          {
            u: "1f3cc-1f3ff-200d-2642-fe0f",
            x: 34,
            y: 19
          }
        ]
      },
      {
        n: [
          "woman-golfing"
        ],
        u: {
          u: "1f3cc-fe0f-200d-2640-fe0f",
          x: 35,
          y: 19
        },
        v: [
          {
            u: "1f3cc-1f3fb-200d-2640-fe0f",
            x: 36,
            y: 19
          },
          {
            u: "1f3cc-1f3fc-200d-2640-fe0f",
            x: 37,
            y: 19
          },
          {
            u: "1f3cc-1f3fd-200d-2640-fe0f",
            x: 38,
            y: 19
          },
          {
            u: "1f3cc-1f3fe-200d-2640-fe0f",
            x: 39,
            y: 19
          },
          {
            u: "1f3cc-1f3ff-200d-2640-fe0f",
            x: 40,
            y: 19
          }
        ]
      },
      {
        n: [
          "surfer"
        ],
        u: {
          u: "1f3c4",
          x: 41,
          y: 19
        },
        v: [
          {
            u: "1f3c4-1f3fb",
            x: 42,
            y: 19
          },
          {
            u: "1f3c4-1f3fc",
            x: 43,
            y: 19
          },
          {
            u: "1f3c4-1f3fd",
            x: 44,
            y: 19
          },
          {
            u: "1f3c4-1f3fe",
            x: 45,
            y: 19
          },
          {
            u: "1f3c4-1f3ff",
            x: 46,
            y: 19
          }
        ]
      },
      {
        n: [
          "man-surfing"
        ],
        u: {
          u: "1f3c4-200d-2642-fe0f",
          x: 47,
          y: 19
        },
        v: [
          {
            u: "1f3c4-1f3fb-200d-2642-fe0f",
            x: 48,
            y: 19
          },
          {
            u: "1f3c4-1f3fc-200d-2642-fe0f",
            x: 49,
            y: 19
          },
          {
            u: "1f3c4-1f3fd-200d-2642-fe0f",
            x: 0,
            y: 20
          },
          {
            u: "1f3c4-1f3fe-200d-2642-fe0f",
            x: 1,
            y: 20
          },
          {
            u: "1f3c4-1f3ff-200d-2642-fe0f",
            x: 2,
            y: 20
          }
        ]
      },
      {
        n: [
          "woman-surfing"
        ],
        u: {
          u: "1f3c4-200d-2640-fe0f",
          x: 3,
          y: 20
        },
        v: [
          {
            u: "1f3c4-1f3fb-200d-2640-fe0f",
            x: 4,
            y: 20
          },
          {
            u: "1f3c4-1f3fc-200d-2640-fe0f",
            x: 5,
            y: 20
          },
          {
            u: "1f3c4-1f3fd-200d-2640-fe0f",
            x: 6,
            y: 20
          },
          {
            u: "1f3c4-1f3fe-200d-2640-fe0f",
            x: 7,
            y: 20
          },
          {
            u: "1f3c4-1f3ff-200d-2640-fe0f",
            x: 8,
            y: 20
          }
        ]
      },
      {
        n: [
          "rowboat"
        ],
        u: {
          u: "1f6a3",
          x: 9,
          y: 20
        },
        v: [
          {
            u: "1f6a3-1f3fb",
            x: 10,
            y: 20
          },
          {
            u: "1f6a3-1f3fc",
            x: 11,
            y: 20
          },
          {
            u: "1f6a3-1f3fd",
            x: 12,
            y: 20
          },
          {
            u: "1f6a3-1f3fe",
            x: 13,
            y: 20
          },
          {
            u: "1f6a3-1f3ff",
            x: 14,
            y: 20
          }
        ]
      },
      {
        n: [
          "man-rowing-boat"
        ],
        u: {
          u: "1f6a3-200d-2642-fe0f",
          x: 15,
          y: 20
        },
        v: [
          {
            u: "1f6a3-1f3fb-200d-2642-fe0f",
            x: 16,
            y: 20
          },
          {
            u: "1f6a3-1f3fc-200d-2642-fe0f",
            x: 17,
            y: 20
          },
          {
            u: "1f6a3-1f3fd-200d-2642-fe0f",
            x: 18,
            y: 20
          },
          {
            u: "1f6a3-1f3fe-200d-2642-fe0f",
            x: 19,
            y: 20
          },
          {
            u: "1f6a3-1f3ff-200d-2642-fe0f",
            x: 20,
            y: 20
          }
        ]
      },
      {
        n: [
          "woman-rowing-boat"
        ],
        u: {
          u: "1f6a3-200d-2640-fe0f",
          x: 21,
          y: 20
        },
        v: [
          {
            u: "1f6a3-1f3fb-200d-2640-fe0f",
            x: 22,
            y: 20
          },
          {
            u: "1f6a3-1f3fc-200d-2640-fe0f",
            x: 23,
            y: 20
          },
          {
            u: "1f6a3-1f3fd-200d-2640-fe0f",
            x: 24,
            y: 20
          },
          {
            u: "1f6a3-1f3fe-200d-2640-fe0f",
            x: 25,
            y: 20
          },
          {
            u: "1f6a3-1f3ff-200d-2640-fe0f",
            x: 26,
            y: 20
          }
        ]
      },
      {
        n: [
          "swimmer"
        ],
        u: {
          u: "1f3ca",
          x: 27,
          y: 20
        },
        v: [
          {
            u: "1f3ca-1f3fb",
            x: 28,
            y: 20
          },
          {
            u: "1f3ca-1f3fc",
            x: 29,
            y: 20
          },
          {
            u: "1f3ca-1f3fd",
            x: 30,
            y: 20
          },
          {
            u: "1f3ca-1f3fe",
            x: 31,
            y: 20
          },
          {
            u: "1f3ca-1f3ff",
            x: 32,
            y: 20
          }
        ]
      },
      {
        n: [
          "man-swimming"
        ],
        u: {
          u: "1f3ca-200d-2642-fe0f",
          x: 33,
          y: 20
        },
        v: [
          {
            u: "1f3ca-1f3fb-200d-2642-fe0f",
            x: 34,
            y: 20
          },
          {
            u: "1f3ca-1f3fc-200d-2642-fe0f",
            x: 35,
            y: 20
          },
          {
            u: "1f3ca-1f3fd-200d-2642-fe0f",
            x: 36,
            y: 20
          },
          {
            u: "1f3ca-1f3fe-200d-2642-fe0f",
            x: 37,
            y: 20
          },
          {
            u: "1f3ca-1f3ff-200d-2642-fe0f",
            x: 38,
            y: 20
          }
        ]
      },
      {
        n: [
          "woman-swimming"
        ],
        u: {
          u: "1f3ca-200d-2640-fe0f",
          x: 39,
          y: 20
        },
        v: [
          {
            u: "1f3ca-1f3fb-200d-2640-fe0f",
            x: 40,
            y: 20
          },
          {
            u: "1f3ca-1f3fc-200d-2640-fe0f",
            x: 41,
            y: 20
          },
          {
            u: "1f3ca-1f3fd-200d-2640-fe0f",
            x: 42,
            y: 20
          },
          {
            u: "1f3ca-1f3fe-200d-2640-fe0f",
            x: 43,
            y: 20
          },
          {
            u: "1f3ca-1f3ff-200d-2640-fe0f",
            x: 44,
            y: 20
          }
        ]
      },
      {
        n: [
          "person_with_ball"
        ],
        u: {
          u: "26f9",
          x: 45,
          y: 20
        },
        v: [
          {
            u: "26f9-1f3fb",
            x: 46,
            y: 20
          },
          {
            u: "26f9-1f3fc",
            x: 47,
            y: 20
          },
          {
            u: "26f9-1f3fd",
            x: 48,
            y: 20
          },
          {
            u: "26f9-1f3fe",
            x: 49,
            y: 20
          },
          {
            u: "26f9-1f3ff",
            x: 0,
            y: 21
          }
        ]
      },
      {
        n: [
          "man-bouncing-ball"
        ],
        u: {
          u: "26f9-fe0f-200d-2642-fe0f",
          x: 1,
          y: 21
        },
        v: [
          {
            u: "26f9-1f3fb-200d-2642-fe0f",
            x: 2,
            y: 21
          },
          {
            u: "26f9-1f3fc-200d-2642-fe0f",
            x: 3,
            y: 21
          },
          {
            u: "26f9-1f3fd-200d-2642-fe0f",
            x: 4,
            y: 21
          },
          {
            u: "26f9-1f3fe-200d-2642-fe0f",
            x: 5,
            y: 21
          },
          {
            u: "26f9-1f3ff-200d-2642-fe0f",
            x: 6,
            y: 21
          }
        ]
      },
      {
        n: [
          "woman-bouncing-ball"
        ],
        u: {
          u: "26f9-fe0f-200d-2640-fe0f",
          x: 7,
          y: 21
        },
        v: [
          {
            u: "26f9-1f3fb-200d-2640-fe0f",
            x: 8,
            y: 21
          },
          {
            u: "26f9-1f3fc-200d-2640-fe0f",
            x: 9,
            y: 21
          },
          {
            u: "26f9-1f3fd-200d-2640-fe0f",
            x: 10,
            y: 21
          },
          {
            u: "26f9-1f3fe-200d-2640-fe0f",
            x: 11,
            y: 21
          },
          {
            u: "26f9-1f3ff-200d-2640-fe0f",
            x: 12,
            y: 21
          }
        ]
      },
      {
        n: [
          "weight_lifter"
        ],
        u: {
          u: "1f3cb",
          x: 13,
          y: 21
        },
        v: [
          {
            u: "1f3cb-1f3fb",
            x: 14,
            y: 21
          },
          {
            u: "1f3cb-1f3fc",
            x: 15,
            y: 21
          },
          {
            u: "1f3cb-1f3fd",
            x: 16,
            y: 21
          },
          {
            u: "1f3cb-1f3fe",
            x: 17,
            y: 21
          },
          {
            u: "1f3cb-1f3ff",
            x: 18,
            y: 21
          }
        ]
      },
      {
        n: [
          "man-lifting-weights"
        ],
        u: {
          u: "1f3cb-fe0f-200d-2642-fe0f",
          x: 19,
          y: 21
        },
        v: [
          {
            u: "1f3cb-1f3fb-200d-2642-fe0f",
            x: 20,
            y: 21
          },
          {
            u: "1f3cb-1f3fc-200d-2642-fe0f",
            x: 21,
            y: 21
          },
          {
            u: "1f3cb-1f3fd-200d-2642-fe0f",
            x: 22,
            y: 21
          },
          {
            u: "1f3cb-1f3fe-200d-2642-fe0f",
            x: 23,
            y: 21
          },
          {
            u: "1f3cb-1f3ff-200d-2642-fe0f",
            x: 24,
            y: 21
          }
        ]
      },
      {
        n: [
          "woman-lifting-weights"
        ],
        u: {
          u: "1f3cb-fe0f-200d-2640-fe0f",
          x: 25,
          y: 21
        },
        v: [
          {
            u: "1f3cb-1f3fb-200d-2640-fe0f",
            x: 26,
            y: 21
          },
          {
            u: "1f3cb-1f3fc-200d-2640-fe0f",
            x: 27,
            y: 21
          },
          {
            u: "1f3cb-1f3fd-200d-2640-fe0f",
            x: 28,
            y: 21
          },
          {
            u: "1f3cb-1f3fe-200d-2640-fe0f",
            x: 29,
            y: 21
          },
          {
            u: "1f3cb-1f3ff-200d-2640-fe0f",
            x: 30,
            y: 21
          }
        ]
      },
      {
        n: [
          "bicyclist"
        ],
        u: {
          u: "1f6b4",
          x: 31,
          y: 21
        },
        v: [
          {
            u: "1f6b4-1f3fb",
            x: 32,
            y: 21
          },
          {
            u: "1f6b4-1f3fc",
            x: 33,
            y: 21
          },
          {
            u: "1f6b4-1f3fd",
            x: 34,
            y: 21
          },
          {
            u: "1f6b4-1f3fe",
            x: 35,
            y: 21
          },
          {
            u: "1f6b4-1f3ff",
            x: 36,
            y: 21
          }
        ]
      },
      {
        n: [
          "man-biking"
        ],
        u: {
          u: "1f6b4-200d-2642-fe0f",
          x: 37,
          y: 21
        },
        v: [
          {
            u: "1f6b4-1f3fb-200d-2642-fe0f",
            x: 38,
            y: 21
          },
          {
            u: "1f6b4-1f3fc-200d-2642-fe0f",
            x: 39,
            y: 21
          },
          {
            u: "1f6b4-1f3fd-200d-2642-fe0f",
            x: 40,
            y: 21
          },
          {
            u: "1f6b4-1f3fe-200d-2642-fe0f",
            x: 41,
            y: 21
          },
          {
            u: "1f6b4-1f3ff-200d-2642-fe0f",
            x: 42,
            y: 21
          }
        ]
      },
      {
        n: [
          "woman-biking"
        ],
        u: {
          u: "1f6b4-200d-2640-fe0f",
          x: 43,
          y: 21
        },
        v: [
          {
            u: "1f6b4-1f3fb-200d-2640-fe0f",
            x: 44,
            y: 21
          },
          {
            u: "1f6b4-1f3fc-200d-2640-fe0f",
            x: 45,
            y: 21
          },
          {
            u: "1f6b4-1f3fd-200d-2640-fe0f",
            x: 46,
            y: 21
          },
          {
            u: "1f6b4-1f3fe-200d-2640-fe0f",
            x: 47,
            y: 21
          },
          {
            u: "1f6b4-1f3ff-200d-2640-fe0f",
            x: 48,
            y: 21
          }
        ]
      },
      {
        n: [
          "mountain bicyclist",
          "mountain_bicyclist"
        ],
        u: {
          u: "1f6b5",
          x: 49,
          y: 21
        },
        v: [
          {
            u: "1f6b5-1f3fb",
            x: 0,
            y: 22
          },
          {
            u: "1f6b5-1f3fc",
            x: 1,
            y: 22
          },
          {
            u: "1f6b5-1f3fd",
            x: 2,
            y: 22
          },
          {
            u: "1f6b5-1f3fe",
            x: 3,
            y: 22
          },
          {
            u: "1f6b5-1f3ff",
            x: 4,
            y: 22
          }
        ]
      },
      {
        n: [
          "man-mountain-biking"
        ],
        u: {
          u: "1f6b5-200d-2642-fe0f",
          x: 5,
          y: 22
        },
        v: [
          {
            u: "1f6b5-1f3fb-200d-2642-fe0f",
            x: 6,
            y: 22
          },
          {
            u: "1f6b5-1f3fc-200d-2642-fe0f",
            x: 7,
            y: 22
          },
          {
            u: "1f6b5-1f3fd-200d-2642-fe0f",
            x: 8,
            y: 22
          },
          {
            u: "1f6b5-1f3fe-200d-2642-fe0f",
            x: 9,
            y: 22
          },
          {
            u: "1f6b5-1f3ff-200d-2642-fe0f",
            x: 10,
            y: 22
          }
        ]
      },
      {
        n: [
          "woman-mountain-biking"
        ],
        u: {
          u: "1f6b5-200d-2640-fe0f",
          x: 11,
          y: 22
        },
        v: [
          {
            u: "1f6b5-1f3fb-200d-2640-fe0f",
            x: 12,
            y: 22
          },
          {
            u: "1f6b5-1f3fc-200d-2640-fe0f",
            x: 13,
            y: 22
          },
          {
            u: "1f6b5-1f3fd-200d-2640-fe0f",
            x: 14,
            y: 22
          },
          {
            u: "1f6b5-1f3fe-200d-2640-fe0f",
            x: 15,
            y: 22
          },
          {
            u: "1f6b5-1f3ff-200d-2640-fe0f",
            x: 16,
            y: 22
          }
        ]
      },
      {
        n: [
          "racing_car"
        ],
        u: {
          u: "1f3ce",
          x: 17,
          y: 22
        }
      },
      {
        n: [
          "racing_motorcycle"
        ],
        u: {
          u: "1f3cd",
          x: 18,
          y: 22
        }
      },
      {
        n: [
          "person doing cartwheel",
          "person_doing_cartwheel"
        ],
        u: {
          u: "1f938",
          x: 19,
          y: 22
        },
        v: [
          {
            u: "1f938-1f3fb",
            x: 20,
            y: 22
          },
          {
            u: "1f938-1f3fc",
            x: 21,
            y: 22
          },
          {
            u: "1f938-1f3fd",
            x: 22,
            y: 22
          },
          {
            u: "1f938-1f3fe",
            x: 23,
            y: 22
          },
          {
            u: "1f938-1f3ff",
            x: 24,
            y: 22
          }
        ]
      },
      {
        n: [
          "man-cartwheeling"
        ],
        u: {
          u: "1f938-200d-2642-fe0f",
          x: 25,
          y: 22
        },
        v: [
          {
            u: "1f938-1f3fb-200d-2642-fe0f",
            x: 26,
            y: 22
          },
          {
            u: "1f938-1f3fc-200d-2642-fe0f",
            x: 27,
            y: 22
          },
          {
            u: "1f938-1f3fd-200d-2642-fe0f",
            x: 28,
            y: 22
          },
          {
            u: "1f938-1f3fe-200d-2642-fe0f",
            x: 29,
            y: 22
          },
          {
            u: "1f938-1f3ff-200d-2642-fe0f",
            x: 30,
            y: 22
          }
        ]
      },
      {
        n: [
          "woman-cartwheeling"
        ],
        u: {
          u: "1f938-200d-2640-fe0f",
          x: 31,
          y: 22
        },
        v: [
          {
            u: "1f938-1f3fb-200d-2640-fe0f",
            x: 32,
            y: 22
          },
          {
            u: "1f938-1f3fc-200d-2640-fe0f",
            x: 33,
            y: 22
          },
          {
            u: "1f938-1f3fd-200d-2640-fe0f",
            x: 34,
            y: 22
          },
          {
            u: "1f938-1f3fe-200d-2640-fe0f",
            x: 35,
            y: 22
          },
          {
            u: "1f938-1f3ff-200d-2640-fe0f",
            x: 36,
            y: 22
          }
        ]
      },
      {
        n: [
          "wrestlers"
        ],
        u: {
          u: "1f93c",
          x: 37,
          y: 22
        }
      },
      {
        n: [
          "man-wrestling"
        ],
        u: {
          u: "1f93c-200d-2642-fe0f",
          x: 38,
          y: 22
        }
      },
      {
        n: [
          "woman-wrestling"
        ],
        u: {
          u: "1f93c-200d-2640-fe0f",
          x: 39,
          y: 22
        }
      },
      {
        n: [
          "water polo",
          "water_polo"
        ],
        u: {
          u: "1f93d",
          x: 40,
          y: 22
        },
        v: [
          {
            u: "1f93d-1f3fb",
            x: 41,
            y: 22
          },
          {
            u: "1f93d-1f3fc",
            x: 42,
            y: 22
          },
          {
            u: "1f93d-1f3fd",
            x: 43,
            y: 22
          },
          {
            u: "1f93d-1f3fe",
            x: 44,
            y: 22
          },
          {
            u: "1f93d-1f3ff",
            x: 45,
            y: 22
          }
        ]
      },
      {
        n: [
          "man-playing-water-polo"
        ],
        u: {
          u: "1f93d-200d-2642-fe0f",
          x: 46,
          y: 22
        },
        v: [
          {
            u: "1f93d-1f3fb-200d-2642-fe0f",
            x: 47,
            y: 22
          },
          {
            u: "1f93d-1f3fc-200d-2642-fe0f",
            x: 48,
            y: 22
          },
          {
            u: "1f93d-1f3fd-200d-2642-fe0f",
            x: 49,
            y: 22
          },
          {
            u: "1f93d-1f3fe-200d-2642-fe0f",
            x: 0,
            y: 23
          },
          {
            u: "1f93d-1f3ff-200d-2642-fe0f",
            x: 1,
            y: 23
          }
        ]
      },
      {
        n: [
          "woman-playing-water-polo"
        ],
        u: {
          u: "1f93d-200d-2640-fe0f",
          x: 2,
          y: 23
        },
        v: [
          {
            u: "1f93d-1f3fb-200d-2640-fe0f",
            x: 3,
            y: 23
          },
          {
            u: "1f93d-1f3fc-200d-2640-fe0f",
            x: 4,
            y: 23
          },
          {
            u: "1f93d-1f3fd-200d-2640-fe0f",
            x: 5,
            y: 23
          },
          {
            u: "1f93d-1f3fe-200d-2640-fe0f",
            x: 6,
            y: 23
          },
          {
            u: "1f93d-1f3ff-200d-2640-fe0f",
            x: 7,
            y: 23
          }
        ]
      },
      {
        n: [
          "handball"
        ],
        u: {
          u: "1f93e",
          x: 8,
          y: 23
        },
        v: [
          {
            u: "1f93e-1f3fb",
            x: 9,
            y: 23
          },
          {
            u: "1f93e-1f3fc",
            x: 10,
            y: 23
          },
          {
            u: "1f93e-1f3fd",
            x: 11,
            y: 23
          },
          {
            u: "1f93e-1f3fe",
            x: 12,
            y: 23
          },
          {
            u: "1f93e-1f3ff",
            x: 13,
            y: 23
          }
        ]
      },
      {
        n: [
          "man-playing-handball"
        ],
        u: {
          u: "1f93e-200d-2642-fe0f",
          x: 14,
          y: 23
        },
        v: [
          {
            u: "1f93e-1f3fb-200d-2642-fe0f",
            x: 15,
            y: 23
          },
          {
            u: "1f93e-1f3fc-200d-2642-fe0f",
            x: 16,
            y: 23
          },
          {
            u: "1f93e-1f3fd-200d-2642-fe0f",
            x: 17,
            y: 23
          },
          {
            u: "1f93e-1f3fe-200d-2642-fe0f",
            x: 18,
            y: 23
          },
          {
            u: "1f93e-1f3ff-200d-2642-fe0f",
            x: 19,
            y: 23
          }
        ]
      },
      {
        n: [
          "woman-playing-handball"
        ],
        u: {
          u: "1f93e-200d-2640-fe0f",
          x: 20,
          y: 23
        },
        v: [
          {
            u: "1f93e-1f3fb-200d-2640-fe0f",
            x: 21,
            y: 23
          },
          {
            u: "1f93e-1f3fc-200d-2640-fe0f",
            x: 22,
            y: 23
          },
          {
            u: "1f93e-1f3fd-200d-2640-fe0f",
            x: 23,
            y: 23
          },
          {
            u: "1f93e-1f3fe-200d-2640-fe0f",
            x: 24,
            y: 23
          },
          {
            u: "1f93e-1f3ff-200d-2640-fe0f",
            x: 25,
            y: 23
          }
        ]
      },
      {
        n: [
          "juggling"
        ],
        u: {
          u: "1f939",
          x: 26,
          y: 23
        },
        v: [
          {
            u: "1f939-1f3fb",
            x: 27,
            y: 23
          },
          {
            u: "1f939-1f3fc",
            x: 28,
            y: 23
          },
          {
            u: "1f939-1f3fd",
            x: 29,
            y: 23
          },
          {
            u: "1f939-1f3fe",
            x: 30,
            y: 23
          },
          {
            u: "1f939-1f3ff",
            x: 31,
            y: 23
          }
        ]
      },
      {
        n: [
          "man-juggling"
        ],
        u: {
          u: "1f939-200d-2642-fe0f",
          x: 32,
          y: 23
        },
        v: [
          {
            u: "1f939-1f3fb-200d-2642-fe0f",
            x: 33,
            y: 23
          },
          {
            u: "1f939-1f3fc-200d-2642-fe0f",
            x: 34,
            y: 23
          },
          {
            u: "1f939-1f3fd-200d-2642-fe0f",
            x: 35,
            y: 23
          },
          {
            u: "1f939-1f3fe-200d-2642-fe0f",
            x: 36,
            y: 23
          },
          {
            u: "1f939-1f3ff-200d-2642-fe0f",
            x: 37,
            y: 23
          }
        ]
      },
      {
        n: [
          "woman-juggling"
        ],
        u: {
          u: "1f939-200d-2640-fe0f",
          x: 38,
          y: 23
        },
        v: [
          {
            u: "1f939-1f3fb-200d-2640-fe0f",
            x: 39,
            y: 23
          },
          {
            u: "1f939-1f3fc-200d-2640-fe0f",
            x: 40,
            y: 23
          },
          {
            u: "1f939-1f3fd-200d-2640-fe0f",
            x: 41,
            y: 23
          },
          {
            u: "1f939-1f3fe-200d-2640-fe0f",
            x: 42,
            y: 23
          },
          {
            u: "1f939-1f3ff-200d-2640-fe0f",
            x: 43,
            y: 23
          }
        ]
      },
      {
        n: [
          "man and woman holding hands",
          "couple",
          "man_and_woman_holding_hands"
        ],
        u: {
          u: "1f46b",
          x: 44,
          y: 23
        }
      },
      {
        n: [
          "two men holding hands",
          "two_men_holding_hands"
        ],
        u: {
          u: "1f46c",
          x: 45,
          y: 23
        }
      },
      {
        n: [
          "two women holding hands",
          "two_women_holding_hands"
        ],
        u: {
          u: "1f46d",
          x: 46,
          y: 23
        }
      },
      {
        n: [
          "kiss",
          "couplekiss"
        ],
        u: {
          u: "1f48f",
          x: 47,
          y: 23
        }
      },
      {
        n: [
          "woman-kiss-man"
        ],
        u: {
          u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
          x: 48,
          y: 23
        }
      },
      {
        n: [
          "man-kiss-man"
        ],
        u: {
          u: "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
          x: 49,
          y: 23
        }
      },
      {
        n: [
          "woman-kiss-woman"
        ],
        u: {
          u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
          x: 0,
          y: 24
        }
      },
      {
        n: [
          "couple with heart",
          "couple_with_heart"
        ],
        u: {
          u: "1f491",
          x: 1,
          y: 24
        }
      },
      {
        n: [
          "woman-heart-man"
        ],
        u: {
          u: "1f469-200d-2764-fe0f-200d-1f468",
          x: 2,
          y: 24
        }
      },
      {
        n: [
          "man-heart-man"
        ],
        u: {
          u: "1f468-200d-2764-fe0f-200d-1f468",
          x: 3,
          y: 24
        }
      },
      {
        n: [
          "woman-heart-woman"
        ],
        u: {
          u: "1f469-200d-2764-fe0f-200d-1f469",
          x: 4,
          y: 24
        }
      },
      {
        n: [
          "family",
          "man-woman-boy"
        ],
        u: {
          u: "1f46a",
          x: 5,
          y: 24
        }
      },
      {
        n: [
          "man-woman-boy",
          "family"
        ],
        u: {
          u: "1f468-200d-1f469-200d-1f466",
          x: 6,
          y: 24
        }
      },
      {
        n: [
          "man-woman-girl"
        ],
        u: {
          u: "1f468-200d-1f469-200d-1f467",
          x: 7,
          y: 24
        }
      },
      {
        n: [
          "man-woman-girl-boy"
        ],
        u: {
          u: "1f468-200d-1f469-200d-1f467-200d-1f466",
          x: 8,
          y: 24
        }
      },
      {
        n: [
          "man-woman-boy-boy"
        ],
        u: {
          u: "1f468-200d-1f469-200d-1f466-200d-1f466",
          x: 9,
          y: 24
        }
      },
      {
        n: [
          "man-woman-girl-girl"
        ],
        u: {
          u: "1f468-200d-1f469-200d-1f467-200d-1f467",
          x: 10,
          y: 24
        }
      },
      {
        n: [
          "man-man-boy"
        ],
        u: {
          u: "1f468-200d-1f468-200d-1f466",
          x: 11,
          y: 24
        }
      },
      {
        n: [
          "man-man-girl"
        ],
        u: {
          u: "1f468-200d-1f468-200d-1f467",
          x: 12,
          y: 24
        }
      },
      {
        n: [
          "man-man-girl-boy"
        ],
        u: {
          u: "1f468-200d-1f468-200d-1f467-200d-1f466",
          x: 13,
          y: 24
        }
      },
      {
        n: [
          "man-man-boy-boy"
        ],
        u: {
          u: "1f468-200d-1f468-200d-1f466-200d-1f466",
          x: 14,
          y: 24
        }
      },
      {
        n: [
          "man-man-girl-girl"
        ],
        u: {
          u: "1f468-200d-1f468-200d-1f467-200d-1f467",
          x: 15,
          y: 24
        }
      },
      {
        n: [
          "woman-woman-boy"
        ],
        u: {
          u: "1f469-200d-1f469-200d-1f466",
          x: 16,
          y: 24
        }
      },
      {
        n: [
          "woman-woman-girl"
        ],
        u: {
          u: "1f469-200d-1f469-200d-1f467",
          x: 17,
          y: 24
        }
      },
      {
        n: [
          "woman-woman-girl-boy"
        ],
        u: {
          u: "1f469-200d-1f469-200d-1f467-200d-1f466",
          x: 18,
          y: 24
        }
      },
      {
        n: [
          "woman-woman-boy-boy"
        ],
        u: {
          u: "1f469-200d-1f469-200d-1f466-200d-1f466",
          x: 19,
          y: 24
        }
      },
      {
        n: [
          "woman-woman-girl-girl"
        ],
        u: {
          u: "1f469-200d-1f469-200d-1f467-200d-1f467",
          x: 20,
          y: 24
        }
      },
      {
        n: [
          "man-boy"
        ],
        u: {
          u: "1f468-200d-1f466",
          x: 21,
          y: 24
        }
      },
      {
        n: [
          "man-boy-boy"
        ],
        u: {
          u: "1f468-200d-1f466-200d-1f466",
          x: 22,
          y: 24
        }
      },
      {
        n: [
          "man-girl"
        ],
        u: {
          u: "1f468-200d-1f467",
          x: 23,
          y: 24
        }
      },
      {
        n: [
          "man-girl-boy"
        ],
        u: {
          u: "1f468-200d-1f467-200d-1f466",
          x: 24,
          y: 24
        }
      },
      {
        n: [
          "man-girl-girl"
        ],
        u: {
          u: "1f468-200d-1f467-200d-1f467",
          x: 25,
          y: 24
        }
      },
      {
        n: [
          "woman-boy"
        ],
        u: {
          u: "1f469-200d-1f466",
          x: 26,
          y: 24
        }
      },
      {
        n: [
          "woman-boy-boy"
        ],
        u: {
          u: "1f469-200d-1f466-200d-1f466",
          x: 27,
          y: 24
        }
      },
      {
        n: [
          "woman-girl"
        ],
        u: {
          u: "1f469-200d-1f467",
          x: 28,
          y: 24
        }
      },
      {
        n: [
          "woman-girl-boy"
        ],
        u: {
          u: "1f469-200d-1f467-200d-1f466",
          x: 29,
          y: 24
        }
      },
      {
        n: [
          "woman-girl-girl"
        ],
        u: {
          u: "1f469-200d-1f467-200d-1f467",
          x: 30,
          y: 24
        }
      },
      {
        n: [
          "selfie"
        ],
        u: {
          u: "1f933",
          x: 31,
          y: 24
        },
        v: [
          {
            u: "1f933-1f3fb",
            x: 32,
            y: 24
          },
          {
            u: "1f933-1f3fc",
            x: 33,
            y: 24
          },
          {
            u: "1f933-1f3fd",
            x: 34,
            y: 24
          },
          {
            u: "1f933-1f3fe",
            x: 35,
            y: 24
          },
          {
            u: "1f933-1f3ff",
            x: 36,
            y: 24
          }
        ]
      },
      {
        n: [
          "flexed biceps",
          "muscle"
        ],
        u: {
          u: "1f4aa",
          x: 37,
          y: 24
        },
        v: [
          {
            u: "1f4aa-1f3fb",
            x: 38,
            y: 24
          },
          {
            u: "1f4aa-1f3fc",
            x: 39,
            y: 24
          },
          {
            u: "1f4aa-1f3fd",
            x: 40,
            y: 24
          },
          {
            u: "1f4aa-1f3fe",
            x: 41,
            y: 24
          },
          {
            u: "1f4aa-1f3ff",
            x: 42,
            y: 24
          }
        ]
      },
      {
        n: [
          "white left pointing backhand index",
          "point_left"
        ],
        u: {
          u: "1f448",
          x: 43,
          y: 24
        },
        v: [
          {
            u: "1f448-1f3fb",
            x: 44,
            y: 24
          },
          {
            u: "1f448-1f3fc",
            x: 45,
            y: 24
          },
          {
            u: "1f448-1f3fd",
            x: 46,
            y: 24
          },
          {
            u: "1f448-1f3fe",
            x: 47,
            y: 24
          },
          {
            u: "1f448-1f3ff",
            x: 48,
            y: 24
          }
        ]
      },
      {
        n: [
          "white right pointing backhand index",
          "point_right"
        ],
        u: {
          u: "1f449",
          x: 49,
          y: 24
        },
        v: [
          {
            u: "1f449-1f3fb",
            x: 0,
            y: 25
          },
          {
            u: "1f449-1f3fc",
            x: 1,
            y: 25
          },
          {
            u: "1f449-1f3fd",
            x: 2,
            y: 25
          },
          {
            u: "1f449-1f3fe",
            x: 3,
            y: 25
          },
          {
            u: "1f449-1f3ff",
            x: 4,
            y: 25
          }
        ]
      },
      {
        n: [
          "white up pointing index",
          "point_up"
        ],
        u: {
          u: "261d",
          x: 5,
          y: 25
        },
        v: [
          {
            u: "261d-1f3fb",
            x: 6,
            y: 25
          },
          {
            u: "261d-1f3fc",
            x: 7,
            y: 25
          },
          {
            u: "261d-1f3fd",
            x: 8,
            y: 25
          },
          {
            u: "261d-1f3fe",
            x: 9,
            y: 25
          },
          {
            u: "261d-1f3ff",
            x: 10,
            y: 25
          }
        ]
      },
      {
        n: [
          "white up pointing backhand index",
          "point_up_2"
        ],
        u: {
          u: "1f446",
          x: 11,
          y: 25
        },
        v: [
          {
            u: "1f446-1f3fb",
            x: 12,
            y: 25
          },
          {
            u: "1f446-1f3fc",
            x: 13,
            y: 25
          },
          {
            u: "1f446-1f3fd",
            x: 14,
            y: 25
          },
          {
            u: "1f446-1f3fe",
            x: 15,
            y: 25
          },
          {
            u: "1f446-1f3ff",
            x: 16,
            y: 25
          }
        ]
      },
      {
        n: [
          "reversed hand with middle finger extended",
          "middle_finger",
          "reversed_hand_with_middle_finger_extended"
        ],
        u: {
          u: "1f595",
          x: 17,
          y: 25
        },
        v: [
          {
            u: "1f595-1f3fb",
            x: 18,
            y: 25
          },
          {
            u: "1f595-1f3fc",
            x: 19,
            y: 25
          },
          {
            u: "1f595-1f3fd",
            x: 20,
            y: 25
          },
          {
            u: "1f595-1f3fe",
            x: 21,
            y: 25
          },
          {
            u: "1f595-1f3ff",
            x: 22,
            y: 25
          }
        ]
      },
      {
        n: [
          "white down pointing backhand index",
          "point_down"
        ],
        u: {
          u: "1f447",
          x: 23,
          y: 25
        },
        v: [
          {
            u: "1f447-1f3fb",
            x: 24,
            y: 25
          },
          {
            u: "1f447-1f3fc",
            x: 25,
            y: 25
          },
          {
            u: "1f447-1f3fd",
            x: 26,
            y: 25
          },
          {
            u: "1f447-1f3fe",
            x: 27,
            y: 25
          },
          {
            u: "1f447-1f3ff",
            x: 28,
            y: 25
          }
        ]
      },
      {
        n: [
          "victory hand",
          "v"
        ],
        u: {
          u: "270c",
          x: 29,
          y: 25
        },
        v: [
          {
            u: "270c-1f3fb",
            x: 30,
            y: 25
          },
          {
            u: "270c-1f3fc",
            x: 31,
            y: 25
          },
          {
            u: "270c-1f3fd",
            x: 32,
            y: 25
          },
          {
            u: "270c-1f3fe",
            x: 33,
            y: 25
          },
          {
            u: "270c-1f3ff",
            x: 34,
            y: 25
          }
        ]
      },
      {
        n: [
          "hand with index and middle fingers crossed",
          "crossed_fingers",
          "hand_with_index_and_middle_fingers_crossed"
        ],
        u: {
          u: "1f91e",
          x: 35,
          y: 25
        },
        v: [
          {
            u: "1f91e-1f3fb",
            x: 36,
            y: 25
          },
          {
            u: "1f91e-1f3fc",
            x: 37,
            y: 25
          },
          {
            u: "1f91e-1f3fd",
            x: 38,
            y: 25
          },
          {
            u: "1f91e-1f3fe",
            x: 39,
            y: 25
          },
          {
            u: "1f91e-1f3ff",
            x: 40,
            y: 25
          }
        ]
      },
      {
        n: [
          "raised hand with part between middle and ring fingers",
          "spock-hand"
        ],
        u: {
          u: "1f596",
          x: 41,
          y: 25
        },
        v: [
          {
            u: "1f596-1f3fb",
            x: 42,
            y: 25
          },
          {
            u: "1f596-1f3fc",
            x: 43,
            y: 25
          },
          {
            u: "1f596-1f3fd",
            x: 44,
            y: 25
          },
          {
            u: "1f596-1f3fe",
            x: 45,
            y: 25
          },
          {
            u: "1f596-1f3ff",
            x: 46,
            y: 25
          }
        ]
      },
      {
        n: [
          "sign of the horns",
          "the_horns",
          "sign_of_the_horns"
        ],
        u: {
          u: "1f918",
          x: 47,
          y: 25
        },
        v: [
          {
            u: "1f918-1f3fb",
            x: 48,
            y: 25
          },
          {
            u: "1f918-1f3fc",
            x: 49,
            y: 25
          },
          {
            u: "1f918-1f3fd",
            x: 0,
            y: 26
          },
          {
            u: "1f918-1f3fe",
            x: 1,
            y: 26
          },
          {
            u: "1f918-1f3ff",
            x: 2,
            y: 26
          }
        ]
      },
      {
        n: [
          "call me hand",
          "call_me_hand"
        ],
        u: {
          u: "1f919",
          x: 3,
          y: 26
        },
        v: [
          {
            u: "1f919-1f3fb",
            x: 4,
            y: 26
          },
          {
            u: "1f919-1f3fc",
            x: 5,
            y: 26
          },
          {
            u: "1f919-1f3fd",
            x: 6,
            y: 26
          },
          {
            u: "1f919-1f3fe",
            x: 7,
            y: 26
          },
          {
            u: "1f919-1f3ff",
            x: 8,
            y: 26
          }
        ]
      },
      {
        n: [
          "raised_hand_with_fingers_splayed"
        ],
        u: {
          u: "1f590",
          x: 9,
          y: 26
        },
        v: [
          {
            u: "1f590-1f3fb",
            x: 10,
            y: 26
          },
          {
            u: "1f590-1f3fc",
            x: 11,
            y: 26
          },
          {
            u: "1f590-1f3fd",
            x: 12,
            y: 26
          },
          {
            u: "1f590-1f3fe",
            x: 13,
            y: 26
          },
          {
            u: "1f590-1f3ff",
            x: 14,
            y: 26
          }
        ]
      },
      {
        n: [
          "raised hand",
          "hand",
          "raised_hand"
        ],
        u: {
          u: "270b",
          x: 15,
          y: 26
        },
        v: [
          {
            u: "270b-1f3fb",
            x: 16,
            y: 26
          },
          {
            u: "270b-1f3fc",
            x: 17,
            y: 26
          },
          {
            u: "270b-1f3fd",
            x: 18,
            y: 26
          },
          {
            u: "270b-1f3fe",
            x: 19,
            y: 26
          },
          {
            u: "270b-1f3ff",
            x: 20,
            y: 26
          }
        ]
      },
      {
        n: [
          "ok hand sign",
          "ok_hand"
        ],
        u: {
          u: "1f44c",
          x: 21,
          y: 26
        },
        v: [
          {
            u: "1f44c-1f3fb",
            x: 22,
            y: 26
          },
          {
            u: "1f44c-1f3fc",
            x: 23,
            y: 26
          },
          {
            u: "1f44c-1f3fd",
            x: 24,
            y: 26
          },
          {
            u: "1f44c-1f3fe",
            x: 25,
            y: 26
          },
          {
            u: "1f44c-1f3ff",
            x: 26,
            y: 26
          }
        ]
      },
      {
        n: [
          "thumbs up sign",
          "+1",
          "thumbsup"
        ],
        u: {
          u: "1f44d",
          x: 27,
          y: 26
        },
        v: [
          {
            u: "1f44d-1f3fb",
            x: 28,
            y: 26
          },
          {
            u: "1f44d-1f3fc",
            x: 29,
            y: 26
          },
          {
            u: "1f44d-1f3fd",
            x: 30,
            y: 26
          },
          {
            u: "1f44d-1f3fe",
            x: 31,
            y: 26
          },
          {
            u: "1f44d-1f3ff",
            x: 32,
            y: 26
          }
        ]
      },
      {
        n: [
          "thumbs down sign",
          "-1",
          "thumbsdown"
        ],
        u: {
          u: "1f44e",
          x: 33,
          y: 26
        },
        v: [
          {
            u: "1f44e-1f3fb",
            x: 34,
            y: 26
          },
          {
            u: "1f44e-1f3fc",
            x: 35,
            y: 26
          },
          {
            u: "1f44e-1f3fd",
            x: 36,
            y: 26
          },
          {
            u: "1f44e-1f3fe",
            x: 37,
            y: 26
          },
          {
            u: "1f44e-1f3ff",
            x: 38,
            y: 26
          }
        ]
      },
      {
        n: [
          "raised fist",
          "fist"
        ],
        u: {
          u: "270a",
          x: 39,
          y: 26
        },
        v: [
          {
            u: "270a-1f3fb",
            x: 40,
            y: 26
          },
          {
            u: "270a-1f3fc",
            x: 41,
            y: 26
          },
          {
            u: "270a-1f3fd",
            x: 42,
            y: 26
          },
          {
            u: "270a-1f3fe",
            x: 43,
            y: 26
          },
          {
            u: "270a-1f3ff",
            x: 44,
            y: 26
          }
        ]
      },
      {
        n: [
          "fisted hand sign",
          "facepunch",
          "punch"
        ],
        u: {
          u: "1f44a",
          x: 45,
          y: 26
        },
        v: [
          {
            u: "1f44a-1f3fb",
            x: 46,
            y: 26
          },
          {
            u: "1f44a-1f3fc",
            x: 47,
            y: 26
          },
          {
            u: "1f44a-1f3fd",
            x: 48,
            y: 26
          },
          {
            u: "1f44a-1f3fe",
            x: 49,
            y: 26
          },
          {
            u: "1f44a-1f3ff",
            x: 0,
            y: 27
          }
        ]
      },
      {
        n: [
          "left-facing fist",
          "left-facing_fist"
        ],
        u: {
          u: "1f91b",
          x: 1,
          y: 27
        },
        v: [
          {
            u: "1f91b-1f3fb",
            x: 2,
            y: 27
          },
          {
            u: "1f91b-1f3fc",
            x: 3,
            y: 27
          },
          {
            u: "1f91b-1f3fd",
            x: 4,
            y: 27
          },
          {
            u: "1f91b-1f3fe",
            x: 5,
            y: 27
          },
          {
            u: "1f91b-1f3ff",
            x: 6,
            y: 27
          }
        ]
      },
      {
        n: [
          "right-facing fist",
          "right-facing_fist"
        ],
        u: {
          u: "1f91c",
          x: 7,
          y: 27
        },
        v: [
          {
            u: "1f91c-1f3fb",
            x: 8,
            y: 27
          },
          {
            u: "1f91c-1f3fc",
            x: 9,
            y: 27
          },
          {
            u: "1f91c-1f3fd",
            x: 10,
            y: 27
          },
          {
            u: "1f91c-1f3fe",
            x: 11,
            y: 27
          },
          {
            u: "1f91c-1f3ff",
            x: 12,
            y: 27
          }
        ]
      },
      {
        n: [
          "raised back of hand",
          "raised_back_of_hand"
        ],
        u: {
          u: "1f91a",
          x: 13,
          y: 27
        },
        v: [
          {
            u: "1f91a-1f3fb",
            x: 14,
            y: 27
          },
          {
            u: "1f91a-1f3fc",
            x: 15,
            y: 27
          },
          {
            u: "1f91a-1f3fd",
            x: 16,
            y: 27
          },
          {
            u: "1f91a-1f3fe",
            x: 17,
            y: 27
          },
          {
            u: "1f91a-1f3ff",
            x: 18,
            y: 27
          }
        ]
      },
      {
        n: [
          "waving hand sign",
          "wave"
        ],
        u: {
          u: "1f44b",
          x: 19,
          y: 27
        },
        v: [
          {
            u: "1f44b-1f3fb",
            x: 20,
            y: 27
          },
          {
            u: "1f44b-1f3fc",
            x: 21,
            y: 27
          },
          {
            u: "1f44b-1f3fd",
            x: 22,
            y: 27
          },
          {
            u: "1f44b-1f3fe",
            x: 23,
            y: 27
          },
          {
            u: "1f44b-1f3ff",
            x: 24,
            y: 27
          }
        ]
      },
      {
        n: [
          "i love you hand sign",
          "i_love_you_hand_sign"
        ],
        u: {
          u: "1f91f",
          x: 25,
          y: 27
        },
        v: [
          {
            u: "1f91f-1f3fb",
            x: 26,
            y: 27
          },
          {
            u: "1f91f-1f3fc",
            x: 27,
            y: 27
          },
          {
            u: "1f91f-1f3fd",
            x: 28,
            y: 27
          },
          {
            u: "1f91f-1f3fe",
            x: 29,
            y: 27
          },
          {
            u: "1f91f-1f3ff",
            x: 30,
            y: 27
          }
        ]
      },
      {
        n: [
          "writing_hand"
        ],
        u: {
          u: "270d",
          x: 31,
          y: 27
        },
        v: [
          {
            u: "270d-1f3fb",
            x: 32,
            y: 27
          },
          {
            u: "270d-1f3fc",
            x: 33,
            y: 27
          },
          {
            u: "270d-1f3fd",
            x: 34,
            y: 27
          },
          {
            u: "270d-1f3fe",
            x: 35,
            y: 27
          },
          {
            u: "270d-1f3ff",
            x: 36,
            y: 27
          }
        ]
      },
      {
        n: [
          "clapping hands sign",
          "clap"
        ],
        u: {
          u: "1f44f",
          x: 37,
          y: 27
        },
        v: [
          {
            u: "1f44f-1f3fb",
            x: 38,
            y: 27
          },
          {
            u: "1f44f-1f3fc",
            x: 39,
            y: 27
          },
          {
            u: "1f44f-1f3fd",
            x: 40,
            y: 27
          },
          {
            u: "1f44f-1f3fe",
            x: 41,
            y: 27
          },
          {
            u: "1f44f-1f3ff",
            x: 42,
            y: 27
          }
        ]
      },
      {
        n: [
          "open hands sign",
          "open_hands"
        ],
        u: {
          u: "1f450",
          x: 43,
          y: 27
        },
        v: [
          {
            u: "1f450-1f3fb",
            x: 44,
            y: 27
          },
          {
            u: "1f450-1f3fc",
            x: 45,
            y: 27
          },
          {
            u: "1f450-1f3fd",
            x: 46,
            y: 27
          },
          {
            u: "1f450-1f3fe",
            x: 47,
            y: 27
          },
          {
            u: "1f450-1f3ff",
            x: 48,
            y: 27
          }
        ]
      },
      {
        n: [
          "person raising both hands in celebration",
          "raised_hands"
        ],
        u: {
          u: "1f64c",
          x: 49,
          y: 27
        },
        v: [
          {
            u: "1f64c-1f3fb",
            x: 0,
            y: 28
          },
          {
            u: "1f64c-1f3fc",
            x: 1,
            y: 28
          },
          {
            u: "1f64c-1f3fd",
            x: 2,
            y: 28
          },
          {
            u: "1f64c-1f3fe",
            x: 3,
            y: 28
          },
          {
            u: "1f64c-1f3ff",
            x: 4,
            y: 28
          }
        ]
      },
      {
        n: [
          "palms up together",
          "palms_up_together"
        ],
        u: {
          u: "1f932",
          x: 5,
          y: 28
        },
        v: [
          {
            u: "1f932-1f3fb",
            x: 6,
            y: 28
          },
          {
            u: "1f932-1f3fc",
            x: 7,
            y: 28
          },
          {
            u: "1f932-1f3fd",
            x: 8,
            y: 28
          },
          {
            u: "1f932-1f3fe",
            x: 9,
            y: 28
          },
          {
            u: "1f932-1f3ff",
            x: 10,
            y: 28
          }
        ]
      },
      {
        n: [
          "person with folded hands",
          "pray"
        ],
        u: {
          u: "1f64f",
          x: 11,
          y: 28
        },
        v: [
          {
            u: "1f64f-1f3fb",
            x: 12,
            y: 28
          },
          {
            u: "1f64f-1f3fc",
            x: 13,
            y: 28
          },
          {
            u: "1f64f-1f3fd",
            x: 14,
            y: 28
          },
          {
            u: "1f64f-1f3fe",
            x: 15,
            y: 28
          },
          {
            u: "1f64f-1f3ff",
            x: 16,
            y: 28
          }
        ]
      },
      {
        n: [
          "handshake"
        ],
        u: {
          u: "1f91d",
          x: 17,
          y: 28
        }
      },
      {
        n: [
          "nail polish",
          "nail_care"
        ],
        u: {
          u: "1f485",
          x: 18,
          y: 28
        },
        v: [
          {
            u: "1f485-1f3fb",
            x: 19,
            y: 28
          },
          {
            u: "1f485-1f3fc",
            x: 20,
            y: 28
          },
          {
            u: "1f485-1f3fd",
            x: 21,
            y: 28
          },
          {
            u: "1f485-1f3fe",
            x: 22,
            y: 28
          },
          {
            u: "1f485-1f3ff",
            x: 23,
            y: 28
          }
        ]
      },
      {
        n: [
          "ear"
        ],
        u: {
          u: "1f442",
          x: 24,
          y: 28
        },
        v: [
          {
            u: "1f442-1f3fb",
            x: 25,
            y: 28
          },
          {
            u: "1f442-1f3fc",
            x: 26,
            y: 28
          },
          {
            u: "1f442-1f3fd",
            x: 27,
            y: 28
          },
          {
            u: "1f442-1f3fe",
            x: 28,
            y: 28
          },
          {
            u: "1f442-1f3ff",
            x: 29,
            y: 28
          }
        ]
      },
      {
        n: [
          "nose"
        ],
        u: {
          u: "1f443",
          x: 30,
          y: 28
        },
        v: [
          {
            u: "1f443-1f3fb",
            x: 31,
            y: 28
          },
          {
            u: "1f443-1f3fc",
            x: 32,
            y: 28
          },
          {
            u: "1f443-1f3fd",
            x: 33,
            y: 28
          },
          {
            u: "1f443-1f3fe",
            x: 34,
            y: 28
          },
          {
            u: "1f443-1f3ff",
            x: 35,
            y: 28
          }
        ]
      },
      {
        n: [
          "footprints"
        ],
        u: {
          u: "1f463",
          x: 36,
          y: 28
        }
      },
      {
        n: [
          "eyes"
        ],
        u: {
          u: "1f440",
          x: 37,
          y: 28
        }
      },
      {
        n: [
          "eye"
        ],
        u: {
          u: "1f441",
          x: 38,
          y: 28
        }
      },
      {
        n: [
          "eye-in-speech-bubble"
        ],
        u: {
          u: "1f441-200d-1f5e8",
          x: 39,
          y: 28
        }
      },
      {
        n: [
          "brain"
        ],
        u: {
          u: "1f9e0",
          x: 40,
          y: 28
        }
      },
      {
        n: [
          "tongue"
        ],
        u: {
          u: "1f445",
          x: 41,
          y: 28
        }
      },
      {
        n: [
          "mouth",
          "lips"
        ],
        u: {
          u: "1f444",
          x: 42,
          y: 28
        }
      },
      {
        n: [
          "kiss mark",
          "kiss"
        ],
        u: {
          u: "1f48b",
          x: 43,
          y: 28
        }
      },
      {
        n: [
          "heart with arrow",
          "cupid"
        ],
        u: {
          u: "1f498",
          x: 44,
          y: 28
        }
      },
      {
        n: [
          "heavy black heart",
          "heart"
        ],
        u: {
          u: "2764",
          x: 45,
          y: 28
        }
      },
      {
        n: [
          "beating heart",
          "heartbeat"
        ],
        u: {
          u: "1f493",
          x: 46,
          y: 28
        }
      },
      {
        n: [
          "broken heart",
          "broken_heart"
        ],
        u: {
          u: "1f494",
          x: 47,
          y: 28
        }
      },
      {
        n: [
          "two hearts",
          "two_hearts"
        ],
        u: {
          u: "1f495",
          x: 48,
          y: 28
        }
      },
      {
        n: [
          "sparkling heart",
          "sparkling_heart"
        ],
        u: {
          u: "1f496",
          x: 49,
          y: 28
        }
      },
      {
        n: [
          "growing heart",
          "heartpulse"
        ],
        u: {
          u: "1f497",
          x: 0,
          y: 29
        }
      },
      {
        n: [
          "blue heart",
          "blue_heart"
        ],
        u: {
          u: "1f499",
          x: 1,
          y: 29
        }
      },
      {
        n: [
          "green heart",
          "green_heart"
        ],
        u: {
          u: "1f49a",
          x: 2,
          y: 29
        }
      },
      {
        n: [
          "yellow heart",
          "yellow_heart"
        ],
        u: {
          u: "1f49b",
          x: 3,
          y: 29
        }
      },
      {
        n: [
          "orange heart",
          "orange_heart"
        ],
        u: {
          u: "1f9e1",
          x: 4,
          y: 29
        }
      },
      {
        n: [
          "purple heart",
          "purple_heart"
        ],
        u: {
          u: "1f49c",
          x: 5,
          y: 29
        }
      },
      {
        n: [
          "black heart",
          "black_heart"
        ],
        u: {
          u: "1f5a4",
          x: 6,
          y: 29
        }
      },
      {
        n: [
          "heart with ribbon",
          "gift_heart"
        ],
        u: {
          u: "1f49d",
          x: 7,
          y: 29
        }
      },
      {
        n: [
          "revolving hearts",
          "revolving_hearts"
        ],
        u: {
          u: "1f49e",
          x: 8,
          y: 29
        }
      },
      {
        n: [
          "heart decoration",
          "heart_decoration"
        ],
        u: {
          u: "1f49f",
          x: 9,
          y: 29
        }
      },
      {
        n: [
          "heavy_heart_exclamation_mark_ornament"
        ],
        u: {
          u: "2763",
          x: 10,
          y: 29
        }
      },
      {
        n: [
          "love letter",
          "love_letter"
        ],
        u: {
          u: "1f48c",
          x: 11,
          y: 29
        }
      },
      {
        n: [
          "sleeping symbol",
          "zzz"
        ],
        u: {
          u: "1f4a4",
          x: 12,
          y: 29
        }
      },
      {
        n: [
          "anger symbol",
          "anger"
        ],
        u: {
          u: "1f4a2",
          x: 13,
          y: 29
        }
      },
      {
        n: [
          "bomb"
        ],
        u: {
          u: "1f4a3",
          x: 14,
          y: 29
        }
      },
      {
        n: [
          "collision symbol",
          "boom",
          "collision"
        ],
        u: {
          u: "1f4a5",
          x: 15,
          y: 29
        }
      },
      {
        n: [
          "splashing sweat symbol",
          "sweat_drops"
        ],
        u: {
          u: "1f4a6",
          x: 16,
          y: 29
        }
      },
      {
        n: [
          "dash symbol",
          "dash"
        ],
        u: {
          u: "1f4a8",
          x: 17,
          y: 29
        }
      },
      {
        n: [
          "dizzy symbol",
          "dizzy"
        ],
        u: {
          u: "1f4ab",
          x: 18,
          y: 29
        }
      },
      {
        n: [
          "speech balloon",
          "speech_balloon"
        ],
        u: {
          u: "1f4ac",
          x: 19,
          y: 29
        }
      },
      {
        n: [
          "left_speech_bubble"
        ],
        u: {
          u: "1f5e8",
          x: 20,
          y: 29
        }
      },
      {
        n: [
          "right_anger_bubble"
        ],
        u: {
          u: "1f5ef",
          x: 21,
          y: 29
        }
      },
      {
        n: [
          "thought balloon",
          "thought_balloon"
        ],
        u: {
          u: "1f4ad",
          x: 22,
          y: 29
        }
      },
      {
        n: [
          "hole"
        ],
        u: {
          u: "1f573",
          x: 23,
          y: 29
        }
      },
      {
        n: [
          "eyeglasses"
        ],
        u: {
          u: "1f453",
          x: 24,
          y: 29
        }
      },
      {
        n: [
          "dark_sunglasses"
        ],
        u: {
          u: "1f576",
          x: 25,
          y: 29
        }
      },
      {
        n: [
          "necktie"
        ],
        u: {
          u: "1f454",
          x: 26,
          y: 29
        }
      },
      {
        n: [
          "t-shirt",
          "shirt",
          "tshirt"
        ],
        u: {
          u: "1f455",
          x: 27,
          y: 29
        }
      },
      {
        n: [
          "jeans"
        ],
        u: {
          u: "1f456",
          x: 28,
          y: 29
        }
      },
      {
        n: [
          "scarf"
        ],
        u: {
          u: "1f9e3",
          x: 29,
          y: 29
        }
      },
      {
        n: [
          "gloves"
        ],
        u: {
          u: "1f9e4",
          x: 30,
          y: 29
        }
      },
      {
        n: [
          "coat"
        ],
        u: {
          u: "1f9e5",
          x: 31,
          y: 29
        }
      },
      {
        n: [
          "socks"
        ],
        u: {
          u: "1f9e6",
          x: 32,
          y: 29
        }
      },
      {
        n: [
          "dress"
        ],
        u: {
          u: "1f457",
          x: 33,
          y: 29
        }
      },
      {
        n: [
          "kimono"
        ],
        u: {
          u: "1f458",
          x: 34,
          y: 29
        }
      },
      {
        n: [
          "bikini"
        ],
        u: {
          u: "1f459",
          x: 35,
          y: 29
        }
      },
      {
        n: [
          "womans clothes",
          "womans_clothes"
        ],
        u: {
          u: "1f45a",
          x: 36,
          y: 29
        }
      },
      {
        n: [
          "purse"
        ],
        u: {
          u: "1f45b",
          x: 37,
          y: 29
        }
      },
      {
        n: [
          "handbag"
        ],
        u: {
          u: "1f45c",
          x: 38,
          y: 29
        }
      },
      {
        n: [
          "pouch"
        ],
        u: {
          u: "1f45d",
          x: 39,
          y: 29
        }
      },
      {
        n: [
          "shopping_bags"
        ],
        u: {
          u: "1f6cd",
          x: 40,
          y: 29
        }
      },
      {
        n: [
          "school satchel",
          "school_satchel"
        ],
        u: {
          u: "1f392",
          x: 41,
          y: 29
        }
      },
      {
        n: [
          "mans shoe",
          "mans_shoe",
          "shoe"
        ],
        u: {
          u: "1f45e",
          x: 42,
          y: 29
        }
      },
      {
        n: [
          "athletic shoe",
          "athletic_shoe"
        ],
        u: {
          u: "1f45f",
          x: 43,
          y: 29
        }
      },
      {
        n: [
          "high-heeled shoe",
          "high_heel"
        ],
        u: {
          u: "1f460",
          x: 44,
          y: 29
        }
      },
      {
        n: [
          "womans sandal",
          "sandal"
        ],
        u: {
          u: "1f461",
          x: 45,
          y: 29
        }
      },
      {
        n: [
          "womans boots",
          "boot"
        ],
        u: {
          u: "1f462",
          x: 46,
          y: 29
        }
      },
      {
        n: [
          "crown"
        ],
        u: {
          u: "1f451",
          x: 47,
          y: 29
        }
      },
      {
        n: [
          "womans hat",
          "womans_hat"
        ],
        u: {
          u: "1f452",
          x: 48,
          y: 29
        }
      },
      {
        n: [
          "top hat",
          "tophat"
        ],
        u: {
          u: "1f3a9",
          x: 49,
          y: 29
        }
      },
      {
        n: [
          "graduation cap",
          "mortar_board"
        ],
        u: {
          u: "1f393",
          x: 0,
          y: 30
        }
      },
      {
        n: [
          "billed cap",
          "billed_cap"
        ],
        u: {
          u: "1f9e2",
          x: 1,
          y: 30
        }
      },
      {
        n: [
          "helmet_with_white_cross"
        ],
        u: {
          u: "26d1",
          x: 2,
          y: 30
        }
      },
      {
        n: [
          "prayer beads",
          "prayer_beads"
        ],
        u: {
          u: "1f4ff",
          x: 3,
          y: 30
        }
      },
      {
        n: [
          "lipstick"
        ],
        u: {
          u: "1f484",
          x: 4,
          y: 30
        }
      },
      {
        n: [
          "ring"
        ],
        u: {
          u: "1f48d",
          x: 5,
          y: 30
        }
      },
      {
        n: [
          "gem stone",
          "gem"
        ],
        u: {
          u: "1f48e",
          x: 6,
          y: 30
        }
      }
    ],
    key: "smileys_people",
    title: "Smiles & People",
    u: "1f600"
  },
  {
    emojis: [
      {
        n: [
          "monkey face",
          "monkey_face"
        ],
        u: {
          u: "1f435",
          x: 7,
          y: 30
        }
      },
      {
        n: [
          "monkey"
        ],
        u: {
          u: "1f412",
          x: 8,
          y: 30
        }
      },
      {
        n: [
          "gorilla"
        ],
        u: {
          u: "1f98d",
          x: 9,
          y: 30
        }
      },
      {
        n: [
          "dog face",
          "dog"
        ],
        u: {
          u: "1f436",
          x: 10,
          y: 30
        }
      },
      {
        n: [
          "dog",
          "dog2"
        ],
        u: {
          u: "1f415",
          x: 11,
          y: 30
        }
      },
      {
        n: [
          "poodle"
        ],
        u: {
          u: "1f429",
          x: 12,
          y: 30
        }
      },
      {
        n: [
          "wolf face",
          "wolf"
        ],
        u: {
          u: "1f43a",
          x: 13,
          y: 30
        }
      },
      {
        n: [
          "fox face",
          "fox_face"
        ],
        u: {
          u: "1f98a",
          x: 14,
          y: 30
        }
      },
      {
        n: [
          "cat face",
          "cat"
        ],
        u: {
          u: "1f431",
          x: 15,
          y: 30
        }
      },
      {
        n: [
          "cat",
          "cat2"
        ],
        u: {
          u: "1f408",
          x: 16,
          y: 30
        }
      },
      {
        n: [
          "lion face",
          "lion_face"
        ],
        u: {
          u: "1f981",
          x: 17,
          y: 30
        }
      },
      {
        n: [
          "tiger face",
          "tiger"
        ],
        u: {
          u: "1f42f",
          x: 18,
          y: 30
        }
      },
      {
        n: [
          "tiger",
          "tiger2"
        ],
        u: {
          u: "1f405",
          x: 19,
          y: 30
        }
      },
      {
        n: [
          "leopard"
        ],
        u: {
          u: "1f406",
          x: 20,
          y: 30
        }
      },
      {
        n: [
          "horse face",
          "horse"
        ],
        u: {
          u: "1f434",
          x: 21,
          y: 30
        }
      },
      {
        n: [
          "horse",
          "racehorse"
        ],
        u: {
          u: "1f40e",
          x: 22,
          y: 30
        }
      },
      {
        n: [
          "unicorn face",
          "unicorn_face"
        ],
        u: {
          u: "1f984",
          x: 23,
          y: 30
        }
      },
      {
        n: [
          "zebra face",
          "zebra_face"
        ],
        u: {
          u: "1f993",
          x: 24,
          y: 30
        }
      },
      {
        n: [
          "deer"
        ],
        u: {
          u: "1f98c",
          x: 25,
          y: 30
        }
      },
      {
        n: [
          "cow face",
          "cow"
        ],
        u: {
          u: "1f42e",
          x: 26,
          y: 30
        }
      },
      {
        n: [
          "ox"
        ],
        u: {
          u: "1f402",
          x: 27,
          y: 30
        }
      },
      {
        n: [
          "water buffalo",
          "water_buffalo"
        ],
        u: {
          u: "1f403",
          x: 28,
          y: 30
        }
      },
      {
        n: [
          "cow",
          "cow2"
        ],
        u: {
          u: "1f404",
          x: 29,
          y: 30
        }
      },
      {
        n: [
          "pig face",
          "pig"
        ],
        u: {
          u: "1f437",
          x: 30,
          y: 30
        }
      },
      {
        n: [
          "pig",
          "pig2"
        ],
        u: {
          u: "1f416",
          x: 31,
          y: 30
        }
      },
      {
        n: [
          "boar"
        ],
        u: {
          u: "1f417",
          x: 32,
          y: 30
        }
      },
      {
        n: [
          "pig nose",
          "pig_nose"
        ],
        u: {
          u: "1f43d",
          x: 33,
          y: 30
        }
      },
      {
        n: [
          "ram"
        ],
        u: {
          u: "1f40f",
          x: 34,
          y: 30
        }
      },
      {
        n: [
          "sheep"
        ],
        u: {
          u: "1f411",
          x: 35,
          y: 30
        }
      },
      {
        n: [
          "goat"
        ],
        u: {
          u: "1f410",
          x: 36,
          y: 30
        }
      },
      {
        n: [
          "dromedary camel",
          "dromedary_camel"
        ],
        u: {
          u: "1f42a",
          x: 37,
          y: 30
        }
      },
      {
        n: [
          "bactrian camel",
          "camel"
        ],
        u: {
          u: "1f42b",
          x: 38,
          y: 30
        }
      },
      {
        n: [
          "giraffe face",
          "giraffe_face"
        ],
        u: {
          u: "1f992",
          x: 39,
          y: 30
        }
      },
      {
        n: [
          "elephant"
        ],
        u: {
          u: "1f418",
          x: 40,
          y: 30
        }
      },
      {
        n: [
          "rhinoceros"
        ],
        u: {
          u: "1f98f",
          x: 41,
          y: 30
        }
      },
      {
        n: [
          "mouse face",
          "mouse"
        ],
        u: {
          u: "1f42d",
          x: 42,
          y: 30
        }
      },
      {
        n: [
          "mouse",
          "mouse2"
        ],
        u: {
          u: "1f401",
          x: 43,
          y: 30
        }
      },
      {
        n: [
          "rat"
        ],
        u: {
          u: "1f400",
          x: 44,
          y: 30
        }
      },
      {
        n: [
          "hamster face",
          "hamster"
        ],
        u: {
          u: "1f439",
          x: 45,
          y: 30
        }
      },
      {
        n: [
          "rabbit face",
          "rabbit"
        ],
        u: {
          u: "1f430",
          x: 46,
          y: 30
        }
      },
      {
        n: [
          "rabbit",
          "rabbit2"
        ],
        u: {
          u: "1f407",
          x: 47,
          y: 30
        }
      },
      {
        n: [
          "chipmunk"
        ],
        u: {
          u: "1f43f",
          x: 48,
          y: 30
        }
      },
      {
        n: [
          "hedgehog"
        ],
        u: {
          u: "1f994",
          x: 49,
          y: 30
        }
      },
      {
        n: [
          "bat"
        ],
        u: {
          u: "1f987",
          x: 0,
          y: 31
        }
      },
      {
        n: [
          "bear face",
          "bear"
        ],
        u: {
          u: "1f43b",
          x: 1,
          y: 31
        }
      },
      {
        n: [
          "koala"
        ],
        u: {
          u: "1f428",
          x: 2,
          y: 31
        }
      },
      {
        n: [
          "panda face",
          "panda_face"
        ],
        u: {
          u: "1f43c",
          x: 3,
          y: 31
        }
      },
      {
        n: [
          "paw prints",
          "feet",
          "paw_prints"
        ],
        u: {
          u: "1f43e",
          x: 4,
          y: 31
        }
      },
      {
        n: [
          "turkey"
        ],
        u: {
          u: "1f983",
          x: 5,
          y: 31
        }
      },
      {
        n: [
          "chicken"
        ],
        u: {
          u: "1f414",
          x: 6,
          y: 31
        }
      },
      {
        n: [
          "rooster"
        ],
        u: {
          u: "1f413",
          x: 7,
          y: 31
        }
      },
      {
        n: [
          "hatching chick",
          "hatching_chick"
        ],
        u: {
          u: "1f423",
          x: 8,
          y: 31
        }
      },
      {
        n: [
          "baby chick",
          "baby_chick"
        ],
        u: {
          u: "1f424",
          x: 9,
          y: 31
        }
      },
      {
        n: [
          "front-facing baby chick",
          "hatched_chick"
        ],
        u: {
          u: "1f425",
          x: 10,
          y: 31
        }
      },
      {
        n: [
          "bird"
        ],
        u: {
          u: "1f426",
          x: 11,
          y: 31
        }
      },
      {
        n: [
          "penguin"
        ],
        u: {
          u: "1f427",
          x: 12,
          y: 31
        }
      },
      {
        n: [
          "dove_of_peace"
        ],
        u: {
          u: "1f54a",
          x: 13,
          y: 31
        }
      },
      {
        n: [
          "eagle"
        ],
        u: {
          u: "1f985",
          x: 14,
          y: 31
        }
      },
      {
        n: [
          "duck"
        ],
        u: {
          u: "1f986",
          x: 15,
          y: 31
        }
      },
      {
        n: [
          "owl"
        ],
        u: {
          u: "1f989",
          x: 16,
          y: 31
        }
      },
      {
        n: [
          "frog face",
          "frog"
        ],
        u: {
          u: "1f438",
          x: 17,
          y: 31
        }
      },
      {
        n: [
          "crocodile"
        ],
        u: {
          u: "1f40a",
          x: 18,
          y: 31
        }
      },
      {
        n: [
          "turtle"
        ],
        u: {
          u: "1f422",
          x: 19,
          y: 31
        }
      },
      {
        n: [
          "lizard"
        ],
        u: {
          u: "1f98e",
          x: 20,
          y: 31
        }
      },
      {
        n: [
          "snake"
        ],
        u: {
          u: "1f40d",
          x: 21,
          y: 31
        }
      },
      {
        n: [
          "dragon face",
          "dragon_face"
        ],
        u: {
          u: "1f432",
          x: 22,
          y: 31
        }
      },
      {
        n: [
          "dragon"
        ],
        u: {
          u: "1f409",
          x: 23,
          y: 31
        }
      },
      {
        n: [
          "sauropod"
        ],
        u: {
          u: "1f995",
          x: 24,
          y: 31
        }
      },
      {
        n: [
          "t-rex"
        ],
        u: {
          u: "1f996",
          x: 25,
          y: 31
        }
      },
      {
        n: [
          "spouting whale",
          "whale"
        ],
        u: {
          u: "1f433",
          x: 26,
          y: 31
        }
      },
      {
        n: [
          "whale",
          "whale2"
        ],
        u: {
          u: "1f40b",
          x: 27,
          y: 31
        }
      },
      {
        n: [
          "dolphin",
          "flipper"
        ],
        u: {
          u: "1f42c",
          x: 28,
          y: 31
        }
      },
      {
        n: [
          "fish"
        ],
        u: {
          u: "1f41f",
          x: 29,
          y: 31
        }
      },
      {
        n: [
          "tropical fish",
          "tropical_fish"
        ],
        u: {
          u: "1f420",
          x: 30,
          y: 31
        }
      },
      {
        n: [
          "blowfish"
        ],
        u: {
          u: "1f421",
          x: 31,
          y: 31
        }
      },
      {
        n: [
          "shark"
        ],
        u: {
          u: "1f988",
          x: 32,
          y: 31
        }
      },
      {
        n: [
          "octopus"
        ],
        u: {
          u: "1f419",
          x: 33,
          y: 31
        }
      },
      {
        n: [
          "spiral shell",
          "shell"
        ],
        u: {
          u: "1f41a",
          x: 34,
          y: 31
        }
      },
      {
        n: [
          "crab"
        ],
        u: {
          u: "1f980",
          x: 35,
          y: 31
        }
      },
      {
        n: [
          "shrimp"
        ],
        u: {
          u: "1f990",
          x: 36,
          y: 31
        }
      },
      {
        n: [
          "squid"
        ],
        u: {
          u: "1f991",
          x: 37,
          y: 31
        }
      },
      {
        n: [
          "snail"
        ],
        u: {
          u: "1f40c",
          x: 38,
          y: 31
        }
      },
      {
        n: [
          "butterfly"
        ],
        u: {
          u: "1f98b",
          x: 39,
          y: 31
        }
      },
      {
        n: [
          "bug"
        ],
        u: {
          u: "1f41b",
          x: 40,
          y: 31
        }
      },
      {
        n: [
          "ant"
        ],
        u: {
          u: "1f41c",
          x: 41,
          y: 31
        }
      },
      {
        n: [
          "honeybee",
          "bee"
        ],
        u: {
          u: "1f41d",
          x: 42,
          y: 31
        }
      },
      {
        n: [
          "lady beetle",
          "beetle"
        ],
        u: {
          u: "1f41e",
          x: 43,
          y: 31
        }
      },
      {
        n: [
          "cricket"
        ],
        u: {
          u: "1f997",
          x: 44,
          y: 31
        }
      },
      {
        n: [
          "spider"
        ],
        u: {
          u: "1f577",
          x: 45,
          y: 31
        }
      },
      {
        n: [
          "spider_web"
        ],
        u: {
          u: "1f578",
          x: 46,
          y: 31
        }
      },
      {
        n: [
          "scorpion"
        ],
        u: {
          u: "1f982",
          x: 47,
          y: 31
        }
      },
      {
        n: [
          "bouquet"
        ],
        u: {
          u: "1f490",
          x: 48,
          y: 31
        }
      },
      {
        n: [
          "cherry blossom",
          "cherry_blossom"
        ],
        u: {
          u: "1f338",
          x: 49,
          y: 31
        }
      },
      {
        n: [
          "white flower",
          "white_flower"
        ],
        u: {
          u: "1f4ae",
          x: 0,
          y: 32
        }
      },
      {
        n: [
          "rosette"
        ],
        u: {
          u: "1f3f5",
          x: 1,
          y: 32
        }
      },
      {
        n: [
          "rose"
        ],
        u: {
          u: "1f339",
          x: 2,
          y: 32
        }
      },
      {
        n: [
          "wilted flower",
          "wilted_flower"
        ],
        u: {
          u: "1f940",
          x: 3,
          y: 32
        }
      },
      {
        n: [
          "hibiscus"
        ],
        u: {
          u: "1f33a",
          x: 4,
          y: 32
        }
      },
      {
        n: [
          "sunflower"
        ],
        u: {
          u: "1f33b",
          x: 5,
          y: 32
        }
      },
      {
        n: [
          "blossom"
        ],
        u: {
          u: "1f33c",
          x: 6,
          y: 32
        }
      },
      {
        n: [
          "tulip"
        ],
        u: {
          u: "1f337",
          x: 7,
          y: 32
        }
      },
      {
        n: [
          "seedling"
        ],
        u: {
          u: "1f331",
          x: 8,
          y: 32
        }
      },
      {
        n: [
          "evergreen tree",
          "evergreen_tree"
        ],
        u: {
          u: "1f332",
          x: 9,
          y: 32
        }
      },
      {
        n: [
          "deciduous tree",
          "deciduous_tree"
        ],
        u: {
          u: "1f333",
          x: 10,
          y: 32
        }
      },
      {
        n: [
          "palm tree",
          "palm_tree"
        ],
        u: {
          u: "1f334",
          x: 11,
          y: 32
        }
      },
      {
        n: [
          "cactus"
        ],
        u: {
          u: "1f335",
          x: 12,
          y: 32
        }
      },
      {
        n: [
          "ear of rice",
          "ear_of_rice"
        ],
        u: {
          u: "1f33e",
          x: 13,
          y: 32
        }
      },
      {
        n: [
          "herb"
        ],
        u: {
          u: "1f33f",
          x: 14,
          y: 32
        }
      },
      {
        n: [
          "shamrock"
        ],
        u: {
          u: "2618",
          x: 15,
          y: 32
        }
      },
      {
        n: [
          "four leaf clover",
          "four_leaf_clover"
        ],
        u: {
          u: "1f340",
          x: 16,
          y: 32
        }
      },
      {
        n: [
          "maple leaf",
          "maple_leaf"
        ],
        u: {
          u: "1f341",
          x: 17,
          y: 32
        }
      },
      {
        n: [
          "fallen leaf",
          "fallen_leaf"
        ],
        u: {
          u: "1f342",
          x: 18,
          y: 32
        }
      },
      {
        n: [
          "leaf fluttering in wind",
          "leaves"
        ],
        u: {
          u: "1f343",
          x: 19,
          y: 32
        }
      }
    ],
    u: "1f43b",
    title: "Animals & Nature",
    key: "animals_nature"
  },
  {
    emojis: [
      {
        n: [
          "grapes"
        ],
        u: {
          u: "1f347",
          x: 20,
          y: 32
        }
      },
      {
        n: [
          "melon"
        ],
        u: {
          u: "1f348",
          x: 21,
          y: 32
        }
      },
      {
        n: [
          "watermelon"
        ],
        u: {
          u: "1f349",
          x: 22,
          y: 32
        }
      },
      {
        n: [
          "tangerine"
        ],
        u: {
          u: "1f34a",
          x: 23,
          y: 32
        }
      },
      {
        n: [
          "lemon"
        ],
        u: {
          u: "1f34b",
          x: 24,
          y: 32
        }
      },
      {
        n: [
          "banana"
        ],
        u: {
          u: "1f34c",
          x: 25,
          y: 32
        }
      },
      {
        n: [
          "pineapple"
        ],
        u: {
          u: "1f34d",
          x: 26,
          y: 32
        }
      },
      {
        n: [
          "red apple",
          "apple"
        ],
        u: {
          u: "1f34e",
          x: 27,
          y: 32
        }
      },
      {
        n: [
          "green apple",
          "green_apple"
        ],
        u: {
          u: "1f34f",
          x: 28,
          y: 32
        }
      },
      {
        n: [
          "pear"
        ],
        u: {
          u: "1f350",
          x: 29,
          y: 32
        }
      },
      {
        n: [
          "peach"
        ],
        u: {
          u: "1f351",
          x: 30,
          y: 32
        }
      },
      {
        n: [
          "cherries"
        ],
        u: {
          u: "1f352",
          x: 31,
          y: 32
        }
      },
      {
        n: [
          "strawberry"
        ],
        u: {
          u: "1f353",
          x: 32,
          y: 32
        }
      },
      {
        n: [
          "kiwifruit"
        ],
        u: {
          u: "1f95d",
          x: 33,
          y: 32
        }
      },
      {
        n: [
          "tomato"
        ],
        u: {
          u: "1f345",
          x: 34,
          y: 32
        }
      },
      {
        n: [
          "coconut"
        ],
        u: {
          u: "1f965",
          x: 35,
          y: 32
        }
      },
      {
        n: [
          "avocado"
        ],
        u: {
          u: "1f951",
          x: 36,
          y: 32
        }
      },
      {
        n: [
          "aubergine",
          "eggplant"
        ],
        u: {
          u: "1f346",
          x: 37,
          y: 32
        }
      },
      {
        n: [
          "potato"
        ],
        u: {
          u: "1f954",
          x: 38,
          y: 32
        }
      },
      {
        n: [
          "carrot"
        ],
        u: {
          u: "1f955",
          x: 39,
          y: 32
        }
      },
      {
        n: [
          "ear of maize",
          "corn"
        ],
        u: {
          u: "1f33d",
          x: 40,
          y: 32
        }
      },
      {
        n: [
          "hot_pepper"
        ],
        u: {
          u: "1f336",
          x: 41,
          y: 32
        }
      },
      {
        n: [
          "cucumber"
        ],
        u: {
          u: "1f952",
          x: 42,
          y: 32
        }
      },
      {
        n: [
          "broccoli"
        ],
        u: {
          u: "1f966",
          x: 43,
          y: 32
        }
      },
      {
        n: [
          "mushroom"
        ],
        u: {
          u: "1f344",
          x: 44,
          y: 32
        }
      },
      {
        n: [
          "peanuts"
        ],
        u: {
          u: "1f95c",
          x: 45,
          y: 32
        }
      },
      {
        n: [
          "chestnut"
        ],
        u: {
          u: "1f330",
          x: 46,
          y: 32
        }
      },
      {
        n: [
          "bread"
        ],
        u: {
          u: "1f35e",
          x: 47,
          y: 32
        }
      },
      {
        n: [
          "croissant"
        ],
        u: {
          u: "1f950",
          x: 48,
          y: 32
        }
      },
      {
        n: [
          "baguette bread",
          "baguette_bread"
        ],
        u: {
          u: "1f956",
          x: 49,
          y: 32
        }
      },
      {
        n: [
          "pretzel"
        ],
        u: {
          u: "1f968",
          x: 0,
          y: 33
        }
      },
      {
        n: [
          "pancakes"
        ],
        u: {
          u: "1f95e",
          x: 1,
          y: 33
        }
      },
      {
        n: [
          "cheese wedge",
          "cheese_wedge"
        ],
        u: {
          u: "1f9c0",
          x: 2,
          y: 33
        }
      },
      {
        n: [
          "meat on bone",
          "meat_on_bone"
        ],
        u: {
          u: "1f356",
          x: 3,
          y: 33
        }
      },
      {
        n: [
          "poultry leg",
          "poultry_leg"
        ],
        u: {
          u: "1f357",
          x: 4,
          y: 33
        }
      },
      {
        n: [
          "cut of meat",
          "cut_of_meat"
        ],
        u: {
          u: "1f969",
          x: 5,
          y: 33
        }
      },
      {
        n: [
          "bacon"
        ],
        u: {
          u: "1f953",
          x: 6,
          y: 33
        }
      },
      {
        n: [
          "hamburger"
        ],
        u: {
          u: "1f354",
          x: 7,
          y: 33
        }
      },
      {
        n: [
          "french fries",
          "fries"
        ],
        u: {
          u: "1f35f",
          x: 8,
          y: 33
        }
      },
      {
        n: [
          "slice of pizza",
          "pizza"
        ],
        u: {
          u: "1f355",
          x: 9,
          y: 33
        }
      },
      {
        n: [
          "hot dog",
          "hotdog"
        ],
        u: {
          u: "1f32d",
          x: 10,
          y: 33
        }
      },
      {
        n: [
          "sandwich"
        ],
        u: {
          u: "1f96a",
          x: 11,
          y: 33
        }
      },
      {
        n: [
          "taco"
        ],
        u: {
          u: "1f32e",
          x: 12,
          y: 33
        }
      },
      {
        n: [
          "burrito"
        ],
        u: {
          u: "1f32f",
          x: 13,
          y: 33
        }
      },
      {
        n: [
          "stuffed flatbread",
          "stuffed_flatbread"
        ],
        u: {
          u: "1f959",
          x: 14,
          y: 33
        }
      },
      {
        n: [
          "egg"
        ],
        u: {
          u: "1f95a",
          x: 15,
          y: 33
        }
      },
      {
        n: [
          "cooking",
          "fried_egg"
        ],
        u: {
          u: "1f373",
          x: 16,
          y: 33
        }
      },
      {
        n: [
          "shallow pan of food",
          "shallow_pan_of_food"
        ],
        u: {
          u: "1f958",
          x: 17,
          y: 33
        }
      },
      {
        n: [
          "pot of food",
          "stew"
        ],
        u: {
          u: "1f372",
          x: 18,
          y: 33
        }
      },
      {
        n: [
          "bowl with spoon",
          "bowl_with_spoon"
        ],
        u: {
          u: "1f963",
          x: 19,
          y: 33
        }
      },
      {
        n: [
          "green salad",
          "green_salad"
        ],
        u: {
          u: "1f957",
          x: 20,
          y: 33
        }
      },
      {
        n: [
          "popcorn"
        ],
        u: {
          u: "1f37f",
          x: 21,
          y: 33
        }
      },
      {
        n: [
          "canned food",
          "canned_food"
        ],
        u: {
          u: "1f96b",
          x: 22,
          y: 33
        }
      },
      {
        n: [
          "bento box",
          "bento"
        ],
        u: {
          u: "1f371",
          x: 23,
          y: 33
        }
      },
      {
        n: [
          "rice cracker",
          "rice_cracker"
        ],
        u: {
          u: "1f358",
          x: 24,
          y: 33
        }
      },
      {
        n: [
          "rice ball",
          "rice_ball"
        ],
        u: {
          u: "1f359",
          x: 25,
          y: 33
        }
      },
      {
        n: [
          "cooked rice",
          "rice"
        ],
        u: {
          u: "1f35a",
          x: 26,
          y: 33
        }
      },
      {
        n: [
          "curry and rice",
          "curry"
        ],
        u: {
          u: "1f35b",
          x: 27,
          y: 33
        }
      },
      {
        n: [
          "steaming bowl",
          "ramen"
        ],
        u: {
          u: "1f35c",
          x: 28,
          y: 33
        }
      },
      {
        n: [
          "spaghetti"
        ],
        u: {
          u: "1f35d",
          x: 29,
          y: 33
        }
      },
      {
        n: [
          "roasted sweet potato",
          "sweet_potato"
        ],
        u: {
          u: "1f360",
          x: 30,
          y: 33
        }
      },
      {
        n: [
          "oden"
        ],
        u: {
          u: "1f362",
          x: 31,
          y: 33
        }
      },
      {
        n: [
          "sushi"
        ],
        u: {
          u: "1f363",
          x: 32,
          y: 33
        }
      },
      {
        n: [
          "fried shrimp",
          "fried_shrimp"
        ],
        u: {
          u: "1f364",
          x: 33,
          y: 33
        }
      },
      {
        n: [
          "fish cake with swirl design",
          "fish_cake"
        ],
        u: {
          u: "1f365",
          x: 34,
          y: 33
        }
      },
      {
        n: [
          "dango"
        ],
        u: {
          u: "1f361",
          x: 35,
          y: 33
        }
      },
      {
        n: [
          "dumpling"
        ],
        u: {
          u: "1f95f",
          x: 36,
          y: 33
        }
      },
      {
        n: [
          "fortune cookie",
          "fortune_cookie"
        ],
        u: {
          u: "1f960",
          x: 37,
          y: 33
        }
      },
      {
        n: [
          "takeout box",
          "takeout_box"
        ],
        u: {
          u: "1f961",
          x: 38,
          y: 33
        }
      },
      {
        n: [
          "soft ice cream",
          "icecream"
        ],
        u: {
          u: "1f366",
          x: 39,
          y: 33
        }
      },
      {
        n: [
          "shaved ice",
          "shaved_ice"
        ],
        u: {
          u: "1f367",
          x: 40,
          y: 33
        }
      },
      {
        n: [
          "ice cream",
          "ice_cream"
        ],
        u: {
          u: "1f368",
          x: 41,
          y: 33
        }
      },
      {
        n: [
          "doughnut"
        ],
        u: {
          u: "1f369",
          x: 42,
          y: 33
        }
      },
      {
        n: [
          "cookie"
        ],
        u: {
          u: "1f36a",
          x: 43,
          y: 33
        }
      },
      {
        n: [
          "birthday cake",
          "birthday"
        ],
        u: {
          u: "1f382",
          x: 44,
          y: 33
        }
      },
      {
        n: [
          "shortcake",
          "cake"
        ],
        u: {
          u: "1f370",
          x: 45,
          y: 33
        }
      },
      {
        n: [
          "pie"
        ],
        u: {
          u: "1f967",
          x: 46,
          y: 33
        }
      },
      {
        n: [
          "chocolate bar",
          "chocolate_bar"
        ],
        u: {
          u: "1f36b",
          x: 47,
          y: 33
        }
      },
      {
        n: [
          "candy"
        ],
        u: {
          u: "1f36c",
          x: 48,
          y: 33
        }
      },
      {
        n: [
          "lollipop"
        ],
        u: {
          u: "1f36d",
          x: 49,
          y: 33
        }
      },
      {
        n: [
          "custard"
        ],
        u: {
          u: "1f36e",
          x: 0,
          y: 34
        }
      },
      {
        n: [
          "honey pot",
          "honey_pot"
        ],
        u: {
          u: "1f36f",
          x: 1,
          y: 34
        }
      },
      {
        n: [
          "baby bottle",
          "baby_bottle"
        ],
        u: {
          u: "1f37c",
          x: 2,
          y: 34
        }
      },
      {
        n: [
          "glass of milk",
          "glass_of_milk"
        ],
        u: {
          u: "1f95b",
          x: 3,
          y: 34
        }
      },
      {
        n: [
          "hot beverage",
          "coffee"
        ],
        u: {
          u: "2615",
          x: 4,
          y: 34
        }
      },
      {
        n: [
          "teacup without handle",
          "tea"
        ],
        u: {
          u: "1f375",
          x: 5,
          y: 34
        }
      },
      {
        n: [
          "sake bottle and cup",
          "sake"
        ],
        u: {
          u: "1f376",
          x: 6,
          y: 34
        }
      },
      {
        n: [
          "bottle with popping cork",
          "champagne"
        ],
        u: {
          u: "1f37e",
          x: 7,
          y: 34
        }
      },
      {
        n: [
          "wine glass",
          "wine_glass"
        ],
        u: {
          u: "1f377",
          x: 8,
          y: 34
        }
      },
      {
        n: [
          "cocktail glass",
          "cocktail"
        ],
        u: {
          u: "1f378",
          x: 9,
          y: 34
        }
      },
      {
        n: [
          "tropical drink",
          "tropical_drink"
        ],
        u: {
          u: "1f379",
          x: 10,
          y: 34
        }
      },
      {
        n: [
          "beer mug",
          "beer"
        ],
        u: {
          u: "1f37a",
          x: 11,
          y: 34
        }
      },
      {
        n: [
          "clinking beer mugs",
          "beers"
        ],
        u: {
          u: "1f37b",
          x: 12,
          y: 34
        }
      },
      {
        n: [
          "clinking glasses",
          "clinking_glasses"
        ],
        u: {
          u: "1f942",
          x: 13,
          y: 34
        }
      },
      {
        n: [
          "tumbler glass",
          "tumbler_glass"
        ],
        u: {
          u: "1f943",
          x: 14,
          y: 34
        }
      },
      {
        n: [
          "cup with straw",
          "cup_with_straw"
        ],
        u: {
          u: "1f964",
          x: 15,
          y: 34
        }
      },
      {
        n: [
          "chopsticks"
        ],
        u: {
          u: "1f962",
          x: 16,
          y: 34
        }
      },
      {
        n: [
          "knife_fork_plate"
        ],
        u: {
          u: "1f37d",
          x: 17,
          y: 34
        }
      },
      {
        n: [
          "fork and knife",
          "fork_and_knife"
        ],
        u: {
          u: "1f374",
          x: 18,
          y: 34
        }
      },
      {
        n: [
          "spoon"
        ],
        u: {
          u: "1f944",
          x: 19,
          y: 34
        }
      },
      {
        n: [
          "hocho",
          "knife"
        ],
        u: {
          u: "1f52a",
          x: 20,
          y: 34
        }
      },
      {
        n: [
          "amphora"
        ],
        u: {
          u: "1f3fa",
          x: 21,
          y: 34
        }
      }
    ],
    key: "food_drink",
    title: "Food & Drink",
    u: "1f354"
  },
  {
    emojis: [
      {
        n: [
          "jack-o-lantern",
          "jack_o_lantern"
        ],
        u: {
          u: "1f383",
          x: 22,
          y: 34
        }
      },
      {
        n: [
          "christmas tree",
          "christmas_tree"
        ],
        u: {
          u: "1f384",
          x: 23,
          y: 34
        }
      },
      {
        n: [
          "fireworks"
        ],
        u: {
          u: "1f386",
          x: 24,
          y: 34
        }
      },
      {
        n: [
          "firework sparkler",
          "sparkler"
        ],
        u: {
          u: "1f387",
          x: 25,
          y: 34
        }
      },
      {
        n: [
          "sparkles"
        ],
        u: {
          u: "2728",
          x: 26,
          y: 34
        }
      },
      {
        n: [
          "balloon"
        ],
        u: {
          u: "1f388",
          x: 27,
          y: 34
        }
      },
      {
        n: [
          "party popper",
          "tada"
        ],
        u: {
          u: "1f389",
          x: 28,
          y: 34
        }
      },
      {
        n: [
          "confetti ball",
          "confetti_ball"
        ],
        u: {
          u: "1f38a",
          x: 29,
          y: 34
        }
      },
      {
        n: [
          "tanabata tree",
          "tanabata_tree"
        ],
        u: {
          u: "1f38b",
          x: 30,
          y: 34
        }
      },
      {
        n: [
          "pine decoration",
          "bamboo"
        ],
        u: {
          u: "1f38d",
          x: 31,
          y: 34
        }
      },
      {
        n: [
          "japanese dolls",
          "dolls"
        ],
        u: {
          u: "1f38e",
          x: 32,
          y: 34
        }
      },
      {
        n: [
          "carp streamer",
          "flags"
        ],
        u: {
          u: "1f38f",
          x: 33,
          y: 34
        }
      },
      {
        n: [
          "wind chime",
          "wind_chime"
        ],
        u: {
          u: "1f390",
          x: 34,
          y: 34
        }
      },
      {
        n: [
          "moon viewing ceremony",
          "rice_scene"
        ],
        u: {
          u: "1f391",
          x: 35,
          y: 34
        }
      },
      {
        n: [
          "ribbon"
        ],
        u: {
          u: "1f380",
          x: 36,
          y: 34
        }
      },
      {
        n: [
          "wrapped present",
          "gift"
        ],
        u: {
          u: "1f381",
          x: 37,
          y: 34
        }
      },
      {
        n: [
          "reminder_ribbon"
        ],
        u: {
          u: "1f397",
          x: 38,
          y: 34
        }
      },
      {
        n: [
          "admission_tickets"
        ],
        u: {
          u: "1f39f",
          x: 39,
          y: 34
        }
      },
      {
        n: [
          "ticket"
        ],
        u: {
          u: "1f3ab",
          x: 40,
          y: 34
        }
      },
      {
        n: [
          "medal"
        ],
        u: {
          u: "1f396",
          x: 41,
          y: 34
        }
      },
      {
        n: [
          "trophy"
        ],
        u: {
          u: "1f3c6",
          x: 42,
          y: 34
        }
      },
      {
        n: [
          "sports medal",
          "sports_medal"
        ],
        u: {
          u: "1f3c5",
          x: 43,
          y: 34
        }
      },
      {
        n: [
          "first place medal",
          "first_place_medal"
        ],
        u: {
          u: "1f947",
          x: 44,
          y: 34
        }
      },
      {
        n: [
          "second place medal",
          "second_place_medal"
        ],
        u: {
          u: "1f948",
          x: 45,
          y: 34
        }
      },
      {
        n: [
          "third place medal",
          "third_place_medal"
        ],
        u: {
          u: "1f949",
          x: 46,
          y: 34
        }
      },
      {
        n: [
          "soccer ball",
          "soccer"
        ],
        u: {
          u: "26bd",
          x: 47,
          y: 34
        }
      },
      {
        n: [
          "baseball"
        ],
        u: {
          u: "26be",
          x: 48,
          y: 34
        }
      },
      {
        n: [
          "basketball and hoop",
          "basketball"
        ],
        u: {
          u: "1f3c0",
          x: 49,
          y: 34
        }
      },
      {
        n: [
          "volleyball"
        ],
        u: {
          u: "1f3d0",
          x: 0,
          y: 35
        }
      },
      {
        n: [
          "american football",
          "football"
        ],
        u: {
          u: "1f3c8",
          x: 1,
          y: 35
        }
      },
      {
        n: [
          "rugby football",
          "rugby_football"
        ],
        u: {
          u: "1f3c9",
          x: 2,
          y: 35
        }
      },
      {
        n: [
          "tennis racquet and ball",
          "tennis"
        ],
        u: {
          u: "1f3be",
          x: 3,
          y: 35
        }
      },
      {
        n: [
          "billiards",
          "8ball"
        ],
        u: {
          u: "1f3b1",
          x: 4,
          y: 35
        }
      },
      {
        n: [
          "bowling"
        ],
        u: {
          u: "1f3b3",
          x: 5,
          y: 35
        }
      },
      {
        n: [
          "cricket bat and ball",
          "cricket_bat_and_ball"
        ],
        u: {
          u: "1f3cf",
          x: 6,
          y: 35
        }
      },
      {
        n: [
          "field hockey stick and ball",
          "field_hockey_stick_and_ball"
        ],
        u: {
          u: "1f3d1",
          x: 7,
          y: 35
        }
      },
      {
        n: [
          "ice hockey stick and puck",
          "ice_hockey_stick_and_puck"
        ],
        u: {
          u: "1f3d2",
          x: 8,
          y: 35
        }
      },
      {
        n: [
          "table tennis paddle and ball",
          "table_tennis_paddle_and_ball"
        ],
        u: {
          u: "1f3d3",
          x: 9,
          y: 35
        }
      },
      {
        n: [
          "badminton racquet and shuttlecock",
          "badminton_racquet_and_shuttlecock"
        ],
        u: {
          u: "1f3f8",
          x: 10,
          y: 35
        }
      },
      {
        n: [
          "boxing glove",
          "boxing_glove"
        ],
        u: {
          u: "1f94a",
          x: 11,
          y: 35
        }
      },
      {
        n: [
          "martial arts uniform",
          "martial_arts_uniform"
        ],
        u: {
          u: "1f94b",
          x: 12,
          y: 35
        }
      },
      {
        n: [
          "goal net",
          "goal_net"
        ],
        u: {
          u: "1f945",
          x: 13,
          y: 35
        }
      },
      {
        n: [
          "direct hit",
          "dart"
        ],
        u: {
          u: "1f3af",
          x: 14,
          y: 35
        }
      },
      {
        n: [
          "flag in hole",
          "golf"
        ],
        u: {
          u: "26f3",
          x: 15,
          y: 35
        }
      },
      {
        n: [
          "ice_skate"
        ],
        u: {
          u: "26f8",
          x: 16,
          y: 35
        }
      },
      {
        n: [
          "fishing pole and fish",
          "fishing_pole_and_fish"
        ],
        u: {
          u: "1f3a3",
          x: 17,
          y: 35
        }
      },
      {
        n: [
          "running shirt with sash",
          "running_shirt_with_sash"
        ],
        u: {
          u: "1f3bd",
          x: 18,
          y: 35
        }
      },
      {
        n: [
          "ski and ski boot",
          "ski"
        ],
        u: {
          u: "1f3bf",
          x: 19,
          y: 35
        }
      },
      {
        n: [
          "sled"
        ],
        u: {
          u: "1f6f7",
          x: 20,
          y: 35
        }
      },
      {
        n: [
          "curling stone",
          "curling_stone"
        ],
        u: {
          u: "1f94c",
          x: 21,
          y: 35
        }
      },
      {
        n: [
          "video game",
          "video_game"
        ],
        u: {
          u: "1f3ae",
          x: 22,
          y: 35
        }
      },
      {
        n: [
          "joystick"
        ],
        u: {
          u: "1f579",
          x: 23,
          y: 35
        }
      },
      {
        n: [
          "game die",
          "game_die"
        ],
        u: {
          u: "1f3b2",
          x: 24,
          y: 35
        }
      },
      {
        n: [
          "black spade suit",
          "spades"
        ],
        u: {
          u: "2660",
          x: 25,
          y: 35
        }
      },
      {
        n: [
          "black heart suit",
          "hearts"
        ],
        u: {
          u: "2665",
          x: 26,
          y: 35
        }
      },
      {
        n: [
          "black diamond suit",
          "diamonds"
        ],
        u: {
          u: "2666",
          x: 27,
          y: 35
        }
      },
      {
        n: [
          "black club suit",
          "clubs"
        ],
        u: {
          u: "2663",
          x: 28,
          y: 35
        }
      },
      {
        n: [
          "playing card black joker",
          "black_joker"
        ],
        u: {
          u: "1f0cf",
          x: 29,
          y: 35
        }
      },
      {
        n: [
          "mahjong tile red dragon",
          "mahjong"
        ],
        u: {
          u: "1f004",
          x: 30,
          y: 35
        }
      },
      {
        n: [
          "flower playing cards",
          "flower_playing_cards"
        ],
        u: {
          u: "1f3b4",
          x: 31,
          y: 35
        }
      }
    ],
    key: "activities",
    title: "Activities",
    u: "26bd"
  },
  {
    emojis: [
      {
        n: [
          "earth globe europe-africa",
          "earth_africa"
        ],
        u: {
          u: "1f30d",
          x: 32,
          y: 35
        }
      },
      {
        n: [
          "earth globe americas",
          "earth_americas"
        ],
        u: {
          u: "1f30e",
          x: 33,
          y: 35
        }
      },
      {
        n: [
          "earth globe asia-australia",
          "earth_asia"
        ],
        u: {
          u: "1f30f",
          x: 34,
          y: 35
        }
      },
      {
        n: [
          "globe with meridians",
          "globe_with_meridians"
        ],
        u: {
          u: "1f310",
          x: 35,
          y: 35
        }
      },
      {
        n: [
          "world_map"
        ],
        u: {
          u: "1f5fa",
          x: 36,
          y: 35
        }
      },
      {
        n: [
          "silhouette of japan",
          "japan"
        ],
        u: {
          u: "1f5fe",
          x: 37,
          y: 35
        }
      },
      {
        n: [
          "snow_capped_mountain"
        ],
        u: {
          u: "1f3d4",
          x: 38,
          y: 35
        }
      },
      {
        n: [
          "mountain"
        ],
        u: {
          u: "26f0",
          x: 39,
          y: 35
        }
      },
      {
        n: [
          "volcano"
        ],
        u: {
          u: "1f30b",
          x: 40,
          y: 35
        }
      },
      {
        n: [
          "mount fuji",
          "mount_fuji"
        ],
        u: {
          u: "1f5fb",
          x: 41,
          y: 35
        }
      },
      {
        n: [
          "camping"
        ],
        u: {
          u: "1f3d5",
          x: 42,
          y: 35
        }
      },
      {
        n: [
          "beach_with_umbrella"
        ],
        u: {
          u: "1f3d6",
          x: 43,
          y: 35
        }
      },
      {
        n: [
          "desert"
        ],
        u: {
          u: "1f3dc",
          x: 44,
          y: 35
        }
      },
      {
        n: [
          "desert_island"
        ],
        u: {
          u: "1f3dd",
          x: 45,
          y: 35
        }
      },
      {
        n: [
          "national_park"
        ],
        u: {
          u: "1f3de",
          x: 46,
          y: 35
        }
      },
      {
        n: [
          "stadium"
        ],
        u: {
          u: "1f3df",
          x: 47,
          y: 35
        }
      },
      {
        n: [
          "classical_building"
        ],
        u: {
          u: "1f3db",
          x: 48,
          y: 35
        }
      },
      {
        n: [
          "building_construction"
        ],
        u: {
          u: "1f3d7",
          x: 49,
          y: 35
        }
      },
      {
        n: [
          "house_buildings"
        ],
        u: {
          u: "1f3d8",
          x: 0,
          y: 36
        }
      },
      {
        n: [
          "cityscape"
        ],
        u: {
          u: "1f3d9",
          x: 1,
          y: 36
        }
      },
      {
        n: [
          "derelict_house_building"
        ],
        u: {
          u: "1f3da",
          x: 2,
          y: 36
        }
      },
      {
        n: [
          "house building",
          "house"
        ],
        u: {
          u: "1f3e0",
          x: 3,
          y: 36
        }
      },
      {
        n: [
          "house with garden",
          "house_with_garden"
        ],
        u: {
          u: "1f3e1",
          x: 4,
          y: 36
        }
      },
      {
        n: [
          "office building",
          "office"
        ],
        u: {
          u: "1f3e2",
          x: 5,
          y: 36
        }
      },
      {
        n: [
          "japanese post office",
          "post_office"
        ],
        u: {
          u: "1f3e3",
          x: 6,
          y: 36
        }
      },
      {
        n: [
          "european post office",
          "european_post_office"
        ],
        u: {
          u: "1f3e4",
          x: 7,
          y: 36
        }
      },
      {
        n: [
          "hospital"
        ],
        u: {
          u: "1f3e5",
          x: 8,
          y: 36
        }
      },
      {
        n: [
          "bank"
        ],
        u: {
          u: "1f3e6",
          x: 9,
          y: 36
        }
      },
      {
        n: [
          "hotel"
        ],
        u: {
          u: "1f3e8",
          x: 10,
          y: 36
        }
      },
      {
        n: [
          "love hotel",
          "love_hotel"
        ],
        u: {
          u: "1f3e9",
          x: 11,
          y: 36
        }
      },
      {
        n: [
          "convenience store",
          "convenience_store"
        ],
        u: {
          u: "1f3ea",
          x: 12,
          y: 36
        }
      },
      {
        n: [
          "school"
        ],
        u: {
          u: "1f3eb",
          x: 13,
          y: 36
        }
      },
      {
        n: [
          "department store",
          "department_store"
        ],
        u: {
          u: "1f3ec",
          x: 14,
          y: 36
        }
      },
      {
        n: [
          "factory"
        ],
        u: {
          u: "1f3ed",
          x: 15,
          y: 36
        }
      },
      {
        n: [
          "japanese castle",
          "japanese_castle"
        ],
        u: {
          u: "1f3ef",
          x: 16,
          y: 36
        }
      },
      {
        n: [
          "european castle",
          "european_castle"
        ],
        u: {
          u: "1f3f0",
          x: 17,
          y: 36
        }
      },
      {
        n: [
          "wedding"
        ],
        u: {
          u: "1f492",
          x: 18,
          y: 36
        }
      },
      {
        n: [
          "tokyo tower",
          "tokyo_tower"
        ],
        u: {
          u: "1f5fc",
          x: 19,
          y: 36
        }
      },
      {
        n: [
          "statue of liberty",
          "statue_of_liberty"
        ],
        u: {
          u: "1f5fd",
          x: 20,
          y: 36
        }
      },
      {
        n: [
          "church"
        ],
        u: {
          u: "26ea",
          x: 21,
          y: 36
        }
      },
      {
        n: [
          "mosque"
        ],
        u: {
          u: "1f54c",
          x: 22,
          y: 36
        }
      },
      {
        n: [
          "synagogue"
        ],
        u: {
          u: "1f54d",
          x: 23,
          y: 36
        }
      },
      {
        n: [
          "shinto_shrine"
        ],
        u: {
          u: "26e9",
          x: 24,
          y: 36
        }
      },
      {
        n: [
          "kaaba"
        ],
        u: {
          u: "1f54b",
          x: 25,
          y: 36
        }
      },
      {
        n: [
          "fountain"
        ],
        u: {
          u: "26f2",
          x: 26,
          y: 36
        }
      },
      {
        n: [
          "tent"
        ],
        u: {
          u: "26fa",
          x: 27,
          y: 36
        }
      },
      {
        n: [
          "foggy"
        ],
        u: {
          u: "1f301",
          x: 28,
          y: 36
        }
      },
      {
        n: [
          "night with stars",
          "night_with_stars"
        ],
        u: {
          u: "1f303",
          x: 29,
          y: 36
        }
      },
      {
        n: [
          "sunrise over mountains",
          "sunrise_over_mountains"
        ],
        u: {
          u: "1f304",
          x: 30,
          y: 36
        }
      },
      {
        n: [
          "sunrise"
        ],
        u: {
          u: "1f305",
          x: 31,
          y: 36
        }
      },
      {
        n: [
          "cityscape at dusk",
          "city_sunset"
        ],
        u: {
          u: "1f306",
          x: 32,
          y: 36
        }
      },
      {
        n: [
          "sunset over buildings",
          "city_sunrise"
        ],
        u: {
          u: "1f307",
          x: 33,
          y: 36
        }
      },
      {
        n: [
          "bridge at night",
          "bridge_at_night"
        ],
        u: {
          u: "1f309",
          x: 34,
          y: 36
        }
      },
      {
        n: [
          "hot springs",
          "hotsprings"
        ],
        u: {
          u: "2668",
          x: 35,
          y: 36
        }
      },
      {
        n: [
          "milky way",
          "milky_way"
        ],
        u: {
          u: "1f30c",
          x: 36,
          y: 36
        }
      },
      {
        n: [
          "carousel horse",
          "carousel_horse"
        ],
        u: {
          u: "1f3a0",
          x: 37,
          y: 36
        }
      },
      {
        n: [
          "ferris wheel",
          "ferris_wheel"
        ],
        u: {
          u: "1f3a1",
          x: 38,
          y: 36
        }
      },
      {
        n: [
          "roller coaster",
          "roller_coaster"
        ],
        u: {
          u: "1f3a2",
          x: 39,
          y: 36
        }
      },
      {
        n: [
          "barber pole",
          "barber"
        ],
        u: {
          u: "1f488",
          x: 40,
          y: 36
        }
      },
      {
        n: [
          "circus tent",
          "circus_tent"
        ],
        u: {
          u: "1f3aa",
          x: 41,
          y: 36
        }
      },
      {
        n: [
          "performing arts",
          "performing_arts"
        ],
        u: {
          u: "1f3ad",
          x: 42,
          y: 36
        }
      },
      {
        n: [
          "frame_with_picture"
        ],
        u: {
          u: "1f5bc",
          x: 43,
          y: 36
        }
      },
      {
        n: [
          "artist palette",
          "art"
        ],
        u: {
          u: "1f3a8",
          x: 44,
          y: 36
        }
      },
      {
        n: [
          "slot machine",
          "slot_machine"
        ],
        u: {
          u: "1f3b0",
          x: 45,
          y: 36
        }
      },
      {
        n: [
          "steam locomotive",
          "steam_locomotive"
        ],
        u: {
          u: "1f682",
          x: 46,
          y: 36
        }
      },
      {
        n: [
          "railway car",
          "railway_car"
        ],
        u: {
          u: "1f683",
          x: 47,
          y: 36
        }
      },
      {
        n: [
          "high-speed train",
          "bullettrain_side"
        ],
        u: {
          u: "1f684",
          x: 48,
          y: 36
        }
      },
      {
        n: [
          "high-speed train with bullet nose",
          "bullettrain_front"
        ],
        u: {
          u: "1f685",
          x: 49,
          y: 36
        }
      },
      {
        n: [
          "train",
          "train2"
        ],
        u: {
          u: "1f686",
          x: 0,
          y: 37
        }
      },
      {
        n: [
          "metro"
        ],
        u: {
          u: "1f687",
          x: 1,
          y: 37
        }
      },
      {
        n: [
          "light rail",
          "light_rail"
        ],
        u: {
          u: "1f688",
          x: 2,
          y: 37
        }
      },
      {
        n: [
          "station"
        ],
        u: {
          u: "1f689",
          x: 3,
          y: 37
        }
      },
      {
        n: [
          "tram"
        ],
        u: {
          u: "1f68a",
          x: 4,
          y: 37
        }
      },
      {
        n: [
          "monorail"
        ],
        u: {
          u: "1f69d",
          x: 5,
          y: 37
        }
      },
      {
        n: [
          "mountain railway",
          "mountain_railway"
        ],
        u: {
          u: "1f69e",
          x: 6,
          y: 37
        }
      },
      {
        n: [
          "tram car",
          "train"
        ],
        u: {
          u: "1f68b",
          x: 7,
          y: 37
        }
      },
      {
        n: [
          "bus"
        ],
        u: {
          u: "1f68c",
          x: 8,
          y: 37
        }
      },
      {
        n: [
          "oncoming bus",
          "oncoming_bus"
        ],
        u: {
          u: "1f68d",
          x: 9,
          y: 37
        }
      },
      {
        n: [
          "trolleybus"
        ],
        u: {
          u: "1f68e",
          x: 10,
          y: 37
        }
      },
      {
        n: [
          "minibus"
        ],
        u: {
          u: "1f690",
          x: 11,
          y: 37
        }
      },
      {
        n: [
          "ambulance"
        ],
        u: {
          u: "1f691",
          x: 12,
          y: 37
        }
      },
      {
        n: [
          "fire engine",
          "fire_engine"
        ],
        u: {
          u: "1f692",
          x: 13,
          y: 37
        }
      },
      {
        n: [
          "police car",
          "police_car"
        ],
        u: {
          u: "1f693",
          x: 14,
          y: 37
        }
      },
      {
        n: [
          "oncoming police car",
          "oncoming_police_car"
        ],
        u: {
          u: "1f694",
          x: 15,
          y: 37
        }
      },
      {
        n: [
          "taxi"
        ],
        u: {
          u: "1f695",
          x: 16,
          y: 37
        }
      },
      {
        n: [
          "oncoming taxi",
          "oncoming_taxi"
        ],
        u: {
          u: "1f696",
          x: 17,
          y: 37
        }
      },
      {
        n: [
          "automobile",
          "car",
          "red_car"
        ],
        u: {
          u: "1f697",
          x: 18,
          y: 37
        }
      },
      {
        n: [
          "oncoming automobile",
          "oncoming_automobile"
        ],
        u: {
          u: "1f698",
          x: 19,
          y: 37
        }
      },
      {
        n: [
          "recreational vehicle",
          "blue_car"
        ],
        u: {
          u: "1f699",
          x: 20,
          y: 37
        }
      },
      {
        n: [
          "delivery truck",
          "truck"
        ],
        u: {
          u: "1f69a",
          x: 21,
          y: 37
        }
      },
      {
        n: [
          "articulated lorry",
          "articulated_lorry"
        ],
        u: {
          u: "1f69b",
          x: 22,
          y: 37
        }
      },
      {
        n: [
          "tractor"
        ],
        u: {
          u: "1f69c",
          x: 23,
          y: 37
        }
      },
      {
        n: [
          "bicycle",
          "bike"
        ],
        u: {
          u: "1f6b2",
          x: 24,
          y: 37
        }
      },
      {
        n: [
          "scooter"
        ],
        u: {
          u: "1f6f4",
          x: 25,
          y: 37
        }
      },
      {
        n: [
          "motor scooter",
          "motor_scooter"
        ],
        u: {
          u: "1f6f5",
          x: 26,
          y: 37
        }
      },
      {
        n: [
          "bus stop",
          "busstop"
        ],
        u: {
          u: "1f68f",
          x: 27,
          y: 37
        }
      },
      {
        n: [
          "motorway"
        ],
        u: {
          u: "1f6e3",
          x: 28,
          y: 37
        }
      },
      {
        n: [
          "railway_track"
        ],
        u: {
          u: "1f6e4",
          x: 29,
          y: 37
        }
      },
      {
        n: [
          "fuel pump",
          "fuelpump"
        ],
        u: {
          u: "26fd",
          x: 30,
          y: 37
        }
      },
      {
        n: [
          "police cars revolving light",
          "rotating_light"
        ],
        u: {
          u: "1f6a8",
          x: 31,
          y: 37
        }
      },
      {
        n: [
          "horizontal traffic light",
          "traffic_light"
        ],
        u: {
          u: "1f6a5",
          x: 32,
          y: 37
        }
      },
      {
        n: [
          "vertical traffic light",
          "vertical_traffic_light"
        ],
        u: {
          u: "1f6a6",
          x: 33,
          y: 37
        }
      },
      {
        n: [
          "construction sign",
          "construction"
        ],
        u: {
          u: "1f6a7",
          x: 34,
          y: 37
        }
      },
      {
        n: [
          "octagonal sign",
          "octagonal_sign"
        ],
        u: {
          u: "1f6d1",
          x: 35,
          y: 37
        }
      },
      {
        n: [
          "anchor"
        ],
        u: {
          u: "2693",
          x: 36,
          y: 37
        }
      },
      {
        n: [
          "sailboat",
          "boat"
        ],
        u: {
          u: "26f5",
          x: 37,
          y: 37
        }
      },
      {
        n: [
          "canoe"
        ],
        u: {
          u: "1f6f6",
          x: 38,
          y: 37
        }
      },
      {
        n: [
          "speedboat"
        ],
        u: {
          u: "1f6a4",
          x: 39,
          y: 37
        }
      },
      {
        n: [
          "passenger_ship"
        ],
        u: {
          u: "1f6f3",
          x: 40,
          y: 37
        }
      },
      {
        n: [
          "ferry"
        ],
        u: {
          u: "26f4",
          x: 41,
          y: 37
        }
      },
      {
        n: [
          "motor_boat"
        ],
        u: {
          u: "1f6e5",
          x: 42,
          y: 37
        }
      },
      {
        n: [
          "ship"
        ],
        u: {
          u: "1f6a2",
          x: 43,
          y: 37
        }
      },
      {
        n: [
          "airplane"
        ],
        u: {
          u: "2708",
          x: 44,
          y: 37
        }
      },
      {
        n: [
          "small_airplane"
        ],
        u: {
          u: "1f6e9",
          x: 45,
          y: 37
        }
      },
      {
        n: [
          "airplane departure",
          "airplane_departure"
        ],
        u: {
          u: "1f6eb",
          x: 46,
          y: 37
        }
      },
      {
        n: [
          "airplane arriving",
          "airplane_arriving"
        ],
        u: {
          u: "1f6ec",
          x: 47,
          y: 37
        }
      },
      {
        n: [
          "seat"
        ],
        u: {
          u: "1f4ba",
          x: 48,
          y: 37
        }
      },
      {
        n: [
          "helicopter"
        ],
        u: {
          u: "1f681",
          x: 49,
          y: 37
        }
      },
      {
        n: [
          "suspension railway",
          "suspension_railway"
        ],
        u: {
          u: "1f69f",
          x: 0,
          y: 38
        }
      },
      {
        n: [
          "mountain cableway",
          "mountain_cableway"
        ],
        u: {
          u: "1f6a0",
          x: 1,
          y: 38
        }
      },
      {
        n: [
          "aerial tramway",
          "aerial_tramway"
        ],
        u: {
          u: "1f6a1",
          x: 2,
          y: 38
        }
      },
      {
        n: [
          "satellite"
        ],
        u: {
          u: "1f6f0",
          x: 3,
          y: 38
        }
      },
      {
        n: [
          "rocket"
        ],
        u: {
          u: "1f680",
          x: 4,
          y: 38
        }
      },
      {
        n: [
          "flying saucer",
          "flying_saucer"
        ],
        u: {
          u: "1f6f8",
          x: 5,
          y: 38
        }
      },
      {
        n: [
          "bellhop_bell"
        ],
        u: {
          u: "1f6ce",
          x: 6,
          y: 38
        }
      },
      {
        n: [
          "door"
        ],
        u: {
          u: "1f6aa",
          x: 7,
          y: 38
        }
      },
      {
        n: [
          "bed"
        ],
        u: {
          u: "1f6cf",
          x: 8,
          y: 38
        }
      },
      {
        n: [
          "couch_and_lamp"
        ],
        u: {
          u: "1f6cb",
          x: 9,
          y: 38
        }
      },
      {
        n: [
          "toilet"
        ],
        u: {
          u: "1f6bd",
          x: 10,
          y: 38
        }
      },
      {
        n: [
          "shower"
        ],
        u: {
          u: "1f6bf",
          x: 11,
          y: 38
        }
      },
      {
        n: [
          "bathtub"
        ],
        u: {
          u: "1f6c1",
          x: 12,
          y: 38
        }
      },
      {
        n: [
          "hourglass"
        ],
        u: {
          u: "231b",
          x: 13,
          y: 38
        }
      },
      {
        n: [
          "hourglass with flowing sand",
          "hourglass_flowing_sand"
        ],
        u: {
          u: "23f3",
          x: 14,
          y: 38
        }
      },
      {
        n: [
          "watch"
        ],
        u: {
          u: "231a",
          x: 15,
          y: 38
        }
      },
      {
        n: [
          "alarm clock",
          "alarm_clock"
        ],
        u: {
          u: "23f0",
          x: 16,
          y: 38
        }
      },
      {
        n: [
          "stopwatch"
        ],
        u: {
          u: "23f1",
          x: 17,
          y: 38
        }
      },
      {
        n: [
          "timer_clock"
        ],
        u: {
          u: "23f2",
          x: 18,
          y: 38
        }
      },
      {
        n: [
          "mantelpiece_clock"
        ],
        u: {
          u: "1f570",
          x: 19,
          y: 38
        }
      },
      {
        n: [
          "clock face twelve oclock",
          "clock12"
        ],
        u: {
          u: "1f55b",
          x: 20,
          y: 38
        }
      },
      {
        n: [
          "clock face twelve-thirty",
          "clock1230"
        ],
        u: {
          u: "1f567",
          x: 21,
          y: 38
        }
      },
      {
        n: [
          "clock face one oclock",
          "clock1"
        ],
        u: {
          u: "1f550",
          x: 22,
          y: 38
        }
      },
      {
        n: [
          "clock face one-thirty",
          "clock130"
        ],
        u: {
          u: "1f55c",
          x: 23,
          y: 38
        }
      },
      {
        n: [
          "clock face two oclock",
          "clock2"
        ],
        u: {
          u: "1f551",
          x: 24,
          y: 38
        }
      },
      {
        n: [
          "clock face two-thirty",
          "clock230"
        ],
        u: {
          u: "1f55d",
          x: 25,
          y: 38
        }
      },
      {
        n: [
          "clock face three oclock",
          "clock3"
        ],
        u: {
          u: "1f552",
          x: 26,
          y: 38
        }
      },
      {
        n: [
          "clock face three-thirty",
          "clock330"
        ],
        u: {
          u: "1f55e",
          x: 27,
          y: 38
        }
      },
      {
        n: [
          "clock face four oclock",
          "clock4"
        ],
        u: {
          u: "1f553",
          x: 28,
          y: 38
        }
      },
      {
        n: [
          "clock face four-thirty",
          "clock430"
        ],
        u: {
          u: "1f55f",
          x: 29,
          y: 38
        }
      },
      {
        n: [
          "clock face five oclock",
          "clock5"
        ],
        u: {
          u: "1f554",
          x: 30,
          y: 38
        }
      },
      {
        n: [
          "clock face five-thirty",
          "clock530"
        ],
        u: {
          u: "1f560",
          x: 31,
          y: 38
        }
      },
      {
        n: [
          "clock face six oclock",
          "clock6"
        ],
        u: {
          u: "1f555",
          x: 32,
          y: 38
        }
      },
      {
        n: [
          "clock face six-thirty",
          "clock630"
        ],
        u: {
          u: "1f561",
          x: 33,
          y: 38
        }
      },
      {
        n: [
          "clock face seven oclock",
          "clock7"
        ],
        u: {
          u: "1f556",
          x: 34,
          y: 38
        }
      },
      {
        n: [
          "clock face seven-thirty",
          "clock730"
        ],
        u: {
          u: "1f562",
          x: 35,
          y: 38
        }
      },
      {
        n: [
          "clock face eight oclock",
          "clock8"
        ],
        u: {
          u: "1f557",
          x: 36,
          y: 38
        }
      },
      {
        n: [
          "clock face eight-thirty",
          "clock830"
        ],
        u: {
          u: "1f563",
          x: 37,
          y: 38
        }
      },
      {
        n: [
          "clock face nine oclock",
          "clock9"
        ],
        u: {
          u: "1f558",
          x: 38,
          y: 38
        }
      },
      {
        n: [
          "clock face nine-thirty",
          "clock930"
        ],
        u: {
          u: "1f564",
          x: 39,
          y: 38
        }
      },
      {
        n: [
          "clock face ten oclock",
          "clock10"
        ],
        u: {
          u: "1f559",
          x: 40,
          y: 38
        }
      },
      {
        n: [
          "clock face ten-thirty",
          "clock1030"
        ],
        u: {
          u: "1f565",
          x: 41,
          y: 38
        }
      },
      {
        n: [
          "clock face eleven oclock",
          "clock11"
        ],
        u: {
          u: "1f55a",
          x: 42,
          y: 38
        }
      },
      {
        n: [
          "clock face eleven-thirty",
          "clock1130"
        ],
        u: {
          u: "1f566",
          x: 43,
          y: 38
        }
      },
      {
        n: [
          "new moon symbol",
          "new_moon"
        ],
        u: {
          u: "1f311",
          x: 44,
          y: 38
        }
      },
      {
        n: [
          "waxing crescent moon symbol",
          "waxing_crescent_moon"
        ],
        u: {
          u: "1f312",
          x: 45,
          y: 38
        }
      },
      {
        n: [
          "first quarter moon symbol",
          "first_quarter_moon"
        ],
        u: {
          u: "1f313",
          x: 46,
          y: 38
        }
      },
      {
        n: [
          "waxing gibbous moon symbol",
          "moon",
          "waxing_gibbous_moon"
        ],
        u: {
          u: "1f314",
          x: 47,
          y: 38
        }
      },
      {
        n: [
          "full moon symbol",
          "full_moon"
        ],
        u: {
          u: "1f315",
          x: 48,
          y: 38
        }
      },
      {
        n: [
          "waning gibbous moon symbol",
          "waning_gibbous_moon"
        ],
        u: {
          u: "1f316",
          x: 49,
          y: 38
        }
      },
      {
        n: [
          "last quarter moon symbol",
          "last_quarter_moon"
        ],
        u: {
          u: "1f317",
          x: 0,
          y: 39
        }
      },
      {
        n: [
          "waning crescent moon symbol",
          "waning_crescent_moon"
        ],
        u: {
          u: "1f318",
          x: 1,
          y: 39
        }
      },
      {
        n: [
          "crescent moon",
          "crescent_moon"
        ],
        u: {
          u: "1f319",
          x: 2,
          y: 39
        }
      },
      {
        n: [
          "new moon with face",
          "new_moon_with_face"
        ],
        u: {
          u: "1f31a",
          x: 3,
          y: 39
        }
      },
      {
        n: [
          "first quarter moon with face",
          "first_quarter_moon_with_face"
        ],
        u: {
          u: "1f31b",
          x: 4,
          y: 39
        }
      },
      {
        n: [
          "last quarter moon with face",
          "last_quarter_moon_with_face"
        ],
        u: {
          u: "1f31c",
          x: 5,
          y: 39
        }
      },
      {
        n: [
          "thermometer"
        ],
        u: {
          u: "1f321",
          x: 6,
          y: 39
        }
      },
      {
        n: [
          "black sun with rays",
          "sunny"
        ],
        u: {
          u: "2600",
          x: 7,
          y: 39
        }
      },
      {
        n: [
          "full moon with face",
          "full_moon_with_face"
        ],
        u: {
          u: "1f31d",
          x: 8,
          y: 39
        }
      },
      {
        n: [
          "sun with face",
          "sun_with_face"
        ],
        u: {
          u: "1f31e",
          x: 9,
          y: 39
        }
      },
      {
        n: [
          "white medium star",
          "star"
        ],
        u: {
          u: "2b50",
          x: 10,
          y: 39
        }
      },
      {
        n: [
          "glowing star",
          "star2"
        ],
        u: {
          u: "1f31f",
          x: 11,
          y: 39
        }
      },
      {
        n: [
          "shooting star",
          "stars"
        ],
        u: {
          u: "1f320",
          x: 12,
          y: 39
        }
      },
      {
        n: [
          "cloud"
        ],
        u: {
          u: "2601",
          x: 13,
          y: 39
        }
      },
      {
        n: [
          "sun behind cloud",
          "partly_sunny"
        ],
        u: {
          u: "26c5",
          x: 14,
          y: 39
        }
      },
      {
        n: [
          "thunder_cloud_and_rain"
        ],
        u: {
          u: "26c8",
          x: 15,
          y: 39
        }
      },
      {
        n: [
          "mostly_sunny",
          "sun_small_cloud"
        ],
        u: {
          u: "1f324",
          x: 16,
          y: 39
        }
      },
      {
        n: [
          "barely_sunny",
          "sun_behind_cloud"
        ],
        u: {
          u: "1f325",
          x: 17,
          y: 39
        }
      },
      {
        n: [
          "partly_sunny_rain",
          "sun_behind_rain_cloud"
        ],
        u: {
          u: "1f326",
          x: 18,
          y: 39
        }
      },
      {
        n: [
          "rain_cloud"
        ],
        u: {
          u: "1f327",
          x: 19,
          y: 39
        }
      },
      {
        n: [
          "snow_cloud"
        ],
        u: {
          u: "1f328",
          x: 20,
          y: 39
        }
      },
      {
        n: [
          "lightning",
          "lightning_cloud"
        ],
        u: {
          u: "1f329",
          x: 21,
          y: 39
        }
      },
      {
        n: [
          "tornado",
          "tornado_cloud"
        ],
        u: {
          u: "1f32a",
          x: 22,
          y: 39
        }
      },
      {
        n: [
          "fog"
        ],
        u: {
          u: "1f32b",
          x: 23,
          y: 39
        }
      },
      {
        n: [
          "wind_blowing_face"
        ],
        u: {
          u: "1f32c",
          x: 24,
          y: 39
        }
      },
      {
        n: [
          "cyclone"
        ],
        u: {
          u: "1f300",
          x: 25,
          y: 39
        }
      },
      {
        n: [
          "rainbow"
        ],
        u: {
          u: "1f308",
          x: 26,
          y: 39
        }
      },
      {
        n: [
          "closed umbrella",
          "closed_umbrella"
        ],
        u: {
          u: "1f302",
          x: 27,
          y: 39
        }
      },
      {
        n: [
          "umbrella"
        ],
        u: {
          u: "2602",
          x: 28,
          y: 39
        }
      },
      {
        n: [
          "umbrella with rain drops",
          "umbrella_with_rain_drops"
        ],
        u: {
          u: "2614",
          x: 29,
          y: 39
        }
      },
      {
        n: [
          "umbrella_on_ground"
        ],
        u: {
          u: "26f1",
          x: 30,
          y: 39
        }
      },
      {
        n: [
          "high voltage sign",
          "zap"
        ],
        u: {
          u: "26a1",
          x: 31,
          y: 39
        }
      },
      {
        n: [
          "snowflake"
        ],
        u: {
          u: "2744",
          x: 32,
          y: 39
        }
      },
      {
        n: [
          "snowman"
        ],
        u: {
          u: "2603",
          x: 33,
          y: 39
        }
      },
      {
        n: [
          "snowman without snow",
          "snowman_without_snow"
        ],
        u: {
          u: "26c4",
          x: 34,
          y: 39
        }
      },
      {
        n: [
          "comet"
        ],
        u: {
          u: "2604",
          x: 35,
          y: 39
        }
      },
      {
        n: [
          "fire"
        ],
        u: {
          u: "1f525",
          x: 36,
          y: 39
        }
      },
      {
        n: [
          "droplet"
        ],
        u: {
          u: "1f4a7",
          x: 37,
          y: 39
        }
      },
      {
        n: [
          "water wave",
          "ocean"
        ],
        u: {
          u: "1f30a",
          x: 38,
          y: 39
        }
      }
    ],
    key: "travel_places",
    title: "Travel & Places",
    u: "1f698"
  },
  {
    emojis: [
      {
        n: [
          "speaker with cancellation stroke",
          "mute"
        ],
        u: {
          u: "1f507",
          x: 39,
          y: 39
        }
      },
      {
        n: [
          "speaker"
        ],
        u: {
          u: "1f508",
          x: 40,
          y: 39
        }
      },
      {
        n: [
          "speaker with one sound wave",
          "sound"
        ],
        u: {
          u: "1f509",
          x: 41,
          y: 39
        }
      },
      {
        n: [
          "speaker with three sound waves",
          "loud_sound"
        ],
        u: {
          u: "1f50a",
          x: 42,
          y: 39
        }
      },
      {
        n: [
          "public address loudspeaker",
          "loudspeaker"
        ],
        u: {
          u: "1f4e2",
          x: 43,
          y: 39
        }
      },
      {
        n: [
          "cheering megaphone",
          "mega"
        ],
        u: {
          u: "1f4e3",
          x: 44,
          y: 39
        }
      },
      {
        n: [
          "postal horn",
          "postal_horn"
        ],
        u: {
          u: "1f4ef",
          x: 45,
          y: 39
        }
      },
      {
        n: [
          "bell"
        ],
        u: {
          u: "1f514",
          x: 46,
          y: 39
        }
      },
      {
        n: [
          "bell with cancellation stroke",
          "no_bell"
        ],
        u: {
          u: "1f515",
          x: 47,
          y: 39
        }
      },
      {
        n: [
          "musical score",
          "musical_score"
        ],
        u: {
          u: "1f3bc",
          x: 48,
          y: 39
        }
      },
      {
        n: [
          "musical note",
          "musical_note"
        ],
        u: {
          u: "1f3b5",
          x: 49,
          y: 39
        }
      },
      {
        n: [
          "multiple musical notes",
          "notes"
        ],
        u: {
          u: "1f3b6",
          x: 0,
          y: 40
        }
      },
      {
        n: [
          "studio_microphone"
        ],
        u: {
          u: "1f399",
          x: 1,
          y: 40
        }
      },
      {
        n: [
          "level_slider"
        ],
        u: {
          u: "1f39a",
          x: 2,
          y: 40
        }
      },
      {
        n: [
          "control_knobs"
        ],
        u: {
          u: "1f39b",
          x: 3,
          y: 40
        }
      },
      {
        n: [
          "microphone"
        ],
        u: {
          u: "1f3a4",
          x: 4,
          y: 40
        }
      },
      {
        n: [
          "headphone",
          "headphones"
        ],
        u: {
          u: "1f3a7",
          x: 5,
          y: 40
        }
      },
      {
        n: [
          "radio"
        ],
        u: {
          u: "1f4fb",
          x: 6,
          y: 40
        }
      },
      {
        n: [
          "saxophone"
        ],
        u: {
          u: "1f3b7",
          x: 7,
          y: 40
        }
      },
      {
        n: [
          "guitar"
        ],
        u: {
          u: "1f3b8",
          x: 8,
          y: 40
        }
      },
      {
        n: [
          "musical keyboard",
          "musical_keyboard"
        ],
        u: {
          u: "1f3b9",
          x: 9,
          y: 40
        }
      },
      {
        n: [
          "trumpet"
        ],
        u: {
          u: "1f3ba",
          x: 10,
          y: 40
        }
      },
      {
        n: [
          "violin"
        ],
        u: {
          u: "1f3bb",
          x: 11,
          y: 40
        }
      },
      {
        n: [
          "drum with drumsticks",
          "drum_with_drumsticks"
        ],
        u: {
          u: "1f941",
          x: 12,
          y: 40
        }
      },
      {
        n: [
          "mobile phone",
          "iphone"
        ],
        u: {
          u: "1f4f1",
          x: 13,
          y: 40
        }
      },
      {
        n: [
          "mobile phone with rightwards arrow at left",
          "calling"
        ],
        u: {
          u: "1f4f2",
          x: 14,
          y: 40
        }
      },
      {
        n: [
          "black telephone",
          "phone",
          "telephone"
        ],
        u: {
          u: "260e",
          x: 15,
          y: 40
        }
      },
      {
        n: [
          "telephone receiver",
          "telephone_receiver"
        ],
        u: {
          u: "1f4de",
          x: 16,
          y: 40
        }
      },
      {
        n: [
          "pager"
        ],
        u: {
          u: "1f4df",
          x: 17,
          y: 40
        }
      },
      {
        n: [
          "fax machine",
          "fax"
        ],
        u: {
          u: "1f4e0",
          x: 18,
          y: 40
        }
      },
      {
        n: [
          "battery"
        ],
        u: {
          u: "1f50b",
          x: 19,
          y: 40
        }
      },
      {
        n: [
          "electric plug",
          "electric_plug"
        ],
        u: {
          u: "1f50c",
          x: 20,
          y: 40
        }
      },
      {
        n: [
          "personal computer",
          "computer"
        ],
        u: {
          u: "1f4bb",
          x: 21,
          y: 40
        }
      },
      {
        n: [
          "desktop_computer"
        ],
        u: {
          u: "1f5a5",
          x: 22,
          y: 40
        }
      },
      {
        n: [
          "printer"
        ],
        u: {
          u: "1f5a8",
          x: 23,
          y: 40
        }
      },
      {
        n: [
          "keyboard"
        ],
        u: {
          u: "2328",
          x: 24,
          y: 40
        }
      },
      {
        n: [
          "three_button_mouse"
        ],
        u: {
          u: "1f5b1",
          x: 25,
          y: 40
        }
      },
      {
        n: [
          "trackball"
        ],
        u: {
          u: "1f5b2",
          x: 26,
          y: 40
        }
      },
      {
        n: [
          "minidisc"
        ],
        u: {
          u: "1f4bd",
          x: 27,
          y: 40
        }
      },
      {
        n: [
          "floppy disk",
          "floppy_disk"
        ],
        u: {
          u: "1f4be",
          x: 28,
          y: 40
        }
      },
      {
        n: [
          "optical disc",
          "cd"
        ],
        u: {
          u: "1f4bf",
          x: 29,
          y: 40
        }
      },
      {
        n: [
          "dvd"
        ],
        u: {
          u: "1f4c0",
          x: 30,
          y: 40
        }
      },
      {
        n: [
          "movie camera",
          "movie_camera"
        ],
        u: {
          u: "1f3a5",
          x: 31,
          y: 40
        }
      },
      {
        n: [
          "film_frames"
        ],
        u: {
          u: "1f39e",
          x: 32,
          y: 40
        }
      },
      {
        n: [
          "film_projector"
        ],
        u: {
          u: "1f4fd",
          x: 33,
          y: 40
        }
      },
      {
        n: [
          "clapper board",
          "clapper"
        ],
        u: {
          u: "1f3ac",
          x: 34,
          y: 40
        }
      },
      {
        n: [
          "television",
          "tv"
        ],
        u: {
          u: "1f4fa",
          x: 35,
          y: 40
        }
      },
      {
        n: [
          "camera"
        ],
        u: {
          u: "1f4f7",
          x: 36,
          y: 40
        }
      },
      {
        n: [
          "camera with flash",
          "camera_with_flash"
        ],
        u: {
          u: "1f4f8",
          x: 37,
          y: 40
        }
      },
      {
        n: [
          "video camera",
          "video_camera"
        ],
        u: {
          u: "1f4f9",
          x: 38,
          y: 40
        }
      },
      {
        n: [
          "videocassette",
          "vhs"
        ],
        u: {
          u: "1f4fc",
          x: 39,
          y: 40
        }
      },
      {
        n: [
          "left-pointing magnifying glass",
          "mag"
        ],
        u: {
          u: "1f50d",
          x: 40,
          y: 40
        }
      },
      {
        n: [
          "right-pointing magnifying glass",
          "mag_right"
        ],
        u: {
          u: "1f50e",
          x: 41,
          y: 40
        }
      },
      {
        n: [
          "microscope"
        ],
        u: {
          u: "1f52c",
          x: 42,
          y: 40
        }
      },
      {
        n: [
          "telescope"
        ],
        u: {
          u: "1f52d",
          x: 43,
          y: 40
        }
      },
      {
        n: [
          "satellite antenna",
          "satellite_antenna"
        ],
        u: {
          u: "1f4e1",
          x: 44,
          y: 40
        }
      },
      {
        n: [
          "candle"
        ],
        u: {
          u: "1f56f",
          x: 45,
          y: 40
        }
      },
      {
        n: [
          "electric light bulb",
          "bulb"
        ],
        u: {
          u: "1f4a1",
          x: 46,
          y: 40
        }
      },
      {
        n: [
          "electric torch",
          "flashlight"
        ],
        u: {
          u: "1f526",
          x: 47,
          y: 40
        }
      },
      {
        n: [
          "izakaya lantern",
          "izakaya_lantern",
          "lantern"
        ],
        u: {
          u: "1f3ee",
          x: 48,
          y: 40
        }
      },
      {
        n: [
          "notebook with decorative cover",
          "notebook_with_decorative_cover"
        ],
        u: {
          u: "1f4d4",
          x: 49,
          y: 40
        }
      },
      {
        n: [
          "closed book",
          "closed_book"
        ],
        u: {
          u: "1f4d5",
          x: 0,
          y: 41
        }
      },
      {
        n: [
          "open book",
          "book",
          "open_book"
        ],
        u: {
          u: "1f4d6",
          x: 1,
          y: 41
        }
      },
      {
        n: [
          "green book",
          "green_book"
        ],
        u: {
          u: "1f4d7",
          x: 2,
          y: 41
        }
      },
      {
        n: [
          "blue book",
          "blue_book"
        ],
        u: {
          u: "1f4d8",
          x: 3,
          y: 41
        }
      },
      {
        n: [
          "orange book",
          "orange_book"
        ],
        u: {
          u: "1f4d9",
          x: 4,
          y: 41
        }
      },
      {
        n: [
          "books"
        ],
        u: {
          u: "1f4da",
          x: 5,
          y: 41
        }
      },
      {
        n: [
          "notebook"
        ],
        u: {
          u: "1f4d3",
          x: 6,
          y: 41
        }
      },
      {
        n: [
          "ledger"
        ],
        u: {
          u: "1f4d2",
          x: 7,
          y: 41
        }
      },
      {
        n: [
          "page with curl",
          "page_with_curl"
        ],
        u: {
          u: "1f4c3",
          x: 8,
          y: 41
        }
      },
      {
        n: [
          "scroll"
        ],
        u: {
          u: "1f4dc",
          x: 9,
          y: 41
        }
      },
      {
        n: [
          "page facing up",
          "page_facing_up"
        ],
        u: {
          u: "1f4c4",
          x: 10,
          y: 41
        }
      },
      {
        n: [
          "newspaper"
        ],
        u: {
          u: "1f4f0",
          x: 11,
          y: 41
        }
      },
      {
        n: [
          "rolled_up_newspaper"
        ],
        u: {
          u: "1f5de",
          x: 12,
          y: 41
        }
      },
      {
        n: [
          "bookmark tabs",
          "bookmark_tabs"
        ],
        u: {
          u: "1f4d1",
          x: 13,
          y: 41
        }
      },
      {
        n: [
          "bookmark"
        ],
        u: {
          u: "1f516",
          x: 14,
          y: 41
        }
      },
      {
        n: [
          "label"
        ],
        u: {
          u: "1f3f7",
          x: 15,
          y: 41
        }
      },
      {
        n: [
          "money bag",
          "moneybag"
        ],
        u: {
          u: "1f4b0",
          x: 16,
          y: 41
        }
      },
      {
        n: [
          "banknote with yen sign",
          "yen"
        ],
        u: {
          u: "1f4b4",
          x: 17,
          y: 41
        }
      },
      {
        n: [
          "banknote with dollar sign",
          "dollar"
        ],
        u: {
          u: "1f4b5",
          x: 18,
          y: 41
        }
      },
      {
        n: [
          "banknote with euro sign",
          "euro"
        ],
        u: {
          u: "1f4b6",
          x: 19,
          y: 41
        }
      },
      {
        n: [
          "banknote with pound sign",
          "pound"
        ],
        u: {
          u: "1f4b7",
          x: 20,
          y: 41
        }
      },
      {
        n: [
          "money with wings",
          "money_with_wings"
        ],
        u: {
          u: "1f4b8",
          x: 21,
          y: 41
        }
      },
      {
        n: [
          "credit card",
          "credit_card"
        ],
        u: {
          u: "1f4b3",
          x: 22,
          y: 41
        }
      },
      {
        n: [
          "chart with upwards trend and yen sign",
          "chart"
        ],
        u: {
          u: "1f4b9",
          x: 23,
          y: 41
        }
      },
      {
        n: [
          "currency exchange",
          "currency_exchange"
        ],
        u: {
          u: "1f4b1",
          x: 24,
          y: 41
        }
      },
      {
        n: [
          "heavy dollar sign",
          "heavy_dollar_sign"
        ],
        u: {
          u: "1f4b2",
          x: 25,
          y: 41
        }
      },
      {
        n: [
          "envelope",
          "email"
        ],
        u: {
          u: "2709",
          x: 26,
          y: 41
        }
      },
      {
        n: [
          "e-mail symbol",
          "e-mail"
        ],
        u: {
          u: "1f4e7",
          x: 27,
          y: 41
        }
      },
      {
        n: [
          "incoming envelope",
          "incoming_envelope"
        ],
        u: {
          u: "1f4e8",
          x: 28,
          y: 41
        }
      },
      {
        n: [
          "envelope with downwards arrow above",
          "envelope_with_arrow"
        ],
        u: {
          u: "1f4e9",
          x: 29,
          y: 41
        }
      },
      {
        n: [
          "outbox tray",
          "outbox_tray"
        ],
        u: {
          u: "1f4e4",
          x: 30,
          y: 41
        }
      },
      {
        n: [
          "inbox tray",
          "inbox_tray"
        ],
        u: {
          u: "1f4e5",
          x: 31,
          y: 41
        }
      },
      {
        n: [
          "package"
        ],
        u: {
          u: "1f4e6",
          x: 32,
          y: 41
        }
      },
      {
        n: [
          "closed mailbox with raised flag",
          "mailbox"
        ],
        u: {
          u: "1f4eb",
          x: 33,
          y: 41
        }
      },
      {
        n: [
          "closed mailbox with lowered flag",
          "mailbox_closed"
        ],
        u: {
          u: "1f4ea",
          x: 34,
          y: 41
        }
      },
      {
        n: [
          "open mailbox with raised flag",
          "mailbox_with_mail"
        ],
        u: {
          u: "1f4ec",
          x: 35,
          y: 41
        }
      },
      {
        n: [
          "open mailbox with lowered flag",
          "mailbox_with_no_mail"
        ],
        u: {
          u: "1f4ed",
          x: 36,
          y: 41
        }
      },
      {
        n: [
          "postbox"
        ],
        u: {
          u: "1f4ee",
          x: 37,
          y: 41
        }
      },
      {
        n: [
          "ballot_box_with_ballot"
        ],
        u: {
          u: "1f5f3",
          x: 38,
          y: 41
        }
      },
      {
        n: [
          "pencil",
          "pencil2"
        ],
        u: {
          u: "270f",
          x: 39,
          y: 41
        }
      },
      {
        n: [
          "black nib",
          "black_nib"
        ],
        u: {
          u: "2712",
          x: 40,
          y: 41
        }
      },
      {
        n: [
          "lower_left_fountain_pen"
        ],
        u: {
          u: "1f58b",
          x: 41,
          y: 41
        }
      },
      {
        n: [
          "lower_left_ballpoint_pen"
        ],
        u: {
          u: "1f58a",
          x: 42,
          y: 41
        }
      },
      {
        n: [
          "lower_left_paintbrush"
        ],
        u: {
          u: "1f58c",
          x: 43,
          y: 41
        }
      },
      {
        n: [
          "lower_left_crayon"
        ],
        u: {
          u: "1f58d",
          x: 44,
          y: 41
        }
      },
      {
        n: [
          "memo",
          "pencil"
        ],
        u: {
          u: "1f4dd",
          x: 45,
          y: 41
        }
      },
      {
        n: [
          "briefcase"
        ],
        u: {
          u: "1f4bc",
          x: 46,
          y: 41
        }
      },
      {
        n: [
          "file folder",
          "file_folder"
        ],
        u: {
          u: "1f4c1",
          x: 47,
          y: 41
        }
      },
      {
        n: [
          "open file folder",
          "open_file_folder"
        ],
        u: {
          u: "1f4c2",
          x: 48,
          y: 41
        }
      },
      {
        n: [
          "card_index_dividers"
        ],
        u: {
          u: "1f5c2",
          x: 49,
          y: 41
        }
      },
      {
        n: [
          "calendar",
          "date"
        ],
        u: {
          u: "1f4c5",
          x: 0,
          y: 42
        }
      },
      {
        n: [
          "tear-off calendar",
          "calendar"
        ],
        u: {
          u: "1f4c6",
          x: 1,
          y: 42
        }
      },
      {
        n: [
          "spiral_note_pad"
        ],
        u: {
          u: "1f5d2",
          x: 2,
          y: 42
        }
      },
      {
        n: [
          "spiral_calendar_pad"
        ],
        u: {
          u: "1f5d3",
          x: 3,
          y: 42
        }
      },
      {
        n: [
          "card index",
          "card_index"
        ],
        u: {
          u: "1f4c7",
          x: 4,
          y: 42
        }
      },
      {
        n: [
          "chart with upwards trend",
          "chart_with_upwards_trend"
        ],
        u: {
          u: "1f4c8",
          x: 5,
          y: 42
        }
      },
      {
        n: [
          "chart with downwards trend",
          "chart_with_downwards_trend"
        ],
        u: {
          u: "1f4c9",
          x: 6,
          y: 42
        }
      },
      {
        n: [
          "bar chart",
          "bar_chart"
        ],
        u: {
          u: "1f4ca",
          x: 7,
          y: 42
        }
      },
      {
        n: [
          "clipboard"
        ],
        u: {
          u: "1f4cb",
          x: 8,
          y: 42
        }
      },
      {
        n: [
          "pushpin"
        ],
        u: {
          u: "1f4cc",
          x: 9,
          y: 42
        }
      },
      {
        n: [
          "round pushpin",
          "round_pushpin"
        ],
        u: {
          u: "1f4cd",
          x: 10,
          y: 42
        }
      },
      {
        n: [
          "paperclip"
        ],
        u: {
          u: "1f4ce",
          x: 11,
          y: 42
        }
      },
      {
        n: [
          "linked_paperclips"
        ],
        u: {
          u: "1f587",
          x: 12,
          y: 42
        }
      },
      {
        n: [
          "straight ruler",
          "straight_ruler"
        ],
        u: {
          u: "1f4cf",
          x: 13,
          y: 42
        }
      },
      {
        n: [
          "triangular ruler",
          "triangular_ruler"
        ],
        u: {
          u: "1f4d0",
          x: 14,
          y: 42
        }
      },
      {
        n: [
          "black scissors",
          "scissors"
        ],
        u: {
          u: "2702",
          x: 15,
          y: 42
        }
      },
      {
        n: [
          "card_file_box"
        ],
        u: {
          u: "1f5c3",
          x: 16,
          y: 42
        }
      },
      {
        n: [
          "file_cabinet"
        ],
        u: {
          u: "1f5c4",
          x: 17,
          y: 42
        }
      },
      {
        n: [
          "wastebasket"
        ],
        u: {
          u: "1f5d1",
          x: 18,
          y: 42
        }
      },
      {
        n: [
          "lock"
        ],
        u: {
          u: "1f512",
          x: 19,
          y: 42
        }
      },
      {
        n: [
          "open lock",
          "unlock"
        ],
        u: {
          u: "1f513",
          x: 20,
          y: 42
        }
      },
      {
        n: [
          "lock with ink pen",
          "lock_with_ink_pen"
        ],
        u: {
          u: "1f50f",
          x: 21,
          y: 42
        }
      },
      {
        n: [
          "closed lock with key",
          "closed_lock_with_key"
        ],
        u: {
          u: "1f510",
          x: 22,
          y: 42
        }
      },
      {
        n: [
          "key"
        ],
        u: {
          u: "1f511",
          x: 23,
          y: 42
        }
      },
      {
        n: [
          "old_key"
        ],
        u: {
          u: "1f5dd",
          x: 24,
          y: 42
        }
      },
      {
        n: [
          "hammer"
        ],
        u: {
          u: "1f528",
          x: 25,
          y: 42
        }
      },
      {
        n: [
          "pick"
        ],
        u: {
          u: "26cf",
          x: 26,
          y: 42
        }
      },
      {
        n: [
          "hammer_and_pick"
        ],
        u: {
          u: "2692",
          x: 27,
          y: 42
        }
      },
      {
        n: [
          "hammer_and_wrench"
        ],
        u: {
          u: "1f6e0",
          x: 28,
          y: 42
        }
      },
      {
        n: [
          "dagger_knife"
        ],
        u: {
          u: "1f5e1",
          x: 29,
          y: 42
        }
      },
      {
        n: [
          "crossed_swords"
        ],
        u: {
          u: "2694",
          x: 30,
          y: 42
        }
      },
      {
        n: [
          "pistol",
          "gun"
        ],
        u: {
          u: "1f52b",
          x: 31,
          y: 42
        }
      },
      {
        n: [
          "bow and arrow",
          "bow_and_arrow"
        ],
        u: {
          u: "1f3f9",
          x: 32,
          y: 42
        }
      },
      {
        n: [
          "shield"
        ],
        u: {
          u: "1f6e1",
          x: 33,
          y: 42
        }
      },
      {
        n: [
          "wrench"
        ],
        u: {
          u: "1f527",
          x: 34,
          y: 42
        }
      },
      {
        n: [
          "nut and bolt",
          "nut_and_bolt"
        ],
        u: {
          u: "1f529",
          x: 35,
          y: 42
        }
      },
      {
        n: [
          "gear"
        ],
        u: {
          u: "2699",
          x: 36,
          y: 42
        }
      },
      {
        n: [
          "compression"
        ],
        u: {
          u: "1f5dc",
          x: 37,
          y: 42
        }
      },
      {
        n: [
          "alembic"
        ],
        u: {
          u: "2697",
          x: 38,
          y: 42
        }
      },
      {
        n: [
          "scales"
        ],
        u: {
          u: "2696",
          x: 39,
          y: 42
        }
      },
      {
        n: [
          "link symbol",
          "link"
        ],
        u: {
          u: "1f517",
          x: 40,
          y: 42
        }
      },
      {
        n: [
          "chains"
        ],
        u: {
          u: "26d3",
          x: 41,
          y: 42
        }
      },
      {
        n: [
          "syringe"
        ],
        u: {
          u: "1f489",
          x: 42,
          y: 42
        }
      },
      {
        n: [
          "pill"
        ],
        u: {
          u: "1f48a",
          x: 43,
          y: 42
        }
      },
      {
        n: [
          "smoking symbol",
          "smoking"
        ],
        u: {
          u: "1f6ac",
          x: 44,
          y: 42
        }
      },
      {
        n: [
          "coffin"
        ],
        u: {
          u: "26b0",
          x: 45,
          y: 42
        }
      },
      {
        n: [
          "funeral_urn"
        ],
        u: {
          u: "26b1",
          x: 46,
          y: 42
        }
      },
      {
        n: [
          "moyai"
        ],
        u: {
          u: "1f5ff",
          x: 47,
          y: 42
        }
      },
      {
        n: [
          "oil_drum"
        ],
        u: {
          u: "1f6e2",
          x: 48,
          y: 42
        }
      },
      {
        n: [
          "crystal ball",
          "crystal_ball"
        ],
        u: {
          u: "1f52e",
          x: 49,
          y: 42
        }
      },
      {
        n: [
          "shopping trolley",
          "shopping_trolley"
        ],
        u: {
          u: "1f6d2",
          x: 0,
          y: 43
        }
      }
    ],
    key: "objects",
    title: "Objects",
    u: "1f4a1"
  },
  {
    emojis: [
      {
        n: [
          "automated teller machine",
          "atm"
        ],
        u: {
          u: "1f3e7",
          x: 1,
          y: 43
        }
      },
      {
        n: [
          "put litter in its place symbol",
          "put_litter_in_its_place"
        ],
        u: {
          u: "1f6ae",
          x: 2,
          y: 43
        }
      },
      {
        n: [
          "potable water symbol",
          "potable_water"
        ],
        u: {
          u: "1f6b0",
          x: 3,
          y: 43
        }
      },
      {
        n: [
          "wheelchair symbol",
          "wheelchair"
        ],
        u: {
          u: "267f",
          x: 4,
          y: 43
        }
      },
      {
        n: [
          "mens symbol",
          "mens"
        ],
        u: {
          u: "1f6b9",
          x: 5,
          y: 43
        }
      },
      {
        n: [
          "womens symbol",
          "womens"
        ],
        u: {
          u: "1f6ba",
          x: 6,
          y: 43
        }
      },
      {
        n: [
          "restroom"
        ],
        u: {
          u: "1f6bb",
          x: 7,
          y: 43
        }
      },
      {
        n: [
          "baby symbol",
          "baby_symbol"
        ],
        u: {
          u: "1f6bc",
          x: 8,
          y: 43
        }
      },
      {
        n: [
          "water closet",
          "wc"
        ],
        u: {
          u: "1f6be",
          x: 9,
          y: 43
        }
      },
      {
        n: [
          "passport control",
          "passport_control"
        ],
        u: {
          u: "1f6c2",
          x: 10,
          y: 43
        }
      },
      {
        n: [
          "customs"
        ],
        u: {
          u: "1f6c3",
          x: 11,
          y: 43
        }
      },
      {
        n: [
          "baggage claim",
          "baggage_claim"
        ],
        u: {
          u: "1f6c4",
          x: 12,
          y: 43
        }
      },
      {
        n: [
          "left luggage",
          "left_luggage"
        ],
        u: {
          u: "1f6c5",
          x: 13,
          y: 43
        }
      },
      {
        n: [
          "warning sign",
          "warning"
        ],
        u: {
          u: "26a0",
          x: 14,
          y: 43
        }
      },
      {
        n: [
          "children crossing",
          "children_crossing"
        ],
        u: {
          u: "1f6b8",
          x: 15,
          y: 43
        }
      },
      {
        n: [
          "no entry",
          "no_entry"
        ],
        u: {
          u: "26d4",
          x: 16,
          y: 43
        }
      },
      {
        n: [
          "no entry sign",
          "no_entry_sign"
        ],
        u: {
          u: "1f6ab",
          x: 17,
          y: 43
        }
      },
      {
        n: [
          "no bicycles",
          "no_bicycles"
        ],
        u: {
          u: "1f6b3",
          x: 18,
          y: 43
        }
      },
      {
        n: [
          "no smoking symbol",
          "no_smoking"
        ],
        u: {
          u: "1f6ad",
          x: 19,
          y: 43
        }
      },
      {
        n: [
          "do not litter symbol",
          "do_not_litter"
        ],
        u: {
          u: "1f6af",
          x: 20,
          y: 43
        }
      },
      {
        n: [
          "non-potable water symbol",
          "non-potable_water"
        ],
        u: {
          u: "1f6b1",
          x: 21,
          y: 43
        }
      },
      {
        n: [
          "no pedestrians",
          "no_pedestrians"
        ],
        u: {
          u: "1f6b7",
          x: 22,
          y: 43
        }
      },
      {
        n: [
          "no mobile phones",
          "no_mobile_phones"
        ],
        u: {
          u: "1f4f5",
          x: 23,
          y: 43
        }
      },
      {
        n: [
          "no one under eighteen symbol",
          "underage"
        ],
        u: {
          u: "1f51e",
          x: 24,
          y: 43
        }
      },
      {
        n: [
          "radioactive_sign"
        ],
        u: {
          u: "2622",
          x: 25,
          y: 43
        }
      },
      {
        n: [
          "biohazard_sign"
        ],
        u: {
          u: "2623",
          x: 26,
          y: 43
        }
      },
      {
        n: [
          "upwards black arrow",
          "arrow_up"
        ],
        u: {
          u: "2b06",
          x: 27,
          y: 43
        }
      },
      {
        n: [
          "north east arrow",
          "arrow_upper_right"
        ],
        u: {
          u: "2197",
          x: 28,
          y: 43
        }
      },
      {
        n: [
          "black rightwards arrow",
          "arrow_right"
        ],
        u: {
          u: "27a1",
          x: 29,
          y: 43
        }
      },
      {
        n: [
          "south east arrow",
          "arrow_lower_right"
        ],
        u: {
          u: "2198",
          x: 30,
          y: 43
        }
      },
      {
        n: [
          "downwards black arrow",
          "arrow_down"
        ],
        u: {
          u: "2b07",
          x: 31,
          y: 43
        }
      },
      {
        n: [
          "south west arrow",
          "arrow_lower_left"
        ],
        u: {
          u: "2199",
          x: 32,
          y: 43
        }
      },
      {
        n: [
          "leftwards black arrow",
          "arrow_left"
        ],
        u: {
          u: "2b05",
          x: 33,
          y: 43
        }
      },
      {
        n: [
          "north west arrow",
          "arrow_upper_left"
        ],
        u: {
          u: "2196",
          x: 34,
          y: 43
        }
      },
      {
        n: [
          "up down arrow",
          "arrow_up_down"
        ],
        u: {
          u: "2195",
          x: 35,
          y: 43
        }
      },
      {
        n: [
          "left right arrow",
          "left_right_arrow"
        ],
        u: {
          u: "2194",
          x: 36,
          y: 43
        }
      },
      {
        n: [
          "leftwards arrow with hook",
          "leftwards_arrow_with_hook"
        ],
        u: {
          u: "21a9",
          x: 37,
          y: 43
        }
      },
      {
        n: [
          "rightwards arrow with hook",
          "arrow_right_hook"
        ],
        u: {
          u: "21aa",
          x: 38,
          y: 43
        }
      },
      {
        n: [
          "arrow pointing rightwards then curving upwards",
          "arrow_heading_up"
        ],
        u: {
          u: "2934",
          x: 39,
          y: 43
        }
      },
      {
        n: [
          "arrow pointing rightwards then curving downwards",
          "arrow_heading_down"
        ],
        u: {
          u: "2935",
          x: 40,
          y: 43
        }
      },
      {
        n: [
          "clockwise downwards and upwards open circle arrows",
          "arrows_clockwise"
        ],
        u: {
          u: "1f503",
          x: 41,
          y: 43
        }
      },
      {
        n: [
          "anticlockwise downwards and upwards open circle arrows",
          "arrows_counterclockwise"
        ],
        u: {
          u: "1f504",
          x: 42,
          y: 43
        }
      },
      {
        n: [
          "back with leftwards arrow above",
          "back"
        ],
        u: {
          u: "1f519",
          x: 43,
          y: 43
        }
      },
      {
        n: [
          "end with leftwards arrow above",
          "end"
        ],
        u: {
          u: "1f51a",
          x: 44,
          y: 43
        }
      },
      {
        n: [
          "on with exclamation mark with left right arrow above",
          "on"
        ],
        u: {
          u: "1f51b",
          x: 45,
          y: 43
        }
      },
      {
        n: [
          "soon with rightwards arrow above",
          "soon"
        ],
        u: {
          u: "1f51c",
          x: 46,
          y: 43
        }
      },
      {
        n: [
          "top with upwards arrow above",
          "top"
        ],
        u: {
          u: "1f51d",
          x: 47,
          y: 43
        }
      },
      {
        n: [
          "place of worship",
          "place_of_worship"
        ],
        u: {
          u: "1f6d0",
          x: 48,
          y: 43
        }
      },
      {
        n: [
          "atom_symbol"
        ],
        u: {
          u: "269b",
          x: 49,
          y: 43
        }
      },
      {
        n: [
          "om_symbol"
        ],
        u: {
          u: "1f549",
          x: 0,
          y: 44
        }
      },
      {
        n: [
          "star_of_david"
        ],
        u: {
          u: "2721",
          x: 1,
          y: 44
        }
      },
      {
        n: [
          "wheel_of_dharma"
        ],
        u: {
          u: "2638",
          x: 2,
          y: 44
        }
      },
      {
        n: [
          "yin_yang"
        ],
        u: {
          u: "262f",
          x: 3,
          y: 44
        }
      },
      {
        n: [
          "latin_cross"
        ],
        u: {
          u: "271d",
          x: 4,
          y: 44
        }
      },
      {
        n: [
          "orthodox_cross"
        ],
        u: {
          u: "2626",
          x: 5,
          y: 44
        }
      },
      {
        n: [
          "star_and_crescent"
        ],
        u: {
          u: "262a",
          x: 6,
          y: 44
        }
      },
      {
        n: [
          "peace_symbol"
        ],
        u: {
          u: "262e",
          x: 7,
          y: 44
        }
      },
      {
        n: [
          "menorah with nine branches",
          "menorah_with_nine_branches"
        ],
        u: {
          u: "1f54e",
          x: 8,
          y: 44
        }
      },
      {
        n: [
          "six pointed star with middle dot",
          "six_pointed_star"
        ],
        u: {
          u: "1f52f",
          x: 9,
          y: 44
        }
      },
      {
        n: [
          "aries"
        ],
        u: {
          u: "2648",
          x: 10,
          y: 44
        }
      },
      {
        n: [
          "taurus"
        ],
        u: {
          u: "2649",
          x: 11,
          y: 44
        }
      },
      {
        n: [
          "gemini"
        ],
        u: {
          u: "264a",
          x: 12,
          y: 44
        }
      },
      {
        n: [
          "cancer"
        ],
        u: {
          u: "264b",
          x: 13,
          y: 44
        }
      },
      {
        n: [
          "leo"
        ],
        u: {
          u: "264c",
          x: 14,
          y: 44
        }
      },
      {
        n: [
          "virgo"
        ],
        u: {
          u: "264d",
          x: 15,
          y: 44
        }
      },
      {
        n: [
          "libra"
        ],
        u: {
          u: "264e",
          x: 16,
          y: 44
        }
      },
      {
        n: [
          "scorpius"
        ],
        u: {
          u: "264f",
          x: 17,
          y: 44
        }
      },
      {
        n: [
          "sagittarius"
        ],
        u: {
          u: "2650",
          x: 18,
          y: 44
        }
      },
      {
        n: [
          "capricorn"
        ],
        u: {
          u: "2651",
          x: 19,
          y: 44
        }
      },
      {
        n: [
          "aquarius"
        ],
        u: {
          u: "2652",
          x: 20,
          y: 44
        }
      },
      {
        n: [
          "pisces"
        ],
        u: {
          u: "2653",
          x: 21,
          y: 44
        }
      },
      {
        n: [
          "ophiuchus"
        ],
        u: {
          u: "26ce",
          x: 22,
          y: 44
        }
      },
      {
        n: [
          "twisted rightwards arrows",
          "twisted_rightwards_arrows"
        ],
        u: {
          u: "1f500",
          x: 23,
          y: 44
        }
      },
      {
        n: [
          "clockwise rightwards and leftwards open circle arrows",
          "repeat"
        ],
        u: {
          u: "1f501",
          x: 24,
          y: 44
        }
      },
      {
        n: [
          "clockwise rightwards and leftwards open circle arrows with circled one overlay",
          "repeat_one"
        ],
        u: {
          u: "1f502",
          x: 25,
          y: 44
        }
      },
      {
        n: [
          "black right-pointing triangle",
          "arrow_forward"
        ],
        u: {
          u: "25b6",
          x: 26,
          y: 44
        }
      },
      {
        n: [
          "black right-pointing double triangle",
          "fast_forward"
        ],
        u: {
          u: "23e9",
          x: 27,
          y: 44
        }
      },
      {
        n: [
          "black_right_pointing_double_triangle_with_vertical_bar"
        ],
        u: {
          u: "23ed",
          x: 28,
          y: 44
        }
      },
      {
        n: [
          "black_right_pointing_triangle_with_double_vertical_bar"
        ],
        u: {
          u: "23ef",
          x: 29,
          y: 44
        }
      },
      {
        n: [
          "black left-pointing triangle",
          "arrow_backward"
        ],
        u: {
          u: "25c0",
          x: 30,
          y: 44
        }
      },
      {
        n: [
          "black left-pointing double triangle",
          "rewind"
        ],
        u: {
          u: "23ea",
          x: 31,
          y: 44
        }
      },
      {
        n: [
          "black_left_pointing_double_triangle_with_vertical_bar"
        ],
        u: {
          u: "23ee",
          x: 32,
          y: 44
        }
      },
      {
        n: [
          "up-pointing small red triangle",
          "arrow_up_small"
        ],
        u: {
          u: "1f53c",
          x: 33,
          y: 44
        }
      },
      {
        n: [
          "black up-pointing double triangle",
          "arrow_double_up"
        ],
        u: {
          u: "23eb",
          x: 34,
          y: 44
        }
      },
      {
        n: [
          "down-pointing small red triangle",
          "arrow_down_small"
        ],
        u: {
          u: "1f53d",
          x: 35,
          y: 44
        }
      },
      {
        n: [
          "black down-pointing double triangle",
          "arrow_double_down"
        ],
        u: {
          u: "23ec",
          x: 36,
          y: 44
        }
      },
      {
        n: [
          "double_vertical_bar"
        ],
        u: {
          u: "23f8",
          x: 37,
          y: 44
        }
      },
      {
        n: [
          "black_square_for_stop"
        ],
        u: {
          u: "23f9",
          x: 38,
          y: 44
        }
      },
      {
        n: [
          "black_circle_for_record"
        ],
        u: {
          u: "23fa",
          x: 39,
          y: 44
        }
      },
      {
        n: [
          "eject"
        ],
        u: {
          u: "23cf",
          x: 40,
          y: 44
        }
      },
      {
        n: [
          "cinema"
        ],
        u: {
          u: "1f3a6",
          x: 41,
          y: 44
        }
      },
      {
        n: [
          "low brightness symbol",
          "low_brightness"
        ],
        u: {
          u: "1f505",
          x: 42,
          y: 44
        }
      },
      {
        n: [
          "high brightness symbol",
          "high_brightness"
        ],
        u: {
          u: "1f506",
          x: 43,
          y: 44
        }
      },
      {
        n: [
          "antenna with bars",
          "signal_strength"
        ],
        u: {
          u: "1f4f6",
          x: 44,
          y: 44
        }
      },
      {
        n: [
          "vibration mode",
          "vibration_mode"
        ],
        u: {
          u: "1f4f3",
          x: 45,
          y: 44
        }
      },
      {
        n: [
          "mobile phone off",
          "mobile_phone_off"
        ],
        u: {
          u: "1f4f4",
          x: 46,
          y: 44
        }
      },
      {
        n: [
          "female_sign"
        ],
        u: {
          u: "2640",
          x: 47,
          y: 44
        }
      },
      {
        n: [
          "male_sign"
        ],
        u: {
          u: "2642",
          x: 48,
          y: 44
        }
      },
      {
        n: [
          "medical_symbol",
          "staff_of_aesculapius"
        ],
        u: {
          u: "2695",
          x: 49,
          y: 44
        }
      },
      {
        n: [
          "black universal recycling symbol",
          "recycle"
        ],
        u: {
          u: "267b",
          x: 0,
          y: 45
        }
      },
      {
        n: [
          "fleur_de_lis"
        ],
        u: {
          u: "269c",
          x: 1,
          y: 45
        }
      },
      {
        n: [
          "trident emblem",
          "trident"
        ],
        u: {
          u: "1f531",
          x: 2,
          y: 45
        }
      },
      {
        n: [
          "name badge",
          "name_badge"
        ],
        u: {
          u: "1f4db",
          x: 3,
          y: 45
        }
      },
      {
        n: [
          "japanese symbol for beginner",
          "beginner"
        ],
        u: {
          u: "1f530",
          x: 4,
          y: 45
        }
      },
      {
        n: [
          "heavy large circle",
          "o"
        ],
        u: {
          u: "2b55",
          x: 5,
          y: 45
        }
      },
      {
        n: [
          "white heavy check mark",
          "white_check_mark"
        ],
        u: {
          u: "2705",
          x: 6,
          y: 45
        }
      },
      {
        n: [
          "ballot box with check",
          "ballot_box_with_check"
        ],
        u: {
          u: "2611",
          x: 7,
          y: 45
        }
      },
      {
        n: [
          "heavy check mark",
          "heavy_check_mark"
        ],
        u: {
          u: "2714",
          x: 8,
          y: 45
        }
      },
      {
        n: [
          "heavy multiplication x",
          "heavy_multiplication_x"
        ],
        u: {
          u: "2716",
          x: 9,
          y: 45
        }
      },
      {
        n: [
          "cross mark",
          "x"
        ],
        u: {
          u: "274c",
          x: 10,
          y: 45
        }
      },
      {
        n: [
          "negative squared cross mark",
          "negative_squared_cross_mark"
        ],
        u: {
          u: "274e",
          x: 11,
          y: 45
        }
      },
      {
        n: [
          "heavy plus sign",
          "heavy_plus_sign"
        ],
        u: {
          u: "2795",
          x: 12,
          y: 45
        }
      },
      {
        n: [
          "heavy minus sign",
          "heavy_minus_sign"
        ],
        u: {
          u: "2796",
          x: 13,
          y: 45
        }
      },
      {
        n: [
          "heavy division sign",
          "heavy_division_sign"
        ],
        u: {
          u: "2797",
          x: 14,
          y: 45
        }
      },
      {
        n: [
          "curly loop",
          "curly_loop"
        ],
        u: {
          u: "27b0",
          x: 15,
          y: 45
        }
      },
      {
        n: [
          "double curly loop",
          "loop"
        ],
        u: {
          u: "27bf",
          x: 16,
          y: 45
        }
      },
      {
        n: [
          "part alternation mark",
          "part_alternation_mark"
        ],
        u: {
          u: "303d",
          x: 17,
          y: 45
        }
      },
      {
        n: [
          "eight spoked asterisk",
          "eight_spoked_asterisk"
        ],
        u: {
          u: "2733",
          x: 18,
          y: 45
        }
      },
      {
        n: [
          "eight pointed black star",
          "eight_pointed_black_star"
        ],
        u: {
          u: "2734",
          x: 19,
          y: 45
        }
      },
      {
        n: [
          "sparkle"
        ],
        u: {
          u: "2747",
          x: 20,
          y: 45
        }
      },
      {
        n: [
          "double exclamation mark",
          "bangbang"
        ],
        u: {
          u: "203c",
          x: 21,
          y: 45
        }
      },
      {
        n: [
          "exclamation question mark",
          "interrobang"
        ],
        u: {
          u: "2049",
          x: 22,
          y: 45
        }
      },
      {
        n: [
          "black question mark ornament",
          "question"
        ],
        u: {
          u: "2753",
          x: 23,
          y: 45
        }
      },
      {
        n: [
          "white question mark ornament",
          "grey_question"
        ],
        u: {
          u: "2754",
          x: 24,
          y: 45
        }
      },
      {
        n: [
          "white exclamation mark ornament",
          "grey_exclamation"
        ],
        u: {
          u: "2755",
          x: 25,
          y: 45
        }
      },
      {
        n: [
          "heavy exclamation mark symbol",
          "exclamation",
          "heavy_exclamation_mark"
        ],
        u: {
          u: "2757",
          x: 26,
          y: 45
        }
      },
      {
        n: [
          "wavy dash",
          "wavy_dash"
        ],
        u: {
          u: "3030",
          x: 27,
          y: 45
        }
      },
      {
        n: [
          "copyright sign",
          "copyright"
        ],
        u: {
          u: "00a9",
          x: 28,
          y: 45
        }
      },
      {
        n: [
          "registered sign",
          "registered"
        ],
        u: {
          u: "00ae",
          x: 29,
          y: 45
        }
      },
      {
        n: [
          "trade mark sign",
          "tm"
        ],
        u: {
          u: "2122",
          x: 30,
          y: 45
        }
      },
      {
        n: [
          "hash key",
          "hash"
        ],
        u: {
          u: "0023-20e3",
          x: 31,
          y: 45
        }
      },
      {
        n: [
          "keycap_star"
        ],
        u: {
          u: "002a-20e3",
          x: 32,
          y: 45
        }
      },
      {
        n: [
          "keycap 0",
          "zero"
        ],
        u: {
          u: "0030-20e3",
          x: 33,
          y: 45
        }
      },
      {
        n: [
          "keycap 1",
          "one"
        ],
        u: {
          u: "0031-20e3",
          x: 34,
          y: 45
        }
      },
      {
        n: [
          "keycap 2",
          "two"
        ],
        u: {
          u: "0032-20e3",
          x: 35,
          y: 45
        }
      },
      {
        n: [
          "keycap 3",
          "three"
        ],
        u: {
          u: "0033-20e3",
          x: 36,
          y: 45
        }
      },
      {
        n: [
          "keycap 4",
          "four"
        ],
        u: {
          u: "0034-20e3",
          x: 37,
          y: 45
        }
      },
      {
        n: [
          "keycap 5",
          "five"
        ],
        u: {
          u: "0035-20e3",
          x: 38,
          y: 45
        }
      },
      {
        n: [
          "keycap 6",
          "six"
        ],
        u: {
          u: "0036-20e3",
          x: 39,
          y: 45
        }
      },
      {
        n: [
          "keycap 7",
          "seven"
        ],
        u: {
          u: "0037-20e3",
          x: 40,
          y: 45
        }
      },
      {
        n: [
          "keycap 8",
          "eight"
        ],
        u: {
          u: "0038-20e3",
          x: 41,
          y: 45
        }
      },
      {
        n: [
          "keycap 9",
          "nine"
        ],
        u: {
          u: "0039-20e3",
          x: 42,
          y: 45
        }
      },
      {
        n: [
          "keycap ten",
          "keycap_ten"
        ],
        u: {
          u: "1f51f",
          x: 43,
          y: 45
        }
      },
      {
        n: [
          "hundred points symbol",
          "100"
        ],
        u: {
          u: "1f4af",
          x: 44,
          y: 45
        }
      },
      {
        n: [
          "input symbol for latin capital letters",
          "capital_abcd"
        ],
        u: {
          u: "1f520",
          x: 45,
          y: 45
        }
      },
      {
        n: [
          "input symbol for latin small letters",
          "abcd"
        ],
        u: {
          u: "1f521",
          x: 46,
          y: 45
        }
      },
      {
        n: [
          "input symbol for numbers",
          "1234"
        ],
        u: {
          u: "1f522",
          x: 47,
          y: 45
        }
      },
      {
        n: [
          "input symbol for symbols",
          "symbols"
        ],
        u: {
          u: "1f523",
          x: 48,
          y: 45
        }
      },
      {
        n: [
          "input symbol for latin letters",
          "abc"
        ],
        u: {
          u: "1f524",
          x: 49,
          y: 45
        }
      },
      {
        n: [
          "negative squared latin capital letter a",
          "a"
        ],
        u: {
          u: "1f170",
          x: 0,
          y: 46
        }
      },
      {
        n: [
          "negative squared ab",
          "ab"
        ],
        u: {
          u: "1f18e",
          x: 1,
          y: 46
        }
      },
      {
        n: [
          "negative squared latin capital letter b",
          "b"
        ],
        u: {
          u: "1f171",
          x: 2,
          y: 46
        }
      },
      {
        n: [
          "squared cl",
          "cl"
        ],
        u: {
          u: "1f191",
          x: 3,
          y: 46
        }
      },
      {
        n: [
          "squared cool",
          "cool"
        ],
        u: {
          u: "1f192",
          x: 4,
          y: 46
        }
      },
      {
        n: [
          "squared free",
          "free"
        ],
        u: {
          u: "1f193",
          x: 5,
          y: 46
        }
      },
      {
        n: [
          "information source",
          "information_source"
        ],
        u: {
          u: "2139",
          x: 6,
          y: 46
        }
      },
      {
        n: [
          "squared id",
          "id"
        ],
        u: {
          u: "1f194",
          x: 7,
          y: 46
        }
      },
      {
        n: [
          "circled latin capital letter m",
          "m"
        ],
        u: {
          u: "24c2",
          x: 8,
          y: 46
        }
      },
      {
        n: [
          "squared new",
          "new"
        ],
        u: {
          u: "1f195",
          x: 9,
          y: 46
        }
      },
      {
        n: [
          "squared ng",
          "ng"
        ],
        u: {
          u: "1f196",
          x: 10,
          y: 46
        }
      },
      {
        n: [
          "negative squared latin capital letter o",
          "o2"
        ],
        u: {
          u: "1f17e",
          x: 11,
          y: 46
        }
      },
      {
        n: [
          "squared ok",
          "ok"
        ],
        u: {
          u: "1f197",
          x: 12,
          y: 46
        }
      },
      {
        n: [
          "negative squared latin capital letter p",
          "parking"
        ],
        u: {
          u: "1f17f",
          x: 13,
          y: 46
        }
      },
      {
        n: [
          "squared sos",
          "sos"
        ],
        u: {
          u: "1f198",
          x: 14,
          y: 46
        }
      },
      {
        n: [
          "squared up with exclamation mark",
          "up"
        ],
        u: {
          u: "1f199",
          x: 15,
          y: 46
        }
      },
      {
        n: [
          "squared vs",
          "vs"
        ],
        u: {
          u: "1f19a",
          x: 16,
          y: 46
        }
      },
      {
        n: [
          "squared katakana koko",
          "koko"
        ],
        u: {
          u: "1f201",
          x: 17,
          y: 46
        }
      },
      {
        n: [
          "squared katakana sa",
          "sa"
        ],
        u: {
          u: "1f202",
          x: 18,
          y: 46
        }
      },
      {
        n: [
          "squared cjk unified ideograph-6708",
          "u6708"
        ],
        u: {
          u: "1f237",
          x: 19,
          y: 46
        }
      },
      {
        n: [
          "squared cjk unified ideograph-6709",
          "u6709"
        ],
        u: {
          u: "1f236",
          x: 20,
          y: 46
        }
      },
      {
        n: [
          "squared cjk unified ideograph-6307",
          "u6307"
        ],
        u: {
          u: "1f22f",
          x: 21,
          y: 46
        }
      },
      {
        n: [
          "circled ideograph advantage",
          "ideograph_advantage"
        ],
        u: {
          u: "1f250",
          x: 22,
          y: 46
        }
      },
      {
        n: [
          "squared cjk unified ideograph-5272",
          "u5272"
        ],
        u: {
          u: "1f239",
          x: 23,
          y: 46
        }
      },
      {
        n: [
          "squared cjk unified ideograph-7121",
          "u7121"
        ],
        u: {
          u: "1f21a",
          x: 24,
          y: 46
        }
      },
      {
        n: [
          "squared cjk unified ideograph-7981",
          "u7981"
        ],
        u: {
          u: "1f232",
          x: 25,
          y: 46
        }
      },
      {
        n: [
          "circled ideograph accept",
          "accept"
        ],
        u: {
          u: "1f251",
          x: 26,
          y: 46
        }
      },
      {
        n: [
          "squared cjk unified ideograph-7533",
          "u7533"
        ],
        u: {
          u: "1f238",
          x: 27,
          y: 46
        }
      },
      {
        n: [
          "squared cjk unified ideograph-5408",
          "u5408"
        ],
        u: {
          u: "1f234",
          x: 28,
          y: 46
        }
      },
      {
        n: [
          "squared cjk unified ideograph-7a7a",
          "u7a7a"
        ],
        u: {
          u: "1f233",
          x: 29,
          y: 46
        }
      },
      {
        n: [
          "circled ideograph congratulation",
          "congratulations"
        ],
        u: {
          u: "3297",
          x: 30,
          y: 46
        }
      },
      {
        n: [
          "circled ideograph secret",
          "secret"
        ],
        u: {
          u: "3299",
          x: 31,
          y: 46
        }
      },
      {
        n: [
          "squared cjk unified ideograph-55b6",
          "u55b6"
        ],
        u: {
          u: "1f23a",
          x: 32,
          y: 46
        }
      },
      {
        n: [
          "squared cjk unified ideograph-6e80",
          "u6e80"
        ],
        u: {
          u: "1f235",
          x: 33,
          y: 46
        }
      },
      {
        n: [
          "black small square",
          "black_small_square"
        ],
        u: {
          u: "25aa",
          x: 34,
          y: 46
        }
      },
      {
        n: [
          "white small square",
          "white_small_square"
        ],
        u: {
          u: "25ab",
          x: 35,
          y: 46
        }
      },
      {
        n: [
          "white medium square",
          "white_medium_square"
        ],
        u: {
          u: "25fb",
          x: 36,
          y: 46
        }
      },
      {
        n: [
          "black medium square",
          "black_medium_square"
        ],
        u: {
          u: "25fc",
          x: 37,
          y: 46
        }
      },
      {
        n: [
          "white medium small square",
          "white_medium_small_square"
        ],
        u: {
          u: "25fd",
          x: 38,
          y: 46
        }
      },
      {
        n: [
          "black medium small square",
          "black_medium_small_square"
        ],
        u: {
          u: "25fe",
          x: 39,
          y: 46
        }
      },
      {
        n: [
          "black large square",
          "black_large_square"
        ],
        u: {
          u: "2b1b",
          x: 40,
          y: 46
        }
      },
      {
        n: [
          "white large square",
          "white_large_square"
        ],
        u: {
          u: "2b1c",
          x: 41,
          y: 46
        }
      },
      {
        n: [
          "large orange diamond",
          "large_orange_diamond"
        ],
        u: {
          u: "1f536",
          x: 42,
          y: 46
        }
      },
      {
        n: [
          "large blue diamond",
          "large_blue_diamond"
        ],
        u: {
          u: "1f537",
          x: 43,
          y: 46
        }
      },
      {
        n: [
          "small orange diamond",
          "small_orange_diamond"
        ],
        u: {
          u: "1f538",
          x: 44,
          y: 46
        }
      },
      {
        n: [
          "small blue diamond",
          "small_blue_diamond"
        ],
        u: {
          u: "1f539",
          x: 45,
          y: 46
        }
      },
      {
        n: [
          "up-pointing red triangle",
          "small_red_triangle"
        ],
        u: {
          u: "1f53a",
          x: 46,
          y: 46
        }
      },
      {
        n: [
          "down-pointing red triangle",
          "small_red_triangle_down"
        ],
        u: {
          u: "1f53b",
          x: 47,
          y: 46
        }
      },
      {
        n: [
          "diamond shape with a dot inside",
          "diamond_shape_with_a_dot_inside"
        ],
        u: {
          u: "1f4a0",
          x: 48,
          y: 46
        }
      },
      {
        n: [
          "radio button",
          "radio_button"
        ],
        u: {
          u: "1f518",
          x: 49,
          y: 46
        }
      },
      {
        n: [
          "black square button",
          "black_square_button"
        ],
        u: {
          u: "1f532",
          x: 0,
          y: 47
        }
      },
      {
        n: [
          "white square button",
          "white_square_button"
        ],
        u: {
          u: "1f533",
          x: 1,
          y: 47
        }
      },
      {
        n: [
          "medium white circle",
          "white_circle"
        ],
        u: {
          u: "26aa",
          x: 2,
          y: 47
        }
      },
      {
        n: [
          "medium black circle",
          "black_circle"
        ],
        u: {
          u: "26ab",
          x: 3,
          y: 47
        }
      },
      {
        n: [
          "large red circle",
          "red_circle"
        ],
        u: {
          u: "1f534",
          x: 4,
          y: 47
        }
      },
      {
        n: [
          "large blue circle",
          "large_blue_circle"
        ],
        u: {
          u: "1f535",
          x: 5,
          y: 47
        }
      }
    ],
    key: "symbols",
    title: "Symbols",
    u: "1f523"
  },
  {
    emojis: [
      {
        n: [
          "chequered flag",
          "checkered_flag"
        ],
        u: {
          u: "1f3c1",
          x: 6,
          y: 47
        }
      },
      {
        n: [
          "triangular flag on post",
          "triangular_flag_on_post"
        ],
        u: {
          u: "1f6a9",
          x: 7,
          y: 47
        }
      },
      {
        n: [
          "crossed flags",
          "crossed_flags"
        ],
        u: {
          u: "1f38c",
          x: 8,
          y: 47
        }
      },
      {
        n: [
          "waving black flag",
          "waving_black_flag"
        ],
        u: {
          u: "1f3f4",
          x: 9,
          y: 47
        }
      },
      {
        n: [
          "waving_white_flag"
        ],
        u: {
          u: "1f3f3",
          x: 10,
          y: 47
        }
      },
      {
        n: [
          "rainbow-flag"
        ],
        u: {
          u: "1f3f3-fe0f-200d-1f308",
          x: 11,
          y: 47
        }
      },
      {
        n: [
          "ascension island flag",
          "flag-ac"
        ],
        u: {
          u: "1f1e6-1f1e8",
          x: 12,
          y: 47
        }
      },
      {
        n: [
          "andorra flag",
          "flag-ad"
        ],
        u: {
          u: "1f1e6-1f1e9",
          x: 13,
          y: 47
        }
      },
      {
        n: [
          "united arab emirates flag",
          "flag-ae"
        ],
        u: {
          u: "1f1e6-1f1ea",
          x: 14,
          y: 47
        }
      },
      {
        n: [
          "afghanistan flag",
          "flag-af"
        ],
        u: {
          u: "1f1e6-1f1eb",
          x: 15,
          y: 47
        }
      },
      {
        n: [
          "antigua & barbuda flag",
          "flag-ag"
        ],
        u: {
          u: "1f1e6-1f1ec",
          x: 16,
          y: 47
        }
      },
      {
        n: [
          "anguilla flag",
          "flag-ai"
        ],
        u: {
          u: "1f1e6-1f1ee",
          x: 17,
          y: 47
        }
      },
      {
        n: [
          "albania flag",
          "flag-al"
        ],
        u: {
          u: "1f1e6-1f1f1",
          x: 18,
          y: 47
        }
      },
      {
        n: [
          "armenia flag",
          "flag-am"
        ],
        u: {
          u: "1f1e6-1f1f2",
          x: 19,
          y: 47
        }
      },
      {
        n: [
          "angola flag",
          "flag-ao"
        ],
        u: {
          u: "1f1e6-1f1f4",
          x: 20,
          y: 47
        }
      },
      {
        n: [
          "antarctica flag",
          "flag-aq"
        ],
        u: {
          u: "1f1e6-1f1f6",
          x: 21,
          y: 47
        }
      },
      {
        n: [
          "argentina flag",
          "flag-ar"
        ],
        u: {
          u: "1f1e6-1f1f7",
          x: 22,
          y: 47
        }
      },
      {
        n: [
          "american samoa flag",
          "flag-as"
        ],
        u: {
          u: "1f1e6-1f1f8",
          x: 23,
          y: 47
        }
      },
      {
        n: [
          "austria flag",
          "flag-at"
        ],
        u: {
          u: "1f1e6-1f1f9",
          x: 24,
          y: 47
        }
      },
      {
        n: [
          "australia flag",
          "flag-au"
        ],
        u: {
          u: "1f1e6-1f1fa",
          x: 25,
          y: 47
        }
      },
      {
        n: [
          "aruba flag",
          "flag-aw"
        ],
        u: {
          u: "1f1e6-1f1fc",
          x: 26,
          y: 47
        }
      },
      {
        n: [
          "\xE5land islands flag",
          "flag-ax"
        ],
        u: {
          u: "1f1e6-1f1fd",
          x: 27,
          y: 47
        }
      },
      {
        n: [
          "azerbaijan flag",
          "flag-az"
        ],
        u: {
          u: "1f1e6-1f1ff",
          x: 28,
          y: 47
        }
      },
      {
        n: [
          "bosnia & herzegovina flag",
          "flag-ba"
        ],
        u: {
          u: "1f1e7-1f1e6",
          x: 29,
          y: 47
        }
      },
      {
        n: [
          "barbados flag",
          "flag-bb"
        ],
        u: {
          u: "1f1e7-1f1e7",
          x: 30,
          y: 47
        }
      },
      {
        n: [
          "bangladesh flag",
          "flag-bd"
        ],
        u: {
          u: "1f1e7-1f1e9",
          x: 31,
          y: 47
        }
      },
      {
        n: [
          "belgium flag",
          "flag-be"
        ],
        u: {
          u: "1f1e7-1f1ea",
          x: 32,
          y: 47
        }
      },
      {
        n: [
          "burkina faso flag",
          "flag-bf"
        ],
        u: {
          u: "1f1e7-1f1eb",
          x: 33,
          y: 47
        }
      },
      {
        n: [
          "bulgaria flag",
          "flag-bg"
        ],
        u: {
          u: "1f1e7-1f1ec",
          x: 34,
          y: 47
        }
      },
      {
        n: [
          "bahrain flag",
          "flag-bh"
        ],
        u: {
          u: "1f1e7-1f1ed",
          x: 35,
          y: 47
        }
      },
      {
        n: [
          "burundi flag",
          "flag-bi"
        ],
        u: {
          u: "1f1e7-1f1ee",
          x: 36,
          y: 47
        }
      },
      {
        n: [
          "benin flag",
          "flag-bj"
        ],
        u: {
          u: "1f1e7-1f1ef",
          x: 37,
          y: 47
        }
      },
      {
        n: [
          "st. barth\xE9lemy flag",
          "flag-bl"
        ],
        u: {
          u: "1f1e7-1f1f1",
          x: 38,
          y: 47
        }
      },
      {
        n: [
          "bermuda flag",
          "flag-bm"
        ],
        u: {
          u: "1f1e7-1f1f2",
          x: 39,
          y: 47
        }
      },
      {
        n: [
          "brunei flag",
          "flag-bn"
        ],
        u: {
          u: "1f1e7-1f1f3",
          x: 40,
          y: 47
        }
      },
      {
        n: [
          "bolivia flag",
          "flag-bo"
        ],
        u: {
          u: "1f1e7-1f1f4",
          x: 41,
          y: 47
        }
      },
      {
        n: [
          "caribbean netherlands flag",
          "flag-bq"
        ],
        u: {
          u: "1f1e7-1f1f6",
          x: 42,
          y: 47
        }
      },
      {
        n: [
          "brazil flag",
          "flag-br"
        ],
        u: {
          u: "1f1e7-1f1f7",
          x: 43,
          y: 47
        }
      },
      {
        n: [
          "bahamas flag",
          "flag-bs"
        ],
        u: {
          u: "1f1e7-1f1f8",
          x: 44,
          y: 47
        }
      },
      {
        n: [
          "bhutan flag",
          "flag-bt"
        ],
        u: {
          u: "1f1e7-1f1f9",
          x: 45,
          y: 47
        }
      },
      {
        n: [
          "bouvet island flag",
          "flag-bv"
        ],
        u: {
          u: "1f1e7-1f1fb",
          x: 46,
          y: 47
        }
      },
      {
        n: [
          "botswana flag",
          "flag-bw"
        ],
        u: {
          u: "1f1e7-1f1fc",
          x: 47,
          y: 47
        }
      },
      {
        n: [
          "belarus flag",
          "flag-by"
        ],
        u: {
          u: "1f1e7-1f1fe",
          x: 48,
          y: 47
        }
      },
      {
        n: [
          "belize flag",
          "flag-bz"
        ],
        u: {
          u: "1f1e7-1f1ff",
          x: 49,
          y: 47
        }
      },
      {
        n: [
          "canada flag",
          "flag-ca"
        ],
        u: {
          u: "1f1e8-1f1e6",
          x: 0,
          y: 48
        }
      },
      {
        n: [
          "cocos (keeling) islands flag",
          "flag-cc"
        ],
        u: {
          u: "1f1e8-1f1e8",
          x: 1,
          y: 48
        }
      },
      {
        n: [
          "congo - kinshasa flag",
          "flag-cd"
        ],
        u: {
          u: "1f1e8-1f1e9",
          x: 2,
          y: 48
        }
      },
      {
        n: [
          "central african republic flag",
          "flag-cf"
        ],
        u: {
          u: "1f1e8-1f1eb",
          x: 3,
          y: 48
        }
      },
      {
        n: [
          "congo - brazzaville flag",
          "flag-cg"
        ],
        u: {
          u: "1f1e8-1f1ec",
          x: 4,
          y: 48
        }
      },
      {
        n: [
          "switzerland flag",
          "flag-ch"
        ],
        u: {
          u: "1f1e8-1f1ed",
          x: 5,
          y: 48
        }
      },
      {
        n: [
          "c\xF4te d\u2019ivoire flag",
          "flag-ci"
        ],
        u: {
          u: "1f1e8-1f1ee",
          x: 6,
          y: 48
        }
      },
      {
        n: [
          "cook islands flag",
          "flag-ck"
        ],
        u: {
          u: "1f1e8-1f1f0",
          x: 7,
          y: 48
        }
      },
      {
        n: [
          "chile flag",
          "flag-cl"
        ],
        u: {
          u: "1f1e8-1f1f1",
          x: 8,
          y: 48
        }
      },
      {
        n: [
          "cameroon flag",
          "flag-cm"
        ],
        u: {
          u: "1f1e8-1f1f2",
          x: 9,
          y: 48
        }
      },
      {
        n: [
          "china flag",
          "cn",
          "flag-cn"
        ],
        u: {
          u: "1f1e8-1f1f3",
          x: 10,
          y: 48
        }
      },
      {
        n: [
          "colombia flag",
          "flag-co"
        ],
        u: {
          u: "1f1e8-1f1f4",
          x: 11,
          y: 48
        }
      },
      {
        n: [
          "clipperton island flag",
          "flag-cp"
        ],
        u: {
          u: "1f1e8-1f1f5",
          x: 12,
          y: 48
        }
      },
      {
        n: [
          "costa rica flag",
          "flag-cr"
        ],
        u: {
          u: "1f1e8-1f1f7",
          x: 13,
          y: 48
        }
      },
      {
        n: [
          "cuba flag",
          "flag-cu"
        ],
        u: {
          u: "1f1e8-1f1fa",
          x: 14,
          y: 48
        }
      },
      {
        n: [
          "cape verde flag",
          "flag-cv"
        ],
        u: {
          u: "1f1e8-1f1fb",
          x: 15,
          y: 48
        }
      },
      {
        n: [
          "cura\xE7ao flag",
          "flag-cw"
        ],
        u: {
          u: "1f1e8-1f1fc",
          x: 16,
          y: 48
        }
      },
      {
        n: [
          "christmas island flag",
          "flag-cx"
        ],
        u: {
          u: "1f1e8-1f1fd",
          x: 17,
          y: 48
        }
      },
      {
        n: [
          "cyprus flag",
          "flag-cy"
        ],
        u: {
          u: "1f1e8-1f1fe",
          x: 18,
          y: 48
        }
      },
      {
        n: [
          "czechia flag",
          "flag-cz"
        ],
        u: {
          u: "1f1e8-1f1ff",
          x: 19,
          y: 48
        }
      },
      {
        n: [
          "germany flag",
          "de",
          "flag-de"
        ],
        u: {
          u: "1f1e9-1f1ea",
          x: 20,
          y: 48
        }
      },
      {
        n: [
          "diego garcia flag",
          "flag-dg"
        ],
        u: {
          u: "1f1e9-1f1ec",
          x: 21,
          y: 48
        }
      },
      {
        n: [
          "djibouti flag",
          "flag-dj"
        ],
        u: {
          u: "1f1e9-1f1ef",
          x: 22,
          y: 48
        }
      },
      {
        n: [
          "denmark flag",
          "flag-dk"
        ],
        u: {
          u: "1f1e9-1f1f0",
          x: 23,
          y: 48
        }
      },
      {
        n: [
          "dominica flag",
          "flag-dm"
        ],
        u: {
          u: "1f1e9-1f1f2",
          x: 24,
          y: 48
        }
      },
      {
        n: [
          "dominican republic flag",
          "flag-do"
        ],
        u: {
          u: "1f1e9-1f1f4",
          x: 25,
          y: 48
        }
      },
      {
        n: [
          "algeria flag",
          "flag-dz"
        ],
        u: {
          u: "1f1e9-1f1ff",
          x: 26,
          y: 48
        }
      },
      {
        n: [
          "ceuta & melilla flag",
          "flag-ea"
        ],
        u: {
          u: "1f1ea-1f1e6",
          x: 27,
          y: 48
        }
      },
      {
        n: [
          "ecuador flag",
          "flag-ec"
        ],
        u: {
          u: "1f1ea-1f1e8",
          x: 28,
          y: 48
        }
      },
      {
        n: [
          "estonia flag",
          "flag-ee"
        ],
        u: {
          u: "1f1ea-1f1ea",
          x: 29,
          y: 48
        }
      },
      {
        n: [
          "egypt flag",
          "flag-eg"
        ],
        u: {
          u: "1f1ea-1f1ec",
          x: 30,
          y: 48
        }
      },
      {
        n: [
          "western sahara flag",
          "flag-eh"
        ],
        u: {
          u: "1f1ea-1f1ed",
          x: 31,
          y: 48
        }
      },
      {
        n: [
          "eritrea flag",
          "flag-er"
        ],
        u: {
          u: "1f1ea-1f1f7",
          x: 32,
          y: 48
        }
      },
      {
        n: [
          "spain flag",
          "es",
          "flag-es"
        ],
        u: {
          u: "1f1ea-1f1f8",
          x: 33,
          y: 48
        }
      },
      {
        n: [
          "ethiopia flag",
          "flag-et"
        ],
        u: {
          u: "1f1ea-1f1f9",
          x: 34,
          y: 48
        }
      },
      {
        n: [
          "european union flag",
          "flag-eu"
        ],
        u: {
          u: "1f1ea-1f1fa",
          x: 35,
          y: 48
        }
      },
      {
        n: [
          "finland flag",
          "flag-fi"
        ],
        u: {
          u: "1f1eb-1f1ee",
          x: 36,
          y: 48
        }
      },
      {
        n: [
          "fiji flag",
          "flag-fj"
        ],
        u: {
          u: "1f1eb-1f1ef",
          x: 37,
          y: 48
        }
      },
      {
        n: [
          "falkland islands flag",
          "flag-fk"
        ],
        u: {
          u: "1f1eb-1f1f0",
          x: 38,
          y: 48
        }
      },
      {
        n: [
          "micronesia flag",
          "flag-fm"
        ],
        u: {
          u: "1f1eb-1f1f2",
          x: 39,
          y: 48
        }
      },
      {
        n: [
          "faroe islands flag",
          "flag-fo"
        ],
        u: {
          u: "1f1eb-1f1f4",
          x: 40,
          y: 48
        }
      },
      {
        n: [
          "france flag",
          "fr",
          "flag-fr"
        ],
        u: {
          u: "1f1eb-1f1f7",
          x: 41,
          y: 48
        }
      },
      {
        n: [
          "gabon flag",
          "flag-ga"
        ],
        u: {
          u: "1f1ec-1f1e6",
          x: 42,
          y: 48
        }
      },
      {
        n: [
          "united kingdom flag",
          "gb",
          "uk",
          "flag-gb"
        ],
        u: {
          u: "1f1ec-1f1e7",
          x: 43,
          y: 48
        }
      },
      {
        n: [
          "grenada flag",
          "flag-gd"
        ],
        u: {
          u: "1f1ec-1f1e9",
          x: 44,
          y: 48
        }
      },
      {
        n: [
          "georgia flag",
          "flag-ge"
        ],
        u: {
          u: "1f1ec-1f1ea",
          x: 45,
          y: 48
        }
      },
      {
        n: [
          "french guiana flag",
          "flag-gf"
        ],
        u: {
          u: "1f1ec-1f1eb",
          x: 46,
          y: 48
        }
      },
      {
        n: [
          "guernsey flag",
          "flag-gg"
        ],
        u: {
          u: "1f1ec-1f1ec",
          x: 47,
          y: 48
        }
      },
      {
        n: [
          "ghana flag",
          "flag-gh"
        ],
        u: {
          u: "1f1ec-1f1ed",
          x: 48,
          y: 48
        }
      },
      {
        n: [
          "gibraltar flag",
          "flag-gi"
        ],
        u: {
          u: "1f1ec-1f1ee",
          x: 49,
          y: 48
        }
      },
      {
        n: [
          "greenland flag",
          "flag-gl"
        ],
        u: {
          u: "1f1ec-1f1f1",
          x: 0,
          y: 49
        }
      },
      {
        n: [
          "gambia flag",
          "flag-gm"
        ],
        u: {
          u: "1f1ec-1f1f2",
          x: 1,
          y: 49
        }
      },
      {
        n: [
          "guinea flag",
          "flag-gn"
        ],
        u: {
          u: "1f1ec-1f1f3",
          x: 2,
          y: 49
        }
      },
      {
        n: [
          "guadeloupe flag",
          "flag-gp"
        ],
        u: {
          u: "1f1ec-1f1f5",
          x: 3,
          y: 49
        }
      },
      {
        n: [
          "equatorial guinea flag",
          "flag-gq"
        ],
        u: {
          u: "1f1ec-1f1f6",
          x: 4,
          y: 49
        }
      },
      {
        n: [
          "greece flag",
          "flag-gr"
        ],
        u: {
          u: "1f1ec-1f1f7",
          x: 5,
          y: 49
        }
      },
      {
        n: [
          "south georgia & south sandwich islands flag",
          "flag-gs"
        ],
        u: {
          u: "1f1ec-1f1f8",
          x: 6,
          y: 49
        }
      },
      {
        n: [
          "guatemala flag",
          "flag-gt"
        ],
        u: {
          u: "1f1ec-1f1f9",
          x: 7,
          y: 49
        }
      },
      {
        n: [
          "guam flag",
          "flag-gu"
        ],
        u: {
          u: "1f1ec-1f1fa",
          x: 8,
          y: 49
        }
      },
      {
        n: [
          "guinea-bissau flag",
          "flag-gw"
        ],
        u: {
          u: "1f1ec-1f1fc",
          x: 9,
          y: 49
        }
      },
      {
        n: [
          "guyana flag",
          "flag-gy"
        ],
        u: {
          u: "1f1ec-1f1fe",
          x: 10,
          y: 49
        }
      },
      {
        n: [
          "hong kong sar china flag",
          "flag-hk"
        ],
        u: {
          u: "1f1ed-1f1f0",
          x: 11,
          y: 49
        }
      },
      {
        n: [
          "heard & mcdonald islands flag",
          "flag-hm"
        ],
        u: {
          u: "1f1ed-1f1f2",
          x: 12,
          y: 49
        }
      },
      {
        n: [
          "honduras flag",
          "flag-hn"
        ],
        u: {
          u: "1f1ed-1f1f3",
          x: 13,
          y: 49
        }
      },
      {
        n: [
          "croatia flag",
          "flag-hr"
        ],
        u: {
          u: "1f1ed-1f1f7",
          x: 14,
          y: 49
        }
      },
      {
        n: [
          "haiti flag",
          "flag-ht"
        ],
        u: {
          u: "1f1ed-1f1f9",
          x: 15,
          y: 49
        }
      },
      {
        n: [
          "hungary flag",
          "flag-hu"
        ],
        u: {
          u: "1f1ed-1f1fa",
          x: 16,
          y: 49
        }
      },
      {
        n: [
          "canary islands flag",
          "flag-ic"
        ],
        u: {
          u: "1f1ee-1f1e8",
          x: 17,
          y: 49
        }
      },
      {
        n: [
          "indonesia flag",
          "flag-id"
        ],
        u: {
          u: "1f1ee-1f1e9",
          x: 18,
          y: 49
        }
      },
      {
        n: [
          "ireland flag",
          "flag-ie"
        ],
        u: {
          u: "1f1ee-1f1ea",
          x: 19,
          y: 49
        }
      },
      {
        n: [
          "israel flag",
          "flag-il"
        ],
        u: {
          u: "1f1ee-1f1f1",
          x: 20,
          y: 49
        }
      },
      {
        n: [
          "isle of man flag",
          "flag-im"
        ],
        u: {
          u: "1f1ee-1f1f2",
          x: 21,
          y: 49
        }
      },
      {
        n: [
          "india flag",
          "flag-in"
        ],
        u: {
          u: "1f1ee-1f1f3",
          x: 22,
          y: 49
        }
      },
      {
        n: [
          "british indian ocean territory flag",
          "flag-io"
        ],
        u: {
          u: "1f1ee-1f1f4",
          x: 23,
          y: 49
        }
      },
      {
        n: [
          "iraq flag",
          "flag-iq"
        ],
        u: {
          u: "1f1ee-1f1f6",
          x: 24,
          y: 49
        }
      },
      {
        n: [
          "iran flag",
          "flag-ir"
        ],
        u: {
          u: "1f1ee-1f1f7",
          x: 25,
          y: 49
        }
      },
      {
        n: [
          "iceland flag",
          "flag-is"
        ],
        u: {
          u: "1f1ee-1f1f8",
          x: 26,
          y: 49
        }
      },
      {
        n: [
          "italy flag",
          "it",
          "flag-it"
        ],
        u: {
          u: "1f1ee-1f1f9",
          x: 27,
          y: 49
        }
      },
      {
        n: [
          "jersey flag",
          "flag-je"
        ],
        u: {
          u: "1f1ef-1f1ea",
          x: 28,
          y: 49
        }
      },
      {
        n: [
          "jamaica flag",
          "flag-jm"
        ],
        u: {
          u: "1f1ef-1f1f2",
          x: 29,
          y: 49
        }
      },
      {
        n: [
          "jordan flag",
          "flag-jo"
        ],
        u: {
          u: "1f1ef-1f1f4",
          x: 30,
          y: 49
        }
      },
      {
        n: [
          "japan flag",
          "jp",
          "flag-jp"
        ],
        u: {
          u: "1f1ef-1f1f5",
          x: 31,
          y: 49
        }
      },
      {
        n: [
          "kenya flag",
          "flag-ke"
        ],
        u: {
          u: "1f1f0-1f1ea",
          x: 32,
          y: 49
        }
      },
      {
        n: [
          "kyrgyzstan flag",
          "flag-kg"
        ],
        u: {
          u: "1f1f0-1f1ec",
          x: 33,
          y: 49
        }
      },
      {
        n: [
          "cambodia flag",
          "flag-kh"
        ],
        u: {
          u: "1f1f0-1f1ed",
          x: 34,
          y: 49
        }
      },
      {
        n: [
          "kiribati flag",
          "flag-ki"
        ],
        u: {
          u: "1f1f0-1f1ee",
          x: 35,
          y: 49
        }
      },
      {
        n: [
          "comoros flag",
          "flag-km"
        ],
        u: {
          u: "1f1f0-1f1f2",
          x: 36,
          y: 49
        }
      },
      {
        n: [
          "st. kitts & nevis flag",
          "flag-kn"
        ],
        u: {
          u: "1f1f0-1f1f3",
          x: 37,
          y: 49
        }
      },
      {
        n: [
          "north korea flag",
          "flag-kp"
        ],
        u: {
          u: "1f1f0-1f1f5",
          x: 38,
          y: 49
        }
      },
      {
        n: [
          "south korea flag",
          "kr",
          "flag-kr"
        ],
        u: {
          u: "1f1f0-1f1f7",
          x: 39,
          y: 49
        }
      },
      {
        n: [
          "kuwait flag",
          "flag-kw"
        ],
        u: {
          u: "1f1f0-1f1fc",
          x: 40,
          y: 49
        }
      },
      {
        n: [
          "cayman islands flag",
          "flag-ky"
        ],
        u: {
          u: "1f1f0-1f1fe",
          x: 41,
          y: 49
        }
      },
      {
        n: [
          "kazakhstan flag",
          "flag-kz"
        ],
        u: {
          u: "1f1f0-1f1ff",
          x: 42,
          y: 49
        }
      },
      {
        n: [
          "laos flag",
          "flag-la"
        ],
        u: {
          u: "1f1f1-1f1e6",
          x: 43,
          y: 49
        }
      },
      {
        n: [
          "lebanon flag",
          "flag-lb"
        ],
        u: {
          u: "1f1f1-1f1e7",
          x: 44,
          y: 49
        }
      },
      {
        n: [
          "st. lucia flag",
          "flag-lc"
        ],
        u: {
          u: "1f1f1-1f1e8",
          x: 45,
          y: 49
        }
      },
      {
        n: [
          "liechtenstein flag",
          "flag-li"
        ],
        u: {
          u: "1f1f1-1f1ee",
          x: 46,
          y: 49
        }
      },
      {
        n: [
          "sri lanka flag",
          "flag-lk"
        ],
        u: {
          u: "1f1f1-1f1f0",
          x: 47,
          y: 49
        }
      },
      {
        n: [
          "liberia flag",
          "flag-lr"
        ],
        u: {
          u: "1f1f1-1f1f7",
          x: 48,
          y: 49
        }
      },
      {
        n: [
          "lesotho flag",
          "flag-ls"
        ],
        u: {
          u: "1f1f1-1f1f8",
          x: 49,
          y: 49
        }
      },
      {
        n: [
          "lithuania flag",
          "flag-lt"
        ],
        u: {
          u: "1f1f1-1f1f9",
          x: 0,
          y: 50
        }
      },
      {
        n: [
          "luxembourg flag",
          "flag-lu"
        ],
        u: {
          u: "1f1f1-1f1fa",
          x: 1,
          y: 50
        }
      },
      {
        n: [
          "latvia flag",
          "flag-lv"
        ],
        u: {
          u: "1f1f1-1f1fb",
          x: 2,
          y: 50
        }
      },
      {
        n: [
          "libya flag",
          "flag-ly"
        ],
        u: {
          u: "1f1f1-1f1fe",
          x: 3,
          y: 50
        }
      },
      {
        n: [
          "morocco flag",
          "flag-ma"
        ],
        u: {
          u: "1f1f2-1f1e6",
          x: 4,
          y: 50
        }
      },
      {
        n: [
          "monaco flag",
          "flag-mc"
        ],
        u: {
          u: "1f1f2-1f1e8",
          x: 5,
          y: 50
        }
      },
      {
        n: [
          "moldova flag",
          "flag-md"
        ],
        u: {
          u: "1f1f2-1f1e9",
          x: 6,
          y: 50
        }
      },
      {
        n: [
          "montenegro flag",
          "flag-me"
        ],
        u: {
          u: "1f1f2-1f1ea",
          x: 7,
          y: 50
        }
      },
      {
        n: [
          "st. martin flag",
          "flag-mf"
        ],
        u: {
          u: "1f1f2-1f1eb",
          x: 8,
          y: 50
        }
      },
      {
        n: [
          "madagascar flag",
          "flag-mg"
        ],
        u: {
          u: "1f1f2-1f1ec",
          x: 9,
          y: 50
        }
      },
      {
        n: [
          "marshall islands flag",
          "flag-mh"
        ],
        u: {
          u: "1f1f2-1f1ed",
          x: 10,
          y: 50
        }
      },
      {
        n: [
          "macedonia flag",
          "flag-mk"
        ],
        u: {
          u: "1f1f2-1f1f0",
          x: 11,
          y: 50
        }
      },
      {
        n: [
          "mali flag",
          "flag-ml"
        ],
        u: {
          u: "1f1f2-1f1f1",
          x: 12,
          y: 50
        }
      },
      {
        n: [
          "myanmar (burma) flag",
          "flag-mm"
        ],
        u: {
          u: "1f1f2-1f1f2",
          x: 13,
          y: 50
        }
      },
      {
        n: [
          "mongolia flag",
          "flag-mn"
        ],
        u: {
          u: "1f1f2-1f1f3",
          x: 14,
          y: 50
        }
      },
      {
        n: [
          "macau sar china flag",
          "flag-mo"
        ],
        u: {
          u: "1f1f2-1f1f4",
          x: 15,
          y: 50
        }
      },
      {
        n: [
          "northern mariana islands flag",
          "flag-mp"
        ],
        u: {
          u: "1f1f2-1f1f5",
          x: 16,
          y: 50
        }
      },
      {
        n: [
          "martinique flag",
          "flag-mq"
        ],
        u: {
          u: "1f1f2-1f1f6",
          x: 17,
          y: 50
        }
      },
      {
        n: [
          "mauritania flag",
          "flag-mr"
        ],
        u: {
          u: "1f1f2-1f1f7",
          x: 18,
          y: 50
        }
      },
      {
        n: [
          "montserrat flag",
          "flag-ms"
        ],
        u: {
          u: "1f1f2-1f1f8",
          x: 19,
          y: 50
        }
      },
      {
        n: [
          "malta flag",
          "flag-mt"
        ],
        u: {
          u: "1f1f2-1f1f9",
          x: 20,
          y: 50
        }
      },
      {
        n: [
          "mauritius flag",
          "flag-mu"
        ],
        u: {
          u: "1f1f2-1f1fa",
          x: 21,
          y: 50
        }
      },
      {
        n: [
          "maldives flag",
          "flag-mv"
        ],
        u: {
          u: "1f1f2-1f1fb",
          x: 22,
          y: 50
        }
      },
      {
        n: [
          "malawi flag",
          "flag-mw"
        ],
        u: {
          u: "1f1f2-1f1fc",
          x: 23,
          y: 50
        }
      },
      {
        n: [
          "mexico flag",
          "flag-mx"
        ],
        u: {
          u: "1f1f2-1f1fd",
          x: 24,
          y: 50
        }
      },
      {
        n: [
          "malaysia flag",
          "flag-my"
        ],
        u: {
          u: "1f1f2-1f1fe",
          x: 25,
          y: 50
        }
      },
      {
        n: [
          "mozambique flag",
          "flag-mz"
        ],
        u: {
          u: "1f1f2-1f1ff",
          x: 26,
          y: 50
        }
      },
      {
        n: [
          "namibia flag",
          "flag-na"
        ],
        u: {
          u: "1f1f3-1f1e6",
          x: 27,
          y: 50
        }
      },
      {
        n: [
          "new caledonia flag",
          "flag-nc"
        ],
        u: {
          u: "1f1f3-1f1e8",
          x: 28,
          y: 50
        }
      },
      {
        n: [
          "niger flag",
          "flag-ne"
        ],
        u: {
          u: "1f1f3-1f1ea",
          x: 29,
          y: 50
        }
      },
      {
        n: [
          "norfolk island flag",
          "flag-nf"
        ],
        u: {
          u: "1f1f3-1f1eb",
          x: 30,
          y: 50
        }
      },
      {
        n: [
          "nigeria flag",
          "flag-ng"
        ],
        u: {
          u: "1f1f3-1f1ec",
          x: 31,
          y: 50
        }
      },
      {
        n: [
          "nicaragua flag",
          "flag-ni"
        ],
        u: {
          u: "1f1f3-1f1ee",
          x: 32,
          y: 50
        }
      },
      {
        n: [
          "netherlands flag",
          "flag-nl"
        ],
        u: {
          u: "1f1f3-1f1f1",
          x: 33,
          y: 50
        }
      },
      {
        n: [
          "norway flag",
          "flag-no"
        ],
        u: {
          u: "1f1f3-1f1f4",
          x: 34,
          y: 50
        }
      },
      {
        n: [
          "nepal flag",
          "flag-np"
        ],
        u: {
          u: "1f1f3-1f1f5",
          x: 35,
          y: 50
        }
      },
      {
        n: [
          "nauru flag",
          "flag-nr"
        ],
        u: {
          u: "1f1f3-1f1f7",
          x: 36,
          y: 50
        }
      },
      {
        n: [
          "niue flag",
          "flag-nu"
        ],
        u: {
          u: "1f1f3-1f1fa",
          x: 37,
          y: 50
        }
      },
      {
        n: [
          "new zealand flag",
          "flag-nz"
        ],
        u: {
          u: "1f1f3-1f1ff",
          x: 38,
          y: 50
        }
      },
      {
        n: [
          "oman flag",
          "flag-om"
        ],
        u: {
          u: "1f1f4-1f1f2",
          x: 39,
          y: 50
        }
      },
      {
        n: [
          "panama flag",
          "flag-pa"
        ],
        u: {
          u: "1f1f5-1f1e6",
          x: 40,
          y: 50
        }
      },
      {
        n: [
          "peru flag",
          "flag-pe"
        ],
        u: {
          u: "1f1f5-1f1ea",
          x: 41,
          y: 50
        }
      },
      {
        n: [
          "french polynesia flag",
          "flag-pf"
        ],
        u: {
          u: "1f1f5-1f1eb",
          x: 42,
          y: 50
        }
      },
      {
        n: [
          "papua new guinea flag",
          "flag-pg"
        ],
        u: {
          u: "1f1f5-1f1ec",
          x: 43,
          y: 50
        }
      },
      {
        n: [
          "philippines flag",
          "flag-ph"
        ],
        u: {
          u: "1f1f5-1f1ed",
          x: 44,
          y: 50
        }
      },
      {
        n: [
          "pakistan flag",
          "flag-pk"
        ],
        u: {
          u: "1f1f5-1f1f0",
          x: 45,
          y: 50
        }
      },
      {
        n: [
          "poland flag",
          "flag-pl"
        ],
        u: {
          u: "1f1f5-1f1f1",
          x: 46,
          y: 50
        }
      },
      {
        n: [
          "st. pierre & miquelon flag",
          "flag-pm"
        ],
        u: {
          u: "1f1f5-1f1f2",
          x: 47,
          y: 50
        }
      },
      {
        n: [
          "pitcairn islands flag",
          "flag-pn"
        ],
        u: {
          u: "1f1f5-1f1f3",
          x: 48,
          y: 50
        }
      },
      {
        n: [
          "puerto rico flag",
          "flag-pr"
        ],
        u: {
          u: "1f1f5-1f1f7",
          x: 49,
          y: 50
        }
      },
      {
        n: [
          "palestinian territories flag",
          "flag-ps"
        ],
        u: {
          u: "1f1f5-1f1f8",
          x: 0,
          y: 51
        }
      },
      {
        n: [
          "portugal flag",
          "flag-pt"
        ],
        u: {
          u: "1f1f5-1f1f9",
          x: 1,
          y: 51
        }
      },
      {
        n: [
          "palau flag",
          "flag-pw"
        ],
        u: {
          u: "1f1f5-1f1fc",
          x: 2,
          y: 51
        }
      },
      {
        n: [
          "paraguay flag",
          "flag-py"
        ],
        u: {
          u: "1f1f5-1f1fe",
          x: 3,
          y: 51
        }
      },
      {
        n: [
          "qatar flag",
          "flag-qa"
        ],
        u: {
          u: "1f1f6-1f1e6",
          x: 4,
          y: 51
        }
      },
      {
        n: [
          "r\xE9union flag",
          "flag-re"
        ],
        u: {
          u: "1f1f7-1f1ea",
          x: 5,
          y: 51
        }
      },
      {
        n: [
          "romania flag",
          "flag-ro"
        ],
        u: {
          u: "1f1f7-1f1f4",
          x: 6,
          y: 51
        }
      },
      {
        n: [
          "serbia flag",
          "flag-rs"
        ],
        u: {
          u: "1f1f7-1f1f8",
          x: 7,
          y: 51
        }
      },
      {
        n: [
          "russia flag",
          "ru",
          "flag-ru"
        ],
        u: {
          u: "1f1f7-1f1fa",
          x: 8,
          y: 51
        }
      },
      {
        n: [
          "rwanda flag",
          "flag-rw"
        ],
        u: {
          u: "1f1f7-1f1fc",
          x: 9,
          y: 51
        }
      },
      {
        n: [
          "saudi arabia flag",
          "flag-sa"
        ],
        u: {
          u: "1f1f8-1f1e6",
          x: 10,
          y: 51
        }
      },
      {
        n: [
          "solomon islands flag",
          "flag-sb"
        ],
        u: {
          u: "1f1f8-1f1e7",
          x: 11,
          y: 51
        }
      },
      {
        n: [
          "seychelles flag",
          "flag-sc"
        ],
        u: {
          u: "1f1f8-1f1e8",
          x: 12,
          y: 51
        }
      },
      {
        n: [
          "sudan flag",
          "flag-sd"
        ],
        u: {
          u: "1f1f8-1f1e9",
          x: 13,
          y: 51
        }
      },
      {
        n: [
          "sweden flag",
          "flag-se"
        ],
        u: {
          u: "1f1f8-1f1ea",
          x: 14,
          y: 51
        }
      },
      {
        n: [
          "singapore flag",
          "flag-sg"
        ],
        u: {
          u: "1f1f8-1f1ec",
          x: 15,
          y: 51
        }
      },
      {
        n: [
          "st. helena flag",
          "flag-sh"
        ],
        u: {
          u: "1f1f8-1f1ed",
          x: 16,
          y: 51
        }
      },
      {
        n: [
          "slovenia flag",
          "flag-si"
        ],
        u: {
          u: "1f1f8-1f1ee",
          x: 17,
          y: 51
        }
      },
      {
        n: [
          "svalbard & jan mayen flag",
          "flag-sj"
        ],
        u: {
          u: "1f1f8-1f1ef",
          x: 18,
          y: 51
        }
      },
      {
        n: [
          "slovakia flag",
          "flag-sk"
        ],
        u: {
          u: "1f1f8-1f1f0",
          x: 19,
          y: 51
        }
      },
      {
        n: [
          "sierra leone flag",
          "flag-sl"
        ],
        u: {
          u: "1f1f8-1f1f1",
          x: 20,
          y: 51
        }
      },
      {
        n: [
          "san marino flag",
          "flag-sm"
        ],
        u: {
          u: "1f1f8-1f1f2",
          x: 21,
          y: 51
        }
      },
      {
        n: [
          "senegal flag",
          "flag-sn"
        ],
        u: {
          u: "1f1f8-1f1f3",
          x: 22,
          y: 51
        }
      },
      {
        n: [
          "somalia flag",
          "flag-so"
        ],
        u: {
          u: "1f1f8-1f1f4",
          x: 23,
          y: 51
        }
      },
      {
        n: [
          "suriname flag",
          "flag-sr"
        ],
        u: {
          u: "1f1f8-1f1f7",
          x: 24,
          y: 51
        }
      },
      {
        n: [
          "south sudan flag",
          "flag-ss"
        ],
        u: {
          u: "1f1f8-1f1f8",
          x: 25,
          y: 51
        }
      },
      {
        n: [
          "s\xE3o tom\xE9 & pr\xEDncipe flag",
          "flag-st"
        ],
        u: {
          u: "1f1f8-1f1f9",
          x: 26,
          y: 51
        }
      },
      {
        n: [
          "el salvador flag",
          "flag-sv"
        ],
        u: {
          u: "1f1f8-1f1fb",
          x: 27,
          y: 51
        }
      },
      {
        n: [
          "sint maarten flag",
          "flag-sx"
        ],
        u: {
          u: "1f1f8-1f1fd",
          x: 28,
          y: 51
        }
      },
      {
        n: [
          "syria flag",
          "flag-sy"
        ],
        u: {
          u: "1f1f8-1f1fe",
          x: 29,
          y: 51
        }
      },
      {
        n: [
          "swaziland flag",
          "flag-sz"
        ],
        u: {
          u: "1f1f8-1f1ff",
          x: 30,
          y: 51
        }
      },
      {
        n: [
          "tristan da cunha flag",
          "flag-ta"
        ],
        u: {
          u: "1f1f9-1f1e6",
          x: 31,
          y: 51
        }
      },
      {
        n: [
          "turks & caicos islands flag",
          "flag-tc"
        ],
        u: {
          u: "1f1f9-1f1e8",
          x: 32,
          y: 51
        }
      },
      {
        n: [
          "chad flag",
          "flag-td"
        ],
        u: {
          u: "1f1f9-1f1e9",
          x: 33,
          y: 51
        }
      },
      {
        n: [
          "french southern territories flag",
          "flag-tf"
        ],
        u: {
          u: "1f1f9-1f1eb",
          x: 34,
          y: 51
        }
      },
      {
        n: [
          "togo flag",
          "flag-tg"
        ],
        u: {
          u: "1f1f9-1f1ec",
          x: 35,
          y: 51
        }
      },
      {
        n: [
          "thailand flag",
          "flag-th"
        ],
        u: {
          u: "1f1f9-1f1ed",
          x: 36,
          y: 51
        }
      },
      {
        n: [
          "tajikistan flag",
          "flag-tj"
        ],
        u: {
          u: "1f1f9-1f1ef",
          x: 37,
          y: 51
        }
      },
      {
        n: [
          "tokelau flag",
          "flag-tk"
        ],
        u: {
          u: "1f1f9-1f1f0",
          x: 38,
          y: 51
        }
      },
      {
        n: [
          "timor-leste flag",
          "flag-tl"
        ],
        u: {
          u: "1f1f9-1f1f1",
          x: 39,
          y: 51
        }
      },
      {
        n: [
          "turkmenistan flag",
          "flag-tm"
        ],
        u: {
          u: "1f1f9-1f1f2",
          x: 40,
          y: 51
        }
      },
      {
        n: [
          "tunisia flag",
          "flag-tn"
        ],
        u: {
          u: "1f1f9-1f1f3",
          x: 41,
          y: 51
        }
      },
      {
        n: [
          "tonga flag",
          "flag-to"
        ],
        u: {
          u: "1f1f9-1f1f4",
          x: 42,
          y: 51
        }
      },
      {
        n: [
          "turkey flag",
          "flag-tr"
        ],
        u: {
          u: "1f1f9-1f1f7",
          x: 43,
          y: 51
        }
      },
      {
        n: [
          "trinidad & tobago flag",
          "flag-tt"
        ],
        u: {
          u: "1f1f9-1f1f9",
          x: 44,
          y: 51
        }
      },
      {
        n: [
          "tuvalu flag",
          "flag-tv"
        ],
        u: {
          u: "1f1f9-1f1fb",
          x: 45,
          y: 51
        }
      },
      {
        n: [
          "taiwan flag",
          "flag-tw"
        ],
        u: {
          u: "1f1f9-1f1fc",
          x: 46,
          y: 51
        }
      },
      {
        n: [
          "tanzania flag",
          "flag-tz"
        ],
        u: {
          u: "1f1f9-1f1ff",
          x: 47,
          y: 51
        }
      },
      {
        n: [
          "ukraine flag",
          "flag-ua"
        ],
        u: {
          u: "1f1fa-1f1e6",
          x: 48,
          y: 51
        }
      },
      {
        n: [
          "uganda flag",
          "flag-ug"
        ],
        u: {
          u: "1f1fa-1f1ec",
          x: 49,
          y: 51
        }
      },
      {
        n: [
          "u.s. outlying islands flag",
          "flag-um"
        ],
        u: {
          u: "1f1fa-1f1f2",
          x: 0,
          y: 52
        }
      },
      {
        n: [
          "united nations flag",
          "flag-un"
        ],
        u: {
          u: "1f1fa-1f1f3",
          x: 1,
          y: 52
        }
      },
      {
        n: [
          "united states flag",
          "us",
          "flag-us"
        ],
        u: {
          u: "1f1fa-1f1f8",
          x: 2,
          y: 52
        }
      },
      {
        n: [
          "uruguay flag",
          "flag-uy"
        ],
        u: {
          u: "1f1fa-1f1fe",
          x: 3,
          y: 52
        }
      },
      {
        n: [
          "uzbekistan flag",
          "flag-uz"
        ],
        u: {
          u: "1f1fa-1f1ff",
          x: 4,
          y: 52
        }
      },
      {
        n: [
          "vatican city flag",
          "flag-va"
        ],
        u: {
          u: "1f1fb-1f1e6",
          x: 5,
          y: 52
        }
      },
      {
        n: [
          "st. vincent & grenadines flag",
          "flag-vc"
        ],
        u: {
          u: "1f1fb-1f1e8",
          x: 6,
          y: 52
        }
      },
      {
        n: [
          "venezuela flag",
          "flag-ve"
        ],
        u: {
          u: "1f1fb-1f1ea",
          x: 7,
          y: 52
        }
      },
      {
        n: [
          "british virgin islands flag",
          "flag-vg"
        ],
        u: {
          u: "1f1fb-1f1ec",
          x: 8,
          y: 52
        }
      },
      {
        n: [
          "u.s. virgin islands flag",
          "flag-vi"
        ],
        u: {
          u: "1f1fb-1f1ee",
          x: 9,
          y: 52
        }
      },
      {
        n: [
          "vietnam flag",
          "flag-vn"
        ],
        u: {
          u: "1f1fb-1f1f3",
          x: 10,
          y: 52
        }
      },
      {
        n: [
          "vanuatu flag",
          "flag-vu"
        ],
        u: {
          u: "1f1fb-1f1fa",
          x: 11,
          y: 52
        }
      },
      {
        n: [
          "wallis & futuna flag",
          "flag-wf"
        ],
        u: {
          u: "1f1fc-1f1eb",
          x: 12,
          y: 52
        }
      },
      {
        n: [
          "samoa flag",
          "flag-ws"
        ],
        u: {
          u: "1f1fc-1f1f8",
          x: 13,
          y: 52
        }
      },
      {
        n: [
          "kosovo flag",
          "flag-xk"
        ],
        u: {
          u: "1f1fd-1f1f0",
          x: 14,
          y: 52
        }
      },
      {
        n: [
          "yemen flag",
          "flag-ye"
        ],
        u: {
          u: "1f1fe-1f1ea",
          x: 15,
          y: 52
        }
      },
      {
        n: [
          "mayotte flag",
          "flag-yt"
        ],
        u: {
          u: "1f1fe-1f1f9",
          x: 16,
          y: 52
        }
      },
      {
        n: [
          "south africa flag",
          "flag-za"
        ],
        u: {
          u: "1f1ff-1f1e6",
          x: 17,
          y: 52
        }
      },
      {
        n: [
          "zambia flag",
          "flag-zm"
        ],
        u: {
          u: "1f1ff-1f1f2",
          x: 18,
          y: 52
        }
      },
      {
        n: [
          "zimbabwe flag",
          "flag-zw"
        ],
        u: {
          u: "1f1ff-1f1fc",
          x: 19,
          y: 52
        }
      },
      {
        n: [
          "england flag",
          "flag-england"
        ],
        u: {
          u: "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
          x: 20,
          y: 52
        }
      },
      {
        n: [
          "scotland flag",
          "flag-scotland"
        ],
        u: {
          u: "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
          x: 21,
          y: 52
        }
      },
      {
        n: [
          "wales flag",
          "flag-wales"
        ],
        u: {
          u: "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
          x: 22,
          y: 52
        }
      }
    ],
    key: "flags",
    title: "Flags",
    u: "1f6a9"
  }
];
var emojiGroupsZhCN = [
  {
    emojis: [],
    u: "1f551",
    title: "\u6700\u8FD1",
    key: "recent_emojis"
  },
  {
    emojis: [
      {
        n: [
          "\u54A7\u5634\u7B11\u7684\u8138",
          "\u9732\u9F7F\u800C\u7B11"
        ],
        u: {
          u: "1f600",
          x: 0,
          y: 0
        }
      },
      {
        n: [
          "\u7B11\u772F\u772F\u7684\u8138",
          "\u54A7\u5634\u7B11"
        ],
        u: {
          u: "1f601",
          x: 1,
          y: 0
        }
      },
      {
        n: [
          "\u9762\u5E26\u559C\u60A6\u7684\u6CEA\u6C34",
          "\u5FEB\u4E50"
        ],
        u: {
          u: "1f602",
          x: 2,
          y: 0
        }
      },
      {
        n: [
          "\u7B11\u7740\u5728\u5730\u677F\u4E0A\u6253\u6EDA"
        ],
        u: {
          u: "1f923",
          x: 3,
          y: 0
        }
      },
      {
        n: [
          "\u5F20\u5634\u7B11\u8138",
          "\u7B11\u8138"
        ],
        u: {
          u: "1f603",
          x: 4,
          y: 0
        }
      },
      {
        n: [
          "\u5F20\u5634\u5FAE\u7B11\u7684\u8138\u548C\u5FAE\u7B11\u7684\u773C\u775B",
          "\u5FAE\u7B11"
        ],
        u: {
          u: "1f604",
          x: 5,
          y: 0
        }
      },
      {
        n: [
          "\u5F20\u5634\u51B7\u6C57\u7B11\u8138",
          "\u6C57\u6C34\u822C\u7684\u5FAE\u7B11"
        ],
        u: {
          u: "1f605",
          x: 6,
          y: 0
        }
      },
      {
        n: [
          "\u5F20\u5634\u7D27\u95ED\u53CC\u773C\u7684\u7B11\u8138",
          "\u5927\u7B11",
          "\u6EE1\u610F\u7684"
        ],
        u: {
          u: "1f606",
          x: 7,
          y: 0
        }
      },
      {
        n: [
          "\u7728\u773C\u7684\u8138",
          "\u7728\u773C"
        ],
        u: {
          u: "1f609",
          x: 8,
          y: 0
        }
      },
      {
        n: [
          "\u5E26\u7740\u5FAE\u7B11\u7684\u773C\u775B\u7684\u7B11\u8138",
          "\u8138\u7EA2"
        ],
        u: {
          u: "1f60a",
          x: 9,
          y: 0
        }
      },
      {
        n: [
          "\u9762\u5BF9\u7F8E\u5473\u7684\u98DF\u7269",
          "\u597D\u5403"
        ],
        u: {
          u: "1f60b",
          x: 10,
          y: 0
        }
      },
      {
        n: [
          "\u6234\u58A8\u955C\u7684\u7B11\u8138",
          "\u592A\u9633\u955C"
        ],
        u: {
          u: "1f60e",
          x: 11,
          y: 0
        }
      },
      {
        n: [
          "\u5FC3\u5F62\u773C\u775B\u7684\u7B11\u8138",
          "\u5FC3\u773C"
        ],
        u: {
          u: "1f60d",
          x: 12,
          y: 0
        }
      },
      {
        n: [
          "\u8138\u4E0A\u98DE\u543B",
          "\u4EB2\u543B\u7684\u5FC3"
        ],
        u: {
          u: "1f618",
          x: 13,
          y: 0
        }
      },
      {
        n: [
          "\u4EB2\u543B\u7684\u8138",
          "\u63A5\u543B"
        ],
        u: {
          u: "1f617",
          x: 14,
          y: 0
        }
      },
      {
        n: [
          "\u7528\u5FAE\u7B11\u7684\u773C\u775B\u4EB2\u543B\u8138",
          "\u4EB2\u543B\u5FAE\u7B11\u7684\u773C\u775B"
        ],
        u: {
          u: "1f619",
          x: 15,
          y: 0
        }
      },
      {
        n: [
          "\u95ED\u4E0A\u773C\u775B\u4EB2\u543B\u8138",
          "\u4EB2\u543B\u95ED\u4E0A\u7684\u773C\u775B"
        ],
        u: {
          u: "1f61a",
          x: 16,
          y: 0
        }
      },
      {
        n: [
          "\u767D\u8272\u7B11\u8138",
          "\u8F7B\u677E\u7684"
        ],
        u: {
          u: "263a",
          x: 17,
          y: 0
        }
      },
      {
        n: [
          "\u5FAE\u5FAE\u4E00\u7B11\u7684\u8138"
        ],
        u: {
          u: "1f642",
          x: 18,
          y: 0
        }
      },
      {
        n: [
          "\u62E5\u62B1\u7684\u8138"
        ],
        u: {
          u: "1f917",
          x: 19,
          y: 0
        }
      },
      {
        n: [
          "\u7B11\u8138\u661F\u773C",
          "\u661F\u5149\u71A0\u71A0"
        ],
        u: {
          u: "1f929",
          x: 20,
          y: 0
        }
      },
      {
        n: [
          "\u601D\u8003\u7684\u9762\u5B54"
        ],
        u: {
          u: "1f914",
          x: 21,
          y: 0
        }
      },
      {
        n: [
          "\u626C\u8D77\u4E00\u6761\u7709\u6BDB\u7684\u8138",
          "\u626C\u7709\u7684\u8138"
        ],
        u: {
          u: "1f928",
          x: 22,
          y: 0
        }
      },
      {
        n: [
          "\u4E2D\u6027\u8138"
        ],
        u: {
          u: "1f610",
          x: 23,
          y: 0
        }
      },
      {
        n: [
          "\u65E0\u8868\u60C5\u7684\u8138",
          "\u65E0\u8868\u60C5"
        ],
        u: {
          u: "1f611",
          x: 24,
          y: 0
        }
      },
      {
        n: [
          "\u6CA1\u6709\u5634\u7684\u8138",
          "\u6CA1\u6709\u5634\u5DF4"
        ],
        u: {
          u: "1f636",
          x: 25,
          y: 0
        }
      },
      {
        n: [
          "\u773C\u775B\u8F6C\u52A8\u7684\u8138"
        ],
        u: {
          u: "1f644",
          x: 26,
          y: 0
        }
      },
      {
        n: [
          "\u50BB\u7B11\u7684\u8138",
          "\u50BB\u7B11"
        ],
        u: {
          u: "1f60f",
          x: 27,
          y: 0
        }
      },
      {
        n: [
          "\u575A\u5FCD\u4E0D\u62D4\u7684\u8138",
          "\u6301\u4E4B\u4EE5\u6052"
        ],
        u: {
          u: "1f623",
          x: 28,
          y: 0
        }
      },
      {
        n: [
          "\u5931\u671B\u4F46\u5BBD\u6170\u7684\u8138",
          "\u5931\u671B\u7684\u677E\u4E86\u53E3\u6C14"
        ],
        u: {
          u: "1f625",
          x: 29,
          y: 0
        }
      },
      {
        n: [
          "\u5F20\u7740\u5634\u7684\u8138",
          "\u5F20\u5F00\u5634"
        ],
        u: {
          u: "1f62e",
          x: 30,
          y: 0
        }
      },
      {
        n: [
          "\u62C9\u94FE\u5634\u9762"
        ],
        u: {
          u: "1f910",
          x: 31,
          y: 0
        }
      },
      {
        n: [
          "\u5B89\u9759\u7684\u8138",
          "\u5B89\u9759"
        ],
        u: {
          u: "1f62f",
          x: 32,
          y: 0
        }
      },
      {
        n: [
          "\u660F\u660F\u6B32\u7761\u7684\u8138",
          "\u56F0\u4E4F\u7684"
        ],
        u: {
          u: "1f62a",
          x: 33,
          y: 0
        }
      },
      {
        n: [
          "\u75B2\u60EB\u7684\u8138"
        ],
        u: {
          u: "1f62b",
          x: 34,
          y: 0
        }
      },
      {
        n: [
          "\u7761\u89C9\u7684\u8138",
          "\u6B63\u5728\u7761\u89C9"
        ],
        u: {
          u: "1f634",
          x: 35,
          y: 0
        }
      },
      {
        n: [
          "\u5378\u538B\u9762",
          "\u91CA\u7136\u7684"
        ],
        u: {
          u: "1f60c",
          x: 36,
          y: 0
        }
      },
      {
        n: [
          "\u820C\u5934\u7A81\u51FA\u7684\u9762\u90E8",
          "\u4F38\u51FA\u7684\u820C\u5934"
        ],
        u: {
          u: "1f61b",
          x: 37,
          y: 0
        }
      },
      {
        n: [
          "\u4F38\u51FA\u820C\u5934\u548C\u7728\u773C\u7684\u8138",
          "\u4F38\u51FA\u820C\u5934\u7728\u773C"
        ],
        u: {
          u: "1f61c",
          x: 38,
          y: 0
        }
      },
      {
        n: [
          "\u820C\u5934\u7A81\u51FA\u3001\u773C\u775B\u7D27\u95ED\u7684\u8138",
          "\u4F38\u51FA\u820C\u5934\u95ED\u4E0A\u773C\u775B"
        ],
        u: {
          u: "1f61d",
          x: 39,
          y: 0
        }
      },
      {
        n: [
          "\u6D41\u53E3\u6C34\u7684\u8138"
        ],
        u: {
          u: "1f924",
          x: 40,
          y: 0
        }
      },
      {
        n: [
          "\u672A\u4F7F\u7528\u7684\u9762",
          "\u672A\u4F7F\u7528\u7684"
        ],
        u: {
          u: "1f612",
          x: 41,
          y: 0
        }
      },
      {
        n: [
          "\u6EE1\u8138\u51B7\u6C57",
          "\u6C57\u6C34"
        ],
        u: {
          u: "1f613",
          x: 42,
          y: 0
        }
      },
      {
        n: [
          "\u5FE7\u90C1\u7684\u8138",
          "\u6C89\u601D\u7684"
        ],
        u: {
          u: "1f614",
          x: 43,
          y: 0
        }
      },
      {
        n: [
          "\u8FF7\u832B\u7684\u8138",
          "\u56F0\u60D1\u7684"
        ],
        u: {
          u: "1f615",
          x: 44,
          y: 0
        }
      },
      {
        n: [
          "\u5012\u7F6E\u7684\u9762"
        ],
        u: {
          u: "1f643",
          x: 45,
          y: 0
        }
      },
      {
        n: [
          "\u91D1\u94B1\u5634\u8138"
        ],
        u: {
          u: "1f911",
          x: 46,
          y: 0
        }
      },
      {
        n: [
          "\u60CA\u8BB6\u7684\u8138",
          "\u60CA\u8BB6\u7684"
        ],
        u: {
          u: "1f632",
          x: 47,
          y: 0
        }
      },
      {
        n: [
          "\u76B1\u7709\u7684\u767D\u8138"
        ],
        u: {
          u: "2639",
          x: 48,
          y: 0
        }
      },
      {
        n: [
          "\u5FAE\u5FAE\u76B1\u7709\u7684\u8138"
        ],
        u: {
          u: "1f641",
          x: 49,
          y: 0
        }
      },
      {
        n: [
          "\u56F0\u60D1\u7684\u8138",
          "\u56F0\u60D1\u7684"
        ],
        u: {
          u: "1f616",
          x: 0,
          y: 1
        }
      },
      {
        n: [
          "\u5931\u671B\u7684\u8138",
          "\u5931\u671B\u7684"
        ],
        u: {
          u: "1f61e",
          x: 1,
          y: 1
        }
      },
      {
        n: [
          "\u6101\u7709\u82E6\u8138",
          "\u62C5\u5FC3"
        ],
        u: {
          u: "1f61f",
          x: 2,
          y: 1
        }
      },
      {
        n: [
          "\u8138\u4E0A\u6D0B\u6EA2\u7740\u80DC\u5229\u7684\u795E\u60C5",
          "\u80DC\u5229"
        ],
        u: {
          u: "1f624",
          x: 3,
          y: 1
        }
      },
      {
        n: [
          "\u54ED\u6CE3\u7684\u8138",
          "\u54ED\u6CE3"
        ],
        u: {
          u: "1f622",
          x: 4,
          y: 1
        }
      },
      {
        n: [
          "\u5927\u54ED\u7684\u8138",
          "\u62BD\u564E"
        ],
        u: {
          u: "1f62d",
          x: 5,
          y: 1
        }
      },
      {
        n: [
          "\u5F20\u7740\u5634\u76B1\u7740\u7709\u5934",
          "\u76B1\u7709"
        ],
        u: {
          u: "1f626",
          x: 6,
          y: 1
        }
      },
      {
        n: [
          "\u75DB\u82E6\u7684\u8138",
          "\u75DB\u82E6\u7684"
        ],
        u: {
          u: "1f627",
          x: 7,
          y: 1
        }
      },
      {
        n: [
          "\u53EF\u6015\u7684\u8138",
          "\u62C5\u5FC3"
        ],
        u: {
          u: "1f628",
          x: 8,
          y: 1
        }
      },
      {
        n: [
          "\u75B2\u5026\u7684\u8138",
          "\u75B2\u5026\u7684"
        ],
        u: {
          u: "1f629",
          x: 9,
          y: 1
        }
      },
      {
        n: [
          "\u5934\u90E8\u7206\u70B8\u7684\u9707\u60CA\u9762\u90E8",
          "\u7206\u70B8\u5934\uFF0C\u7206\u70B8\u5934"
        ],
        u: {
          u: "1f92f",
          x: 10,
          y: 1
        }
      },
      {
        n: [
          "\u6B6A\u626D",
          "\u9B3C\u8138"
        ],
        u: {
          u: "1f62c",
          x: 11,
          y: 1
        }
      },
      {
        n: [
          "\u5F20\u5634\u51B7\u6C57\u8138",
          "\u51B7\u6C57"
        ],
        u: {
          u: "1f630",
          x: 12,
          y: 1
        }
      },
      {
        n: [
          "\u8138\u4E0A\u6050\u60E7\u5730\u5C16\u53EB",
          "\u5C16\u53EB"
        ],
        u: {
          u: "1f631",
          x: 13,
          y: 1
        }
      },
      {
        n: [
          "\u9F50\u5E73\u7684\u8138",
          "\u8138\u7EA2"
        ],
        u: {
          u: "1f633",
          x: 14,
          y: 1
        }
      },
      {
        n: [
          "\u4E00\u53EA\u5927\u773C\u775B\u548C\u4E00\u53EA\u5C0F\u773C\u775B\u54A7\u5634\u7B11\u7740\u7684\u8138",
          "\u6ED1\u7A3D\u7684\u8138"
        ],
        u: {
          u: "1f92a",
          x: 15,
          y: 1
        }
      },
      {
        n: [
          "\u5934\u6655\u7684\u8138"
        ],
        u: {
          u: "1f635",
          x: 16,
          y: 1
        }
      },
      {
        n: [
          "\u6485\u5634\u7684\u8138",
          "\u6124\u6012"
        ],
        u: {
          u: "1f621",
          x: 17,
          y: 1
        }
      },
      {
        n: [
          "\u6124\u6012\u7684\u8138",
          "\u53D1\u6012\u7684"
        ],
        u: {
          u: "1f620",
          x: 18,
          y: 1
        }
      },
      {
        n: [
          "\u4E25\u8083\u7684\u8138\uFF0C\u7528\u7B26\u53F7\u906E\u4F4F\u5634",
          "\u5634\u4E0A\u6709\u7B26\u53F7\u7684\u8138"
        ],
        u: {
          u: "1f92c",
          x: 19,
          y: 1
        }
      },
      {
        n: [
          "\u5E26\u533B\u7528\u9762\u7F69\u7684\u9762\u90E8",
          "\u9762\u5177"
        ],
        u: {
          u: "1f637",
          x: 20,
          y: 1
        }
      },
      {
        n: [
          "\u5E26\u6E29\u5EA6\u8BA1\u7684\u8868\u9762"
        ],
        u: {
          u: "1f912",
          x: 21,
          y: 1
        }
      },
      {
        n: [
          "\u5934\u90E8\u7EF7\u5E26\u9762\u90E8"
        ],
        u: {
          u: "1f915",
          x: 22,
          y: 1
        }
      },
      {
        n: [
          "\u6076\u5FC3\u7684\u8138"
        ],
        u: {
          u: "1f922",
          x: 23,
          y: 1
        }
      },
      {
        n: [
          "\u9762\u90E8\u5F20\u53E3\u5455\u5410",
          "\u9762\u90E8\u5455\u5410"
        ],
        u: {
          u: "1f92e",
          x: 24,
          y: 1
        }
      },
      {
        n: [
          "\u6253\u55B7\u568F\u7684\u8138"
        ],
        u: {
          u: "1f927",
          x: 25,
          y: 1
        }
      },
      {
        n: [
          "\u5E26\u5149\u73AF\u7684\u7B11\u8138",
          "\u65E0\u8F9C\u7684"
        ],
        u: {
          u: "1f607",
          x: 26,
          y: 1
        }
      },
      {
        n: [
          "\u6234\u725B\u4ED4\u5E3D\u7684\u8138"
        ],
        u: {
          u: "1f920",
          x: 27,
          y: 1
        }
      },
      {
        n: [
          "\u5C0F\u4E11\u8138"
        ],
        u: {
          u: "1f921",
          x: 28,
          y: 1
        }
      },
      {
        n: [
          "\u8EBA\u7740\u7684\u8138"
        ],
        u: {
          u: "1f925",
          x: 29,
          y: 1
        }
      },
      {
        n: [
          "\u624B\u6307\u6342\u4F4F\u5634\u5507\u7684\u8138",
          "shushing\u9762"
        ],
        u: {
          u: "1f92b",
          x: 30,
          y: 1
        }
      },
      {
        n: [
          "\u9762\u5E26\u5FAE\u7B11\u7684\u773C\u775B\u548C\u624B\u6342\u4F4F\u5634\u7684\u7B11\u8138",
          "\u7528\u624B\u6342\u4F4F\u5634\u7684\u8138"
        ],
        u: {
          u: "1f92d",
          x: 31,
          y: 1
        }
      },
      {
        n: [
          "\u5E26\u5355\u7247\u773C\u955C\u7684\u9762\u90E8"
        ],
        u: {
          u: "1f9d0",
          x: 32,
          y: 1
        }
      },
      {
        n: [
          "\u4E66\u5446\u5B50\u8138"
        ],
        u: {
          u: "1f913",
          x: 33,
          y: 1
        }
      },
      {
        n: [
          "\u5E26\u89D2\u7684\u7B11\u8138",
          "\u5FAE\u7B11\u7684\u5C0F\u9B3C"
        ],
        u: {
          u: "1f608",
          x: 34,
          y: 1
        }
      },
      {
        n: [
          "\u63A5\u53E3\u4FE1\u606F\u5904\u7406\u5668"
        ],
        u: {
          u: "1f47f",
          x: 35,
          y: 1
        }
      },
      {
        n: [
          "\u65E5\u672C\u98DF\u4EBA\u9B54"
        ],
        u: {
          u: "1f479",
          x: 36,
          y: 1
        }
      },
      {
        n: [
          "\u65E5\u672C\u5730\u7CBE"
        ],
        u: {
          u: "1f47a",
          x: 37,
          y: 1
        }
      },
      {
        n: [
          "\u9885\u9AA8"
        ],
        u: {
          u: "1f480",
          x: 38,
          y: 1
        }
      },
      {
        n: [
          "\u9AB7\u9AC5"
        ],
        u: {
          u: "2620",
          x: 39,
          y: 1
        }
      },
      {
        n: [
          "\u9B3C"
        ],
        u: {
          u: "1f47b",
          x: 40,
          y: 1
        }
      },
      {
        n: [
          "\u5916\u661F\u5916\u661F\u4EBA",
          "\u5916\u661F\u4EBA"
        ],
        u: {
          u: "1f47d",
          x: 41,
          y: 1
        }
      },
      {
        n: [
          "\u5916\u661F\u602A\u7269",
          "\u592A\u7A7A\u5165\u4FB5\u8005"
        ],
        u: {
          u: "1f47e",
          x: 42,
          y: 1
        }
      },
      {
        n: [
          "\u673A\u5668\u4EBA\u8138"
        ],
        u: {
          u: "1f916",
          x: 43,
          y: 1
        }
      },
      {
        n: [
          "\u4E00\u5806\u4FBF\u4FBF",
          "\u624B\u5E15",
          "\u5927\u4FBF",
          "\u8BE5\u6B7B\u7684"
        ],
        u: {
          u: "1f4a9",
          x: 44,
          y: 1
        }
      },
      {
        n: [
          "\u5F20\u7740\u5634\u5FAE\u7B11\u7684\u732B\u8138",
          "\u7B11\u8138\u732B"
        ],
        u: {
          u: "1f63a",
          x: 45,
          y: 1
        }
      },
      {
        n: [
          "\u7B11\u772F\u772F\u7684\u732B\u8138",
          "\u5FAE\u7B11\u732B"
        ],
        u: {
          u: "1f638",
          x: 46,
          y: 1
        }
      },
      {
        n: [
          "\u559C\u6781\u800C\u6CE3\u7684\u732B\u8138",
          "\u6B22\u4E50\u732B"
        ],
        u: {
          u: "1f639",
          x: 47,
          y: 1
        }
      },
      {
        n: [
          "\u5FC3\u5F62\u773C\u775B\u7684\u5FAE\u7B11\u732B\u8138",
          "\u5FC3\u773C\u732B"
        ],
        u: {
          u: "1f63b",
          x: 48,
          y: 1
        }
      },
      {
        n: [
          "\u732B\u8138\u82E6\u7B11",
          "\u50BB\u7B11\u732B"
        ],
        u: {
          u: "1f63c",
          x: 49,
          y: 1
        }
      },
      {
        n: [
          "\u95ED\u7740\u773C\u775B\u4EB2\u543B\u732B\u8138",
          "\u4EB2\u543B\u732B"
        ],
        u: {
          u: "1f63d",
          x: 0,
          y: 2
        }
      },
      {
        n: [
          "\u75B2\u5026\u7684\u732B\u8138",
          "\u5C16\u53EB\u732B"
        ],
        u: {
          u: "1f640",
          x: 1,
          y: 2
        }
      },
      {
        n: [
          "\u54ED\u6CE3\u7684\u732B\u8138"
        ],
        u: {
          u: "1f63f",
          x: 2,
          y: 2
        }
      },
      {
        n: [
          "\u6485\u5634\u732B\u8138",
          "\u6485\u5634\u732B"
        ],
        u: {
          u: "1f63e",
          x: 3,
          y: 2
        }
      },
      {
        n: [
          "\u770B\u4E0D\u5230\u90AA\u6076\u7684\u7334\u5B50",
          "\u770B\u4E0D\u5230\u90AA\u6076"
        ],
        u: {
          u: "1f648",
          x: 4,
          y: 2
        }
      },
      {
        n: [
          "\u4E0D\u8981\u542C\u5230\u90AA\u6076\u7684\u7334\u5B50",
          "\u4E0D\u8981\u542C\u5230\u90AA\u6076\u7684\u58F0\u97F3"
        ],
        u: {
          u: "1f649",
          x: 5,
          y: 2
        }
      },
      {
        n: [
          "\u4E0D\u8981\u8BF4\u6076\u6BD2\u7684\u7334\u5B50",
          "\u4E0D\u8981\u8BF4\u574F\u8BDD"
        ],
        u: {
          u: "1f64a",
          x: 6,
          y: 2
        }
      },
      {
        n: [
          "\u5B9D\u8D1D"
        ],
        u: {
          u: "1f476",
          x: 7,
          y: 2
        },
        v: [
          {
            u: "1f476-1f3fb",
            x: 8,
            y: 2
          },
          {
            u: "1f476-1f3fc",
            x: 9,
            y: 2
          },
          {
            u: "1f476-1f3fd",
            x: 10,
            y: 2
          },
          {
            u: "1f476-1f3fe",
            x: 11,
            y: 2
          },
          {
            u: "1f476-1f3ff",
            x: 12,
            y: 2
          }
        ]
      },
      {
        n: [
          "\u5C0F\u5B69"
        ],
        u: {
          u: "1f9d2",
          x: 13,
          y: 2
        },
        v: [
          {
            u: "1f9d2-1f3fb",
            x: 14,
            y: 2
          },
          {
            u: "1f9d2-1f3fc",
            x: 15,
            y: 2
          },
          {
            u: "1f9d2-1f3fd",
            x: 16,
            y: 2
          },
          {
            u: "1f9d2-1f3fe",
            x: 17,
            y: 2
          },
          {
            u: "1f9d2-1f3ff",
            x: 18,
            y: 2
          }
        ]
      },
      {
        n: [
          "\u7537\u5B69"
        ],
        u: {
          u: "1f466",
          x: 19,
          y: 2
        },
        v: [
          {
            u: "1f466-1f3fb",
            x: 20,
            y: 2
          },
          {
            u: "1f466-1f3fc",
            x: 21,
            y: 2
          },
          {
            u: "1f466-1f3fd",
            x: 22,
            y: 2
          },
          {
            u: "1f466-1f3fe",
            x: 23,
            y: 2
          },
          {
            u: "1f466-1f3ff",
            x: 24,
            y: 2
          }
        ]
      },
      {
        n: [
          "\u5973\u5B69"
        ],
        u: {
          u: "1f467",
          x: 25,
          y: 2
        },
        v: [
          {
            u: "1f467-1f3fb",
            x: 26,
            y: 2
          },
          {
            u: "1f467-1f3fc",
            x: 27,
            y: 2
          },
          {
            u: "1f467-1f3fd",
            x: 28,
            y: 2
          },
          {
            u: "1f467-1f3fe",
            x: 29,
            y: 2
          },
          {
            u: "1f467-1f3ff",
            x: 30,
            y: 2
          }
        ]
      },
      {
        n: [
          "\u6210\u4EBA"
        ],
        u: {
          u: "1f9d1",
          x: 31,
          y: 2
        },
        v: [
          {
            u: "1f9d1-1f3fb",
            x: 32,
            y: 2
          },
          {
            u: "1f9d1-1f3fc",
            x: 33,
            y: 2
          },
          {
            u: "1f9d1-1f3fd",
            x: 34,
            y: 2
          },
          {
            u: "1f9d1-1f3fe",
            x: 35,
            y: 2
          },
          {
            u: "1f9d1-1f3ff",
            x: 36,
            y: 2
          }
        ]
      },
      {
        n: [
          "\u6210\u5E74\u7537\u5B50"
        ],
        u: {
          u: "1f468",
          x: 37,
          y: 2
        },
        v: [
          {
            u: "1f468-1f3fb",
            x: 38,
            y: 2
          },
          {
            u: "1f468-1f3fc",
            x: 39,
            y: 2
          },
          {
            u: "1f468-1f3fd",
            x: 40,
            y: 2
          },
          {
            u: "1f468-1f3fe",
            x: 41,
            y: 2
          },
          {
            u: "1f468-1f3ff",
            x: 42,
            y: 2
          }
        ]
      },
      {
        n: [
          "\u6210\u5E74\u5973\u5B50"
        ],
        u: {
          u: "1f469",
          x: 43,
          y: 2
        },
        v: [
          {
            u: "1f469-1f3fb",
            x: 44,
            y: 2
          },
          {
            u: "1f469-1f3fc",
            x: 45,
            y: 2
          },
          {
            u: "1f469-1f3fd",
            x: 46,
            y: 2
          },
          {
            u: "1f469-1f3fe",
            x: 47,
            y: 2
          },
          {
            u: "1f469-1f3ff",
            x: 48,
            y: 2
          }
        ]
      },
      {
        n: [
          "\u8001\u5E74\u4EBA"
        ],
        u: {
          u: "1f9d3",
          x: 49,
          y: 2
        },
        v: [
          {
            u: "1f9d3-1f3fb",
            x: 0,
            y: 3
          },
          {
            u: "1f9d3-1f3fc",
            x: 1,
            y: 3
          },
          {
            u: "1f9d3-1f3fd",
            x: 2,
            y: 3
          },
          {
            u: "1f9d3-1f3fe",
            x: 3,
            y: 3
          },
          {
            u: "1f9d3-1f3ff",
            x: 4,
            y: 3
          }
        ]
      },
      {
        n: [
          "\u8001\u4EBA"
        ],
        u: {
          u: "1f474",
          x: 5,
          y: 3
        },
        v: [
          {
            u: "1f474-1f3fb",
            x: 6,
            y: 3
          },
          {
            u: "1f474-1f3fc",
            x: 7,
            y: 3
          },
          {
            u: "1f474-1f3fd",
            x: 8,
            y: 3
          },
          {
            u: "1f474-1f3fe",
            x: 9,
            y: 3
          },
          {
            u: "1f474-1f3ff",
            x: 10,
            y: 3
          }
        ]
      },
      {
        n: [
          "\u8001\u5E74\u5987\u5973"
        ],
        u: {
          u: "1f475",
          x: 11,
          y: 3
        },
        v: [
          {
            u: "1f475-1f3fb",
            x: 12,
            y: 3
          },
          {
            u: "1f475-1f3fc",
            x: 13,
            y: 3
          },
          {
            u: "1f475-1f3fd",
            x: 14,
            y: 3
          },
          {
            u: "1f475-1f3fe",
            x: 15,
            y: 3
          },
          {
            u: "1f475-1f3ff",
            x: 16,
            y: 3
          }
        ]
      },
      {
        n: [
          "\u7537\u533B\u751F"
        ],
        u: {
          u: "1f468-200d-2695-fe0f",
          x: 17,
          y: 3
        },
        v: [
          {
            u: "1f468-1f3fb-200d-2695-fe0f",
            x: 18,
            y: 3
          },
          {
            u: "1f468-1f3fc-200d-2695-fe0f",
            x: 19,
            y: 3
          },
          {
            u: "1f468-1f3fd-200d-2695-fe0f",
            x: 20,
            y: 3
          },
          {
            u: "1f468-1f3fe-200d-2695-fe0f",
            x: 21,
            y: 3
          },
          {
            u: "1f468-1f3ff-200d-2695-fe0f",
            x: 22,
            y: 3
          }
        ]
      },
      {
        n: [
          "\u5973\u533B\u751F"
        ],
        u: {
          u: "1f469-200d-2695-fe0f",
          x: 23,
          y: 3
        },
        v: [
          {
            u: "1f469-1f3fb-200d-2695-fe0f",
            x: 24,
            y: 3
          },
          {
            u: "1f469-1f3fc-200d-2695-fe0f",
            x: 25,
            y: 3
          },
          {
            u: "1f469-1f3fd-200d-2695-fe0f",
            x: 26,
            y: 3
          },
          {
            u: "1f469-1f3fe-200d-2695-fe0f",
            x: 27,
            y: 3
          },
          {
            u: "1f469-1f3ff-200d-2695-fe0f",
            x: 28,
            y: 3
          }
        ]
      },
      {
        n: [
          "\u7537\u751F"
        ],
        u: {
          u: "1f468-200d-1f393",
          x: 29,
          y: 3
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f393",
            x: 30,
            y: 3
          },
          {
            u: "1f468-1f3fc-200d-1f393",
            x: 31,
            y: 3
          },
          {
            u: "1f468-1f3fd-200d-1f393",
            x: 32,
            y: 3
          },
          {
            u: "1f468-1f3fe-200d-1f393",
            x: 33,
            y: 3
          },
          {
            u: "1f468-1f3ff-200d-1f393",
            x: 34,
            y: 3
          }
        ]
      },
      {
        n: [
          "\u5973\u751F"
        ],
        u: {
          u: "1f469-200d-1f393",
          x: 35,
          y: 3
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f393",
            x: 36,
            y: 3
          },
          {
            u: "1f469-1f3fc-200d-1f393",
            x: 37,
            y: 3
          },
          {
            u: "1f469-1f3fd-200d-1f393",
            x: 38,
            y: 3
          },
          {
            u: "1f469-1f3fe-200d-1f393",
            x: 39,
            y: 3
          },
          {
            u: "1f469-1f3ff-200d-1f393",
            x: 40,
            y: 3
          }
        ]
      },
      {
        n: [
          "\u7537\u6559\u5E08"
        ],
        u: {
          u: "1f468-200d-1f3eb",
          x: 41,
          y: 3
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f3eb",
            x: 42,
            y: 3
          },
          {
            u: "1f468-1f3fc-200d-1f3eb",
            x: 43,
            y: 3
          },
          {
            u: "1f468-1f3fd-200d-1f3eb",
            x: 44,
            y: 3
          },
          {
            u: "1f468-1f3fe-200d-1f3eb",
            x: 45,
            y: 3
          },
          {
            u: "1f468-1f3ff-200d-1f3eb",
            x: 46,
            y: 3
          }
        ]
      },
      {
        n: [
          "\u5973\u6559\u5E08"
        ],
        u: {
          u: "1f469-200d-1f3eb",
          x: 47,
          y: 3
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f3eb",
            x: 48,
            y: 3
          },
          {
            u: "1f469-1f3fc-200d-1f3eb",
            x: 49,
            y: 3
          },
          {
            u: "1f469-1f3fd-200d-1f3eb",
            x: 0,
            y: 4
          },
          {
            u: "1f469-1f3fe-200d-1f3eb",
            x: 1,
            y: 4
          },
          {
            u: "1f469-1f3ff-200d-1f3eb",
            x: 2,
            y: 4
          }
        ]
      },
      {
        n: [
          "\u7537\u6CD5\u5B98"
        ],
        u: {
          u: "1f468-200d-2696-fe0f",
          x: 3,
          y: 4
        },
        v: [
          {
            u: "1f468-1f3fb-200d-2696-fe0f",
            x: 4,
            y: 4
          },
          {
            u: "1f468-1f3fc-200d-2696-fe0f",
            x: 5,
            y: 4
          },
          {
            u: "1f468-1f3fd-200d-2696-fe0f",
            x: 6,
            y: 4
          },
          {
            u: "1f468-1f3fe-200d-2696-fe0f",
            x: 7,
            y: 4
          },
          {
            u: "1f468-1f3ff-200d-2696-fe0f",
            x: 8,
            y: 4
          }
        ]
      },
      {
        n: [
          "\u5973\u6CD5\u5B98"
        ],
        u: {
          u: "1f469-200d-2696-fe0f",
          x: 9,
          y: 4
        },
        v: [
          {
            u: "1f469-1f3fb-200d-2696-fe0f",
            x: 10,
            y: 4
          },
          {
            u: "1f469-1f3fc-200d-2696-fe0f",
            x: 11,
            y: 4
          },
          {
            u: "1f469-1f3fd-200d-2696-fe0f",
            x: 12,
            y: 4
          },
          {
            u: "1f469-1f3fe-200d-2696-fe0f",
            x: 13,
            y: 4
          },
          {
            u: "1f469-1f3ff-200d-2696-fe0f",
            x: 14,
            y: 4
          }
        ]
      },
      {
        n: [
          "\u7537\u6027\u519C\u6C11"
        ],
        u: {
          u: "1f468-200d-1f33e",
          x: 15,
          y: 4
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f33e",
            x: 16,
            y: 4
          },
          {
            u: "1f468-1f3fc-200d-1f33e",
            x: 17,
            y: 4
          },
          {
            u: "1f468-1f3fd-200d-1f33e",
            x: 18,
            y: 4
          },
          {
            u: "1f468-1f3fe-200d-1f33e",
            x: 19,
            y: 4
          },
          {
            u: "1f468-1f3ff-200d-1f33e",
            x: 20,
            y: 4
          }
        ]
      },
      {
        n: [
          "\u5973\u519C\u6C11"
        ],
        u: {
          u: "1f469-200d-1f33e",
          x: 21,
          y: 4
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f33e",
            x: 22,
            y: 4
          },
          {
            u: "1f469-1f3fc-200d-1f33e",
            x: 23,
            y: 4
          },
          {
            u: "1f469-1f3fd-200d-1f33e",
            x: 24,
            y: 4
          },
          {
            u: "1f469-1f3fe-200d-1f33e",
            x: 25,
            y: 4
          },
          {
            u: "1f469-1f3ff-200d-1f33e",
            x: 26,
            y: 4
          }
        ]
      },
      {
        n: [
          "\u7537\u53A8\u5E08"
        ],
        u: {
          u: "1f468-200d-1f373",
          x: 27,
          y: 4
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f373",
            x: 28,
            y: 4
          },
          {
            u: "1f468-1f3fc-200d-1f373",
            x: 29,
            y: 4
          },
          {
            u: "1f468-1f3fd-200d-1f373",
            x: 30,
            y: 4
          },
          {
            u: "1f468-1f3fe-200d-1f373",
            x: 31,
            y: 4
          },
          {
            u: "1f468-1f3ff-200d-1f373",
            x: 32,
            y: 4
          }
        ]
      },
      {
        n: [
          "\u5973\u53A8\u5E08"
        ],
        u: {
          u: "1f469-200d-1f373",
          x: 33,
          y: 4
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f373",
            x: 34,
            y: 4
          },
          {
            u: "1f469-1f3fc-200d-1f373",
            x: 35,
            y: 4
          },
          {
            u: "1f469-1f3fd-200d-1f373",
            x: 36,
            y: 4
          },
          {
            u: "1f469-1f3fe-200d-1f373",
            x: 37,
            y: 4
          },
          {
            u: "1f469-1f3ff-200d-1f373",
            x: 38,
            y: 4
          }
        ]
      },
      {
        n: [
          "\u7537\u673A\u68B0\u5E08"
        ],
        u: {
          u: "1f468-200d-1f527",
          x: 39,
          y: 4
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f527",
            x: 40,
            y: 4
          },
          {
            u: "1f468-1f3fc-200d-1f527",
            x: 41,
            y: 4
          },
          {
            u: "1f468-1f3fd-200d-1f527",
            x: 42,
            y: 4
          },
          {
            u: "1f468-1f3fe-200d-1f527",
            x: 43,
            y: 4
          },
          {
            u: "1f468-1f3ff-200d-1f527",
            x: 44,
            y: 4
          }
        ]
      },
      {
        n: [
          "\u5973\u673A\u68B0\u5E08"
        ],
        u: {
          u: "1f469-200d-1f527",
          x: 45,
          y: 4
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f527",
            x: 46,
            y: 4
          },
          {
            u: "1f469-1f3fc-200d-1f527",
            x: 47,
            y: 4
          },
          {
            u: "1f469-1f3fd-200d-1f527",
            x: 48,
            y: 4
          },
          {
            u: "1f469-1f3fe-200d-1f527",
            x: 49,
            y: 4
          },
          {
            u: "1f469-1f3ff-200d-1f527",
            x: 0,
            y: 5
          }
        ]
      },
      {
        n: [
          "\u7537\u6027\u5DE5\u5382\u5DE5\u4EBA"
        ],
        u: {
          u: "1f468-200d-1f3ed",
          x: 1,
          y: 5
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f3ed",
            x: 2,
            y: 5
          },
          {
            u: "1f468-1f3fc-200d-1f3ed",
            x: 3,
            y: 5
          },
          {
            u: "1f468-1f3fd-200d-1f3ed",
            x: 4,
            y: 5
          },
          {
            u: "1f468-1f3fe-200d-1f3ed",
            x: 5,
            y: 5
          },
          {
            u: "1f468-1f3ff-200d-1f3ed",
            x: 6,
            y: 5
          }
        ]
      },
      {
        n: [
          "\u5DE5\u5382\u5973\u5DE5"
        ],
        u: {
          u: "1f469-200d-1f3ed",
          x: 7,
          y: 5
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f3ed",
            x: 8,
            y: 5
          },
          {
            u: "1f469-1f3fc-200d-1f3ed",
            x: 9,
            y: 5
          },
          {
            u: "1f469-1f3fd-200d-1f3ed",
            x: 10,
            y: 5
          },
          {
            u: "1f469-1f3fe-200d-1f3ed",
            x: 11,
            y: 5
          },
          {
            u: "1f469-1f3ff-200d-1f3ed",
            x: 12,
            y: 5
          }
        ]
      },
      {
        n: [
          "\u7537\u6027\u529E\u516C\u5BA4\u804C\u5458"
        ],
        u: {
          u: "1f468-200d-1f4bc",
          x: 13,
          y: 5
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f4bc",
            x: 14,
            y: 5
          },
          {
            u: "1f468-1f3fc-200d-1f4bc",
            x: 15,
            y: 5
          },
          {
            u: "1f468-1f3fd-200d-1f4bc",
            x: 16,
            y: 5
          },
          {
            u: "1f468-1f3fe-200d-1f4bc",
            x: 17,
            y: 5
          },
          {
            u: "1f468-1f3ff-200d-1f4bc",
            x: 18,
            y: 5
          }
        ]
      },
      {
        n: [
          "\u5973\u529E\u516C\u5BA4\u804C\u5458"
        ],
        u: {
          u: "1f469-200d-1f4bc",
          x: 19,
          y: 5
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f4bc",
            x: 20,
            y: 5
          },
          {
            u: "1f469-1f3fc-200d-1f4bc",
            x: 21,
            y: 5
          },
          {
            u: "1f469-1f3fd-200d-1f4bc",
            x: 22,
            y: 5
          },
          {
            u: "1f469-1f3fe-200d-1f4bc",
            x: 23,
            y: 5
          },
          {
            u: "1f469-1f3ff-200d-1f4bc",
            x: 24,
            y: 5
          }
        ]
      },
      {
        n: [
          "\u7537\u79D1\u5B66\u5BB6"
        ],
        u: {
          u: "1f468-200d-1f52c",
          x: 25,
          y: 5
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f52c",
            x: 26,
            y: 5
          },
          {
            u: "1f468-1f3fc-200d-1f52c",
            x: 27,
            y: 5
          },
          {
            u: "1f468-1f3fd-200d-1f52c",
            x: 28,
            y: 5
          },
          {
            u: "1f468-1f3fe-200d-1f52c",
            x: 29,
            y: 5
          },
          {
            u: "1f468-1f3ff-200d-1f52c",
            x: 30,
            y: 5
          }
        ]
      },
      {
        n: [
          "\u5973\u79D1\u5B66\u5BB6"
        ],
        u: {
          u: "1f469-200d-1f52c",
          x: 31,
          y: 5
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f52c",
            x: 32,
            y: 5
          },
          {
            u: "1f469-1f3fc-200d-1f52c",
            x: 33,
            y: 5
          },
          {
            u: "1f469-1f3fd-200d-1f52c",
            x: 34,
            y: 5
          },
          {
            u: "1f469-1f3fe-200d-1f52c",
            x: 35,
            y: 5
          },
          {
            u: "1f469-1f3ff-200d-1f52c",
            x: 36,
            y: 5
          }
        ]
      },
      {
        n: [
          "\u7537\u6027\u6280\u672F\u4E13\u5BB6"
        ],
        u: {
          u: "1f468-200d-1f4bb",
          x: 37,
          y: 5
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f4bb",
            x: 38,
            y: 5
          },
          {
            u: "1f468-1f3fc-200d-1f4bb",
            x: 39,
            y: 5
          },
          {
            u: "1f468-1f3fd-200d-1f4bb",
            x: 40,
            y: 5
          },
          {
            u: "1f468-1f3fe-200d-1f4bb",
            x: 41,
            y: 5
          },
          {
            u: "1f468-1f3ff-200d-1f4bb",
            x: 42,
            y: 5
          }
        ]
      },
      {
        n: [
          "\u5973\u6027\u6280\u672F\u4E13\u5BB6"
        ],
        u: {
          u: "1f469-200d-1f4bb",
          x: 43,
          y: 5
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f4bb",
            x: 44,
            y: 5
          },
          {
            u: "1f469-1f3fc-200d-1f4bb",
            x: 45,
            y: 5
          },
          {
            u: "1f469-1f3fd-200d-1f4bb",
            x: 46,
            y: 5
          },
          {
            u: "1f469-1f3fe-200d-1f4bb",
            x: 47,
            y: 5
          },
          {
            u: "1f469-1f3ff-200d-1f4bb",
            x: 48,
            y: 5
          }
        ]
      },
      {
        n: [
          "\u7537\u6B4C\u624B"
        ],
        u: {
          u: "1f468-200d-1f3a4",
          x: 49,
          y: 5
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f3a4",
            x: 0,
            y: 6
          },
          {
            u: "1f468-1f3fc-200d-1f3a4",
            x: 1,
            y: 6
          },
          {
            u: "1f468-1f3fd-200d-1f3a4",
            x: 2,
            y: 6
          },
          {
            u: "1f468-1f3fe-200d-1f3a4",
            x: 3,
            y: 6
          },
          {
            u: "1f468-1f3ff-200d-1f3a4",
            x: 4,
            y: 6
          }
        ]
      },
      {
        n: [
          "\u5973\u6B4C\u624B"
        ],
        u: {
          u: "1f469-200d-1f3a4",
          x: 5,
          y: 6
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f3a4",
            x: 6,
            y: 6
          },
          {
            u: "1f469-1f3fc-200d-1f3a4",
            x: 7,
            y: 6
          },
          {
            u: "1f469-1f3fd-200d-1f3a4",
            x: 8,
            y: 6
          },
          {
            u: "1f469-1f3fe-200d-1f3a4",
            x: 9,
            y: 6
          },
          {
            u: "1f469-1f3ff-200d-1f3a4",
            x: 10,
            y: 6
          }
        ]
      },
      {
        n: [
          "\u7537\u827A\u4EBA"
        ],
        u: {
          u: "1f468-200d-1f3a8",
          x: 11,
          y: 6
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f3a8",
            x: 12,
            y: 6
          },
          {
            u: "1f468-1f3fc-200d-1f3a8",
            x: 13,
            y: 6
          },
          {
            u: "1f468-1f3fd-200d-1f3a8",
            x: 14,
            y: 6
          },
          {
            u: "1f468-1f3fe-200d-1f3a8",
            x: 15,
            y: 6
          },
          {
            u: "1f468-1f3ff-200d-1f3a8",
            x: 16,
            y: 6
          }
        ]
      },
      {
        n: [
          "\u5973\u827A\u4EBA"
        ],
        u: {
          u: "1f469-200d-1f3a8",
          x: 17,
          y: 6
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f3a8",
            x: 18,
            y: 6
          },
          {
            u: "1f469-1f3fc-200d-1f3a8",
            x: 19,
            y: 6
          },
          {
            u: "1f469-1f3fd-200d-1f3a8",
            x: 20,
            y: 6
          },
          {
            u: "1f469-1f3fe-200d-1f3a8",
            x: 21,
            y: 6
          },
          {
            u: "1f469-1f3ff-200d-1f3a8",
            x: 22,
            y: 6
          }
        ]
      },
      {
        n: [
          "\u7537\u98DE\u884C\u5458"
        ],
        u: {
          u: "1f468-200d-2708-fe0f",
          x: 23,
          y: 6
        },
        v: [
          {
            u: "1f468-1f3fb-200d-2708-fe0f",
            x: 24,
            y: 6
          },
          {
            u: "1f468-1f3fc-200d-2708-fe0f",
            x: 25,
            y: 6
          },
          {
            u: "1f468-1f3fd-200d-2708-fe0f",
            x: 26,
            y: 6
          },
          {
            u: "1f468-1f3fe-200d-2708-fe0f",
            x: 27,
            y: 6
          },
          {
            u: "1f468-1f3ff-200d-2708-fe0f",
            x: 28,
            y: 6
          }
        ]
      },
      {
        n: [
          "\u5973\u98DE\u884C\u5458"
        ],
        u: {
          u: "1f469-200d-2708-fe0f",
          x: 29,
          y: 6
        },
        v: [
          {
            u: "1f469-1f3fb-200d-2708-fe0f",
            x: 30,
            y: 6
          },
          {
            u: "1f469-1f3fc-200d-2708-fe0f",
            x: 31,
            y: 6
          },
          {
            u: "1f469-1f3fd-200d-2708-fe0f",
            x: 32,
            y: 6
          },
          {
            u: "1f469-1f3fe-200d-2708-fe0f",
            x: 33,
            y: 6
          },
          {
            u: "1f469-1f3ff-200d-2708-fe0f",
            x: 34,
            y: 6
          }
        ]
      },
      {
        n: [
          "\u7537\u5B87\u822A\u5458"
        ],
        u: {
          u: "1f468-200d-1f680",
          x: 35,
          y: 6
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f680",
            x: 36,
            y: 6
          },
          {
            u: "1f468-1f3fc-200d-1f680",
            x: 37,
            y: 6
          },
          {
            u: "1f468-1f3fd-200d-1f680",
            x: 38,
            y: 6
          },
          {
            u: "1f468-1f3fe-200d-1f680",
            x: 39,
            y: 6
          },
          {
            u: "1f468-1f3ff-200d-1f680",
            x: 40,
            y: 6
          }
        ]
      },
      {
        n: [
          "\u5973\u5B87\u822A\u5458"
        ],
        u: {
          u: "1f469-200d-1f680",
          x: 41,
          y: 6
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f680",
            x: 42,
            y: 6
          },
          {
            u: "1f469-1f3fc-200d-1f680",
            x: 43,
            y: 6
          },
          {
            u: "1f469-1f3fd-200d-1f680",
            x: 44,
            y: 6
          },
          {
            u: "1f469-1f3fe-200d-1f680",
            x: 45,
            y: 6
          },
          {
            u: "1f469-1f3ff-200d-1f680",
            x: 46,
            y: 6
          }
        ]
      },
      {
        n: [
          "\u7537\u6D88\u9632\u5458"
        ],
        u: {
          u: "1f468-200d-1f692",
          x: 47,
          y: 6
        },
        v: [
          {
            u: "1f468-1f3fb-200d-1f692",
            x: 48,
            y: 6
          },
          {
            u: "1f468-1f3fc-200d-1f692",
            x: 49,
            y: 6
          },
          {
            u: "1f468-1f3fd-200d-1f692",
            x: 0,
            y: 7
          },
          {
            u: "1f468-1f3fe-200d-1f692",
            x: 1,
            y: 7
          },
          {
            u: "1f468-1f3ff-200d-1f692",
            x: 2,
            y: 7
          }
        ]
      },
      {
        n: [
          "\u5973\u6D88\u9632\u5458"
        ],
        u: {
          u: "1f469-200d-1f692",
          x: 3,
          y: 7
        },
        v: [
          {
            u: "1f469-1f3fb-200d-1f692",
            x: 4,
            y: 7
          },
          {
            u: "1f469-1f3fc-200d-1f692",
            x: 5,
            y: 7
          },
          {
            u: "1f469-1f3fd-200d-1f692",
            x: 6,
            y: 7
          },
          {
            u: "1f469-1f3fe-200d-1f692",
            x: 7,
            y: 7
          },
          {
            u: "1f469-1f3ff-200d-1f692",
            x: 8,
            y: 7
          }
        ]
      },
      {
        n: [
          "\u8B66\u5B98",
          "\u8B66\u5BDF"
        ],
        u: {
          u: "1f46e",
          x: 9,
          y: 7
        },
        v: [
          {
            u: "1f46e-1f3fb",
            x: 10,
            y: 7
          },
          {
            u: "1f46e-1f3fc",
            x: 11,
            y: 7
          },
          {
            u: "1f46e-1f3fd",
            x: 12,
            y: 7
          },
          {
            u: "1f46e-1f3fe",
            x: 13,
            y: 7
          },
          {
            u: "1f46e-1f3ff",
            x: 14,
            y: 7
          }
        ]
      },
      {
        n: [
          "\u7537\u8B66\u5B98"
        ],
        u: {
          u: "1f46e-200d-2642-fe0f",
          x: 15,
          y: 7
        },
        v: [
          {
            u: "1f46e-1f3fb-200d-2642-fe0f",
            x: 16,
            y: 7
          },
          {
            u: "1f46e-1f3fc-200d-2642-fe0f",
            x: 17,
            y: 7
          },
          {
            u: "1f46e-1f3fd-200d-2642-fe0f",
            x: 18,
            y: 7
          },
          {
            u: "1f46e-1f3fe-200d-2642-fe0f",
            x: 19,
            y: 7
          },
          {
            u: "1f46e-1f3ff-200d-2642-fe0f",
            x: 20,
            y: 7
          }
        ]
      },
      {
        n: [
          "\u5973\u8B66\u5B98"
        ],
        u: {
          u: "1f46e-200d-2640-fe0f",
          x: 21,
          y: 7
        },
        v: [
          {
            u: "1f46e-1f3fb-200d-2640-fe0f",
            x: 22,
            y: 7
          },
          {
            u: "1f46e-1f3fc-200d-2640-fe0f",
            x: 23,
            y: 7
          },
          {
            u: "1f46e-1f3fd-200d-2640-fe0f",
            x: 24,
            y: 7
          },
          {
            u: "1f46e-1f3fe-200d-2640-fe0f",
            x: 25,
            y: 7
          },
          {
            u: "1f46e-1f3ff-200d-2640-fe0f",
            x: 26,
            y: 7
          }
        ]
      },
      {
        n: [
          "\u4FA6\u63A2\u6216\u95F4\u8C0D"
        ],
        u: {
          u: "1f575",
          x: 27,
          y: 7
        },
        v: [
          {
            u: "1f575-1f3fb",
            x: 28,
            y: 7
          },
          {
            u: "1f575-1f3fc",
            x: 29,
            y: 7
          },
          {
            u: "1f575-1f3fd",
            x: 30,
            y: 7
          },
          {
            u: "1f575-1f3fe",
            x: 31,
            y: 7
          },
          {
            u: "1f575-1f3ff",
            x: 32,
            y: 7
          }
        ]
      },
      {
        n: [
          "\u7537\u4FA6\u63A2"
        ],
        u: {
          u: "1f575-fe0f-200d-2642-fe0f",
          x: 33,
          y: 7
        },
        v: [
          {
            u: "1f575-1f3fb-200d-2642-fe0f",
            x: 34,
            y: 7
          },
          {
            u: "1f575-1f3fc-200d-2642-fe0f",
            x: 35,
            y: 7
          },
          {
            u: "1f575-1f3fd-200d-2642-fe0f",
            x: 36,
            y: 7
          },
          {
            u: "1f575-1f3fe-200d-2642-fe0f",
            x: 37,
            y: 7
          },
          {
            u: "1f575-1f3ff-200d-2642-fe0f",
            x: 38,
            y: 7
          }
        ]
      },
      {
        n: [
          "\u5973\u4FA6\u63A2"
        ],
        u: {
          u: "1f575-fe0f-200d-2640-fe0f",
          x: 39,
          y: 7
        },
        v: [
          {
            u: "1f575-1f3fb-200d-2640-fe0f",
            x: 40,
            y: 7
          },
          {
            u: "1f575-1f3fc-200d-2640-fe0f",
            x: 41,
            y: 7
          },
          {
            u: "1f575-1f3fd-200d-2640-fe0f",
            x: 42,
            y: 7
          },
          {
            u: "1f575-1f3fe-200d-2640-fe0f",
            x: 43,
            y: 7
          },
          {
            u: "1f575-1f3ff-200d-2640-fe0f",
            x: 44,
            y: 7
          }
        ]
      },
      {
        n: [
          "\u536B\u5175"
        ],
        u: {
          u: "1f482",
          x: 45,
          y: 7
        },
        v: [
          {
            u: "1f482-1f3fb",
            x: 46,
            y: 7
          },
          {
            u: "1f482-1f3fc",
            x: 47,
            y: 7
          },
          {
            u: "1f482-1f3fd",
            x: 48,
            y: 7
          },
          {
            u: "1f482-1f3fe",
            x: 49,
            y: 7
          },
          {
            u: "1f482-1f3ff",
            x: 0,
            y: 8
          }
        ]
      },
      {
        n: [
          "\u7537\u6027\u9632\u62A4\u88C5\u7F6E"
        ],
        u: {
          u: "1f482-200d-2642-fe0f",
          x: 1,
          y: 8
        },
        v: [
          {
            u: "1f482-1f3fb-200d-2642-fe0f",
            x: 2,
            y: 8
          },
          {
            u: "1f482-1f3fc-200d-2642-fe0f",
            x: 3,
            y: 8
          },
          {
            u: "1f482-1f3fd-200d-2642-fe0f",
            x: 4,
            y: 8
          },
          {
            u: "1f482-1f3fe-200d-2642-fe0f",
            x: 5,
            y: 8
          },
          {
            u: "1f482-1f3ff-200d-2642-fe0f",
            x: 6,
            y: 8
          }
        ]
      },
      {
        n: [
          "\u5973\u6027\u9632\u62A4\u88C5\u7F6E"
        ],
        u: {
          u: "1f482-200d-2640-fe0f",
          x: 7,
          y: 8
        },
        v: [
          {
            u: "1f482-1f3fb-200d-2640-fe0f",
            x: 8,
            y: 8
          },
          {
            u: "1f482-1f3fc-200d-2640-fe0f",
            x: 9,
            y: 8
          },
          {
            u: "1f482-1f3fd-200d-2640-fe0f",
            x: 10,
            y: 8
          },
          {
            u: "1f482-1f3fe-200d-2640-fe0f",
            x: 11,
            y: 8
          },
          {
            u: "1f482-1f3ff-200d-2640-fe0f",
            x: 12,
            y: 8
          }
        ]
      },
      {
        n: [
          "\u5EFA\u7B51\u5DE5\u4EBA"
        ],
        u: {
          u: "1f477",
          x: 13,
          y: 8
        },
        v: [
          {
            u: "1f477-1f3fb",
            x: 14,
            y: 8
          },
          {
            u: "1f477-1f3fc",
            x: 15,
            y: 8
          },
          {
            u: "1f477-1f3fd",
            x: 16,
            y: 8
          },
          {
            u: "1f477-1f3fe",
            x: 17,
            y: 8
          },
          {
            u: "1f477-1f3ff",
            x: 18,
            y: 8
          }
        ]
      },
      {
        n: [
          "\u7537\u5EFA\u7B51\u5DE5\u4EBA"
        ],
        u: {
          u: "1f477-200d-2642-fe0f",
          x: 19,
          y: 8
        },
        v: [
          {
            u: "1f477-1f3fb-200d-2642-fe0f",
            x: 20,
            y: 8
          },
          {
            u: "1f477-1f3fc-200d-2642-fe0f",
            x: 21,
            y: 8
          },
          {
            u: "1f477-1f3fd-200d-2642-fe0f",
            x: 22,
            y: 8
          },
          {
            u: "1f477-1f3fe-200d-2642-fe0f",
            x: 23,
            y: 8
          },
          {
            u: "1f477-1f3ff-200d-2642-fe0f",
            x: 24,
            y: 8
          }
        ]
      },
      {
        n: [
          "\u5973\u5EFA\u7B51\u5DE5\u4EBA"
        ],
        u: {
          u: "1f477-200d-2640-fe0f",
          x: 25,
          y: 8
        },
        v: [
          {
            u: "1f477-1f3fb-200d-2640-fe0f",
            x: 26,
            y: 8
          },
          {
            u: "1f477-1f3fc-200d-2640-fe0f",
            x: 27,
            y: 8
          },
          {
            u: "1f477-1f3fd-200d-2640-fe0f",
            x: 28,
            y: 8
          },
          {
            u: "1f477-1f3fe-200d-2640-fe0f",
            x: 29,
            y: 8
          },
          {
            u: "1f477-1f3ff-200d-2640-fe0f",
            x: 30,
            y: 8
          }
        ]
      },
      {
        n: [
          "\u738B\u5B50"
        ],
        u: {
          u: "1f934",
          x: 31,
          y: 8
        },
        v: [
          {
            u: "1f934-1f3fb",
            x: 32,
            y: 8
          },
          {
            u: "1f934-1f3fc",
            x: 33,
            y: 8
          },
          {
            u: "1f934-1f3fd",
            x: 34,
            y: 8
          },
          {
            u: "1f934-1f3fe",
            x: 35,
            y: 8
          },
          {
            u: "1f934-1f3ff",
            x: 36,
            y: 8
          }
        ]
      },
      {
        n: [
          "\u516C\u4E3B"
        ],
        u: {
          u: "1f478",
          x: 37,
          y: 8
        },
        v: [
          {
            u: "1f478-1f3fb",
            x: 38,
            y: 8
          },
          {
            u: "1f478-1f3fc",
            x: 39,
            y: 8
          },
          {
            u: "1f478-1f3fd",
            x: 40,
            y: 8
          },
          {
            u: "1f478-1f3fe",
            x: 41,
            y: 8
          },
          {
            u: "1f478-1f3ff",
            x: 42,
            y: 8
          }
        ]
      },
      {
        n: [
          "\u6234\u5934\u5DFE\u7684\u7537\u4EBA"
        ],
        u: {
          u: "1f473",
          x: 43,
          y: 8
        },
        v: [
          {
            u: "1f473-1f3fb",
            x: 44,
            y: 8
          },
          {
            u: "1f473-1f3fc",
            x: 45,
            y: 8
          },
          {
            u: "1f473-1f3fd",
            x: 46,
            y: 8
          },
          {
            u: "1f473-1f3fe",
            x: 47,
            y: 8
          },
          {
            u: "1f473-1f3ff",
            x: 48,
            y: 8
          }
        ]
      },
      {
        n: [
          "\u6234\u5934\u5DFE\u7684\u7537\u5B50"
        ],
        u: {
          u: "1f473-200d-2642-fe0f",
          x: 49,
          y: 8
        },
        v: [
          {
            u: "1f473-1f3fb-200d-2642-fe0f",
            x: 0,
            y: 9
          },
          {
            u: "1f473-1f3fc-200d-2642-fe0f",
            x: 1,
            y: 9
          },
          {
            u: "1f473-1f3fd-200d-2642-fe0f",
            x: 2,
            y: 9
          },
          {
            u: "1f473-1f3fe-200d-2642-fe0f",
            x: 3,
            y: 9
          },
          {
            u: "1f473-1f3ff-200d-2642-fe0f",
            x: 4,
            y: 9
          }
        ]
      },
      {
        n: [
          "\u6234\u5934\u5DFE\u7684\u5973\u4EBA"
        ],
        u: {
          u: "1f473-200d-2640-fe0f",
          x: 5,
          y: 9
        },
        v: [
          {
            u: "1f473-1f3fb-200d-2640-fe0f",
            x: 6,
            y: 9
          },
          {
            u: "1f473-1f3fc-200d-2640-fe0f",
            x: 7,
            y: 9
          },
          {
            u: "1f473-1f3fd-200d-2640-fe0f",
            x: 8,
            y: 9
          },
          {
            u: "1f473-1f3fe-200d-2640-fe0f",
            x: 9,
            y: 9
          },
          {
            u: "1f473-1f3ff-200d-2640-fe0f",
            x: 10,
            y: 9
          }
        ]
      },
      {
        n: [
          "\u74DC\u76AE\u5E3D\u7537\u5B50"
        ],
        u: {
          u: "1f472",
          x: 11,
          y: 9
        },
        v: [
          {
            u: "1f472-1f3fb",
            x: 12,
            y: 9
          },
          {
            u: "1f472-1f3fc",
            x: 13,
            y: 9
          },
          {
            u: "1f472-1f3fd",
            x: 14,
            y: 9
          },
          {
            u: "1f472-1f3fe",
            x: 15,
            y: 9
          },
          {
            u: "1f472-1f3ff",
            x: 16,
            y: 9
          }
        ]
      },
      {
        n: [
          "\u6234\u5934\u5DFE\u7684\u4EBA"
        ],
        u: {
          u: "1f9d5",
          x: 17,
          y: 9
        },
        v: [
          {
            u: "1f9d5-1f3fb",
            x: 18,
            y: 9
          },
          {
            u: "1f9d5-1f3fc",
            x: 19,
            y: 9
          },
          {
            u: "1f9d5-1f3fd",
            x: 20,
            y: 9
          },
          {
            u: "1f9d5-1f3fe",
            x: 21,
            y: 9
          },
          {
            u: "1f9d5-1f3ff",
            x: 22,
            y: 9
          }
        ]
      },
      {
        n: [
          "\u7559\u80E1\u5B50\u7684\u4EBA"
        ],
        u: {
          u: "1f9d4",
          x: 23,
          y: 9
        },
        v: [
          {
            u: "1f9d4-1f3fb",
            x: 24,
            y: 9
          },
          {
            u: "1f9d4-1f3fc",
            x: 25,
            y: 9
          },
          {
            u: "1f9d4-1f3fd",
            x: 26,
            y: 9
          },
          {
            u: "1f9d4-1f3fe",
            x: 27,
            y: 9
          },
          {
            u: "1f9d4-1f3ff",
            x: 28,
            y: 9
          }
        ]
      },
      {
        n: [
          "\u91D1\u53D1\u7684\u4EBA"
        ],
        u: {
          u: "1f471",
          x: 29,
          y: 9
        },
        v: [
          {
            u: "1f471-1f3fb",
            x: 30,
            y: 9
          },
          {
            u: "1f471-1f3fc",
            x: 31,
            y: 9
          },
          {
            u: "1f471-1f3fd",
            x: 32,
            y: 9
          },
          {
            u: "1f471-1f3fe",
            x: 33,
            y: 9
          },
          {
            u: "1f471-1f3ff",
            x: 34,
            y: 9
          }
        ]
      },
      {
        n: [
          "\u91D1\u53D1\u7537\u5B50"
        ],
        u: {
          u: "1f471-200d-2642-fe0f",
          x: 35,
          y: 9
        },
        v: [
          {
            u: "1f471-1f3fb-200d-2642-fe0f",
            x: 36,
            y: 9
          },
          {
            u: "1f471-1f3fc-200d-2642-fe0f",
            x: 37,
            y: 9
          },
          {
            u: "1f471-1f3fd-200d-2642-fe0f",
            x: 38,
            y: 9
          },
          {
            u: "1f471-1f3fe-200d-2642-fe0f",
            x: 39,
            y: 9
          },
          {
            u: "1f471-1f3ff-200d-2642-fe0f",
            x: 40,
            y: 9
          }
        ]
      },
      {
        n: [
          "\u91D1\u53D1\u5973\u5B50"
        ],
        u: {
          u: "1f471-200d-2640-fe0f",
          x: 41,
          y: 9
        },
        v: [
          {
            u: "1f471-1f3fb-200d-2640-fe0f",
            x: 42,
            y: 9
          },
          {
            u: "1f471-1f3fc-200d-2640-fe0f",
            x: 43,
            y: 9
          },
          {
            u: "1f471-1f3fd-200d-2640-fe0f",
            x: 44,
            y: 9
          },
          {
            u: "1f471-1f3fe-200d-2640-fe0f",
            x: 45,
            y: 9
          },
          {
            u: "1f471-1f3ff-200d-2640-fe0f",
            x: 46,
            y: 9
          }
        ]
      },
      {
        n: [
          "\u7537\u665A\u793C\u670D"
        ],
        u: {
          u: "1f935",
          x: 47,
          y: 9
        },
        v: [
          {
            u: "1f935-1f3fb",
            x: 48,
            y: 9
          },
          {
            u: "1f935-1f3fc",
            x: 49,
            y: 9
          },
          {
            u: "1f935-1f3fd",
            x: 0,
            y: 10
          },
          {
            u: "1f935-1f3fe",
            x: 1,
            y: 10
          },
          {
            u: "1f935-1f3ff",
            x: 2,
            y: 10
          }
        ]
      },
      {
        n: [
          "\u6234\u9762\u7EB1\u7684\u65B0\u5A18"
        ],
        u: {
          u: "1f470",
          x: 3,
          y: 10
        },
        v: [
          {
            u: "1f470-1f3fb",
            x: 4,
            y: 10
          },
          {
            u: "1f470-1f3fc",
            x: 5,
            y: 10
          },
          {
            u: "1f470-1f3fd",
            x: 6,
            y: 10
          },
          {
            u: "1f470-1f3fe",
            x: 7,
            y: 10
          },
          {
            u: "1f470-1f3ff",
            x: 8,
            y: 10
          }
        ]
      },
      {
        n: [
          "\u5B55\u5987"
        ],
        u: {
          u: "1f930",
          x: 9,
          y: 10
        },
        v: [
          {
            u: "1f930-1f3fb",
            x: 10,
            y: 10
          },
          {
            u: "1f930-1f3fc",
            x: 11,
            y: 10
          },
          {
            u: "1f930-1f3fd",
            x: 12,
            y: 10
          },
          {
            u: "1f930-1f3fe",
            x: 13,
            y: 10
          },
          {
            u: "1f930-1f3ff",
            x: 14,
            y: 10
          }
        ]
      },
      {
        n: [
          "\u6BCD\u4E73\u5582\u517B"
        ],
        u: {
          u: "1f931",
          x: 15,
          y: 10
        },
        v: [
          {
            u: "1f931-1f3fb",
            x: 16,
            y: 10
          },
          {
            u: "1f931-1f3fc",
            x: 17,
            y: 10
          },
          {
            u: "1f931-1f3fd",
            x: 18,
            y: 10
          },
          {
            u: "1f931-1f3fe",
            x: 19,
            y: 10
          },
          {
            u: "1f931-1f3ff",
            x: 20,
            y: 10
          }
        ]
      },
      {
        n: [
          "\u5C0F\u5929\u4F7F",
          "\u5929\u4F7F"
        ],
        u: {
          u: "1f47c",
          x: 21,
          y: 10
        },
        v: [
          {
            u: "1f47c-1f3fb",
            x: 22,
            y: 10
          },
          {
            u: "1f47c-1f3fc",
            x: 23,
            y: 10
          },
          {
            u: "1f47c-1f3fd",
            x: 24,
            y: 10
          },
          {
            u: "1f47c-1f3fe",
            x: 25,
            y: 10
          },
          {
            u: "1f47c-1f3ff",
            x: 26,
            y: 10
          }
        ]
      },
      {
        n: [
          "\u5723\u8BDE\u8001\u4EBA",
          "\u5723\u8BDE\u8001\u4EBA"
        ],
        u: {
          u: "1f385",
          x: 27,
          y: 10
        },
        v: [
          {
            u: "1f385-1f3fb",
            x: 28,
            y: 10
          },
          {
            u: "1f385-1f3fc",
            x: 29,
            y: 10
          },
          {
            u: "1f385-1f3fd",
            x: 30,
            y: 10
          },
          {
            u: "1f385-1f3fe",
            x: 31,
            y: 10
          },
          {
            u: "1f385-1f3ff",
            x: 32,
            y: 10
          }
        ]
      },
      {
        n: [
          "\u5723\u8BDE\u6BCD\u4EB2",
          "\u514B\u52B3\u65AF\u592B\u4EBA"
        ],
        u: {
          u: "1f936",
          x: 33,
          y: 10
        },
        v: [
          {
            u: "1f936-1f3fb",
            x: 34,
            y: 10
          },
          {
            u: "1f936-1f3fc",
            x: 35,
            y: 10
          },
          {
            u: "1f936-1f3fd",
            x: 36,
            y: 10
          },
          {
            u: "1f936-1f3fe",
            x: 37,
            y: 10
          },
          {
            u: "1f936-1f3ff",
            x: 38,
            y: 10
          }
        ]
      },
      {
        n: [
          "\u6CD5\u5E08"
        ],
        u: {
          u: "1f9d9",
          x: 39,
          y: 10
        },
        v: [
          {
            u: "1f9d9-1f3fb",
            x: 40,
            y: 10
          },
          {
            u: "1f9d9-1f3fc",
            x: 41,
            y: 10
          },
          {
            u: "1f9d9-1f3fd",
            x: 42,
            y: 10
          },
          {
            u: "1f9d9-1f3fe",
            x: 43,
            y: 10
          },
          {
            u: "1f9d9-1f3ff",
            x: 44,
            y: 10
          }
        ]
      },
      {
        n: [
          "\u5973\u6CD5\u5E08"
        ],
        u: {
          u: "1f9d9-200d-2640-fe0f",
          x: 45,
          y: 10
        },
        v: [
          {
            u: "1f9d9-1f3fb-200d-2640-fe0f",
            x: 46,
            y: 10
          },
          {
            u: "1f9d9-1f3fc-200d-2640-fe0f",
            x: 47,
            y: 10
          },
          {
            u: "1f9d9-1f3fd-200d-2640-fe0f",
            x: 48,
            y: 10
          },
          {
            u: "1f9d9-1f3fe-200d-2640-fe0f",
            x: 49,
            y: 10
          },
          {
            u: "1f9d9-1f3ff-200d-2640-fe0f",
            x: 0,
            y: 11
          }
        ]
      },
      {
        n: [
          "\u7537\u6027\u6CD5\u5E08"
        ],
        u: {
          u: "1f9d9-200d-2642-fe0f",
          x: 1,
          y: 11
        },
        v: [
          {
            u: "1f9d9-1f3fb-200d-2642-fe0f",
            x: 2,
            y: 11
          },
          {
            u: "1f9d9-1f3fc-200d-2642-fe0f",
            x: 3,
            y: 11
          },
          {
            u: "1f9d9-1f3fd-200d-2642-fe0f",
            x: 4,
            y: 11
          },
          {
            u: "1f9d9-1f3fe-200d-2642-fe0f",
            x: 5,
            y: 11
          },
          {
            u: "1f9d9-1f3ff-200d-2642-fe0f",
            x: 6,
            y: 11
          }
        ]
      },
      {
        n: [
          "\u4ED9\u5973"
        ],
        u: {
          u: "1f9da",
          x: 7,
          y: 11
        },
        v: [
          {
            u: "1f9da-1f3fb",
            x: 8,
            y: 11
          },
          {
            u: "1f9da-1f3fc",
            x: 9,
            y: 11
          },
          {
            u: "1f9da-1f3fd",
            x: 10,
            y: 11
          },
          {
            u: "1f9da-1f3fe",
            x: 11,
            y: 11
          },
          {
            u: "1f9da-1f3ff",
            x: 12,
            y: 11
          }
        ]
      },
      {
        n: [
          "\u5973\u4ED9\u5973"
        ],
        u: {
          u: "1f9da-200d-2640-fe0f",
          x: 13,
          y: 11
        },
        v: [
          {
            u: "1f9da-1f3fb-200d-2640-fe0f",
            x: 14,
            y: 11
          },
          {
            u: "1f9da-1f3fc-200d-2640-fe0f",
            x: 15,
            y: 11
          },
          {
            u: "1f9da-1f3fd-200d-2640-fe0f",
            x: 16,
            y: 11
          },
          {
            u: "1f9da-1f3fe-200d-2640-fe0f",
            x: 17,
            y: 11
          },
          {
            u: "1f9da-1f3ff-200d-2640-fe0f",
            x: 18,
            y: 11
          }
        ]
      },
      {
        n: [
          "\u7537\u4ED9\u5973"
        ],
        u: {
          u: "1f9da-200d-2642-fe0f",
          x: 19,
          y: 11
        },
        v: [
          {
            u: "1f9da-1f3fb-200d-2642-fe0f",
            x: 20,
            y: 11
          },
          {
            u: "1f9da-1f3fc-200d-2642-fe0f",
            x: 21,
            y: 11
          },
          {
            u: "1f9da-1f3fd-200d-2642-fe0f",
            x: 22,
            y: 11
          },
          {
            u: "1f9da-1f3fe-200d-2642-fe0f",
            x: 23,
            y: 11
          },
          {
            u: "1f9da-1f3ff-200d-2642-fe0f",
            x: 24,
            y: 11
          }
        ]
      },
      {
        n: [
          "\u5438\u8840\u9B3C"
        ],
        u: {
          u: "1f9db",
          x: 25,
          y: 11
        },
        v: [
          {
            u: "1f9db-1f3fb",
            x: 26,
            y: 11
          },
          {
            u: "1f9db-1f3fc",
            x: 27,
            y: 11
          },
          {
            u: "1f9db-1f3fd",
            x: 28,
            y: 11
          },
          {
            u: "1f9db-1f3fe",
            x: 29,
            y: 11
          },
          {
            u: "1f9db-1f3ff",
            x: 30,
            y: 11
          }
        ]
      },
      {
        n: [
          "\u5973\u5438\u8840\u9B3C"
        ],
        u: {
          u: "1f9db-200d-2640-fe0f",
          x: 31,
          y: 11
        },
        v: [
          {
            u: "1f9db-1f3fb-200d-2640-fe0f",
            x: 32,
            y: 11
          },
          {
            u: "1f9db-1f3fc-200d-2640-fe0f",
            x: 33,
            y: 11
          },
          {
            u: "1f9db-1f3fd-200d-2640-fe0f",
            x: 34,
            y: 11
          },
          {
            u: "1f9db-1f3fe-200d-2640-fe0f",
            x: 35,
            y: 11
          },
          {
            u: "1f9db-1f3ff-200d-2640-fe0f",
            x: 36,
            y: 11
          }
        ]
      },
      {
        n: [
          "\u7537\u6027\u5438\u8840\u9B3C"
        ],
        u: {
          u: "1f9db-200d-2642-fe0f",
          x: 37,
          y: 11
        },
        v: [
          {
            u: "1f9db-1f3fb-200d-2642-fe0f",
            x: 38,
            y: 11
          },
          {
            u: "1f9db-1f3fc-200d-2642-fe0f",
            x: 39,
            y: 11
          },
          {
            u: "1f9db-1f3fd-200d-2642-fe0f",
            x: 40,
            y: 11
          },
          {
            u: "1f9db-1f3fe-200d-2642-fe0f",
            x: 41,
            y: 11
          },
          {
            u: "1f9db-1f3ff-200d-2642-fe0f",
            x: 42,
            y: 11
          }
        ]
      },
      {
        n: [
          "\u4EBA\u9C7C"
        ],
        u: {
          u: "1f9dc",
          x: 43,
          y: 11
        },
        v: [
          {
            u: "1f9dc-1f3fb",
            x: 44,
            y: 11
          },
          {
            u: "1f9dc-1f3fc",
            x: 45,
            y: 11
          },
          {
            u: "1f9dc-1f3fd",
            x: 46,
            y: 11
          },
          {
            u: "1f9dc-1f3fe",
            x: 47,
            y: 11
          },
          {
            u: "1f9dc-1f3ff",
            x: 48,
            y: 11
          }
        ]
      },
      {
        n: [
          "\u7F8E\u4EBA\u9C7C"
        ],
        u: {
          u: "1f9dc-200d-2640-fe0f",
          x: 49,
          y: 11
        },
        v: [
          {
            u: "1f9dc-1f3fb-200d-2640-fe0f",
            x: 0,
            y: 12
          },
          {
            u: "1f9dc-1f3fc-200d-2640-fe0f",
            x: 1,
            y: 12
          },
          {
            u: "1f9dc-1f3fd-200d-2640-fe0f",
            x: 2,
            y: 12
          },
          {
            u: "1f9dc-1f3fe-200d-2640-fe0f",
            x: 3,
            y: 12
          },
          {
            u: "1f9dc-1f3ff-200d-2640-fe0f",
            x: 4,
            y: 12
          }
        ]
      },
      {
        n: [
          "\u4EBA\u9C7C"
        ],
        u: {
          u: "1f9dc-200d-2642-fe0f",
          x: 5,
          y: 12
        },
        v: [
          {
            u: "1f9dc-1f3fb-200d-2642-fe0f",
            x: 6,
            y: 12
          },
          {
            u: "1f9dc-1f3fc-200d-2642-fe0f",
            x: 7,
            y: 12
          },
          {
            u: "1f9dc-1f3fd-200d-2642-fe0f",
            x: 8,
            y: 12
          },
          {
            u: "1f9dc-1f3fe-200d-2642-fe0f",
            x: 9,
            y: 12
          },
          {
            u: "1f9dc-1f3ff-200d-2642-fe0f",
            x: 10,
            y: 12
          }
        ]
      },
      {
        n: [
          "\u7CBE\u7075"
        ],
        u: {
          u: "1f9dd",
          x: 11,
          y: 12
        },
        v: [
          {
            u: "1f9dd-1f3fb",
            x: 12,
            y: 12
          },
          {
            u: "1f9dd-1f3fc",
            x: 13,
            y: 12
          },
          {
            u: "1f9dd-1f3fd",
            x: 14,
            y: 12
          },
          {
            u: "1f9dd-1f3fe",
            x: 15,
            y: 12
          },
          {
            u: "1f9dd-1f3ff",
            x: 16,
            y: 12
          }
        ]
      },
      {
        n: [
          "\u5973\u7CBE\u7075"
        ],
        u: {
          u: "1f9dd-200d-2640-fe0f",
          x: 17,
          y: 12
        },
        v: [
          {
            u: "1f9dd-1f3fb-200d-2640-fe0f",
            x: 18,
            y: 12
          },
          {
            u: "1f9dd-1f3fc-200d-2640-fe0f",
            x: 19,
            y: 12
          },
          {
            u: "1f9dd-1f3fd-200d-2640-fe0f",
            x: 20,
            y: 12
          },
          {
            u: "1f9dd-1f3fe-200d-2640-fe0f",
            x: 21,
            y: 12
          },
          {
            u: "1f9dd-1f3ff-200d-2640-fe0f",
            x: 22,
            y: 12
          }
        ]
      },
      {
        n: [
          "\u96C4\u6027\u7CBE\u7075"
        ],
        u: {
          u: "1f9dd-200d-2642-fe0f",
          x: 23,
          y: 12
        },
        v: [
          {
            u: "1f9dd-1f3fb-200d-2642-fe0f",
            x: 24,
            y: 12
          },
          {
            u: "1f9dd-1f3fc-200d-2642-fe0f",
            x: 25,
            y: 12
          },
          {
            u: "1f9dd-1f3fd-200d-2642-fe0f",
            x: 26,
            y: 12
          },
          {
            u: "1f9dd-1f3fe-200d-2642-fe0f",
            x: 27,
            y: 12
          },
          {
            u: "1f9dd-1f3ff-200d-2642-fe0f",
            x: 28,
            y: 12
          }
        ]
      },
      {
        n: [
          "\u7CBE\u7075"
        ],
        u: {
          u: "1f9de",
          x: 29,
          y: 12
        }
      },
      {
        n: [
          "\u5973\u5996\u7CBE"
        ],
        u: {
          u: "1f9de-200d-2640-fe0f",
          x: 30,
          y: 12
        }
      },
      {
        n: [
          "\u96C4\u6027\u7CBE\u7075"
        ],
        u: {
          u: "1f9de-200d-2642-fe0f",
          x: 31,
          y: 12
        }
      },
      {
        n: [
          "\u50F5\u5C38"
        ],
        u: {
          u: "1f9df",
          x: 32,
          y: 12
        }
      },
      {
        n: [
          "\u96CC\u6027\u50F5\u5C38"
        ],
        u: {
          u: "1f9df-200d-2640-fe0f",
          x: 33,
          y: 12
        }
      },
      {
        n: [
          "\u7537\u6027\u50F5\u5C38"
        ],
        u: {
          u: "1f9df-200d-2642-fe0f",
          x: 34,
          y: 12
        }
      },
      {
        n: [
          "\u76B1\u7709\u7684\u4EBA"
        ],
        u: {
          u: "1f64d",
          x: 35,
          y: 12
        },
        v: [
          {
            u: "1f64d-1f3fb",
            x: 36,
            y: 12
          },
          {
            u: "1f64d-1f3fc",
            x: 37,
            y: 12
          },
          {
            u: "1f64d-1f3fd",
            x: 38,
            y: 12
          },
          {
            u: "1f64d-1f3fe",
            x: 39,
            y: 12
          },
          {
            u: "1f64d-1f3ff",
            x: 40,
            y: 12
          }
        ]
      },
      {
        n: [
          "\u7537\u4EBA\u76B1\u7709"
        ],
        u: {
          u: "1f64d-200d-2642-fe0f",
          x: 41,
          y: 12
        },
        v: [
          {
            u: "1f64d-1f3fb-200d-2642-fe0f",
            x: 42,
            y: 12
          },
          {
            u: "1f64d-1f3fc-200d-2642-fe0f",
            x: 43,
            y: 12
          },
          {
            u: "1f64d-1f3fd-200d-2642-fe0f",
            x: 44,
            y: 12
          },
          {
            u: "1f64d-1f3fe-200d-2642-fe0f",
            x: 45,
            y: 12
          },
          {
            u: "1f64d-1f3ff-200d-2642-fe0f",
            x: 46,
            y: 12
          }
        ]
      },
      {
        n: [
          "\u76B1\u7709\u5934\u7684\u5973\u4EBA"
        ],
        u: {
          u: "1f64d-200d-2640-fe0f",
          x: 47,
          y: 12
        },
        v: [
          {
            u: "1f64d-1f3fb-200d-2640-fe0f",
            x: 48,
            y: 12
          },
          {
            u: "1f64d-1f3fc-200d-2640-fe0f",
            x: 49,
            y: 12
          },
          {
            u: "1f64d-1f3fd-200d-2640-fe0f",
            x: 0,
            y: 13
          },
          {
            u: "1f64d-1f3fe-200d-2640-fe0f",
            x: 1,
            y: 13
          },
          {
            u: "1f64d-1f3ff-200d-2640-fe0f",
            x: 2,
            y: 13
          }
        ]
      },
      {
        n: [
          "\u6485\u5634\u7684\u4EBA"
        ],
        u: {
          u: "1f64e",
          x: 3,
          y: 13
        },
        v: [
          {
            u: "1f64e-1f3fb",
            x: 4,
            y: 13
          },
          {
            u: "1f64e-1f3fc",
            x: 5,
            y: 13
          },
          {
            u: "1f64e-1f3fd",
            x: 6,
            y: 13
          },
          {
            u: "1f64e-1f3fe",
            x: 7,
            y: 13
          },
          {
            u: "1f64e-1f3ff",
            x: 8,
            y: 13
          }
        ]
      },
      {
        n: [
          "\u7537\u4EBA\u6485\u5634"
        ],
        u: {
          u: "1f64e-200d-2642-fe0f",
          x: 9,
          y: 13
        },
        v: [
          {
            u: "1f64e-1f3fb-200d-2642-fe0f",
            x: 10,
            y: 13
          },
          {
            u: "1f64e-1f3fc-200d-2642-fe0f",
            x: 11,
            y: 13
          },
          {
            u: "1f64e-1f3fd-200d-2642-fe0f",
            x: 12,
            y: 13
          },
          {
            u: "1f64e-1f3fe-200d-2642-fe0f",
            x: 13,
            y: 13
          },
          {
            u: "1f64e-1f3ff-200d-2642-fe0f",
            x: 14,
            y: 13
          }
        ]
      },
      {
        n: [
          "\u5973\u4EBA\u6485\u5634"
        ],
        u: {
          u: "1f64e-200d-2640-fe0f",
          x: 15,
          y: 13
        },
        v: [
          {
            u: "1f64e-1f3fb-200d-2640-fe0f",
            x: 16,
            y: 13
          },
          {
            u: "1f64e-1f3fc-200d-2640-fe0f",
            x: 17,
            y: 13
          },
          {
            u: "1f64e-1f3fd-200d-2640-fe0f",
            x: 18,
            y: 13
          },
          {
            u: "1f64e-1f3fe-200d-2640-fe0f",
            x: 19,
            y: 13
          },
          {
            u: "1f64e-1f3ff-200d-2640-fe0f",
            x: 20,
            y: 13
          }
        ]
      },
      {
        n: [
          "\u6CA1\u6709\u597D\u59FF\u52BF\u7684\u8138",
          "\u4E0D\u592A\u597D"
        ],
        u: {
          u: "1f645",
          x: 21,
          y: 13
        },
        v: [
          {
            u: "1f645-1f3fb",
            x: 22,
            y: 13
          },
          {
            u: "1f645-1f3fc",
            x: 23,
            y: 13
          },
          {
            u: "1f645-1f3fd",
            x: 24,
            y: 13
          },
          {
            u: "1f645-1f3fe",
            x: 25,
            y: 13
          },
          {
            u: "1f645-1f3ff",
            x: 26,
            y: 13
          }
        ]
      },
      {
        n: [
          "\u7537\u5B50\u793A\u610F\u5426"
        ],
        u: {
          u: "1f645-200d-2642-fe0f",
          x: 27,
          y: 13
        },
        v: [
          {
            u: "1f645-1f3fb-200d-2642-fe0f",
            x: 28,
            y: 13
          },
          {
            u: "1f645-1f3fc-200d-2642-fe0f",
            x: 29,
            y: 13
          },
          {
            u: "1f645-1f3fd-200d-2642-fe0f",
            x: 30,
            y: 13
          },
          {
            u: "1f645-1f3fe-200d-2642-fe0f",
            x: 31,
            y: 13
          },
          {
            u: "1f645-1f3ff-200d-2642-fe0f",
            x: 32,
            y: 13
          }
        ]
      },
      {
        n: [
          "\u5973\u4EBA\u505A\u624B\u52BF\u4E0D"
        ],
        u: {
          u: "1f645-200d-2640-fe0f",
          x: 33,
          y: 13
        },
        v: [
          {
            u: "1f645-1f3fb-200d-2640-fe0f",
            x: 34,
            y: 13
          },
          {
            u: "1f645-1f3fc-200d-2640-fe0f",
            x: 35,
            y: 13
          },
          {
            u: "1f645-1f3fd-200d-2640-fe0f",
            x: 36,
            y: 13
          },
          {
            u: "1f645-1f3fe-200d-2640-fe0f",
            x: 37,
            y: 13
          },
          {
            u: "1f645-1f3ff-200d-2640-fe0f",
            x: 38,
            y: 13
          }
        ]
      },
      {
        n: [
          "\u5E26ok\u624B\u52BF\u7684\u8138",
          "ok\u5973\u58EB"
        ],
        u: {
          u: "1f646",
          x: 39,
          y: 13
        },
        v: [
          {
            u: "1f646-1f3fb",
            x: 40,
            y: 13
          },
          {
            u: "1f646-1f3fc",
            x: 41,
            y: 13
          },
          {
            u: "1f646-1f3fd",
            x: 42,
            y: 13
          },
          {
            u: "1f646-1f3fe",
            x: 43,
            y: 13
          },
          {
            u: "1f646-1f3ff",
            x: 44,
            y: 13
          }
        ]
      },
      {
        n: [
          "\u7537\u5B50\u624B\u52BFok"
        ],
        u: {
          u: "1f646-200d-2642-fe0f",
          x: 45,
          y: 13
        },
        v: [
          {
            u: "1f646-1f3fb-200d-2642-fe0f",
            x: 46,
            y: 13
          },
          {
            u: "1f646-1f3fc-200d-2642-fe0f",
            x: 47,
            y: 13
          },
          {
            u: "1f646-1f3fd-200d-2642-fe0f",
            x: 48,
            y: 13
          },
          {
            u: "1f646-1f3fe-200d-2642-fe0f",
            x: 49,
            y: 13
          },
          {
            u: "1f646-1f3ff-200d-2642-fe0f",
            x: 0,
            y: 14
          }
        ]
      },
      {
        n: [
          "\u5973\u5B50\u624B\u52BFok"
        ],
        u: {
          u: "1f646-200d-2640-fe0f",
          x: 1,
          y: 14
        },
        v: [
          {
            u: "1f646-1f3fb-200d-2640-fe0f",
            x: 2,
            y: 14
          },
          {
            u: "1f646-1f3fc-200d-2640-fe0f",
            x: 3,
            y: 14
          },
          {
            u: "1f646-1f3fd-200d-2640-fe0f",
            x: 4,
            y: 14
          },
          {
            u: "1f646-1f3fe-200d-2640-fe0f",
            x: 5,
            y: 14
          },
          {
            u: "1f646-1f3ff-200d-2640-fe0f",
            x: 6,
            y: 14
          }
        ]
      },
      {
        n: [
          "\u95EE\u8BAF\u53F0\u4EBA\u5458"
        ],
        u: {
          u: "1f481",
          x: 7,
          y: 14
        },
        v: [
          {
            u: "1f481-1f3fb",
            x: 8,
            y: 14
          },
          {
            u: "1f481-1f3fc",
            x: 9,
            y: 14
          },
          {
            u: "1f481-1f3fd",
            x: 10,
            y: 14
          },
          {
            u: "1f481-1f3fe",
            x: 11,
            y: 14
          },
          {
            u: "1f481-1f3ff",
            x: 12,
            y: 14
          }
        ]
      },
      {
        n: [
          "\u7537\u5B50\u503E\u7FFB\u624B"
        ],
        u: {
          u: "1f481-200d-2642-fe0f",
          x: 13,
          y: 14
        },
        v: [
          {
            u: "1f481-1f3fb-200d-2642-fe0f",
            x: 14,
            y: 14
          },
          {
            u: "1f481-1f3fc-200d-2642-fe0f",
            x: 15,
            y: 14
          },
          {
            u: "1f481-1f3fd-200d-2642-fe0f",
            x: 16,
            y: 14
          },
          {
            u: "1f481-1f3fe-200d-2642-fe0f",
            x: 17,
            y: 14
          },
          {
            u: "1f481-1f3ff-200d-2642-fe0f",
            x: 18,
            y: 14
          }
        ]
      },
      {
        n: [
          "\u5973\u6027\u503E\u7FFB\u624B"
        ],
        u: {
          u: "1f481-200d-2640-fe0f",
          x: 19,
          y: 14
        },
        v: [
          {
            u: "1f481-1f3fb-200d-2640-fe0f",
            x: 20,
            y: 14
          },
          {
            u: "1f481-1f3fc-200d-2640-fe0f",
            x: 21,
            y: 14
          },
          {
            u: "1f481-1f3fd-200d-2640-fe0f",
            x: 22,
            y: 14
          },
          {
            u: "1f481-1f3fe-200d-2640-fe0f",
            x: 23,
            y: 14
          },
          {
            u: "1f481-1f3ff-200d-2640-fe0f",
            x: 24,
            y: 14
          }
        ]
      },
      {
        n: [
          "\u5FEB\u4E50\u7684\u4EBA\u4E3E\u8D77\u4E00\u53EA\u624B",
          "\u4E3E\u624B"
        ],
        u: {
          u: "1f64b",
          x: 25,
          y: 14
        },
        v: [
          {
            u: "1f64b-1f3fb",
            x: 26,
            y: 14
          },
          {
            u: "1f64b-1f3fc",
            x: 27,
            y: 14
          },
          {
            u: "1f64b-1f3fd",
            x: 28,
            y: 14
          },
          {
            u: "1f64b-1f3fe",
            x: 29,
            y: 14
          },
          {
            u: "1f64b-1f3ff",
            x: 30,
            y: 14
          }
        ]
      },
      {
        n: [
          "\u7537\u5B50\u4E3E\u624B"
        ],
        u: {
          u: "1f64b-200d-2642-fe0f",
          x: 31,
          y: 14
        },
        v: [
          {
            u: "1f64b-1f3fb-200d-2642-fe0f",
            x: 32,
            y: 14
          },
          {
            u: "1f64b-1f3fc-200d-2642-fe0f",
            x: 33,
            y: 14
          },
          {
            u: "1f64b-1f3fd-200d-2642-fe0f",
            x: 34,
            y: 14
          },
          {
            u: "1f64b-1f3fe-200d-2642-fe0f",
            x: 35,
            y: 14
          },
          {
            u: "1f64b-1f3ff-200d-2642-fe0f",
            x: 36,
            y: 14
          }
        ]
      },
      {
        n: [
          "\u5973\u58EB\u4E3E\u624B"
        ],
        u: {
          u: "1f64b-200d-2640-fe0f",
          x: 37,
          y: 14
        },
        v: [
          {
            u: "1f64b-1f3fb-200d-2640-fe0f",
            x: 38,
            y: 14
          },
          {
            u: "1f64b-1f3fc-200d-2640-fe0f",
            x: 39,
            y: 14
          },
          {
            u: "1f64b-1f3fd-200d-2640-fe0f",
            x: 40,
            y: 14
          },
          {
            u: "1f64b-1f3fe-200d-2640-fe0f",
            x: 41,
            y: 14
          },
          {
            u: "1f64b-1f3ff-200d-2640-fe0f",
            x: 42,
            y: 14
          }
        ]
      },
      {
        n: [
          "\u6DF1\u6DF1\u97A0\u8EAC\u7684\u4EBA",
          "\u5F13"
        ],
        u: {
          u: "1f647",
          x: 43,
          y: 14
        },
        v: [
          {
            u: "1f647-1f3fb",
            x: 44,
            y: 14
          },
          {
            u: "1f647-1f3fc",
            x: 45,
            y: 14
          },
          {
            u: "1f647-1f3fd",
            x: 46,
            y: 14
          },
          {
            u: "1f647-1f3fe",
            x: 47,
            y: 14
          },
          {
            u: "1f647-1f3ff",
            x: 48,
            y: 14
          }
        ]
      },
      {
        n: [
          "\u7537\u5B50\u97A0\u8EAC"
        ],
        u: {
          u: "1f647-200d-2642-fe0f",
          x: 49,
          y: 14
        },
        v: [
          {
            u: "1f647-1f3fb-200d-2642-fe0f",
            x: 0,
            y: 15
          },
          {
            u: "1f647-1f3fc-200d-2642-fe0f",
            x: 1,
            y: 15
          },
          {
            u: "1f647-1f3fd-200d-2642-fe0f",
            x: 2,
            y: 15
          },
          {
            u: "1f647-1f3fe-200d-2642-fe0f",
            x: 3,
            y: 15
          },
          {
            u: "1f647-1f3ff-200d-2642-fe0f",
            x: 4,
            y: 15
          }
        ]
      },
      {
        n: [
          "\u5973\u5B50\u97A0\u8EAC"
        ],
        u: {
          u: "1f647-200d-2640-fe0f",
          x: 5,
          y: 15
        },
        v: [
          {
            u: "1f647-1f3fb-200d-2640-fe0f",
            x: 6,
            y: 15
          },
          {
            u: "1f647-1f3fc-200d-2640-fe0f",
            x: 7,
            y: 15
          },
          {
            u: "1f647-1f3fd-200d-2640-fe0f",
            x: 8,
            y: 15
          },
          {
            u: "1f647-1f3fe-200d-2640-fe0f",
            x: 9,
            y: 15
          },
          {
            u: "1f647-1f3ff-200d-2640-fe0f",
            x: 10,
            y: 15
          }
        ]
      },
      {
        n: [
          "\u9762\u90E8\u624B\u638C"
        ],
        u: {
          u: "1f926",
          x: 11,
          y: 15
        },
        v: [
          {
            u: "1f926-1f3fb",
            x: 12,
            y: 15
          },
          {
            u: "1f926-1f3fc",
            x: 13,
            y: 15
          },
          {
            u: "1f926-1f3fd",
            x: 14,
            y: 15
          },
          {
            u: "1f926-1f3fe",
            x: 15,
            y: 15
          },
          {
            u: "1f926-1f3ff",
            x: 16,
            y: 15
          }
        ]
      },
      {
        n: [
          "\u4EBA\u8138\u638C\u7EB9"
        ],
        u: {
          u: "1f926-200d-2642-fe0f",
          x: 17,
          y: 15
        },
        v: [
          {
            u: "1f926-1f3fb-200d-2642-fe0f",
            x: 18,
            y: 15
          },
          {
            u: "1f926-1f3fc-200d-2642-fe0f",
            x: 19,
            y: 15
          },
          {
            u: "1f926-1f3fd-200d-2642-fe0f",
            x: 20,
            y: 15
          },
          {
            u: "1f926-1f3fe-200d-2642-fe0f",
            x: 21,
            y: 15
          },
          {
            u: "1f926-1f3ff-200d-2642-fe0f",
            x: 22,
            y: 15
          }
        ]
      },
      {
        n: [
          "\u5973\u6027\u638C\u7EB9"
        ],
        u: {
          u: "1f926-200d-2640-fe0f",
          x: 23,
          y: 15
        },
        v: [
          {
            u: "1f926-1f3fb-200d-2640-fe0f",
            x: 24,
            y: 15
          },
          {
            u: "1f926-1f3fc-200d-2640-fe0f",
            x: 25,
            y: 15
          },
          {
            u: "1f926-1f3fd-200d-2640-fe0f",
            x: 26,
            y: 15
          },
          {
            u: "1f926-1f3fe-200d-2640-fe0f",
            x: 27,
            y: 15
          },
          {
            u: "1f926-1f3ff-200d-2640-fe0f",
            x: 28,
            y: 15
          }
        ]
      },
      {
        n: [
          "\u8038\u80A9"
        ],
        u: {
          u: "1f937",
          x: 29,
          y: 15
        },
        v: [
          {
            u: "1f937-1f3fb",
            x: 30,
            y: 15
          },
          {
            u: "1f937-1f3fc",
            x: 31,
            y: 15
          },
          {
            u: "1f937-1f3fd",
            x: 32,
            y: 15
          },
          {
            u: "1f937-1f3fe",
            x: 33,
            y: 15
          },
          {
            u: "1f937-1f3ff",
            x: 34,
            y: 15
          }
        ]
      },
      {
        n: [
          "\u7537\u4EBA\u8038\u8038\u80A9"
        ],
        u: {
          u: "1f937-200d-2642-fe0f",
          x: 35,
          y: 15
        },
        v: [
          {
            u: "1f937-1f3fb-200d-2642-fe0f",
            x: 36,
            y: 15
          },
          {
            u: "1f937-1f3fc-200d-2642-fe0f",
            x: 37,
            y: 15
          },
          {
            u: "1f937-1f3fd-200d-2642-fe0f",
            x: 38,
            y: 15
          },
          {
            u: "1f937-1f3fe-200d-2642-fe0f",
            x: 39,
            y: 15
          },
          {
            u: "1f937-1f3ff-200d-2642-fe0f",
            x: 40,
            y: 15
          }
        ]
      },
      {
        n: [
          "\u5973\u4EBA\u8038\u8038\u80A9"
        ],
        u: {
          u: "1f937-200d-2640-fe0f",
          x: 41,
          y: 15
        },
        v: [
          {
            u: "1f937-1f3fb-200d-2640-fe0f",
            x: 42,
            y: 15
          },
          {
            u: "1f937-1f3fc-200d-2640-fe0f",
            x: 43,
            y: 15
          },
          {
            u: "1f937-1f3fd-200d-2640-fe0f",
            x: 44,
            y: 15
          },
          {
            u: "1f937-1f3fe-200d-2640-fe0f",
            x: 45,
            y: 15
          },
          {
            u: "1f937-1f3ff-200d-2640-fe0f",
            x: 46,
            y: 15
          }
        ]
      },
      {
        n: [
          "\u9762\u90E8\u6309\u6469",
          "\u6309\u6469"
        ],
        u: {
          u: "1f486",
          x: 47,
          y: 15
        },
        v: [
          {
            u: "1f486-1f3fb",
            x: 48,
            y: 15
          },
          {
            u: "1f486-1f3fc",
            x: 49,
            y: 15
          },
          {
            u: "1f486-1f3fd",
            x: 0,
            y: 16
          },
          {
            u: "1f486-1f3fe",
            x: 1,
            y: 16
          },
          {
            u: "1f486-1f3ff",
            x: 2,
            y: 16
          }
        ]
      },
      {
        n: [
          "\u7537\u6309\u6469\u5E08"
        ],
        u: {
          u: "1f486-200d-2642-fe0f",
          x: 3,
          y: 16
        },
        v: [
          {
            u: "1f486-1f3fb-200d-2642-fe0f",
            x: 4,
            y: 16
          },
          {
            u: "1f486-1f3fc-200d-2642-fe0f",
            x: 5,
            y: 16
          },
          {
            u: "1f486-1f3fd-200d-2642-fe0f",
            x: 6,
            y: 16
          },
          {
            u: "1f486-1f3fe-200d-2642-fe0f",
            x: 7,
            y: 16
          },
          {
            u: "1f486-1f3ff-200d-2642-fe0f",
            x: 8,
            y: 16
          }
        ]
      },
      {
        n: [
          "\u63A5\u53D7\u6309\u6469\u7684\u5973\u6027"
        ],
        u: {
          u: "1f486-200d-2640-fe0f",
          x: 9,
          y: 16
        },
        v: [
          {
            u: "1f486-1f3fb-200d-2640-fe0f",
            x: 10,
            y: 16
          },
          {
            u: "1f486-1f3fc-200d-2640-fe0f",
            x: 11,
            y: 16
          },
          {
            u: "1f486-1f3fd-200d-2640-fe0f",
            x: 12,
            y: 16
          },
          {
            u: "1f486-1f3fe-200d-2640-fe0f",
            x: 13,
            y: 16
          },
          {
            u: "1f486-1f3ff-200d-2640-fe0f",
            x: 14,
            y: 16
          }
        ]
      },
      {
        n: [
          "\u53D1\u578B"
        ],
        u: {
          u: "1f487",
          x: 15,
          y: 16
        },
        v: [
          {
            u: "1f487-1f3fb",
            x: 16,
            y: 16
          },
          {
            u: "1f487-1f3fc",
            x: 17,
            y: 16
          },
          {
            u: "1f487-1f3fd",
            x: 18,
            y: 16
          },
          {
            u: "1f487-1f3fe",
            x: 19,
            y: 16
          },
          {
            u: "1f487-1f3ff",
            x: 20,
            y: 16
          }
        ]
      },
      {
        n: [
          "\u7406\u53D1\u7684\u7537\u4EBA"
        ],
        u: {
          u: "1f487-200d-2642-fe0f",
          x: 21,
          y: 16
        },
        v: [
          {
            u: "1f487-1f3fb-200d-2642-fe0f",
            x: 22,
            y: 16
          },
          {
            u: "1f487-1f3fc-200d-2642-fe0f",
            x: 23,
            y: 16
          },
          {
            u: "1f487-1f3fd-200d-2642-fe0f",
            x: 24,
            y: 16
          },
          {
            u: "1f487-1f3fe-200d-2642-fe0f",
            x: 25,
            y: 16
          },
          {
            u: "1f487-1f3ff-200d-2642-fe0f",
            x: 26,
            y: 16
          }
        ]
      },
      {
        n: [
          "\u7406\u53D1\u7684\u5973\u4EBA"
        ],
        u: {
          u: "1f487-200d-2640-fe0f",
          x: 27,
          y: 16
        },
        v: [
          {
            u: "1f487-1f3fb-200d-2640-fe0f",
            x: 28,
            y: 16
          },
          {
            u: "1f487-1f3fc-200d-2640-fe0f",
            x: 29,
            y: 16
          },
          {
            u: "1f487-1f3fd-200d-2640-fe0f",
            x: 30,
            y: 16
          },
          {
            u: "1f487-1f3fe-200d-2640-fe0f",
            x: 31,
            y: 16
          },
          {
            u: "1f487-1f3ff-200d-2640-fe0f",
            x: 32,
            y: 16
          }
        ]
      },
      {
        n: [
          "\u884C\u4EBA",
          "\u884C\u8D70"
        ],
        u: {
          u: "1f6b6",
          x: 33,
          y: 16
        },
        v: [
          {
            u: "1f6b6-1f3fb",
            x: 34,
            y: 16
          },
          {
            u: "1f6b6-1f3fc",
            x: 35,
            y: 16
          },
          {
            u: "1f6b6-1f3fd",
            x: 36,
            y: 16
          },
          {
            u: "1f6b6-1f3fe",
            x: 37,
            y: 16
          },
          {
            u: "1f6b6-1f3ff",
            x: 38,
            y: 16
          }
        ]
      },
      {
        n: [
          "\u7537\u5B50\u6B65\u884C"
        ],
        u: {
          u: "1f6b6-200d-2642-fe0f",
          x: 39,
          y: 16
        },
        v: [
          {
            u: "1f6b6-1f3fb-200d-2642-fe0f",
            x: 40,
            y: 16
          },
          {
            u: "1f6b6-1f3fc-200d-2642-fe0f",
            x: 41,
            y: 16
          },
          {
            u: "1f6b6-1f3fd-200d-2642-fe0f",
            x: 42,
            y: 16
          },
          {
            u: "1f6b6-1f3fe-200d-2642-fe0f",
            x: 43,
            y: 16
          },
          {
            u: "1f6b6-1f3ff-200d-2642-fe0f",
            x: 44,
            y: 16
          }
        ]
      },
      {
        n: [
          "\u5973\u4EBA\u8D70\u8DEF"
        ],
        u: {
          u: "1f6b6-200d-2640-fe0f",
          x: 45,
          y: 16
        },
        v: [
          {
            u: "1f6b6-1f3fb-200d-2640-fe0f",
            x: 46,
            y: 16
          },
          {
            u: "1f6b6-1f3fc-200d-2640-fe0f",
            x: 47,
            y: 16
          },
          {
            u: "1f6b6-1f3fd-200d-2640-fe0f",
            x: 48,
            y: 16
          },
          {
            u: "1f6b6-1f3fe-200d-2640-fe0f",
            x: 49,
            y: 16
          },
          {
            u: "1f6b6-1f3ff-200d-2640-fe0f",
            x: 0,
            y: 17
          }
        ]
      },
      {
        n: [
          "\u8DD1\u6B65\u8005",
          "\u8DD1\u6B65"
        ],
        u: {
          u: "1f3c3",
          x: 1,
          y: 17
        },
        v: [
          {
            u: "1f3c3-1f3fb",
            x: 2,
            y: 17
          },
          {
            u: "1f3c3-1f3fc",
            x: 3,
            y: 17
          },
          {
            u: "1f3c3-1f3fd",
            x: 4,
            y: 17
          },
          {
            u: "1f3c3-1f3fe",
            x: 5,
            y: 17
          },
          {
            u: "1f3c3-1f3ff",
            x: 6,
            y: 17
          }
        ]
      },
      {
        n: [
          "\u7537\u5B50\u8DD1\u6B65"
        ],
        u: {
          u: "1f3c3-200d-2642-fe0f",
          x: 7,
          y: 17
        },
        v: [
          {
            u: "1f3c3-1f3fb-200d-2642-fe0f",
            x: 8,
            y: 17
          },
          {
            u: "1f3c3-1f3fc-200d-2642-fe0f",
            x: 9,
            y: 17
          },
          {
            u: "1f3c3-1f3fd-200d-2642-fe0f",
            x: 10,
            y: 17
          },
          {
            u: "1f3c3-1f3fe-200d-2642-fe0f",
            x: 11,
            y: 17
          },
          {
            u: "1f3c3-1f3ff-200d-2642-fe0f",
            x: 12,
            y: 17
          }
        ]
      },
      {
        n: [
          "\u5973\u5B50\u8DD1\u6B65"
        ],
        u: {
          u: "1f3c3-200d-2640-fe0f",
          x: 13,
          y: 17
        },
        v: [
          {
            u: "1f3c3-1f3fb-200d-2640-fe0f",
            x: 14,
            y: 17
          },
          {
            u: "1f3c3-1f3fc-200d-2640-fe0f",
            x: 15,
            y: 17
          },
          {
            u: "1f3c3-1f3fd-200d-2640-fe0f",
            x: 16,
            y: 17
          },
          {
            u: "1f3c3-1f3fe-200d-2640-fe0f",
            x: 17,
            y: 17
          },
          {
            u: "1f3c3-1f3ff-200d-2640-fe0f",
            x: 18,
            y: 17
          }
        ]
      },
      {
        n: [
          "\u821E\u8005"
        ],
        u: {
          u: "1f483",
          x: 19,
          y: 17
        },
        v: [
          {
            u: "1f483-1f3fb",
            x: 20,
            y: 17
          },
          {
            u: "1f483-1f3fc",
            x: 21,
            y: 17
          },
          {
            u: "1f483-1f3fd",
            x: 22,
            y: 17
          },
          {
            u: "1f483-1f3fe",
            x: 23,
            y: 17
          },
          {
            u: "1f483-1f3ff",
            x: 24,
            y: 17
          }
        ]
      },
      {
        n: [
          "\u7537\u5B50\u821E\u8E48"
        ],
        u: {
          u: "1f57a",
          x: 25,
          y: 17
        },
        v: [
          {
            u: "1f57a-1f3fb",
            x: 26,
            y: 17
          },
          {
            u: "1f57a-1f3fc",
            x: 27,
            y: 17
          },
          {
            u: "1f57a-1f3fd",
            x: 28,
            y: 17
          },
          {
            u: "1f57a-1f3fe",
            x: 29,
            y: 17
          },
          {
            u: "1f57a-1f3ff",
            x: 30,
            y: 17
          }
        ]
      },
      {
        n: [
          "\u6709\u5154\u5B50\u8033\u6735\u7684\u5973\u4EBA",
          "\u821E\u8005"
        ],
        u: {
          u: "1f46f",
          x: 31,
          y: 17
        }
      },
      {
        n: [
          "\u5154\u5B50\u8033\u6735\u7537\u4EBA\u805A\u4F1A"
        ],
        u: {
          u: "1f46f-200d-2642-fe0f",
          x: 32,
          y: 17
        }
      },
      {
        n: [
          "\u6709\u5154\u5B50\u8033\u6735\u7684\u5973\u4EBA\u805A\u4F1A"
        ],
        u: {
          u: "1f46f-200d-2640-fe0f",
          x: 33,
          y: 17
        }
      },
      {
        n: [
          "\u84B8\u6C7D\u5BA4\u4E2D\u7684\u4EBA\u5458"
        ],
        u: {
          u: "1f9d6",
          x: 34,
          y: 17
        },
        v: [
          {
            u: "1f9d6-1f3fb",
            x: 35,
            y: 17
          },
          {
            u: "1f9d6-1f3fc",
            x: 36,
            y: 17
          },
          {
            u: "1f9d6-1f3fd",
            x: 37,
            y: 17
          },
          {
            u: "1f9d6-1f3fe",
            x: 38,
            y: 17
          },
          {
            u: "1f9d6-1f3ff",
            x: 39,
            y: 17
          }
        ]
      },
      {
        n: [
          "\u84B8\u6C7D\u623F\u91CC\u7684\u5973\u4EBA"
        ],
        u: {
          u: "1f9d6-200d-2640-fe0f",
          x: 40,
          y: 17
        },
        v: [
          {
            u: "1f9d6-1f3fb-200d-2640-fe0f",
            x: 41,
            y: 17
          },
          {
            u: "1f9d6-1f3fc-200d-2640-fe0f",
            x: 42,
            y: 17
          },
          {
            u: "1f9d6-1f3fd-200d-2640-fe0f",
            x: 43,
            y: 17
          },
          {
            u: "1f9d6-1f3fe-200d-2640-fe0f",
            x: 44,
            y: 17
          },
          {
            u: "1f9d6-1f3ff-200d-2640-fe0f",
            x: 45,
            y: 17
          }
        ]
      },
      {
        n: [
          "\u84B8\u6C7D\u623F\u91CC\u7684\u7537\u4EBA"
        ],
        u: {
          u: "1f9d6-200d-2642-fe0f",
          x: 46,
          y: 17
        },
        v: [
          {
            u: "1f9d6-1f3fb-200d-2642-fe0f",
            x: 47,
            y: 17
          },
          {
            u: "1f9d6-1f3fc-200d-2642-fe0f",
            x: 48,
            y: 17
          },
          {
            u: "1f9d6-1f3fd-200d-2642-fe0f",
            x: 49,
            y: 17
          },
          {
            u: "1f9d6-1f3fe-200d-2642-fe0f",
            x: 0,
            y: 18
          },
          {
            u: "1f9d6-1f3ff-200d-2642-fe0f",
            x: 1,
            y: 18
          }
        ]
      },
      {
        n: [
          "\u4EBA\u5458\u6500\u722C"
        ],
        u: {
          u: "1f9d7",
          x: 2,
          y: 18
        },
        v: [
          {
            u: "1f9d7-1f3fb",
            x: 3,
            y: 18
          },
          {
            u: "1f9d7-1f3fc",
            x: 4,
            y: 18
          },
          {
            u: "1f9d7-1f3fd",
            x: 5,
            y: 18
          },
          {
            u: "1f9d7-1f3fe",
            x: 6,
            y: 18
          },
          {
            u: "1f9d7-1f3ff",
            x: 7,
            y: 18
          }
        ]
      },
      {
        n: [
          "\u5973\u5B50\u6500\u5CA9"
        ],
        u: {
          u: "1f9d7-200d-2640-fe0f",
          x: 8,
          y: 18
        },
        v: [
          {
            u: "1f9d7-1f3fb-200d-2640-fe0f",
            x: 9,
            y: 18
          },
          {
            u: "1f9d7-1f3fc-200d-2640-fe0f",
            x: 10,
            y: 18
          },
          {
            u: "1f9d7-1f3fd-200d-2640-fe0f",
            x: 11,
            y: 18
          },
          {
            u: "1f9d7-1f3fe-200d-2640-fe0f",
            x: 12,
            y: 18
          },
          {
            u: "1f9d7-1f3ff-200d-2640-fe0f",
            x: 13,
            y: 18
          }
        ]
      },
      {
        n: [
          "\u8F7D\u4EBA\u6500\u5CA9"
        ],
        u: {
          u: "1f9d7-200d-2642-fe0f",
          x: 14,
          y: 18
        },
        v: [
          {
            u: "1f9d7-1f3fb-200d-2642-fe0f",
            x: 15,
            y: 18
          },
          {
            u: "1f9d7-1f3fc-200d-2642-fe0f",
            x: 16,
            y: 18
          },
          {
            u: "1f9d7-1f3fd-200d-2642-fe0f",
            x: 17,
            y: 18
          },
          {
            u: "1f9d7-1f3fe-200d-2642-fe0f",
            x: 18,
            y: 18
          },
          {
            u: "1f9d7-1f3ff-200d-2642-fe0f",
            x: 19,
            y: 18
          }
        ]
      },
      {
        n: [
          "\u83B2\u82B1\u804C\u4F4D\u4EBA\u5458"
        ],
        u: {
          u: "1f9d8",
          x: 20,
          y: 18
        },
        v: [
          {
            u: "1f9d8-1f3fb",
            x: 21,
            y: 18
          },
          {
            u: "1f9d8-1f3fc",
            x: 22,
            y: 18
          },
          {
            u: "1f9d8-1f3fd",
            x: 23,
            y: 18
          },
          {
            u: "1f9d8-1f3fe",
            x: 24,
            y: 18
          },
          {
            u: "1f9d8-1f3ff",
            x: 25,
            y: 18
          }
        ]
      },
      {
        n: [
          "\u83B2\u82B1\u5973"
        ],
        u: {
          u: "1f9d8-200d-2640-fe0f",
          x: 26,
          y: 18
        },
        v: [
          {
            u: "1f9d8-1f3fb-200d-2640-fe0f",
            x: 27,
            y: 18
          },
          {
            u: "1f9d8-1f3fc-200d-2640-fe0f",
            x: 28,
            y: 18
          },
          {
            u: "1f9d8-1f3fd-200d-2640-fe0f",
            x: 29,
            y: 18
          },
          {
            u: "1f9d8-1f3fe-200d-2640-fe0f",
            x: 30,
            y: 18
          },
          {
            u: "1f9d8-1f3ff-200d-2640-fe0f",
            x: 31,
            y: 18
          }
        ]
      },
      {
        n: [
          "\u8377\u82B1\u4EBA"
        ],
        u: {
          u: "1f9d8-200d-2642-fe0f",
          x: 32,
          y: 18
        },
        v: [
          {
            u: "1f9d8-1f3fb-200d-2642-fe0f",
            x: 33,
            y: 18
          },
          {
            u: "1f9d8-1f3fc-200d-2642-fe0f",
            x: 34,
            y: 18
          },
          {
            u: "1f9d8-1f3fd-200d-2642-fe0f",
            x: 35,
            y: 18
          },
          {
            u: "1f9d8-1f3fe-200d-2642-fe0f",
            x: 36,
            y: 18
          },
          {
            u: "1f9d8-1f3ff-200d-2642-fe0f",
            x: 37,
            y: 18
          }
        ]
      },
      {
        n: [
          "\u6D74\u7F38"
        ],
        u: {
          u: "1f6c0",
          x: 38,
          y: 18
        },
        v: [
          {
            u: "1f6c0-1f3fb",
            x: 39,
            y: 18
          },
          {
            u: "1f6c0-1f3fc",
            x: 40,
            y: 18
          },
          {
            u: "1f6c0-1f3fd",
            x: 41,
            y: 18
          },
          {
            u: "1f6c0-1f3fe",
            x: 42,
            y: 18
          },
          {
            u: "1f6c0-1f3ff",
            x: 43,
            y: 18
          }
        ]
      },
      {
        n: [
          "\u4F4F\u5BBF\u8BBE\u65BD"
        ],
        u: {
          u: "1f6cc",
          x: 44,
          y: 18
        },
        v: [
          {
            u: "1f6cc-1f3fb",
            x: 45,
            y: 18
          },
          {
            u: "1f6cc-1f3fc",
            x: 46,
            y: 18
          },
          {
            u: "1f6cc-1f3fd",
            x: 47,
            y: 18
          },
          {
            u: "1f6cc-1f3fe",
            x: 48,
            y: 18
          },
          {
            u: "1f6cc-1f3ff",
            x: 49,
            y: 18
          }
        ]
      },
      {
        n: [
          "\u897F\u88C5\u7537\u60AC\u6D6E"
        ],
        u: {
          u: "1f574",
          x: 0,
          y: 19
        },
        v: [
          {
            u: "1f574-1f3fb",
            x: 1,
            y: 19
          },
          {
            u: "1f574-1f3fc",
            x: 2,
            y: 19
          },
          {
            u: "1f574-1f3fd",
            x: 3,
            y: 19
          },
          {
            u: "1f574-1f3fe",
            x: 4,
            y: 19
          },
          {
            u: "1f574-1f3ff",
            x: 5,
            y: 19
          }
        ]
      },
      {
        n: [
          "\u8BF4\u8BDD\u65F6\u5934\u90E8\u8F6E\u5ED3"
        ],
        u: {
          u: "1f5e3",
          x: 6,
          y: 19
        }
      },
      {
        n: [
          "\u80F8\u90E8\u8F6E\u5ED3"
        ],
        u: {
          u: "1f464",
          x: 7,
          y: 19
        }
      },
      {
        n: [
          "\u526A\u5F71\u534A\u8EAB\u50CF"
        ],
        u: {
          u: "1f465",
          x: 8,
          y: 19
        }
      },
      {
        n: [
          "\u51FB\u5251\u8FD0\u52A8\u5458"
        ],
        u: {
          u: "1f93a",
          x: 9,
          y: 19
        }
      },
      {
        n: [
          "\u8D5B\u9A6C"
        ],
        u: {
          u: "1f3c7",
          x: 10,
          y: 19
        },
        v: [
          {
            u: "1f3c7-1f3fb",
            x: 11,
            y: 19
          },
          {
            u: "1f3c7-1f3fc",
            x: 12,
            y: 19
          },
          {
            u: "1f3c7-1f3fd",
            x: 13,
            y: 19
          },
          {
            u: "1f3c7-1f3fe",
            x: 14,
            y: 19
          },
          {
            u: "1f3c7-1f3ff",
            x: 15,
            y: 19
          }
        ]
      },
      {
        n: [
          "\u6ED1\u96EA\u8005"
        ],
        u: {
          u: "26f7",
          x: 16,
          y: 19
        }
      },
      {
        n: [
          "\u6ED1\u96EA\u8FD0\u52A8\u5458"
        ],
        u: {
          u: "1f3c2",
          x: 17,
          y: 19
        },
        v: [
          {
            u: "1f3c2-1f3fb",
            x: 18,
            y: 19
          },
          {
            u: "1f3c2-1f3fc",
            x: 19,
            y: 19
          },
          {
            u: "1f3c2-1f3fd",
            x: 20,
            y: 19
          },
          {
            u: "1f3c2-1f3fe",
            x: 21,
            y: 19
          },
          {
            u: "1f3c2-1f3ff",
            x: 22,
            y: 19
          }
        ]
      },
      {
        n: [
          "\u9AD8\u5C14\u592B\u7403\u624B"
        ],
        u: {
          u: "1f3cc",
          x: 23,
          y: 19
        },
        v: [
          {
            u: "1f3cc-1f3fb",
            x: 24,
            y: 19
          },
          {
            u: "1f3cc-1f3fc",
            x: 25,
            y: 19
          },
          {
            u: "1f3cc-1f3fd",
            x: 26,
            y: 19
          },
          {
            u: "1f3cc-1f3fe",
            x: 27,
            y: 19
          },
          {
            u: "1f3cc-1f3ff",
            x: 28,
            y: 19
          }
        ]
      },
      {
        n: [
          "\u7537\u5B50\u9AD8\u5C14\u592B"
        ],
        u: {
          u: "1f3cc-fe0f-200d-2642-fe0f",
          x: 29,
          y: 19
        },
        v: [
          {
            u: "1f3cc-1f3fb-200d-2642-fe0f",
            x: 30,
            y: 19
          },
          {
            u: "1f3cc-1f3fc-200d-2642-fe0f",
            x: 31,
            y: 19
          },
          {
            u: "1f3cc-1f3fd-200d-2642-fe0f",
            x: 32,
            y: 19
          },
          {
            u: "1f3cc-1f3fe-200d-2642-fe0f",
            x: 33,
            y: 19
          },
          {
            u: "1f3cc-1f3ff-200d-2642-fe0f",
            x: 34,
            y: 19
          }
        ]
      },
      {
        n: [
          "\u5973\u5B50\u9AD8\u5C14\u592B"
        ],
        u: {
          u: "1f3cc-fe0f-200d-2640-fe0f",
          x: 35,
          y: 19
        },
        v: [
          {
            u: "1f3cc-1f3fb-200d-2640-fe0f",
            x: 36,
            y: 19
          },
          {
            u: "1f3cc-1f3fc-200d-2640-fe0f",
            x: 37,
            y: 19
          },
          {
            u: "1f3cc-1f3fd-200d-2640-fe0f",
            x: 38,
            y: 19
          },
          {
            u: "1f3cc-1f3fe-200d-2640-fe0f",
            x: 39,
            y: 19
          },
          {
            u: "1f3cc-1f3ff-200d-2640-fe0f",
            x: 40,
            y: 19
          }
        ]
      },
      {
        n: [
          "\u51B2\u6D6A\u8005"
        ],
        u: {
          u: "1f3c4",
          x: 41,
          y: 19
        },
        v: [
          {
            u: "1f3c4-1f3fb",
            x: 42,
            y: 19
          },
          {
            u: "1f3c4-1f3fc",
            x: 43,
            y: 19
          },
          {
            u: "1f3c4-1f3fd",
            x: 44,
            y: 19
          },
          {
            u: "1f3c4-1f3fe",
            x: 45,
            y: 19
          },
          {
            u: "1f3c4-1f3ff",
            x: 46,
            y: 19
          }
        ]
      },
      {
        n: [
          "\u7537\u5B50\u51B2\u6D6A"
        ],
        u: {
          u: "1f3c4-200d-2642-fe0f",
          x: 47,
          y: 19
        },
        v: [
          {
            u: "1f3c4-1f3fb-200d-2642-fe0f",
            x: 48,
            y: 19
          },
          {
            u: "1f3c4-1f3fc-200d-2642-fe0f",
            x: 49,
            y: 19
          },
          {
            u: "1f3c4-1f3fd-200d-2642-fe0f",
            x: 0,
            y: 20
          },
          {
            u: "1f3c4-1f3fe-200d-2642-fe0f",
            x: 1,
            y: 20
          },
          {
            u: "1f3c4-1f3ff-200d-2642-fe0f",
            x: 2,
            y: 20
          }
        ]
      },
      {
        n: [
          "\u5973\u5B50\u51B2\u6D6A"
        ],
        u: {
          u: "1f3c4-200d-2640-fe0f",
          x: 3,
          y: 20
        },
        v: [
          {
            u: "1f3c4-1f3fb-200d-2640-fe0f",
            x: 4,
            y: 20
          },
          {
            u: "1f3c4-1f3fc-200d-2640-fe0f",
            x: 5,
            y: 20
          },
          {
            u: "1f3c4-1f3fd-200d-2640-fe0f",
            x: 6,
            y: 20
          },
          {
            u: "1f3c4-1f3fe-200d-2640-fe0f",
            x: 7,
            y: 20
          },
          {
            u: "1f3c4-1f3ff-200d-2640-fe0f",
            x: 8,
            y: 20
          }
        ]
      },
      {
        n: [
          "\u5212\u8247"
        ],
        u: {
          u: "1f6a3",
          x: 9,
          y: 20
        },
        v: [
          {
            u: "1f6a3-1f3fb",
            x: 10,
            y: 20
          },
          {
            u: "1f6a3-1f3fc",
            x: 11,
            y: 20
          },
          {
            u: "1f6a3-1f3fd",
            x: 12,
            y: 20
          },
          {
            u: "1f6a3-1f3fe",
            x: 13,
            y: 20
          },
          {
            u: "1f6a3-1f3ff",
            x: 14,
            y: 20
          }
        ]
      },
      {
        n: [
          "\u8F7D\u4EBA\u5212\u8247"
        ],
        u: {
          u: "1f6a3-200d-2642-fe0f",
          x: 15,
          y: 20
        },
        v: [
          {
            u: "1f6a3-1f3fb-200d-2642-fe0f",
            x: 16,
            y: 20
          },
          {
            u: "1f6a3-1f3fc-200d-2642-fe0f",
            x: 17,
            y: 20
          },
          {
            u: "1f6a3-1f3fd-200d-2642-fe0f",
            x: 18,
            y: 20
          },
          {
            u: "1f6a3-1f3fe-200d-2642-fe0f",
            x: 19,
            y: 20
          },
          {
            u: "1f6a3-1f3ff-200d-2642-fe0f",
            x: 20,
            y: 20
          }
        ]
      },
      {
        n: [
          "\u5973\u5B50\u5212\u8247"
        ],
        u: {
          u: "1f6a3-200d-2640-fe0f",
          x: 21,
          y: 20
        },
        v: [
          {
            u: "1f6a3-1f3fb-200d-2640-fe0f",
            x: 22,
            y: 20
          },
          {
            u: "1f6a3-1f3fc-200d-2640-fe0f",
            x: 23,
            y: 20
          },
          {
            u: "1f6a3-1f3fd-200d-2640-fe0f",
            x: 24,
            y: 20
          },
          {
            u: "1f6a3-1f3fe-200d-2640-fe0f",
            x: 25,
            y: 20
          },
          {
            u: "1f6a3-1f3ff-200d-2640-fe0f",
            x: 26,
            y: 20
          }
        ]
      },
      {
        n: [
          "\u4F1A\u6E38\u6CF3\u8005"
        ],
        u: {
          u: "1f3ca",
          x: 27,
          y: 20
        },
        v: [
          {
            u: "1f3ca-1f3fb",
            x: 28,
            y: 20
          },
          {
            u: "1f3ca-1f3fc",
            x: 29,
            y: 20
          },
          {
            u: "1f3ca-1f3fd",
            x: 30,
            y: 20
          },
          {
            u: "1f3ca-1f3fe",
            x: 31,
            y: 20
          },
          {
            u: "1f3ca-1f3ff",
            x: 32,
            y: 20
          }
        ]
      },
      {
        n: [
          "\u7537\u5B50\u6E38\u6CF3"
        ],
        u: {
          u: "1f3ca-200d-2642-fe0f",
          x: 33,
          y: 20
        },
        v: [
          {
            u: "1f3ca-1f3fb-200d-2642-fe0f",
            x: 34,
            y: 20
          },
          {
            u: "1f3ca-1f3fc-200d-2642-fe0f",
            x: 35,
            y: 20
          },
          {
            u: "1f3ca-1f3fd-200d-2642-fe0f",
            x: 36,
            y: 20
          },
          {
            u: "1f3ca-1f3fe-200d-2642-fe0f",
            x: 37,
            y: 20
          },
          {
            u: "1f3ca-1f3ff-200d-2642-fe0f",
            x: 38,
            y: 20
          }
        ]
      },
      {
        n: [
          "\u5973\u5B50\u6E38\u6CF3"
        ],
        u: {
          u: "1f3ca-200d-2640-fe0f",
          x: 39,
          y: 20
        },
        v: [
          {
            u: "1f3ca-1f3fb-200d-2640-fe0f",
            x: 40,
            y: 20
          },
          {
            u: "1f3ca-1f3fc-200d-2640-fe0f",
            x: 41,
            y: 20
          },
          {
            u: "1f3ca-1f3fd-200d-2640-fe0f",
            x: 42,
            y: 20
          },
          {
            u: "1f3ca-1f3fe-200d-2640-fe0f",
            x: 43,
            y: 20
          },
          {
            u: "1f3ca-1f3ff-200d-2640-fe0f",
            x: 44,
            y: 20
          }
        ]
      },
      {
        n: [
          "\u6301\u7403\u4EBA"
        ],
        u: {
          u: "26f9",
          x: 45,
          y: 20
        },
        v: [
          {
            u: "26f9-1f3fb",
            x: 46,
            y: 20
          },
          {
            u: "26f9-1f3fc",
            x: 47,
            y: 20
          },
          {
            u: "26f9-1f3fd",
            x: 48,
            y: 20
          },
          {
            u: "26f9-1f3fe",
            x: 49,
            y: 20
          },
          {
            u: "26f9-1f3ff",
            x: 0,
            y: 21
          }
        ]
      },
      {
        n: [
          "\u7537\u5B50\u5F39\u7403"
        ],
        u: {
          u: "26f9-fe0f-200d-2642-fe0f",
          x: 1,
          y: 21
        },
        v: [
          {
            u: "26f9-1f3fb-200d-2642-fe0f",
            x: 2,
            y: 21
          },
          {
            u: "26f9-1f3fc-200d-2642-fe0f",
            x: 3,
            y: 21
          },
          {
            u: "26f9-1f3fd-200d-2642-fe0f",
            x: 4,
            y: 21
          },
          {
            u: "26f9-1f3fe-200d-2642-fe0f",
            x: 5,
            y: 21
          },
          {
            u: "26f9-1f3ff-200d-2642-fe0f",
            x: 6,
            y: 21
          }
        ]
      },
      {
        n: [
          "\u5973\u5B50\u5F39\u7403"
        ],
        u: {
          u: "26f9-fe0f-200d-2640-fe0f",
          x: 7,
          y: 21
        },
        v: [
          {
            u: "26f9-1f3fb-200d-2640-fe0f",
            x: 8,
            y: 21
          },
          {
            u: "26f9-1f3fc-200d-2640-fe0f",
            x: 9,
            y: 21
          },
          {
            u: "26f9-1f3fd-200d-2640-fe0f",
            x: 10,
            y: 21
          },
          {
            u: "26f9-1f3fe-200d-2640-fe0f",
            x: 11,
            y: 21
          },
          {
            u: "26f9-1f3ff-200d-2640-fe0f",
            x: 12,
            y: 21
          }
        ]
      },
      {
        n: [
          "\u4E3E\u91CD\u8FD0\u52A8\u5458"
        ],
        u: {
          u: "1f3cb",
          x: 13,
          y: 21
        },
        v: [
          {
            u: "1f3cb-1f3fb",
            x: 14,
            y: 21
          },
          {
            u: "1f3cb-1f3fc",
            x: 15,
            y: 21
          },
          {
            u: "1f3cb-1f3fd",
            x: 16,
            y: 21
          },
          {
            u: "1f3cb-1f3fe",
            x: 17,
            y: 21
          },
          {
            u: "1f3cb-1f3ff",
            x: 18,
            y: 21
          }
        ]
      },
      {
        n: [
          "\u7537\u5B50\u4E3E\u91CD"
        ],
        u: {
          u: "1f3cb-fe0f-200d-2642-fe0f",
          x: 19,
          y: 21
        },
        v: [
          {
            u: "1f3cb-1f3fb-200d-2642-fe0f",
            x: 20,
            y: 21
          },
          {
            u: "1f3cb-1f3fc-200d-2642-fe0f",
            x: 21,
            y: 21
          },
          {
            u: "1f3cb-1f3fd-200d-2642-fe0f",
            x: 22,
            y: 21
          },
          {
            u: "1f3cb-1f3fe-200d-2642-fe0f",
            x: 23,
            y: 21
          },
          {
            u: "1f3cb-1f3ff-200d-2642-fe0f",
            x: 24,
            y: 21
          }
        ]
      },
      {
        n: [
          "\u5973\u5B50\u4E3E\u91CD"
        ],
        u: {
          u: "1f3cb-fe0f-200d-2640-fe0f",
          x: 25,
          y: 21
        },
        v: [
          {
            u: "1f3cb-1f3fb-200d-2640-fe0f",
            x: 26,
            y: 21
          },
          {
            u: "1f3cb-1f3fc-200d-2640-fe0f",
            x: 27,
            y: 21
          },
          {
            u: "1f3cb-1f3fd-200d-2640-fe0f",
            x: 28,
            y: 21
          },
          {
            u: "1f3cb-1f3fe-200d-2640-fe0f",
            x: 29,
            y: 21
          },
          {
            u: "1f3cb-1f3ff-200d-2640-fe0f",
            x: 30,
            y: 21
          }
        ]
      },
      {
        n: [
          "\u9A91\u81EA\u884C\u8F66\u7684"
        ],
        u: {
          u: "1f6b4",
          x: 31,
          y: 21
        },
        v: [
          {
            u: "1f6b4-1f3fb",
            x: 32,
            y: 21
          },
          {
            u: "1f6b4-1f3fc",
            x: 33,
            y: 21
          },
          {
            u: "1f6b4-1f3fd",
            x: 34,
            y: 21
          },
          {
            u: "1f6b4-1f3fe",
            x: 35,
            y: 21
          },
          {
            u: "1f6b4-1f3ff",
            x: 36,
            y: 21
          }
        ]
      },
      {
        n: [
          "\u7537\u5B50\u81EA\u884C\u8F66\u8FD0\u52A8"
        ],
        u: {
          u: "1f6b4-200d-2642-fe0f",
          x: 37,
          y: 21
        },
        v: [
          {
            u: "1f6b4-1f3fb-200d-2642-fe0f",
            x: 38,
            y: 21
          },
          {
            u: "1f6b4-1f3fc-200d-2642-fe0f",
            x: 39,
            y: 21
          },
          {
            u: "1f6b4-1f3fd-200d-2642-fe0f",
            x: 40,
            y: 21
          },
          {
            u: "1f6b4-1f3fe-200d-2642-fe0f",
            x: 41,
            y: 21
          },
          {
            u: "1f6b4-1f3ff-200d-2642-fe0f",
            x: 42,
            y: 21
          }
        ]
      },
      {
        n: [
          "\u5973\u5B50\u81EA\u884C\u8F66\u8FD0\u52A8"
        ],
        u: {
          u: "1f6b4-200d-2640-fe0f",
          x: 43,
          y: 21
        },
        v: [
          {
            u: "1f6b4-1f3fb-200d-2640-fe0f",
            x: 44,
            y: 21
          },
          {
            u: "1f6b4-1f3fc-200d-2640-fe0f",
            x: 45,
            y: 21
          },
          {
            u: "1f6b4-1f3fd-200d-2640-fe0f",
            x: 46,
            y: 21
          },
          {
            u: "1f6b4-1f3fe-200d-2640-fe0f",
            x: 47,
            y: 21
          },
          {
            u: "1f6b4-1f3ff-200d-2640-fe0f",
            x: 48,
            y: 21
          }
        ]
      },
      {
        n: [
          "\u5C71\u5730\u81EA\u884C\u8F66\u624B"
        ],
        u: {
          u: "1f6b5",
          x: 49,
          y: 21
        },
        v: [
          {
            u: "1f6b5-1f3fb",
            x: 0,
            y: 22
          },
          {
            u: "1f6b5-1f3fc",
            x: 1,
            y: 22
          },
          {
            u: "1f6b5-1f3fd",
            x: 2,
            y: 22
          },
          {
            u: "1f6b5-1f3fe",
            x: 3,
            y: 22
          },
          {
            u: "1f6b5-1f3ff",
            x: 4,
            y: 22
          }
        ]
      },
      {
        n: [
          "\u7537\u5B50\u5C71\u5730\u81EA\u884C\u8F66"
        ],
        u: {
          u: "1f6b5-200d-2642-fe0f",
          x: 5,
          y: 22
        },
        v: [
          {
            u: "1f6b5-1f3fb-200d-2642-fe0f",
            x: 6,
            y: 22
          },
          {
            u: "1f6b5-1f3fc-200d-2642-fe0f",
            x: 7,
            y: 22
          },
          {
            u: "1f6b5-1f3fd-200d-2642-fe0f",
            x: 8,
            y: 22
          },
          {
            u: "1f6b5-1f3fe-200d-2642-fe0f",
            x: 9,
            y: 22
          },
          {
            u: "1f6b5-1f3ff-200d-2642-fe0f",
            x: 10,
            y: 22
          }
        ]
      },
      {
        n: [
          "\u5973\u5B50\u5C71\u5730\u81EA\u884C\u8F66"
        ],
        u: {
          u: "1f6b5-200d-2640-fe0f",
          x: 11,
          y: 22
        },
        v: [
          {
            u: "1f6b5-1f3fb-200d-2640-fe0f",
            x: 12,
            y: 22
          },
          {
            u: "1f6b5-1f3fc-200d-2640-fe0f",
            x: 13,
            y: 22
          },
          {
            u: "1f6b5-1f3fd-200d-2640-fe0f",
            x: 14,
            y: 22
          },
          {
            u: "1f6b5-1f3fe-200d-2640-fe0f",
            x: 15,
            y: 22
          },
          {
            u: "1f6b5-1f3ff-200d-2640-fe0f",
            x: 16,
            y: 22
          }
        ]
      },
      {
        n: [
          "\u8D5B\u8F66"
        ],
        u: {
          u: "1f3ce",
          x: 17,
          y: 22
        }
      },
      {
        n: [
          "\u8D5B\u8F66\u6469\u6258\u8F66"
        ],
        u: {
          u: "1f3cd",
          x: 18,
          y: 22
        }
      },
      {
        n: [
          "\u505A\u4FA7\u624B\u7FFB\u7684\u4EBA"
        ],
        u: {
          u: "1f938",
          x: 19,
          y: 22
        },
        v: [
          {
            u: "1f938-1f3fb",
            x: 20,
            y: 22
          },
          {
            u: "1f938-1f3fc",
            x: 21,
            y: 22
          },
          {
            u: "1f938-1f3fd",
            x: 22,
            y: 22
          },
          {
            u: "1f938-1f3fe",
            x: 23,
            y: 22
          },
          {
            u: "1f938-1f3ff",
            x: 24,
            y: 22
          }
        ]
      },
      {
        n: [
          "\u8F7D\u4EBA\u624B\u63A8\u8F66"
        ],
        u: {
          u: "1f938-200d-2642-fe0f",
          x: 25,
          y: 22
        },
        v: [
          {
            u: "1f938-1f3fb-200d-2642-fe0f",
            x: 26,
            y: 22
          },
          {
            u: "1f938-1f3fc-200d-2642-fe0f",
            x: 27,
            y: 22
          },
          {
            u: "1f938-1f3fd-200d-2642-fe0f",
            x: 28,
            y: 22
          },
          {
            u: "1f938-1f3fe-200d-2642-fe0f",
            x: 29,
            y: 22
          },
          {
            u: "1f938-1f3ff-200d-2642-fe0f",
            x: 30,
            y: 22
          }
        ]
      },
      {
        n: [
          "\u5973\u5B50\u624B\u63A8\u8F66"
        ],
        u: {
          u: "1f938-200d-2640-fe0f",
          x: 31,
          y: 22
        },
        v: [
          {
            u: "1f938-1f3fb-200d-2640-fe0f",
            x: 32,
            y: 22
          },
          {
            u: "1f938-1f3fc-200d-2640-fe0f",
            x: 33,
            y: 22
          },
          {
            u: "1f938-1f3fd-200d-2640-fe0f",
            x: 34,
            y: 22
          },
          {
            u: "1f938-1f3fe-200d-2640-fe0f",
            x: 35,
            y: 22
          },
          {
            u: "1f938-1f3ff-200d-2640-fe0f",
            x: 36,
            y: 22
          }
        ]
      },
      {
        n: [
          "\u6454\u8DE4\u624B"
        ],
        u: {
          u: "1f93c",
          x: 37,
          y: 22
        }
      },
      {
        n: [
          "\u7537\u5B50\u6454\u8DE4"
        ],
        u: {
          u: "1f93c-200d-2642-fe0f",
          x: 38,
          y: 22
        }
      },
      {
        n: [
          "\u5973\u5B50\u6454\u8DE4"
        ],
        u: {
          u: "1f93c-200d-2640-fe0f",
          x: 39,
          y: 22
        }
      },
      {
        n: [
          "\u6C34\u7403"
        ],
        u: {
          u: "1f93d",
          x: 40,
          y: 22
        },
        v: [
          {
            u: "1f93d-1f3fb",
            x: 41,
            y: 22
          },
          {
            u: "1f93d-1f3fc",
            x: 42,
            y: 22
          },
          {
            u: "1f93d-1f3fd",
            x: 43,
            y: 22
          },
          {
            u: "1f93d-1f3fe",
            x: 44,
            y: 22
          },
          {
            u: "1f93d-1f3ff",
            x: 45,
            y: 22
          }
        ]
      },
      {
        n: [
          "\u7537\u5B50\u6C34\u7403"
        ],
        u: {
          u: "1f93d-200d-2642-fe0f",
          x: 46,
          y: 22
        },
        v: [
          {
            u: "1f93d-1f3fb-200d-2642-fe0f",
            x: 47,
            y: 22
          },
          {
            u: "1f93d-1f3fc-200d-2642-fe0f",
            x: 48,
            y: 22
          },
          {
            u: "1f93d-1f3fd-200d-2642-fe0f",
            x: 49,
            y: 22
          },
          {
            u: "1f93d-1f3fe-200d-2642-fe0f",
            x: 0,
            y: 23
          },
          {
            u: "1f93d-1f3ff-200d-2642-fe0f",
            x: 1,
            y: 23
          }
        ]
      },
      {
        n: [
          "\u5973\u5B50\u6C34\u7403"
        ],
        u: {
          u: "1f93d-200d-2640-fe0f",
          x: 2,
          y: 23
        },
        v: [
          {
            u: "1f93d-1f3fb-200d-2640-fe0f",
            x: 3,
            y: 23
          },
          {
            u: "1f93d-1f3fc-200d-2640-fe0f",
            x: 4,
            y: 23
          },
          {
            u: "1f93d-1f3fd-200d-2640-fe0f",
            x: 5,
            y: 23
          },
          {
            u: "1f93d-1f3fe-200d-2640-fe0f",
            x: 6,
            y: 23
          },
          {
            u: "1f93d-1f3ff-200d-2640-fe0f",
            x: 7,
            y: 23
          }
        ]
      },
      {
        n: [
          "\u624B\u7403"
        ],
        u: {
          u: "1f93e",
          x: 8,
          y: 23
        },
        v: [
          {
            u: "1f93e-1f3fb",
            x: 9,
            y: 23
          },
          {
            u: "1f93e-1f3fc",
            x: 10,
            y: 23
          },
          {
            u: "1f93e-1f3fd",
            x: 11,
            y: 23
          },
          {
            u: "1f93e-1f3fe",
            x: 12,
            y: 23
          },
          {
            u: "1f93e-1f3ff",
            x: 13,
            y: 23
          }
        ]
      },
      {
        n: [
          "\u7537\u5B50\u624B\u7403"
        ],
        u: {
          u: "1f93e-200d-2642-fe0f",
          x: 14,
          y: 23
        },
        v: [
          {
            u: "1f93e-1f3fb-200d-2642-fe0f",
            x: 15,
            y: 23
          },
          {
            u: "1f93e-1f3fc-200d-2642-fe0f",
            x: 16,
            y: 23
          },
          {
            u: "1f93e-1f3fd-200d-2642-fe0f",
            x: 17,
            y: 23
          },
          {
            u: "1f93e-1f3fe-200d-2642-fe0f",
            x: 18,
            y: 23
          },
          {
            u: "1f93e-1f3ff-200d-2642-fe0f",
            x: 19,
            y: 23
          }
        ]
      },
      {
        n: [
          "\u5973\u5B50\u624B\u7403"
        ],
        u: {
          u: "1f93e-200d-2640-fe0f",
          x: 20,
          y: 23
        },
        v: [
          {
            u: "1f93e-1f3fb-200d-2640-fe0f",
            x: 21,
            y: 23
          },
          {
            u: "1f93e-1f3fc-200d-2640-fe0f",
            x: 22,
            y: 23
          },
          {
            u: "1f93e-1f3fd-200d-2640-fe0f",
            x: 23,
            y: 23
          },
          {
            u: "1f93e-1f3fe-200d-2640-fe0f",
            x: 24,
            y: 23
          },
          {
            u: "1f93e-1f3ff-200d-2640-fe0f",
            x: 25,
            y: 23
          }
        ]
      },
      {
        n: [
          "\u6742\u800D"
        ],
        u: {
          u: "1f939",
          x: 26,
          y: 23
        },
        v: [
          {
            u: "1f939-1f3fb",
            x: 27,
            y: 23
          },
          {
            u: "1f939-1f3fc",
            x: 28,
            y: 23
          },
          {
            u: "1f939-1f3fd",
            x: 29,
            y: 23
          },
          {
            u: "1f939-1f3fe",
            x: 30,
            y: 23
          },
          {
            u: "1f939-1f3ff",
            x: 31,
            y: 23
          }
        ]
      },
      {
        n: [
          "\u7537\u5B50\u6742\u800D"
        ],
        u: {
          u: "1f939-200d-2642-fe0f",
          x: 32,
          y: 23
        },
        v: [
          {
            u: "1f939-1f3fb-200d-2642-fe0f",
            x: 33,
            y: 23
          },
          {
            u: "1f939-1f3fc-200d-2642-fe0f",
            x: 34,
            y: 23
          },
          {
            u: "1f939-1f3fd-200d-2642-fe0f",
            x: 35,
            y: 23
          },
          {
            u: "1f939-1f3fe-200d-2642-fe0f",
            x: 36,
            y: 23
          },
          {
            u: "1f939-1f3ff-200d-2642-fe0f",
            x: 37,
            y: 23
          }
        ]
      },
      {
        n: [
          "\u5973\u5B50\u6742\u800D"
        ],
        u: {
          u: "1f939-200d-2640-fe0f",
          x: 38,
          y: 23
        },
        v: [
          {
            u: "1f939-1f3fb-200d-2640-fe0f",
            x: 39,
            y: 23
          },
          {
            u: "1f939-1f3fc-200d-2640-fe0f",
            x: 40,
            y: 23
          },
          {
            u: "1f939-1f3fd-200d-2640-fe0f",
            x: 41,
            y: 23
          },
          {
            u: "1f939-1f3fe-200d-2640-fe0f",
            x: 42,
            y: 23
          },
          {
            u: "1f939-1f3ff-200d-2640-fe0f",
            x: 43,
            y: 23
          }
        ]
      },
      {
        n: [
          "\u7537\u4EBA\u548C\u5973\u4EBA\u624B\u7275\u624B",
          "\u592B\u5987"
        ],
        u: {
          u: "1f46b",
          x: 44,
          y: 23
        }
      },
      {
        n: [
          "\u4E24\u4E2A\u7537\u4EBA\u624B\u62C9\u624B"
        ],
        u: {
          u: "1f46c",
          x: 45,
          y: 23
        }
      },
      {
        n: [
          "\u4E24\u4E2A\u5973\u4EBA\u624B\u62C9\u624B"
        ],
        u: {
          u: "1f46d",
          x: 46,
          y: 23
        }
      },
      {
        n: [
          "\u543B",
          "\u8F66\u94A9\u543B"
        ],
        u: {
          u: "1f48f",
          x: 47,
          y: 23
        }
      },
      {
        n: [
          "\u5973\u4EBA\u4EB2\u543B\u7537\u4EBA"
        ],
        u: {
          u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
          x: 48,
          y: 23
        }
      },
      {
        n: [
          "\u7537\u4EBA\u4EB2\u543B\u7537\u4EBA"
        ],
        u: {
          u: "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
          x: 49,
          y: 23
        }
      },
      {
        n: [
          "\u5973\u4EBA\u4EB2\u543B\u5973\u4EBA"
        ],
        u: {
          u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
          x: 0,
          y: 24
        }
      },
      {
        n: [
          "\u6709\u7231\u5FC3\u7684\u4F34\u4FA3"
        ],
        u: {
          u: "1f491",
          x: 1,
          y: 24
        }
      },
      {
        n: [
          "\u5973\u4EBA\u5FC3\u7537\u4EBA"
        ],
        u: {
          u: "1f469-200d-2764-fe0f-200d-1f468",
          x: 2,
          y: 24
        }
      },
      {
        n: [
          "\u7537\u4EBA\u5FC3\u7537\u4EBA"
        ],
        u: {
          u: "1f468-200d-2764-fe0f-200d-1f468",
          x: 3,
          y: 24
        }
      },
      {
        n: [
          "\u5973\u4EBA\u5FC3\u5973\u4EBA"
        ],
        u: {
          u: "1f469-200d-2764-fe0f-200d-1f469",
          x: 4,
          y: 24
        }
      },
      {
        n: [
          "\u5BB6\u5EAD",
          "\u7537\u4EBA\u5973\u4EBA\u7537\u5B69"
        ],
        u: {
          u: "1f46a",
          x: 5,
          y: 24
        }
      },
      {
        n: [
          "\u7537\u4EBA\u5973\u4EBA\u7537\u5B69",
          "\u5BB6\u5EAD"
        ],
        u: {
          u: "1f468-200d-1f469-200d-1f466",
          x: 6,
          y: 24
        }
      },
      {
        n: [
          "\u7537\u7537\u5973\u5973"
        ],
        u: {
          u: "1f468-200d-1f469-200d-1f467",
          x: 7,
          y: 24
        }
      },
      {
        n: [
          "\u7537\u4EBA\u5973\u4EBA\u5973\u5B69\u7537\u5B69"
        ],
        u: {
          u: "1f468-200d-1f469-200d-1f467-200d-1f466",
          x: 8,
          y: 24
        }
      },
      {
        n: [
          "\u7537\u5973\u8001\u5C11"
        ],
        u: {
          u: "1f468-200d-1f469-200d-1f466-200d-1f466",
          x: 9,
          y: 24
        }
      },
      {
        n: [
          "\u7537\u4EBA\u5973\u4EBA\u5973\u5B69"
        ],
        u: {
          u: "1f468-200d-1f469-200d-1f467-200d-1f467",
          x: 10,
          y: 24
        }
      },
      {
        n: [
          "\u7537\u4EBA\u7537\u4EBA\u7537\u5B69"
        ],
        u: {
          u: "1f468-200d-1f468-200d-1f466",
          x: 11,
          y: 24
        }
      },
      {
        n: [
          "\u7537\u7537\u5973"
        ],
        u: {
          u: "1f468-200d-1f468-200d-1f467",
          x: 12,
          y: 24
        }
      },
      {
        n: [
          "\u7537\u7537\u5973\u7537"
        ],
        u: {
          u: "1f468-200d-1f468-200d-1f467-200d-1f466",
          x: 13,
          y: 24
        }
      },
      {
        n: [
          "\u7537\u4EBA\u7537\u4EBA\u7537\u5B69\u7537\u5B69"
        ],
        u: {
          u: "1f468-200d-1f468-200d-1f466-200d-1f466",
          x: 14,
          y: 24
        }
      },
      {
        n: [
          "\u7537\u7537\u5973\u5973"
        ],
        u: {
          u: "1f468-200d-1f468-200d-1f467-200d-1f467",
          x: 15,
          y: 24
        }
      },
      {
        n: [
          "\u5973\u4EBA\u5973\u4EBA\u7537\u5B69"
        ],
        u: {
          u: "1f469-200d-1f469-200d-1f466",
          x: 16,
          y: 24
        }
      },
      {
        n: [
          "\u5973\u4EBA\u5973\u4EBA\u5973\u5B69"
        ],
        u: {
          u: "1f469-200d-1f469-200d-1f467",
          x: 17,
          y: 24
        }
      },
      {
        n: [
          "\u5973\u5973\u5973\u7537"
        ],
        u: {
          u: "1f469-200d-1f469-200d-1f467-200d-1f466",
          x: 18,
          y: 24
        }
      },
      {
        n: [
          "\u5973\u7537\u5973\u7537"
        ],
        u: {
          u: "1f469-200d-1f469-200d-1f466-200d-1f466",
          x: 19,
          y: 24
        }
      },
      {
        n: [
          "\u5973\u4EBA\u5973\u4EBA\u5973\u5B69\u5973\u5B69"
        ],
        u: {
          u: "1f469-200d-1f469-200d-1f467-200d-1f467",
          x: 20,
          y: 24
        }
      },
      {
        n: [
          "\u7537\u7537\u5B69"
        ],
        u: {
          u: "1f468-200d-1f466",
          x: 21,
          y: 24
        }
      },
      {
        n: [
          "\u7537\u4EBA\u7537\u5B69\u7537\u5B69"
        ],
        u: {
          u: "1f468-200d-1f466-200d-1f466",
          x: 22,
          y: 24
        }
      },
      {
        n: [
          "\u7537\u5973\u5B69"
        ],
        u: {
          u: "1f468-200d-1f467",
          x: 23,
          y: 24
        }
      },
      {
        n: [
          "\u7537\u5973\u5B69\u7537"
        ],
        u: {
          u: "1f468-200d-1f467-200d-1f466",
          x: 24,
          y: 24
        }
      },
      {
        n: [
          "\u7537\u5973\u5B69\u5973"
        ],
        u: {
          u: "1f468-200d-1f467-200d-1f467",
          x: 25,
          y: 24
        }
      },
      {
        n: [
          "\u5973\u7537\u5B69"
        ],
        u: {
          u: "1f469-200d-1f466",
          x: 26,
          y: 24
        }
      },
      {
        n: [
          "\u7537\u7537\u5973\u5973"
        ],
        u: {
          u: "1f469-200d-1f466-200d-1f466",
          x: 27,
          y: 24
        }
      },
      {
        n: [
          "\u5973\u5973\u5B69"
        ],
        u: {
          u: "1f469-200d-1f467",
          x: 28,
          y: 24
        }
      },
      {
        n: [
          "\u5973\u5973\u5B69\u7537\u5B69"
        ],
        u: {
          u: "1f469-200d-1f467-200d-1f466",
          x: 29,
          y: 24
        }
      },
      {
        n: [
          "\u5973\u5973\u5B69\u5973\u5B69"
        ],
        u: {
          u: "1f469-200d-1f467-200d-1f467",
          x: 30,
          y: 24
        }
      },
      {
        n: [
          "\u81EA\u62CD"
        ],
        u: {
          u: "1f933",
          x: 31,
          y: 24
        },
        v: [
          {
            u: "1f933-1f3fb",
            x: 32,
            y: 24
          },
          {
            u: "1f933-1f3fc",
            x: 33,
            y: 24
          },
          {
            u: "1f933-1f3fd",
            x: 34,
            y: 24
          },
          {
            u: "1f933-1f3fe",
            x: 35,
            y: 24
          },
          {
            u: "1f933-1f3ff",
            x: 36,
            y: 24
          }
        ]
      },
      {
        n: [
          "\u5F2F\u66F2\u7684\u4E8C\u5934\u808C",
          "\u808C\u8089"
        ],
        u: {
          u: "1f4aa",
          x: 37,
          y: 24
        },
        v: [
          {
            u: "1f4aa-1f3fb",
            x: 38,
            y: 24
          },
          {
            u: "1f4aa-1f3fc",
            x: 39,
            y: 24
          },
          {
            u: "1f4aa-1f3fd",
            x: 40,
            y: 24
          },
          {
            u: "1f4aa-1f3fe",
            x: 41,
            y: 24
          },
          {
            u: "1f4aa-1f3ff",
            x: 42,
            y: 24
          }
        ]
      },
      {
        n: [
          "\u767D\u8272\u5DE6\u6307\u53CD\u624B\u6307\u6570",
          "\u5411\u5DE6\u70B9"
        ],
        u: {
          u: "1f448",
          x: 43,
          y: 24
        },
        v: [
          {
            u: "1f448-1f3fb",
            x: 44,
            y: 24
          },
          {
            u: "1f448-1f3fc",
            x: 45,
            y: 24
          },
          {
            u: "1f448-1f3fd",
            x: 46,
            y: 24
          },
          {
            u: "1f448-1f3fe",
            x: 47,
            y: 24
          },
          {
            u: "1f448-1f3ff",
            x: 48,
            y: 24
          }
        ]
      },
      {
        n: [
          "\u767D\u8272\u53F3\u6307\u53CD\u624B\u6307\u6570",
          "\u6307\u5411\u53F3\u4FA7"
        ],
        u: {
          u: "1f449",
          x: 49,
          y: 24
        },
        v: [
          {
            u: "1f449-1f3fb",
            x: 0,
            y: 25
          },
          {
            u: "1f449-1f3fc",
            x: 1,
            y: 25
          },
          {
            u: "1f449-1f3fd",
            x: 2,
            y: 25
          },
          {
            u: "1f449-1f3fe",
            x: 3,
            y: 25
          },
          {
            u: "1f449-1f3ff",
            x: 4,
            y: 25
          }
        ]
      },
      {
        n: [
          "\u767D\u8272\u6307\u5411\u7D22\u5F15",
          "\u6307\u51FA"
        ],
        u: {
          u: "261d",
          x: 5,
          y: 25
        },
        v: [
          {
            u: "261d-1f3fb",
            x: 6,
            y: 25
          },
          {
            u: "261d-1f3fc",
            x: 7,
            y: 25
          },
          {
            u: "261d-1f3fd",
            x: 8,
            y: 25
          },
          {
            u: "261d-1f3fe",
            x: 9,
            y: 25
          },
          {
            u: "261d-1f3ff",
            x: 10,
            y: 25
          }
        ]
      },
      {
        n: [
          "\u767D\u8272\u6307\u5411\u53CD\u624B\u7D22\u5F15",
          "\u6307\u5411\u4E0A2"
        ],
        u: {
          u: "1f446",
          x: 11,
          y: 25
        },
        v: [
          {
            u: "1f446-1f3fb",
            x: 12,
            y: 25
          },
          {
            u: "1f446-1f3fc",
            x: 13,
            y: 25
          },
          {
            u: "1f446-1f3fd",
            x: 14,
            y: 25
          },
          {
            u: "1f446-1f3fe",
            x: 15,
            y: 25
          },
          {
            u: "1f446-1f3ff",
            x: 16,
            y: 25
          }
        ]
      },
      {
        n: [
          "\u53CD\u624B\u4F38\u51FA\u4E2D\u6307",
          "\u4E2D\u6307"
        ],
        u: {
          u: "1f595",
          x: 17,
          y: 25
        },
        v: [
          {
            u: "1f595-1f3fb",
            x: 18,
            y: 25
          },
          {
            u: "1f595-1f3fc",
            x: 19,
            y: 25
          },
          {
            u: "1f595-1f3fd",
            x: 20,
            y: 25
          },
          {
            u: "1f595-1f3fe",
            x: 21,
            y: 25
          },
          {
            u: "1f595-1f3ff",
            x: 22,
            y: 25
          }
        ]
      },
      {
        n: [
          "\u767D\u8272\u4E0B\u6307\u53CD\u624B\u6307\u6570",
          "\u5411\u4E0B\u6307"
        ],
        u: {
          u: "1f447",
          x: 23,
          y: 25
        },
        v: [
          {
            u: "1f447-1f3fb",
            x: 24,
            y: 25
          },
          {
            u: "1f447-1f3fc",
            x: 25,
            y: 25
          },
          {
            u: "1f447-1f3fd",
            x: 26,
            y: 25
          },
          {
            u: "1f447-1f3fe",
            x: 27,
            y: 25
          },
          {
            u: "1f447-1f3ff",
            x: 28,
            y: 25
          }
        ]
      },
      {
        n: [
          "\u80DC\u5229\u4E4B\u624B",
          "\u4E94\u3001"
        ],
        u: {
          u: "270c",
          x: 29,
          y: 25
        },
        v: [
          {
            u: "270c-1f3fb",
            x: 30,
            y: 25
          },
          {
            u: "270c-1f3fc",
            x: 31,
            y: 25
          },
          {
            u: "270c-1f3fd",
            x: 32,
            y: 25
          },
          {
            u: "270c-1f3fe",
            x: 33,
            y: 25
          },
          {
            u: "270c-1f3ff",
            x: 34,
            y: 25
          }
        ]
      },
      {
        n: [
          "\u98DF\u6307\u548C\u4E2D\u6307\u4EA4\u53C9\u7684\u624B",
          "\u5341\u6307\u4EA4\u53C9"
        ],
        u: {
          u: "1f91e",
          x: 35,
          y: 25
        },
        v: [
          {
            u: "1f91e-1f3fb",
            x: 36,
            y: 25
          },
          {
            u: "1f91e-1f3fc",
            x: 37,
            y: 25
          },
          {
            u: "1f91e-1f3fd",
            x: 38,
            y: 25
          },
          {
            u: "1f91e-1f3fe",
            x: 39,
            y: 25
          },
          {
            u: "1f91e-1f3ff",
            x: 40,
            y: 25
          }
        ]
      },
      {
        n: [
          "\u4E3E\u8D77\u7684\u624B\uFF0C\u90E8\u5206\u4F4D\u4E8E\u4E2D\u6307\u548C\u65E0\u540D\u6307\u4E4B\u95F4",
          "\u65AF\u6CE2\u514B\u624B"
        ],
        u: {
          u: "1f596",
          x: 41,
          y: 25
        },
        v: [
          {
            u: "1f596-1f3fb",
            x: 42,
            y: 25
          },
          {
            u: "1f596-1f3fc",
            x: 43,
            y: 25
          },
          {
            u: "1f596-1f3fd",
            x: 44,
            y: 25
          },
          {
            u: "1f596-1f3fe",
            x: 45,
            y: 25
          },
          {
            u: "1f596-1f3ff",
            x: 46,
            y: 25
          }
        ]
      },
      {
        n: [
          "\u5587\u53ED\u7684\u6807\u5FD7",
          "\u5587\u53ED"
        ],
        u: {
          u: "1f918",
          x: 47,
          y: 25
        },
        v: [
          {
            u: "1f918-1f3fb",
            x: 48,
            y: 25
          },
          {
            u: "1f918-1f3fc",
            x: 49,
            y: 25
          },
          {
            u: "1f918-1f3fd",
            x: 0,
            y: 26
          },
          {
            u: "1f918-1f3fe",
            x: 1,
            y: 26
          },
          {
            u: "1f918-1f3ff",
            x: 2,
            y: 26
          }
        ]
      },
      {
        n: [
          "\u53EB\u6211\u5E2E\u624B"
        ],
        u: {
          u: "1f919",
          x: 3,
          y: 26
        },
        v: [
          {
            u: "1f919-1f3fb",
            x: 4,
            y: 26
          },
          {
            u: "1f919-1f3fc",
            x: 5,
            y: 26
          },
          {
            u: "1f919-1f3fd",
            x: 6,
            y: 26
          },
          {
            u: "1f919-1f3fe",
            x: 7,
            y: 26
          },
          {
            u: "1f919-1f3ff",
            x: 8,
            y: 26
          }
        ]
      },
      {
        n: [
          "\u5F20\u5F00\u624B\u6307\u4E3E\u8D77\u624B"
        ],
        u: {
          u: "1f590",
          x: 9,
          y: 26
        },
        v: [
          {
            u: "1f590-1f3fb",
            x: 10,
            y: 26
          },
          {
            u: "1f590-1f3fc",
            x: 11,
            y: 26
          },
          {
            u: "1f590-1f3fd",
            x: 12,
            y: 26
          },
          {
            u: "1f590-1f3fe",
            x: 13,
            y: 26
          },
          {
            u: "1f590-1f3ff",
            x: 14,
            y: 26
          }
        ]
      },
      {
        n: [
          "\u4E3E\u8D77\u624B\u6765",
          "\u624B"
        ],
        u: {
          u: "270b",
          x: 15,
          y: 26
        },
        v: [
          {
            u: "270b-1f3fb",
            x: 16,
            y: 26
          },
          {
            u: "270b-1f3fc",
            x: 17,
            y: 26
          },
          {
            u: "270b-1f3fd",
            x: 18,
            y: 26
          },
          {
            u: "270b-1f3fe",
            x: 19,
            y: 26
          },
          {
            u: "270b-1f3ff",
            x: 20,
            y: 26
          }
        ]
      },
      {
        n: [
          "ok\u624B\u52BF",
          "\u597D\u7684\u624B"
        ],
        u: {
          u: "1f44c",
          x: 21,
          y: 26
        },
        v: [
          {
            u: "1f44c-1f3fb",
            x: 22,
            y: 26
          },
          {
            u: "1f44c-1f3fc",
            x: 23,
            y: 26
          },
          {
            u: "1f44c-1f3fd",
            x: 24,
            y: 26
          },
          {
            u: "1f44c-1f3fe",
            x: 25,
            y: 26
          },
          {
            u: "1f44c-1f3ff",
            x: 26,
            y: 26
          }
        ]
      },
      {
        n: [
          "\u7AD6\u8D77\u5927\u62C7\u6307",
          "\u62C7\u6307\u652F\u6491"
        ],
        u: {
          u: "1f44d",
          x: 27,
          y: 26
        },
        v: [
          {
            u: "1f44d-1f3fb",
            x: 28,
            y: 26
          },
          {
            u: "1f44d-1f3fc",
            x: 29,
            y: 26
          },
          {
            u: "1f44d-1f3fd",
            x: 30,
            y: 26
          },
          {
            u: "1f44d-1f3fe",
            x: 31,
            y: 26
          },
          {
            u: "1f44d-1f3ff",
            x: 32,
            y: 26
          }
        ]
      },
      {
        n: [
          "\u62C7\u6307\u671D\u4E0B\u6807\u5FD7",
          "1.",
          "\u62C7\u6307\u5411\u4E0B"
        ],
        u: {
          u: "1f44e",
          x: 33,
          y: 26
        },
        v: [
          {
            u: "1f44e-1f3fb",
            x: 34,
            y: 26
          },
          {
            u: "1f44e-1f3fc",
            x: 35,
            y: 26
          },
          {
            u: "1f44e-1f3fd",
            x: 36,
            y: 26
          },
          {
            u: "1f44e-1f3fe",
            x: 37,
            y: 26
          },
          {
            u: "1f44e-1f3ff",
            x: 38,
            y: 26
          }
        ]
      },
      {
        n: [
          "\u4E3E\u8D77\u62F3\u5934",
          "\u62F3"
        ],
        u: {
          u: "270a",
          x: 39,
          y: 26
        },
        v: [
          {
            u: "270a-1f3fb",
            x: 40,
            y: 26
          },
          {
            u: "270a-1f3fc",
            x: 41,
            y: 26
          },
          {
            u: "270a-1f3fd",
            x: 42,
            y: 26
          },
          {
            u: "270a-1f3fe",
            x: 43,
            y: 26
          },
          {
            u: "270a-1f3ff",
            x: 44,
            y: 26
          }
        ]
      },
      {
        n: [
          "\u62F3\u5934\u624B\u52BF",
          "facepunch\u516C\u53F8",
          "\u7528\u62F3\u731B\u51FB"
        ],
        u: {
          u: "1f44a",
          x: 45,
          y: 26
        },
        v: [
          {
            u: "1f44a-1f3fb",
            x: 46,
            y: 26
          },
          {
            u: "1f44a-1f3fc",
            x: 47,
            y: 26
          },
          {
            u: "1f44a-1f3fd",
            x: 48,
            y: 26
          },
          {
            u: "1f44a-1f3fe",
            x: 49,
            y: 26
          },
          {
            u: "1f44a-1f3ff",
            x: 0,
            y: 27
          }
        ]
      },
      {
        n: [
          "\u5DE6\u5411\u62F3"
        ],
        u: {
          u: "1f91b",
          x: 1,
          y: 27
        },
        v: [
          {
            u: "1f91b-1f3fb",
            x: 2,
            y: 27
          },
          {
            u: "1f91b-1f3fc",
            x: 3,
            y: 27
          },
          {
            u: "1f91b-1f3fd",
            x: 4,
            y: 27
          },
          {
            u: "1f91b-1f3fe",
            x: 5,
            y: 27
          },
          {
            u: "1f91b-1f3ff",
            x: 6,
            y: 27
          }
        ]
      },
      {
        n: [
          "\u53F3\u5411\u62F3"
        ],
        u: {
          u: "1f91c",
          x: 7,
          y: 27
        },
        v: [
          {
            u: "1f91c-1f3fb",
            x: 8,
            y: 27
          },
          {
            u: "1f91c-1f3fc",
            x: 9,
            y: 27
          },
          {
            u: "1f91c-1f3fd",
            x: 10,
            y: 27
          },
          {
            u: "1f91c-1f3fe",
            x: 11,
            y: 27
          },
          {
            u: "1f91c-1f3ff",
            x: 12,
            y: 27
          }
        ]
      },
      {
        n: [
          "\u62AC\u8D77\u624B\u80CC"
        ],
        u: {
          u: "1f91a",
          x: 13,
          y: 27
        },
        v: [
          {
            u: "1f91a-1f3fb",
            x: 14,
            y: 27
          },
          {
            u: "1f91a-1f3fc",
            x: 15,
            y: 27
          },
          {
            u: "1f91a-1f3fd",
            x: 16,
            y: 27
          },
          {
            u: "1f91a-1f3fe",
            x: 17,
            y: 27
          },
          {
            u: "1f91a-1f3ff",
            x: 18,
            y: 27
          }
        ]
      },
      {
        n: [
          "\u6325\u624B\u6807\u5FD7",
          "\u6CE2\u52A8"
        ],
        u: {
          u: "1f44b",
          x: 19,
          y: 27
        },
        v: [
          {
            u: "1f44b-1f3fb",
            x: 20,
            y: 27
          },
          {
            u: "1f44b-1f3fc",
            x: 21,
            y: 27
          },
          {
            u: "1f44b-1f3fd",
            x: 22,
            y: 27
          },
          {
            u: "1f44b-1f3fe",
            x: 23,
            y: 27
          },
          {
            u: "1f44b-1f3ff",
            x: 24,
            y: 27
          }
        ]
      },
      {
        n: [
          "\u6211\u7231\u4F60\u624B\u7B7E"
        ],
        u: {
          u: "1f91f",
          x: 25,
          y: 27
        },
        v: [
          {
            u: "1f91f-1f3fb",
            x: 26,
            y: 27
          },
          {
            u: "1f91f-1f3fc",
            x: 27,
            y: 27
          },
          {
            u: "1f91f-1f3fd",
            x: 28,
            y: 27
          },
          {
            u: "1f91f-1f3fe",
            x: 29,
            y: 27
          },
          {
            u: "1f91f-1f3ff",
            x: 30,
            y: 27
          }
        ]
      },
      {
        n: [
          "\u4E66\u5199\u7528\u624B"
        ],
        u: {
          u: "270d",
          x: 31,
          y: 27
        },
        v: [
          {
            u: "270d-1f3fb",
            x: 32,
            y: 27
          },
          {
            u: "270d-1f3fc",
            x: 33,
            y: 27
          },
          {
            u: "270d-1f3fd",
            x: 34,
            y: 27
          },
          {
            u: "270d-1f3fe",
            x: 35,
            y: 27
          },
          {
            u: "270d-1f3ff",
            x: 36,
            y: 27
          }
        ]
      },
      {
        n: [
          "\u9F13\u638C\u624B\u52BF",
          "\u9F13\u638C"
        ],
        u: {
          u: "1f44f",
          x: 37,
          y: 27
        },
        v: [
          {
            u: "1f44f-1f3fb",
            x: 38,
            y: 27
          },
          {
            u: "1f44f-1f3fc",
            x: 39,
            y: 27
          },
          {
            u: "1f44f-1f3fd",
            x: 40,
            y: 27
          },
          {
            u: "1f44f-1f3fe",
            x: 41,
            y: 27
          },
          {
            u: "1f44f-1f3ff",
            x: 42,
            y: 27
          }
        ]
      },
      {
        n: [
          "\u5F20\u5F00\u53CC\u624B\u6807\u5FD7",
          "\u5F20\u5F00\u53CC\u624B"
        ],
        u: {
          u: "1f450",
          x: 43,
          y: 27
        },
        v: [
          {
            u: "1f450-1f3fb",
            x: 44,
            y: 27
          },
          {
            u: "1f450-1f3fc",
            x: 45,
            y: 27
          },
          {
            u: "1f450-1f3fd",
            x: 46,
            y: 27
          },
          {
            u: "1f450-1f3fe",
            x: 47,
            y: 27
          },
          {
            u: "1f450-1f3ff",
            x: 48,
            y: 27
          }
        ]
      },
      {
        n: [
          "\u4E3E\u53CC\u624B\u5E86\u795D\u7684\u4EBA",
          "\u4E3E\u624B"
        ],
        u: {
          u: "1f64c",
          x: 49,
          y: 27
        },
        v: [
          {
            u: "1f64c-1f3fb",
            x: 0,
            y: 28
          },
          {
            u: "1f64c-1f3fc",
            x: 1,
            y: 28
          },
          {
            u: "1f64c-1f3fd",
            x: 2,
            y: 28
          },
          {
            u: "1f64c-1f3fe",
            x: 3,
            y: 28
          },
          {
            u: "1f64c-1f3ff",
            x: 4,
            y: 28
          }
        ]
      },
      {
        n: [
          "\u53CC\u624B\u5408\u5341"
        ],
        u: {
          u: "1f932",
          x: 5,
          y: 28
        },
        v: [
          {
            u: "1f932-1f3fb",
            x: 6,
            y: 28
          },
          {
            u: "1f932-1f3fc",
            x: 7,
            y: 28
          },
          {
            u: "1f932-1f3fd",
            x: 8,
            y: 28
          },
          {
            u: "1f932-1f3fe",
            x: 9,
            y: 28
          },
          {
            u: "1f932-1f3ff",
            x: 10,
            y: 28
          }
        ]
      },
      {
        n: [
          "\u53CC\u624B\u4EA4\u53C9\u7684\u4EBA",
          "\u7948\u7977"
        ],
        u: {
          u: "1f64f",
          x: 11,
          y: 28
        },
        v: [
          {
            u: "1f64f-1f3fb",
            x: 12,
            y: 28
          },
          {
            u: "1f64f-1f3fc",
            x: 13,
            y: 28
          },
          {
            u: "1f64f-1f3fd",
            x: 14,
            y: 28
          },
          {
            u: "1f64f-1f3fe",
            x: 15,
            y: 28
          },
          {
            u: "1f64f-1f3ff",
            x: 16,
            y: 28
          }
        ]
      },
      {
        n: [
          "\u63E1\u624B"
        ],
        u: {
          u: "1f91d",
          x: 17,
          y: 28
        }
      },
      {
        n: [
          "\u6307\u7532\u6CB9",
          "\u6307\u7532\u62A4\u7406"
        ],
        u: {
          u: "1f485",
          x: 18,
          y: 28
        },
        v: [
          {
            u: "1f485-1f3fb",
            x: 19,
            y: 28
          },
          {
            u: "1f485-1f3fc",
            x: 20,
            y: 28
          },
          {
            u: "1f485-1f3fd",
            x: 21,
            y: 28
          },
          {
            u: "1f485-1f3fe",
            x: 22,
            y: 28
          },
          {
            u: "1f485-1f3ff",
            x: 23,
            y: 28
          }
        ]
      },
      {
        n: [
          "\u8033\u6735"
        ],
        u: {
          u: "1f442",
          x: 24,
          y: 28
        },
        v: [
          {
            u: "1f442-1f3fb",
            x: 25,
            y: 28
          },
          {
            u: "1f442-1f3fc",
            x: 26,
            y: 28
          },
          {
            u: "1f442-1f3fd",
            x: 27,
            y: 28
          },
          {
            u: "1f442-1f3fe",
            x: 28,
            y: 28
          },
          {
            u: "1f442-1f3ff",
            x: 29,
            y: 28
          }
        ]
      },
      {
        n: [
          "\u9F3B"
        ],
        u: {
          u: "1f443",
          x: 30,
          y: 28
        },
        v: [
          {
            u: "1f443-1f3fb",
            x: 31,
            y: 28
          },
          {
            u: "1f443-1f3fc",
            x: 32,
            y: 28
          },
          {
            u: "1f443-1f3fd",
            x: 33,
            y: 28
          },
          {
            u: "1f443-1f3fe",
            x: 34,
            y: 28
          },
          {
            u: "1f443-1f3ff",
            x: 35,
            y: 28
          }
        ]
      },
      {
        n: [
          "\u811A\u5370"
        ],
        u: {
          u: "1f463",
          x: 36,
          y: 28
        }
      },
      {
        n: [
          "\u773C\u775B"
        ],
        u: {
          u: "1f440",
          x: 37,
          y: 28
        }
      },
      {
        n: [
          "\u773C\u775B"
        ],
        u: {
          u: "1f441",
          x: 38,
          y: 28
        }
      },
      {
        n: [
          "\u8BED\u97F3\u6C14\u6CE1\u4E2D\u7684\u773C\u775B"
        ],
        u: {
          u: "1f441-200d-1f5e8",
          x: 39,
          y: 28
        }
      },
      {
        n: [
          "\u8111"
        ],
        u: {
          u: "1f9e0",
          x: 40,
          y: 28
        }
      },
      {
        n: [
          "\u820C\u5934"
        ],
        u: {
          u: "1f445",
          x: 41,
          y: 28
        }
      },
      {
        n: [
          "\u5634",
          "\u5634\u5507"
        ],
        u: {
          u: "1f444",
          x: 42,
          y: 28
        }
      },
      {
        n: [
          "\u543B\u75D5",
          "\u543B"
        ],
        u: {
          u: "1f48b",
          x: 43,
          y: 28
        }
      },
      {
        n: [
          "\u5E26\u7BAD\u5934\u7684\u5FC3",
          "\u4E18\u6BD4\u7279"
        ],
        u: {
          u: "1f498",
          x: 44,
          y: 28
        }
      },
      {
        n: [
          "\u6C89\u91CD\u7684\u9ED1\u5FC3",
          "\u5FC3"
        ],
        u: {
          u: "2764",
          x: 45,
          y: 28
        }
      },
      {
        n: [
          "\u8DF3\u52A8\u7684\u5FC3\u810F",
          "\u5FC3\u8DF3"
        ],
        u: {
          u: "1f493",
          x: 46,
          y: 28
        }
      },
      {
        n: [
          "\u7834\u788E\u7684\u5FC3"
        ],
        u: {
          u: "1f494",
          x: 47,
          y: 28
        }
      },
      {
        n: [
          "\u4E24\u9897\u5FC3"
        ],
        u: {
          u: "1f495",
          x: 48,
          y: 28
        }
      },
      {
        n: [
          "\u95EA\u95EA\u53D1\u5149\u7684\u5FC3"
        ],
        u: {
          u: "1f496",
          x: 49,
          y: 28
        }
      },
      {
        n: [
          "\u6210\u957F\u7684\u5FC3",
          "\u5FC3\u8DF3"
        ],
        u: {
          u: "1f497",
          x: 0,
          y: 29
        }
      },
      {
        n: [
          "\u84DD\u8272\u5FC3\u5F62"
        ],
        u: {
          u: "1f499",
          x: 1,
          y: 29
        }
      },
      {
        n: [
          "\u9752\u5FC3\u6811"
        ],
        u: {
          u: "1f49a",
          x: 2,
          y: 29
        }
      },
      {
        n: [
          "\u9EC4\u5FC3"
        ],
        u: {
          u: "1f49b",
          x: 3,
          y: 29
        }
      },
      {
        n: [
          "\u6A59\u5FC3"
        ],
        u: {
          u: "1f9e1",
          x: 4,
          y: 29
        }
      },
      {
        n: [
          "\u7D2B\u5FC3"
        ],
        u: {
          u: "1f49c",
          x: 5,
          y: 29
        }
      },
      {
        n: [
          "\u9ED1\u5FC3"
        ],
        u: {
          u: "1f5a4",
          x: 6,
          y: 29
        }
      },
      {
        n: [
          "\u5FC3\u5F62\u4E1D\u5E26",
          "\u793C\u54C1\u5FC3"
        ],
        u: {
          u: "1f49d",
          x: 7,
          y: 29
        }
      },
      {
        n: [
          "\u65CB\u8F6C\u5FC3\u810F"
        ],
        u: {
          u: "1f49e",
          x: 8,
          y: 29
        }
      },
      {
        n: [
          "\u5FC3\u5F62\u88C5\u9970"
        ],
        u: {
          u: "1f49f",
          x: 9,
          y: 29
        }
      },
      {
        n: [
          "\u6C89\u91CD\u7684\u5FC3\u611F\u53F9\u53F7\u88C5\u9970"
        ],
        u: {
          u: "2763",
          x: 10,
          y: 29
        }
      },
      {
        n: [
          "\u60C5\u4E66"
        ],
        u: {
          u: "1f48c",
          x: 11,
          y: 29
        }
      },
      {
        n: [
          "\u7761\u7720\u7B26\u53F7",
          "zzz\u516C\u53F8"
        ],
        u: {
          u: "1f4a4",
          x: 12,
          y: 29
        }
      },
      {
        n: [
          "\u6124\u6012\u7B26\u53F7",
          "\u6124\u6012"
        ],
        u: {
          u: "1f4a2",
          x: 13,
          y: 29
        }
      },
      {
        n: [
          "\u70B8\u5F39"
        ],
        u: {
          u: "1f4a3",
          x: 14,
          y: 29
        }
      },
      {
        n: [
          "\u78B0\u649E\u7B26\u53F7",
          "\u7E41\u8363",
          "\u78B0\u649E"
        ],
        u: {
          u: "1f4a5",
          x: 15,
          y: 29
        }
      },
      {
        n: [
          "\u98DE\u6E85\u7684\u6C57\u6C34\u7B26\u53F7",
          "\u6C57\u73E0"
        ],
        u: {
          u: "1f4a6",
          x: 16,
          y: 29
        }
      },
      {
        n: [
          "\u7834\u6298\u53F7\u7B26\u53F7",
          "\u731B\u51B2"
        ],
        u: {
          u: "1f4a8",
          x: 17,
          y: 29
        }
      },
      {
        n: [
          "\u7729\u6655\u7B26\u53F7",
          "\u5934\u6655\u7684"
        ],
        u: {
          u: "1f4ab",
          x: 18,
          y: 29
        }
      },
      {
        n: [
          "\u8BED\u97F3\u6C14\u7403"
        ],
        u: {
          u: "1f4ac",
          x: 19,
          y: 29
        }
      },
      {
        n: [
          "\u5DE6\u4FA7\u8BED\u97F3\u6C14\u6CE1"
        ],
        u: {
          u: "1f5e8",
          x: 20,
          y: 29
        }
      },
      {
        n: [
          "\u53F3\u6124\u6012\u6CE1\u6CE1"
        ],
        u: {
          u: "1f5ef",
          x: 21,
          y: 29
        }
      },
      {
        n: [
          "\u601D\u60F3\u6C14\u7403"
        ],
        u: {
          u: "1f4ad",
          x: 22,
          y: 29
        }
      },
      {
        n: [
          "\u6D1E"
        ],
        u: {
          u: "1f573",
          x: 23,
          y: 29
        }
      },
      {
        n: [
          "\u773C\u955C"
        ],
        u: {
          u: "1f453",
          x: 24,
          y: 29
        }
      },
      {
        n: [
          "\u6DF1\u8272\u592A\u9633\u955C"
        ],
        u: {
          u: "1f576",
          x: 25,
          y: 29
        }
      },
      {
        n: [
          "\u9886\u5E26"
        ],
        u: {
          u: "1f454",
          x: 26,
          y: 29
        }
      },
      {
        n: [
          "t\u6064\u886B",
          "\u886C\u886B",
          "T\u6064\u886B"
        ],
        u: {
          u: "1f455",
          x: 27,
          y: 29
        }
      },
      {
        n: [
          "\u725B\u4ED4\u88E4"
        ],
        u: {
          u: "1f456",
          x: 28,
          y: 29
        }
      },
      {
        n: [
          "\u56F4\u5DFE"
        ],
        u: {
          u: "1f9e3",
          x: 29,
          y: 29
        }
      },
      {
        n: [
          "\u624B\u5957"
        ],
        u: {
          u: "1f9e4",
          x: 30,
          y: 29
        }
      },
      {
        n: [
          "\u5916\u5957"
        ],
        u: {
          u: "1f9e5",
          x: 31,
          y: 29
        }
      },
      {
        n: [
          "\u889C\u5B50"
        ],
        u: {
          u: "1f9e6",
          x: 32,
          y: 29
        }
      },
      {
        n: [
          "\u8FDE\u8863\u88D9"
        ],
        u: {
          u: "1f457",
          x: 33,
          y: 29
        }
      },
      {
        n: [
          "\u548C\u670D"
        ],
        u: {
          u: "1f458",
          x: 34,
          y: 29
        }
      },
      {
        n: [
          "\u6BD4\u57FA\u5C3C"
        ],
        u: {
          u: "1f459",
          x: 35,
          y: 29
        }
      },
      {
        n: [
          "\u5973\u88C5"
        ],
        u: {
          u: "1f45a",
          x: 36,
          y: 29
        }
      },
      {
        n: [
          "\u94B1\u5305"
        ],
        u: {
          u: "1f45b",
          x: 37,
          y: 29
        }
      },
      {
        n: [
          "\u624B\u63D0\u5305"
        ],
        u: {
          u: "1f45c",
          x: 38,
          y: 29
        }
      },
      {
        n: [
          "\u5C0F\u888B"
        ],
        u: {
          u: "1f45d",
          x: 39,
          y: 29
        }
      },
      {
        n: [
          "\u8D2D\u7269\u888B"
        ],
        u: {
          u: "1f6cd",
          x: 40,
          y: 29
        }
      },
      {
        n: [
          "\u5B66\u6821\u4E66\u5305"
        ],
        u: {
          u: "1f392",
          x: 41,
          y: 29
        }
      },
      {
        n: [
          "\u7537\u5F0F\u8FD0\u52A8\u978B",
          "\u978B"
        ],
        u: {
          u: "1f45e",
          x: 42,
          y: 29
        }
      },
      {
        n: [
          "\u8FD0\u52A8\u978B"
        ],
        u: {
          u: "1f45f",
          x: 43,
          y: 29
        }
      },
      {
        n: [
          "\u9AD8\u8DDF\u978B",
          "\u9AD8\u8DDF\u978B"
        ],
        u: {
          u: "1f460",
          x: 44,
          y: 29
        }
      },
      {
        n: [
          "\u5973\u5F0F\u51C9\u978B",
          "\u51C9\u978B"
        ],
        u: {
          u: "1f461",
          x: 45,
          y: 29
        }
      },
      {
        n: [
          "\u5973\u5F0F\u9774\u5B50",
          "\u9774\u5B50"
        ],
        u: {
          u: "1f462",
          x: 46,
          y: 29
        }
      },
      {
        n: [
          "\u738B\u51A0"
        ],
        u: {
          u: "1f451",
          x: 47,
          y: 29
        }
      },
      {
        n: [
          "\u5973\u5F0F\u5E3D\u5B50"
        ],
        u: {
          u: "1f452",
          x: 48,
          y: 29
        }
      },
      {
        n: [
          "\u793C\u5E3D",
          "\u9876\u5E3D"
        ],
        u: {
          u: "1f3a9",
          x: 49,
          y: 29
        }
      },
      {
        n: [
          "\u523B\u5EA6\u76D6",
          "\u7802\u6D46\u677F"
        ],
        u: {
          u: "1f393",
          x: 0,
          y: 30
        }
      },
      {
        n: [
          "\u8BA1\u8D39\u4E0A\u9650"
        ],
        u: {
          u: "1f9e2",
          x: 1,
          y: 30
        }
      },
      {
        n: [
          "\u5E26\u767D\u8272\u5341\u5B57\u7684\u5934\u76D4"
        ],
        u: {
          u: "26d1",
          x: 2,
          y: 30
        }
      },
      {
        n: [
          "\u5FF5\u73E0"
        ],
        u: {
          u: "1f4ff",
          x: 3,
          y: 30
        }
      },
      {
        n: [
          "\u53E3\u7EA2"
        ],
        u: {
          u: "1f484",
          x: 4,
          y: 30
        }
      },
      {
        n: [
          "\u6212\u6307"
        ],
        u: {
          u: "1f48d",
          x: 5,
          y: 30
        }
      },
      {
        n: [
          "\u5B9D\u77F3",
          "\u5B9D\u77F3"
        ],
        u: {
          u: "1f48e",
          x: 6,
          y: 30
        }
      }
    ],
    u: "1f600",
    title: "\u8868\u60C5\u548C\u4EBA\u7269",
    key: "smileys_people"
  },
  {
    emojis: [
      {
        n: [
          "\u7334\u8138"
        ],
        u: {
          u: "1f435",
          x: 7,
          y: 30
        }
      },
      {
        n: [
          "\u7334\u5B50"
        ],
        u: {
          u: "1f412",
          x: 8,
          y: 30
        }
      },
      {
        n: [
          "\u5927\u7329\u7329"
        ],
        u: {
          u: "1f98d",
          x: 9,
          y: 30
        }
      },
      {
        n: [
          "\u72D7\u8138",
          "\u72D7"
        ],
        u: {
          u: "1f436",
          x: 10,
          y: 30
        }
      },
      {
        n: [
          "\u72D7",
          "\u72D72"
        ],
        u: {
          u: "1f415",
          x: 11,
          y: 30
        }
      },
      {
        n: [
          "\u8D35\u5BBE\u72AC"
        ],
        u: {
          u: "1f429",
          x: 12,
          y: 30
        }
      },
      {
        n: [
          "\u72FC\u8138",
          "\u72FC"
        ],
        u: {
          u: "1f43a",
          x: 13,
          y: 30
        }
      },
      {
        n: [
          "\u72D0\u72F8\u8138"
        ],
        u: {
          u: "1f98a",
          x: 14,
          y: 30
        }
      },
      {
        n: [
          "\u732B\u8138",
          "\u732B"
        ],
        u: {
          u: "1f431",
          x: 15,
          y: 30
        }
      },
      {
        n: [
          "\u732B",
          "cat2\u7C7B"
        ],
        u: {
          u: "1f408",
          x: 16,
          y: 30
        }
      },
      {
        n: [
          "\u72EE\u5B50\u8138"
        ],
        u: {
          u: "1f981",
          x: 17,
          y: 30
        }
      },
      {
        n: [
          "\u8001\u864E\u8138",
          "\u864E"
        ],
        u: {
          u: "1f42f",
          x: 18,
          y: 30
        }
      },
      {
        n: [
          "\u864E",
          "\u8001\u864E2"
        ],
        u: {
          u: "1f405",
          x: 19,
          y: 30
        }
      },
      {
        n: [
          "\u8C79\u5B50"
        ],
        u: {
          u: "1f406",
          x: 20,
          y: 30
        }
      },
      {
        n: [
          "\u9A6C\u8138",
          "\u9A6C"
        ],
        u: {
          u: "1f434",
          x: 21,
          y: 30
        }
      },
      {
        n: [
          "\u9A6C",
          "\u8D5B\u9A6C"
        ],
        u: {
          u: "1f40e",
          x: 22,
          y: 30
        }
      },
      {
        n: [
          "\u72EC\u89D2\u517D\u8138"
        ],
        u: {
          u: "1f984",
          x: 23,
          y: 30
        }
      },
      {
        n: [
          "\u6591\u9A6C\u8138"
        ],
        u: {
          u: "1f993",
          x: 24,
          y: 30
        }
      },
      {
        n: [
          "\u9E7F"
        ],
        u: {
          u: "1f98c",
          x: 25,
          y: 30
        }
      },
      {
        n: [
          "\u725B\u8138",
          "\u6BCD\u725B"
        ],
        u: {
          u: "1f42e",
          x: 26,
          y: 30
        }
      },
      {
        n: [
          "\u516C\u725B"
        ],
        u: {
          u: "1f402",
          x: 27,
          y: 30
        }
      },
      {
        n: [
          "\u6C34\u725B"
        ],
        u: {
          u: "1f403",
          x: 28,
          y: 30
        }
      },
      {
        n: [
          "\u6BCD\u725B",
          "cow2\u578B"
        ],
        u: {
          u: "1f404",
          x: 29,
          y: 30
        }
      },
      {
        n: [
          "\u6E05\u7BA1\u5668\u8868\u9762",
          "\u732A"
        ],
        u: {
          u: "1f437",
          x: 30,
          y: 30
        }
      },
      {
        n: [
          "\u732A",
          "pig2"
        ],
        u: {
          u: "1f416",
          x: 31,
          y: 30
        }
      },
      {
        n: [
          "\u91CE\u732A"
        ],
        u: {
          u: "1f417",
          x: 32,
          y: 30
        }
      },
      {
        n: [
          "\u732A\u9F3B\u5B50"
        ],
        u: {
          u: "1f43d",
          x: 33,
          y: 30
        }
      },
      {
        n: [
          "\u5185\u5B58"
        ],
        u: {
          u: "1f40f",
          x: 34,
          y: 30
        }
      },
      {
        n: [
          "\u7F8A"
        ],
        u: {
          u: "1f411",
          x: 35,
          y: 30
        }
      },
      {
        n: [
          "\u5C71\u7F8A"
        ],
        u: {
          u: "1f410",
          x: 36,
          y: 30
        }
      },
      {
        n: [
          "\u5355\u5CF0\u9A86\u9A7C"
        ],
        u: {
          u: "1f42a",
          x: 37,
          y: 30
        }
      },
      {
        n: [
          "\u53CC\u5CF0\u9A7C",
          "\u9A86\u9A7C"
        ],
        u: {
          u: "1f42b",
          x: 38,
          y: 30
        }
      },
      {
        n: [
          "\u957F\u9888\u9E7F\u8138"
        ],
        u: {
          u: "1f992",
          x: 39,
          y: 30
        }
      },
      {
        n: [
          "\u5927\u8C61"
        ],
        u: {
          u: "1f418",
          x: 40,
          y: 30
        }
      },
      {
        n: [
          "\u7280\u725B"
        ],
        u: {
          u: "1f98f",
          x: 41,
          y: 30
        }
      },
      {
        n: [
          "\u9F20\u6807\u9762",
          "\u8001\u9F20"
        ],
        u: {
          u: "1f42d",
          x: 42,
          y: 30
        }
      },
      {
        n: [
          "\u8001\u9F20",
          "\u9F20\u68072"
        ],
        u: {
          u: "1f401",
          x: 43,
          y: 30
        }
      },
      {
        n: [
          "\u8001\u9F20"
        ],
        u: {
          u: "1f400",
          x: 44,
          y: 30
        }
      },
      {
        n: [
          "\u4ED3\u9F20\u8138",
          "\u4ED3\u9F20"
        ],
        u: {
          u: "1f439",
          x: 45,
          y: 30
        }
      },
      {
        n: [
          "\u5154\u5B50\u8138",
          "\u5154\u5B50"
        ],
        u: {
          u: "1f430",
          x: 46,
          y: 30
        }
      },
      {
        n: [
          "\u5154\u5B50",
          "\u5154\u5B502"
        ],
        u: {
          u: "1f407",
          x: 47,
          y: 30
        }
      },
      {
        n: [
          "\u82B1\u6817\u9F20"
        ],
        u: {
          u: "1f43f",
          x: 48,
          y: 30
        }
      },
      {
        n: [
          "\u523A\u732C"
        ],
        u: {
          u: "1f994",
          x: 49,
          y: 30
        }
      },
      {
        n: [
          "\u7403\u68D2"
        ],
        u: {
          u: "1f987",
          x: 0,
          y: 31
        }
      },
      {
        n: [
          "\u718A\u8138",
          "\u718A"
        ],
        u: {
          u: "1f43b",
          x: 1,
          y: 31
        }
      },
      {
        n: [
          "\u6811\u888B\u718A"
        ],
        u: {
          u: "1f428",
          x: 2,
          y: 31
        }
      },
      {
        n: [
          "\u718A\u732B\u8138"
        ],
        u: {
          u: "1f43c",
          x: 3,
          y: 31
        }
      },
      {
        n: [
          "\u722A\u5370",
          "\u811A"
        ],
        u: {
          u: "1f43e",
          x: 4,
          y: 31
        }
      },
      {
        n: [
          "\u571F\u8033\u5176"
        ],
        u: {
          u: "1f983",
          x: 5,
          y: 31
        }
      },
      {
        n: [
          "\u9E21"
        ],
        u: {
          u: "1f414",
          x: 6,
          y: 31
        }
      },
      {
        n: [
          "\u516C\u9E21"
        ],
        u: {
          u: "1f413",
          x: 7,
          y: 31
        }
      },
      {
        n: [
          "\u5B75\u5316\u96CF\u9E21"
        ],
        u: {
          u: "1f423",
          x: 8,
          y: 31
        }
      },
      {
        n: [
          "\u5C0F\u9E21"
        ],
        u: {
          u: "1f424",
          x: 9,
          y: 31
        }
      },
      {
        n: [
          "\u6B63\u9762\u5C0F\u9E21\u5B9D\u5B9D",
          "\u5B75\u51FA\u7684\u5C0F\u9E21"
        ],
        u: {
          u: "1f425",
          x: 10,
          y: 31
        }
      },
      {
        n: [
          "\u9E1F"
        ],
        u: {
          u: "1f426",
          x: 11,
          y: 31
        }
      },
      {
        n: [
          "\u4F01\u9E45"
        ],
        u: {
          u: "1f427",
          x: 12,
          y: 31
        }
      },
      {
        n: [
          "\u548C\u5E73\u9E3D"
        ],
        u: {
          u: "1f54a",
          x: 13,
          y: 31
        }
      },
      {
        n: [
          "\u9E70"
        ],
        u: {
          u: "1f985",
          x: 14,
          y: 31
        }
      },
      {
        n: [
          "\u9E2D\u5B50"
        ],
        u: {
          u: "1f986",
          x: 15,
          y: 31
        }
      },
      {
        n: [
          "\u732B\u5934\u9E70"
        ],
        u: {
          u: "1f989",
          x: 16,
          y: 31
        }
      },
      {
        n: [
          "\u9752\u86D9\u8138",
          "\u86D9"
        ],
        u: {
          u: "1f438",
          x: 17,
          y: 31
        }
      },
      {
        n: [
          "\u9CC4\u9C7C"
        ],
        u: {
          u: "1f40a",
          x: 18,
          y: 31
        }
      },
      {
        n: [
          "\u4E4C\u9F9F"
        ],
        u: {
          u: "1f422",
          x: 19,
          y: 31
        }
      },
      {
        n: [
          "\u8725\u8734"
        ],
        u: {
          u: "1f98e",
          x: 20,
          y: 31
        }
      },
      {
        n: [
          "\u86C7"
        ],
        u: {
          u: "1f40d",
          x: 21,
          y: 31
        }
      },
      {
        n: [
          "\u9F99\u8138"
        ],
        u: {
          u: "1f432",
          x: 22,
          y: 31
        }
      },
      {
        n: [
          "\u9F99"
        ],
        u: {
          u: "1f409",
          x: 23,
          y: 31
        }
      },
      {
        n: [
          "\u8725\u811A\u7C7B"
        ],
        u: {
          u: "1f995",
          x: 24,
          y: 31
        }
      },
      {
        n: [
          "\u9738\u738B\u9F99"
        ],
        u: {
          u: "1f996",
          x: 25,
          y: 31
        }
      },
      {
        n: [
          "\u55B7\u9F3B\u9CB8",
          "\u9CB8\u9C7C"
        ],
        u: {
          u: "1f433",
          x: 26,
          y: 31
        }
      },
      {
        n: [
          "\u9CB8\u9C7C",
          "whale2\u9CB8"
        ],
        u: {
          u: "1f40b",
          x: 27,
          y: 31
        }
      },
      {
        n: [
          "\u6D77\u8C5A",
          "\u9CCD\u72B6\u80A2"
        ],
        u: {
          u: "1f42c",
          x: 28,
          y: 31
        }
      },
      {
        n: [
          "\u9C7C"
        ],
        u: {
          u: "1f41f",
          x: 29,
          y: 31
        }
      },
      {
        n: [
          "\u70ED\u5E26\u9C7C"
        ],
        u: {
          u: "1f420",
          x: 30,
          y: 31
        }
      },
      {
        n: [
          "\u6CB3\u8C5A"
        ],
        u: {
          u: "1f421",
          x: 31,
          y: 31
        }
      },
      {
        n: [
          "\u9CA8\u9C7C"
        ],
        u: {
          u: "1f988",
          x: 32,
          y: 31
        }
      },
      {
        n: [
          "\u7AE0\u9C7C"
        ],
        u: {
          u: "1f419",
          x: 33,
          y: 31
        }
      },
      {
        n: [
          "\u87BA\u65CB\u58F3\u4F53",
          "\u58F3"
        ],
        u: {
          u: "1f41a",
          x: 34,
          y: 31
        }
      },
      {
        n: [
          "\u87F9"
        ],
        u: {
          u: "1f980",
          x: 35,
          y: 31
        }
      },
      {
        n: [
          "\u867E"
        ],
        u: {
          u: "1f990",
          x: 36,
          y: 31
        }
      },
      {
        n: [
          "\u9C7F\u9C7C"
        ],
        u: {
          u: "1f991",
          x: 37,
          y: 31
        }
      },
      {
        n: [
          "\u8717\u725B"
        ],
        u: {
          u: "1f40c",
          x: 38,
          y: 31
        }
      },
      {
        n: [
          "\u8774\u8776"
        ],
        u: {
          u: "1f98b",
          x: 39,
          y: 31
        }
      },
      {
        n: [
          "\u7F3A\u9677"
        ],
        u: {
          u: "1f41b",
          x: 40,
          y: 31
        }
      },
      {
        n: [
          "\u8682\u8681"
        ],
        u: {
          u: "1f41c",
          x: 41,
          y: 31
        }
      },
      {
        n: [
          "\u871C\u8702",
          "\u871C\u8702"
        ],
        u: {
          u: "1f41d",
          x: 42,
          y: 31
        }
      },
      {
        n: [
          "\u74E2\u866B",
          "\u7532\u866B"
        ],
        u: {
          u: "1f41e",
          x: 43,
          y: 31
        }
      },
      {
        n: [
          "\u677F\u7403"
        ],
        u: {
          u: "1f997",
          x: 44,
          y: 31
        }
      },
      {
        n: [
          "\u8718\u86DB"
        ],
        u: {
          u: "1f577",
          x: 45,
          y: 31
        }
      },
      {
        n: [
          "\u8718\u86DB\u7F51"
        ],
        u: {
          u: "1f578",
          x: 46,
          y: 31
        }
      },
      {
        n: [
          "\u874E\u5B50"
        ],
        u: {
          u: "1f982",
          x: 47,
          y: 31
        }
      },
      {
        n: [
          "\u82B1\u675F"
        ],
        u: {
          u: "1f490",
          x: 48,
          y: 31
        }
      },
      {
        n: [
          "\u6A31\u82B1"
        ],
        u: {
          u: "1f338",
          x: 49,
          y: 31
        }
      },
      {
        n: [
          "\u767D\u82B1"
        ],
        u: {
          u: "1f4ae",
          x: 0,
          y: 32
        }
      },
      {
        n: [
          "\u73AB\u7470\u82B1\u7ED3"
        ],
        u: {
          u: "1f3f5",
          x: 1,
          y: 32
        }
      },
      {
        n: [
          "\u73AB\u7470"
        ],
        u: {
          u: "1f339",
          x: 2,
          y: 32
        }
      },
      {
        n: [
          "\u67AF\u840E\u7684\u82B1"
        ],
        u: {
          u: "1f940",
          x: 3,
          y: 32
        }
      },
      {
        n: [
          "\u8299\u84C9"
        ],
        u: {
          u: "1f33a",
          x: 4,
          y: 32
        }
      },
      {
        n: [
          "\u5411\u65E5\u8475"
        ],
        u: {
          u: "1f33b",
          x: 5,
          y: 32
        }
      },
      {
        n: [
          "\u5F00\u82B1"
        ],
        u: {
          u: "1f33c",
          x: 6,
          y: 32
        }
      },
      {
        n: [
          "\u90C1\u91D1\u9999"
        ],
        u: {
          u: "1f337",
          x: 7,
          y: 32
        }
      },
      {
        n: [
          "\u5E7C\u82D7"
        ],
        u: {
          u: "1f331",
          x: 8,
          y: 32
        }
      },
      {
        n: [
          "\u5E38\u7EFF\u4E54\u6728"
        ],
        u: {
          u: "1f332",
          x: 9,
          y: 32
        }
      },
      {
        n: [
          "\u843D\u53F6\u6811"
        ],
        u: {
          u: "1f333",
          x: 10,
          y: 32
        }
      },
      {
        n: [
          "\u68D5\u6988\u6811"
        ],
        u: {
          u: "1f334",
          x: 11,
          y: 32
        }
      },
      {
        n: [
          "\u4ED9\u4EBA\u638C"
        ],
        u: {
          u: "1f335",
          x: 12,
          y: 32
        }
      },
      {
        n: [
          "\u7A3B\u7A57"
        ],
        u: {
          u: "1f33e",
          x: 13,
          y: 32
        }
      },
      {
        n: [
          "\u836F\u8349"
        ],
        u: {
          u: "1f33f",
          x: 14,
          y: 32
        }
      },
      {
        n: [
          "\u4E09\u53F6\u8349"
        ],
        u: {
          u: "2618",
          x: 15,
          y: 32
        }
      },
      {
        n: [
          "\u56DB\u53F6\u4E09\u53F6\u8349"
        ],
        u: {
          u: "1f340",
          x: 16,
          y: 32
        }
      },
      {
        n: [
          "\u67AB\u53F6"
        ],
        u: {
          u: "1f341",
          x: 17,
          y: 32
        }
      },
      {
        n: [
          "\u843D\u53F6"
        ],
        u: {
          u: "1f342",
          x: 18,
          y: 32
        }
      },
      {
        n: [
          "\u6811\u53F6\u5728\u98CE\u4E2D\u98D8\u52A8",
          "\u53F6\u5B50"
        ],
        u: {
          u: "1f343",
          x: 19,
          y: 32
        }
      }
    ],
    u: "1f43b",
    title: "\u52A8\u7269\u548C\u81EA\u7136",
    key: "animals_nature"
  },
  {
    emojis: [
      {
        n: [
          "\u8461\u8404"
        ],
        u: {
          u: "1f347",
          x: 20,
          y: 32
        }
      },
      {
        n: [
          "\u751C\u74DC"
        ],
        u: {
          u: "1f348",
          x: 21,
          y: 32
        }
      },
      {
        n: [
          "\u897F\u74DC"
        ],
        u: {
          u: "1f349",
          x: 22,
          y: 32
        }
      },
      {
        n: [
          "\u6A58"
        ],
        u: {
          u: "1f34a",
          x: 23,
          y: 32
        }
      },
      {
        n: [
          "\u67E0\u6AAC"
        ],
        u: {
          u: "1f34b",
          x: 24,
          y: 32
        }
      },
      {
        n: [
          "\u9999\u8549"
        ],
        u: {
          u: "1f34c",
          x: 25,
          y: 32
        }
      },
      {
        n: [
          "\u83E0\u841D"
        ],
        u: {
          u: "1f34d",
          x: 26,
          y: 32
        }
      },
      {
        n: [
          "\u7EA2\u82F9\u679C",
          "\u82F9\u679C"
        ],
        u: {
          u: "1f34e",
          x: 27,
          y: 32
        }
      },
      {
        n: [
          "\u9752\u82F9\u679C"
        ],
        u: {
          u: "1f34f",
          x: 28,
          y: 32
        }
      },
      {
        n: [
          "\u68A8"
        ],
        u: {
          u: "1f350",
          x: 29,
          y: 32
        }
      },
      {
        n: [
          "\u6843"
        ],
        u: {
          u: "1f351",
          x: 30,
          y: 32
        }
      },
      {
        n: [
          "\u6A31\u6843"
        ],
        u: {
          u: "1f352",
          x: 31,
          y: 32
        }
      },
      {
        n: [
          "\u8349\u8393"
        ],
        u: {
          u: "1f353",
          x: 32,
          y: 32
        }
      },
      {
        n: [
          "\u7315\u7334\u6843"
        ],
        u: {
          u: "1f95d",
          x: 33,
          y: 32
        }
      },
      {
        n: [
          "\u756A\u8304"
        ],
        u: {
          u: "1f345",
          x: 34,
          y: 32
        }
      },
      {
        n: [
          "\u6930\u5B50"
        ],
        u: {
          u: "1f965",
          x: 35,
          y: 32
        }
      },
      {
        n: [
          "\u9CC4\u68A8"
        ],
        u: {
          u: "1f951",
          x: 36,
          y: 32
        }
      },
      {
        n: [
          "\u8304\u5B50",
          "\u8304\u5B50"
        ],
        u: {
          u: "1f346",
          x: 37,
          y: 32
        }
      },
      {
        n: [
          "\u9A6C\u94C3\u85AF"
        ],
        u: {
          u: "1f954",
          x: 38,
          y: 32
        }
      },
      {
        n: [
          "\u80E1\u841D\u535C"
        ],
        u: {
          u: "1f955",
          x: 39,
          y: 32
        }
      },
      {
        n: [
          "\u7389\u7C73\u7A57",
          "\u7389\u7C73"
        ],
        u: {
          u: "1f33d",
          x: 40,
          y: 32
        }
      },
      {
        n: [
          "\u8FA3\u6912"
        ],
        u: {
          u: "1f336",
          x: 41,
          y: 32
        }
      },
      {
        n: [
          "\u9EC4\u74DC"
        ],
        u: {
          u: "1f952",
          x: 42,
          y: 32
        }
      },
      {
        n: [
          "\u897F\u5170\u82B1"
        ],
        u: {
          u: "1f966",
          x: 43,
          y: 32
        }
      },
      {
        n: [
          "\u8611\u83C7"
        ],
        u: {
          u: "1f344",
          x: 44,
          y: 32
        }
      },
      {
        n: [
          "\u82B1\u751F"
        ],
        u: {
          u: "1f95c",
          x: 45,
          y: 32
        }
      },
      {
        n: [
          "\u6817\u6811"
        ],
        u: {
          u: "1f330",
          x: 46,
          y: 32
        }
      },
      {
        n: [
          "\u9762\u5305"
        ],
        u: {
          u: "1f35e",
          x: 47,
          y: 32
        }
      },
      {
        n: [
          "\u725B\u89D2\u9762\u5305"
        ],
        u: {
          u: "1f950",
          x: 48,
          y: 32
        }
      },
      {
        n: [
          "\u6CD5\u5F0F\u9762\u5305"
        ],
        u: {
          u: "1f956",
          x: 49,
          y: 32
        }
      },
      {
        n: [
          "\u6912\u76D0\u8106\u997C"
        ],
        u: {
          u: "1f968",
          x: 0,
          y: 33
        }
      },
      {
        n: [
          "\u714E\u997C"
        ],
        u: {
          u: "1f95e",
          x: 1,
          y: 33
        }
      },
      {
        n: [
          "\u5976\u916A\u6954"
        ],
        u: {
          u: "1f9c0",
          x: 2,
          y: 33
        }
      },
      {
        n: [
          "\u9AA8\u5934\u4E0A\u7684\u8089"
        ],
        u: {
          u: "1f356",
          x: 3,
          y: 33
        }
      },
      {
        n: [
          "\u5BB6\u79BD\u817F"
        ],
        u: {
          u: "1f357",
          x: 4,
          y: 33
        }
      },
      {
        n: [
          "\u8089\u5757"
        ],
        u: {
          u: "1f969",
          x: 5,
          y: 33
        }
      },
      {
        n: [
          "\u57F9\u6839"
        ],
        u: {
          u: "1f953",
          x: 6,
          y: 33
        }
      },
      {
        n: [
          "\u6C49\u5821\u5305"
        ],
        u: {
          u: "1f354",
          x: 7,
          y: 33
        }
      },
      {
        n: [
          "\u70B8\u85AF\u6761",
          "\u70B8\u85AF\u6761"
        ],
        u: {
          u: "1f35f",
          x: 8,
          y: 33
        }
      },
      {
        n: [
          "\u62AB\u8428\u7247",
          "\u62AB\u8428"
        ],
        u: {
          u: "1f355",
          x: 9,
          y: 33
        }
      },
      {
        n: [
          "\u70ED\u72D7",
          "\u70ED\u72D7"
        ],
        u: {
          u: "1f32d",
          x: 10,
          y: 33
        }
      },
      {
        n: [
          "\u4E09\u660E\u6CBB"
        ],
        u: {
          u: "1f96a",
          x: 11,
          y: 33
        }
      },
      {
        n: [
          "\u58A8\u897F\u54E5\u7389\u7C73\u5377"
        ],
        u: {
          u: "1f32e",
          x: 12,
          y: 33
        }
      },
      {
        n: [
          "\u7389\u7C73\u714E\u997C"
        ],
        u: {
          u: "1f32f",
          x: 13,
          y: 33
        }
      },
      {
        n: [
          "\u586B\u9985\u6241\u5E73\u9762\u5305"
        ],
        u: {
          u: "1f959",
          x: 14,
          y: 33
        }
      },
      {
        n: [
          "\u9E21\u86CB"
        ],
        u: {
          u: "1f95a",
          x: 15,
          y: 33
        }
      },
      {
        n: [
          "\u70F9\u996A",
          "\u7092\u9E21\u86CB"
        ],
        u: {
          u: "1f373",
          x: 16,
          y: 33
        }
      },
      {
        n: [
          "\u6D45\u76D8\u98DF\u7269"
        ],
        u: {
          u: "1f958",
          x: 17,
          y: 33
        }
      },
      {
        n: [
          "\u4E00\u9505\u98DF\u7269",
          "\u7096"
        ],
        u: {
          u: "1f372",
          x: 18,
          y: 33
        }
      },
      {
        n: [
          "\u5E26\u52FA\u5B50\u7684\u7897"
        ],
        u: {
          u: "1f963",
          x: 19,
          y: 33
        }
      },
      {
        n: [
          "\u852C\u83DC\u6C99\u62C9"
        ],
        u: {
          u: "1f957",
          x: 20,
          y: 33
        }
      },
      {
        n: [
          "\u7206\u7C73\u82B1"
        ],
        u: {
          u: "1f37f",
          x: 21,
          y: 33
        }
      },
      {
        n: [
          "\u7F50\u5934\u98DF\u54C1"
        ],
        u: {
          u: "1f96b",
          x: 22,
          y: 33
        }
      },
      {
        n: [
          "\u4FBF\u5F53\u76D2",
          "\u4FBF\u5F53"
        ],
        u: {
          u: "1f371",
          x: 23,
          y: 33
        }
      },
      {
        n: [
          "\u7C73\u7CD5"
        ],
        u: {
          u: "1f358",
          x: 24,
          y: 33
        }
      },
      {
        n: [
          "\u996D\u56E2"
        ],
        u: {
          u: "1f359",
          x: 25,
          y: 33
        }
      },
      {
        n: [
          "\u7C73\u996D",
          "\u5927\u7C73"
        ],
        u: {
          u: "1f35a",
          x: 26,
          y: 33
        }
      },
      {
        n: [
          "\u5496\u55B1\u996D",
          "\u5496\u55B1"
        ],
        u: {
          u: "1f35b",
          x: 27,
          y: 33
        }
      },
      {
        n: [
          "\u84B8\u7897",
          "\u62C9\u9762"
        ],
        u: {
          u: "1f35c",
          x: 28,
          y: 33
        }
      },
      {
        n: [
          "\u610F\u5927\u5229\u9762"
        ],
        u: {
          u: "1f35d",
          x: 29,
          y: 33
        }
      },
      {
        n: [
          "\u70E4\u7EA2\u85AF",
          "\u7EA2\u85AF"
        ],
        u: {
          u: "1f360",
          x: 30,
          y: 33
        }
      },
      {
        n: [
          "\u5965\u767B"
        ],
        u: {
          u: "1f362",
          x: 31,
          y: 33
        }
      },
      {
        n: [
          "\u5BFF\u53F8"
        ],
        u: {
          u: "1f363",
          x: 32,
          y: 33
        }
      },
      {
        n: [
          "\u70B8\u867E"
        ],
        u: {
          u: "1f364",
          x: 33,
          y: 33
        }
      },
      {
        n: [
          "\u6F29\u6DA1\u5F0F\u9C7C\u7CD5",
          "\u9C7C\u7CD5"
        ],
        u: {
          u: "1f365",
          x: 34,
          y: 33
        }
      },
      {
        n: [
          "\u4E39\u6208"
        ],
        u: {
          u: "1f361",
          x: 35,
          y: 33
        }
      },
      {
        n: [
          "\u5C0F\u9762\u56E2"
        ],
        u: {
          u: "1f95f",
          x: 36,
          y: 33
        }
      },
      {
        n: [
          "\u5E78\u8FD0\u997C\u5E72"
        ],
        u: {
          u: "1f960",
          x: 37,
          y: 33
        }
      },
      {
        n: [
          "\u5916\u5356\u76D2"
        ],
        u: {
          u: "1f961",
          x: 38,
          y: 33
        }
      },
      {
        n: [
          "\u8F6F\u51B0\u6DC7\u6DCB",
          "\u51B0\u6DC7\u6DCB"
        ],
        u: {
          u: "1f366",
          x: 39,
          y: 33
        }
      },
      {
        n: [
          "\u5228\u51B0"
        ],
        u: {
          u: "1f367",
          x: 40,
          y: 33
        }
      },
      {
        n: [
          "\u51B0\u6DC7\u6DCB"
        ],
        u: {
          u: "1f368",
          x: 41,
          y: 33
        }
      },
      {
        n: [
          "\u751C\u751C\u5708"
        ],
        u: {
          u: "1f369",
          x: 42,
          y: 33
        }
      },
      {
        n: [
          "\u66F2\u5947"
        ],
        u: {
          u: "1f36a",
          x: 43,
          y: 33
        }
      },
      {
        n: [
          "\u751F\u65E5\u86CB\u7CD5",
          "\u751F\u65E5"
        ],
        u: {
          u: "1f382",
          x: 44,
          y: 33
        }
      },
      {
        n: [
          "\u7F3A\u70B9",
          "\u7CD5\u997C"
        ],
        u: {
          u: "1f370",
          x: 45,
          y: 33
        }
      },
      {
        n: [
          "\u9985\u997C"
        ],
        u: {
          u: "1f967",
          x: 46,
          y: 33
        }
      },
      {
        n: [
          "\u5DE7\u514B\u529B\u68D2"
        ],
        u: {
          u: "1f36b",
          x: 47,
          y: 33
        }
      },
      {
        n: [
          "\u7CD6\u679C"
        ],
        u: {
          u: "1f36c",
          x: 48,
          y: 33
        }
      },
      {
        n: [
          "\u68D2\u68D2\u7CD6"
        ],
        u: {
          u: "1f36d",
          x: 49,
          y: 33
        }
      },
      {
        n: [
          "\u86CB\u5976\u6C99\u53F8"
        ],
        u: {
          u: "1f36e",
          x: 0,
          y: 34
        }
      },
      {
        n: [
          "\u8702\u871C\u7F50"
        ],
        u: {
          u: "1f36f",
          x: 1,
          y: 34
        }
      },
      {
        n: [
          "\u5A74\u513F\u5976\u74F6"
        ],
        u: {
          u: "1f37c",
          x: 2,
          y: 34
        }
      },
      {
        n: [
          "\u4E00\u676F\u725B\u5976"
        ],
        u: {
          u: "1f95b",
          x: 3,
          y: 34
        }
      },
      {
        n: [
          "\u70ED\u996E",
          "\u5496\u5561"
        ],
        u: {
          u: "2615",
          x: 4,
          y: 34
        }
      },
      {
        n: [
          "\u65E0\u67C4\u8336\u676F",
          "\u8336\u53F6"
        ],
        u: {
          u: "1f375",
          x: 5,
          y: 34
        }
      },
      {
        n: [
          "\u6E05\u9152\u74F6\u548C\u676F\u5B50",
          "\u76EE\u7684"
        ],
        u: {
          u: "1f376",
          x: 6,
          y: 34
        }
      },
      {
        n: [
          "\u5E26\u7206\u88C2\u8F6F\u6728\u585E\u7684\u74F6\u5B50",
          "\u9999\u69DF"
        ],
        u: {
          u: "1f37e",
          x: 7,
          y: 34
        }
      },
      {
        n: [
          "\u9152\u676F"
        ],
        u: {
          u: "1f377",
          x: 8,
          y: 34
        }
      },
      {
        n: [
          "\u9E21\u5C3E\u9152\u676F",
          "\u9E21\u5C3E\u9152"
        ],
        u: {
          u: "1f378",
          x: 9,
          y: 34
        }
      },
      {
        n: [
          "\u70ED\u5E26\u996E\u6599"
        ],
        u: {
          u: "1f379",
          x: 10,
          y: 34
        }
      },
      {
        n: [
          "\u5564\u9152\u676F",
          "\u5564\u9152"
        ],
        u: {
          u: "1f37a",
          x: 11,
          y: 34
        }
      },
      {
        n: [
          "\u53EE\u5F53\u4F5C\u54CD\u7684\u5564\u9152\u676F",
          "\u5564\u9152"
        ],
        u: {
          u: "1f37b",
          x: 12,
          y: 34
        }
      },
      {
        n: [
          "\u78B0\u676F"
        ],
        u: {
          u: "1f942",
          x: 13,
          y: 34
        }
      },
      {
        n: [
          "\u5E73\u5E95\u676F"
        ],
        u: {
          u: "1f943",
          x: 14,
          y: 34
        }
      },
      {
        n: [
          "\u5438\u7BA1\u676F"
        ],
        u: {
          u: "1f964",
          x: 15,
          y: 34
        }
      },
      {
        n: [
          "\u7B77\u5B50"
        ],
        u: {
          u: "1f962",
          x: 16,
          y: 34
        }
      },
      {
        n: [
          "\u5200\u53C9\u677F"
        ],
        u: {
          u: "1f37d",
          x: 17,
          y: 34
        }
      },
      {
        n: [
          "\u5200\u53C9"
        ],
        u: {
          u: "1f374",
          x: 18,
          y: 34
        }
      },
      {
        n: [
          "\u52FA\u5B50"
        ],
        u: {
          u: "1f944",
          x: 19,
          y: 34
        }
      },
      {
        n: [
          "\u970D\u4E54",
          "\u5200"
        ],
        u: {
          u: "1f52a",
          x: 20,
          y: 34
        }
      },
      {
        n: [
          "\u5B89\u6CE2\u62C9"
        ],
        u: {
          u: "1f3fa",
          x: 21,
          y: 34
        }
      }
    ],
    u: "1f354",
    title: "\u996E\u98DF",
    key: "food_drink"
  },
  {
    emojis: [
      {
        n: [
          "\u6770\u514Bo\u706F"
        ],
        u: {
          u: "1f383",
          x: 22,
          y: 34
        }
      },
      {
        n: [
          "\u5723\u8BDE\u6811"
        ],
        u: {
          u: "1f384",
          x: 23,
          y: 34
        }
      },
      {
        n: [
          "\u70DF\u706B"
        ],
        u: {
          u: "1f386",
          x: 24,
          y: 34
        }
      },
      {
        n: [
          "\u70DF\u82B1\u706B\u82B1\u5668",
          "\u706B\u82B1"
        ],
        u: {
          u: "1f387",
          x: 25,
          y: 34
        }
      },
      {
        n: [
          "\u95EA\u95EA\u53D1\u5149"
        ],
        u: {
          u: "2728",
          x: 26,
          y: 34
        }
      },
      {
        n: [
          "\u6C14\u7403"
        ],
        u: {
          u: "1f388",
          x: 27,
          y: 34
        }
      },
      {
        n: [
          "\u6D3E\u5BF9\u6CE2\u666E\u5C14",
          "\u5854\u8FBE"
        ],
        u: {
          u: "1f389",
          x: 28,
          y: 34
        }
      },
      {
        n: [
          "\u4E94\u5F69\u7EB8\u5C51\u7403"
        ],
        u: {
          u: "1f38a",
          x: 29,
          y: 34
        }
      },
      {
        n: [
          "\u4E03\u5915\u6811"
        ],
        u: {
          u: "1f38b",
          x: 30,
          y: 34
        }
      },
      {
        n: [
          "\u677E\u6728\u88C5\u9970",
          "\u7AF9\u5B50"
        ],
        u: {
          u: "1f38d",
          x: 31,
          y: 34
        }
      },
      {
        n: [
          "\u65E5\u672C\u73A9\u5076",
          "\u73A9\u5076"
        ],
        u: {
          u: "1f38e",
          x: 32,
          y: 34
        }
      },
      {
        n: [
          "\u9CA4\u9C7C\u62D6\u7F06",
          "\u6807\u5FD7"
        ],
        u: {
          u: "1f38f",
          x: 33,
          y: 34
        }
      },
      {
        n: [
          "\u98CE\u94C3"
        ],
        u: {
          u: "1f390",
          x: 34,
          y: 34
        }
      },
      {
        n: [
          "\u8D4F\u6708\u4EEA\u5F0F",
          "\u5927\u7C73\u573A\u666F"
        ],
        u: {
          u: "1f391",
          x: 35,
          y: 34
        }
      },
      {
        n: [
          "\u5E26\u5B50"
        ],
        u: {
          u: "1f380",
          x: 36,
          y: 34
        }
      },
      {
        n: [
          "\u5305\u88C5\u597D\u7684\u793C\u7269",
          "\u793C\u7269"
        ],
        u: {
          u: "1f381",
          x: 37,
          y: 34
        }
      },
      {
        n: [
          "\u63D0\u9192\u529F\u80FD\u533A"
        ],
        u: {
          u: "1f397",
          x: 38,
          y: 34
        }
      },
      {
        n: [
          "\u5165\u573A\u5238"
        ],
        u: {
          u: "1f39f",
          x: 39,
          y: 34
        }
      },
      {
        n: [
          "\u7968"
        ],
        u: {
          u: "1f3ab",
          x: 40,
          y: 34
        }
      },
      {
        n: [
          "\u5956\u7AE0"
        ],
        u: {
          u: "1f396",
          x: 41,
          y: 34
        }
      },
      {
        n: [
          "\u5956\u676F"
        ],
        u: {
          u: "1f3c6",
          x: 42,
          y: 34
        }
      },
      {
        n: [
          "\u4F53\u80B2\u5956\u724C"
        ],
        u: {
          u: "1f3c5",
          x: 43,
          y: 34
        }
      },
      {
        n: [
          "\u7B2C\u4E00\u540D\u5956\u724C"
        ],
        u: {
          u: "1f947",
          x: 44,
          y: 34
        }
      },
      {
        n: [
          "\u7B2C\u4E8C\u540D\u5956\u724C"
        ],
        u: {
          u: "1f948",
          x: 45,
          y: 34
        }
      },
      {
        n: [
          "\u7B2C\u4E09\u540D\u5956\u724C"
        ],
        u: {
          u: "1f949",
          x: 46,
          y: 34
        }
      },
      {
        n: [
          "\u8DB3\u7403",
          "\u8DB3\u7403"
        ],
        u: {
          u: "26bd",
          x: 47,
          y: 34
        }
      },
      {
        n: [
          "\u68D2\u7403\u8FD0\u52A8"
        ],
        u: {
          u: "26be",
          x: 48,
          y: 34
        }
      },
      {
        n: [
          "\u7BEE\u7403\u548C\u7BEE\u7403",
          "\u7BEE\u7403\u8FD0\u52A8"
        ],
        u: {
          u: "1f3c0",
          x: 49,
          y: 34
        }
      },
      {
        n: [
          "\u6392\u7403"
        ],
        u: {
          u: "1f3d0",
          x: 0,
          y: 35
        }
      },
      {
        n: [
          "\u7F8E\u5F0F\u8DB3\u7403",
          "\u8DB3\u7403\u8FD0\u52A8"
        ],
        u: {
          u: "1f3c8",
          x: 1,
          y: 35
        }
      },
      {
        n: [
          "\u6A44\u6984\u7403"
        ],
        u: {
          u: "1f3c9",
          x: 2,
          y: 35
        }
      },
      {
        n: [
          "\u7F51\u7403\u62CD\u548C\u7F51\u7403",
          "\u7F51\u7403"
        ],
        u: {
          u: "1f3be",
          x: 3,
          y: 35
        }
      },
      {
        n: [
          "\u53F0\u7403",
          "8\u7403"
        ],
        u: {
          u: "1f3b1",
          x: 4,
          y: 35
        }
      },
      {
        n: [
          "\u4FDD\u9F84\u7403"
        ],
        u: {
          u: "1f3b3",
          x: 5,
          y: 35
        }
      },
      {
        n: [
          "\u677F\u7403\u68D2\u548C\u7403"
        ],
        u: {
          u: "1f3cf",
          x: 6,
          y: 35
        }
      },
      {
        n: [
          "\u66F2\u68CD\u7403\u68D2\u548C\u7403"
        ],
        u: {
          u: "1f3d1",
          x: 7,
          y: 35
        }
      },
      {
        n: [
          "\u51B0\u7403\u68D2\u548C\u51B0\u7403"
        ],
        u: {
          u: "1f3d2",
          x: 8,
          y: 35
        }
      },
      {
        n: [
          "\u4E52\u4E53\u7403\u62CD\u548C\u7403"
        ],
        u: {
          u: "1f3d3",
          x: 9,
          y: 35
        }
      },
      {
        n: [
          "\u7FBD\u6BDB\u7403\u7403\u62CD\u548C\u7FBD\u6BDB\u7403"
        ],
        u: {
          u: "1f3f8",
          x: 10,
          y: 35
        }
      },
      {
        n: [
          "\u62F3\u51FB\u624B\u5957"
        ],
        u: {
          u: "1f94a",
          x: 11,
          y: 35
        }
      },
      {
        n: [
          "\u6B66\u672F\u670D"
        ],
        u: {
          u: "1f94b",
          x: 12,
          y: 35
        }
      },
      {
        n: [
          "\u76EE\u6807\u7F51"
        ],
        u: {
          u: "1f945",
          x: 13,
          y: 35
        }
      },
      {
        n: [
          "\u76F4\u63A5\u547D\u4E2D",
          "\u98DE\u5954"
        ],
        u: {
          u: "1f3af",
          x: 14,
          y: 35
        }
      },
      {
        n: [
          "\u5B54\u5185\u6807\u8BB0",
          "\u9AD8\u5C14\u592B\u7403\u8FD0\u52A8"
        ],
        u: {
          u: "26f3",
          x: 15,
          y: 35
        }
      },
      {
        n: [
          "\u6E9C\u51B0"
        ],
        u: {
          u: "26f8",
          x: 16,
          y: 35
        }
      },
      {
        n: [
          "\u9493\u9C7C\u7AFF\u548C\u9C7C"
        ],
        u: {
          u: "1f3a3",
          x: 17,
          y: 35
        }
      },
      {
        n: [
          "\u5E26\u8170\u5E26\u8DD1\u6B65\u886B"
        ],
        u: {
          u: "1f3bd",
          x: 18,
          y: 35
        }
      },
      {
        n: [
          "\u6ED1\u96EA\u677F\u548C\u6ED1\u96EA\u9774",
          "\u6ED1\u96EA"
        ],
        u: {
          u: "1f3bf",
          x: 19,
          y: 35
        }
      },
      {
        n: [
          "\u96EA\u6A47"
        ],
        u: {
          u: "1f6f7",
          x: 20,
          y: 35
        }
      },
      {
        n: [
          "\u51B0\u58F6\u77F3"
        ],
        u: {
          u: "1f94c",
          x: 21,
          y: 35
        }
      },
      {
        n: [
          "\u7535\u5B50\u6E38\u620F"
        ],
        u: {
          u: "1f3ae",
          x: 22,
          y: 35
        }
      },
      {
        n: [
          "\u64CD\u7EB5\u6746"
        ],
        u: {
          u: "1f579",
          x: 23,
          y: 35
        }
      },
      {
        n: [
          "\u6E38\u620F\u6A21\u5177"
        ],
        u: {
          u: "1f3b2",
          x: 24,
          y: 35
        }
      },
      {
        n: [
          "\u9ED1\u8272\u9ED1\u6843\u5957\u88C5",
          "\u9ED1\u6843"
        ],
        u: {
          u: "2660",
          x: 25,
          y: 35
        }
      },
      {
        n: [
          "\u9ED1\u5FC3\u897F\u88C5",
          "\u7EA2\u5FC3"
        ],
        u: {
          u: "2665",
          x: 26,
          y: 35
        }
      },
      {
        n: [
          "\u9ED1\u94BB\u77F3\u5957\u88C5",
          "\u94BB\u77F3"
        ],
        u: {
          u: "2666",
          x: 27,
          y: 35
        }
      },
      {
        n: [
          "\u9ED1\u8272\u4FF1\u4E50\u90E8\u5957\u88C5",
          "\u4FF1\u4E50\u90E8"
        ],
        u: {
          u: "2663",
          x: 28,
          y: 35
        }
      },
      {
        n: [
          "\u6251\u514B\u724C\u9ED1\u5C0F\u4E11",
          "\u5C0F\u738B"
        ],
        u: {
          u: "1f0cf",
          x: 29,
          y: 35
        }
      },
      {
        n: [
          "\u9EBB\u5C06\u724C\u7EA2\u9F99",
          "\u9EBB\u5C06\u724C"
        ],
        u: {
          u: "1f004",
          x: 30,
          y: 35
        }
      },
      {
        n: [
          "\u82B1\u6251\u514B\u724C"
        ],
        u: {
          u: "1f3b4",
          x: 31,
          y: 35
        }
      }
    ],
    u: "26bd",
    title: "\u52A8\u6001",
    key: "activities"
  },
  {
    emojis: [
      {
        n: [
          "\u5730\u7403\u4EEA\u6B27\u6D32-\u975E\u6D32",
          "\u975E\u6D32\u5730\u7403"
        ],
        u: {
          u: "1f30d",
          x: 32,
          y: 35
        }
      },
      {
        n: [
          "\u5730\u7403\u5730\u7403\u4EEA\u7F8E\u6D32",
          "\u5730\u7403\u7F8E\u6D32"
        ],
        u: {
          u: "1f30e",
          x: 33,
          y: 35
        }
      },
      {
        n: [
          "\u6FB3\u5927\u5229\u4E9A\u4E9A\u6D32\u5730\u7403\u62A5",
          "\u4E9A\u6D32\u5730\u7403"
        ],
        u: {
          u: "1f30f",
          x: 34,
          y: 35
        }
      },
      {
        n: [
          "\u5E26\u5B50\u5348\u7EBF\u7684\u7403\u4F53"
        ],
        u: {
          u: "1f310",
          x: 35,
          y: 35
        }
      },
      {
        n: [
          "\u4E16\u754C\u5730\u56FE"
        ],
        u: {
          u: "1f5fa",
          x: 36,
          y: 35
        }
      },
      {
        n: [
          "\u65E5\u672C\u526A\u5F71",
          "\u65E5\u672C"
        ],
        u: {
          u: "1f5fe",
          x: 37,
          y: 35
        }
      },
      {
        n: [
          "\u96EA\u5C71"
        ],
        u: {
          u: "1f3d4",
          x: 38,
          y: 35
        }
      },
      {
        n: [
          "\u5C71"
        ],
        u: {
          u: "26f0",
          x: 39,
          y: 35
        }
      },
      {
        n: [
          "\u706B\u5C71"
        ],
        u: {
          u: "1f30b",
          x: 40,
          y: 35
        }
      },
      {
        n: [
          "\u5BCC\u58EB\u5C71"
        ],
        u: {
          u: "1f5fb",
          x: 41,
          y: 35
        }
      },
      {
        n: [
          "\u9732\u8425"
        ],
        u: {
          u: "1f3d5",
          x: 42,
          y: 35
        }
      },
      {
        n: [
          "\u5E26\u96E8\u4F1E\u7684\u6D77\u6EE9"
        ],
        u: {
          u: "1f3d6",
          x: 43,
          y: 35
        }
      },
      {
        n: [
          "\u6C99\u6F20"
        ],
        u: {
          u: "1f3dc",
          x: 44,
          y: 35
        }
      },
      {
        n: [
          "\u8352\u5C9B"
        ],
        u: {
          u: "1f3dd",
          x: 45,
          y: 35
        }
      },
      {
        n: [
          "\u56FD\u5BB6\u516C\u56ED"
        ],
        u: {
          u: "1f3de",
          x: 46,
          y: 35
        }
      },
      {
        n: [
          "\u4F53\u80B2\u573A"
        ],
        u: {
          u: "1f3df",
          x: 47,
          y: 35
        }
      },
      {
        n: [
          "\u53E4\u5178\u5EFA\u7B51"
        ],
        u: {
          u: "1f3db",
          x: 48,
          y: 35
        }
      },
      {
        n: [
          "\u5EFA\u7B51\u65BD\u5DE5"
        ],
        u: {
          u: "1f3d7",
          x: 49,
          y: 35
        }
      },
      {
        n: [
          "\u623F\u5C4B\u5EFA\u7B51"
        ],
        u: {
          u: "1f3d8",
          x: 0,
          y: 36
        }
      },
      {
        n: [
          "\u57CE\u5E02\u666F\u89C2"
        ],
        u: {
          u: "1f3d9",
          x: 1,
          y: 36
        }
      },
      {
        n: [
          "\u5E9F\u5F03\u623F\u5C4B\u5EFA\u7B51"
        ],
        u: {
          u: "1f3da",
          x: 2,
          y: 36
        }
      },
      {
        n: [
          "\u623F\u5C4B\u5EFA\u7B51",
          "\u623F\u5C4B"
        ],
        u: {
          u: "1f3e0",
          x: 3,
          y: 36
        }
      },
      {
        n: [
          "\u5E26\u82B1\u56ED\u7684\u623F\u5B50"
        ],
        u: {
          u: "1f3e1",
          x: 4,
          y: 36
        }
      },
      {
        n: [
          "\u529E\u516C\u697C",
          "\u529E\u516C\u5BA4"
        ],
        u: {
          u: "1f3e2",
          x: 5,
          y: 36
        }
      },
      {
        n: [
          "\u65E5\u672C\u90AE\u653F\u5C40",
          "\u90AE\u5C40"
        ],
        u: {
          u: "1f3e3",
          x: 6,
          y: 36
        }
      },
      {
        n: [
          "\u6B27\u6D32\u90AE\u653F\u5C40"
        ],
        u: {
          u: "1f3e4",
          x: 7,
          y: 36
        }
      },
      {
        n: [
          "\u533B\u9662"
        ],
        u: {
          u: "1f3e5",
          x: 8,
          y: 36
        }
      },
      {
        n: [
          "\u94F6\u884C"
        ],
        u: {
          u: "1f3e6",
          x: 9,
          y: 36
        }
      },
      {
        n: [
          "\u9152\u5E97"
        ],
        u: {
          u: "1f3e8",
          x: 10,
          y: 36
        }
      },
      {
        n: [
          "\u7231\u60C5\u9152\u5E97"
        ],
        u: {
          u: "1f3e9",
          x: 11,
          y: 36
        }
      },
      {
        n: [
          "\u4FBF\u5229\u5E97"
        ],
        u: {
          u: "1f3ea",
          x: 12,
          y: 36
        }
      },
      {
        n: [
          "\u5B66\u6821"
        ],
        u: {
          u: "1f3eb",
          x: 13,
          y: 36
        }
      },
      {
        n: [
          "\u767E\u8D27\u516C\u53F8"
        ],
        u: {
          u: "1f3ec",
          x: 14,
          y: 36
        }
      },
      {
        n: [
          "\u5DE5\u5382"
        ],
        u: {
          u: "1f3ed",
          x: 15,
          y: 36
        }
      },
      {
        n: [
          "\u65E5\u672C\u57CE\u5821"
        ],
        u: {
          u: "1f3ef",
          x: 16,
          y: 36
        }
      },
      {
        n: [
          "\u6B27\u6D32\u57CE\u5821"
        ],
        u: {
          u: "1f3f0",
          x: 17,
          y: 36
        }
      },
      {
        n: [
          "\u5A5A\u793C"
        ],
        u: {
          u: "1f492",
          x: 18,
          y: 36
        }
      },
      {
        n: [
          "\u4E1C\u4EAC\u5854"
        ],
        u: {
          u: "1f5fc",
          x: 19,
          y: 36
        }
      },
      {
        n: [
          "\u81EA\u7531\u5973\u795E\u50CF"
        ],
        u: {
          u: "1f5fd",
          x: 20,
          y: 36
        }
      },
      {
        n: [
          "\u6559\u5802"
        ],
        u: {
          u: "26ea",
          x: 21,
          y: 36
        }
      },
      {
        n: [
          "\u6E05\u771F\u5BFA"
        ],
        u: {
          u: "1f54c",
          x: 22,
          y: 36
        }
      },
      {
        n: [
          "\u72B9\u592A\u4F1A\u5802"
        ],
        u: {
          u: "1f54d",
          x: 23,
          y: 36
        }
      },
      {
        n: [
          "\u795E\u793E"
        ],
        u: {
          u: "26e9",
          x: 24,
          y: 36
        }
      },
      {
        n: [
          "\u5361\u5DF4"
        ],
        u: {
          u: "1f54b",
          x: 25,
          y: 36
        }
      },
      {
        n: [
          "\u4EBA\u5DE5\u55B7\u6CC9"
        ],
        u: {
          u: "26f2",
          x: 26,
          y: 36
        }
      },
      {
        n: [
          "\u5E10\u7BF7"
        ],
        u: {
          u: "26fa",
          x: 27,
          y: 36
        }
      },
      {
        n: [
          "\u6709\u96FE\u7684"
        ],
        u: {
          u: "1f301",
          x: 28,
          y: 36
        }
      },
      {
        n: [
          "\u6709\u661F\u661F\u7684\u591C\u665A"
        ],
        u: {
          u: "1f303",
          x: 29,
          y: 36
        }
      },
      {
        n: [
          "\u5C71\u4E0A\u65E5\u51FA"
        ],
        u: {
          u: "1f304",
          x: 30,
          y: 36
        }
      },
      {
        n: [
          "\u65E5\u51FA"
        ],
        u: {
          u: "1f305",
          x: 31,
          y: 36
        }
      },
      {
        n: [
          "\u9EC4\u660F\u7684\u57CE\u5E02\u98CE\u5149",
          "\u57CE\u5E02\u65E5\u843D"
        ],
        u: {
          u: "1f306",
          x: 32,
          y: 36
        }
      },
      {
        n: [
          "\u5EFA\u7B51\u7269\u4E0A\u65B9\u7684\u65E5\u843D",
          "\u57CE\u5E02\u65E5\u51FA"
        ],
        u: {
          u: "1f307",
          x: 33,
          y: 36
        }
      },
      {
        n: [
          "\u591C\u95F4\u9A7E\u9A76\u53F0"
        ],
        u: {
          u: "1f309",
          x: 34,
          y: 36
        }
      },
      {
        n: [
          "\u6E29\u6CC9",
          "\u6E29\u6CC9"
        ],
        u: {
          u: "2668",
          x: 35,
          y: 36
        }
      },
      {
        n: [
          "\u94F6\u6CB3\u7CFB"
        ],
        u: {
          u: "1f30c",
          x: 36,
          y: 36
        }
      },
      {
        n: [
          "\u65CB\u8F6C\u6728\u9A6C"
        ],
        u: {
          u: "1f3a0",
          x: 37,
          y: 36
        }
      },
      {
        n: [
          "\u6469\u5929\u8F6E"
        ],
        u: {
          u: "1f3a1",
          x: 38,
          y: 36
        }
      },
      {
        n: [
          "\u8FC7\u5C71\u8F66"
        ],
        u: {
          u: "1f3a2",
          x: 39,
          y: 36
        }
      },
      {
        n: [
          "\u7406\u53D1\u6746",
          "\u7406\u53D1\u5E08"
        ],
        u: {
          u: "1f488",
          x: 40,
          y: 36
        }
      },
      {
        n: [
          "\u9A6C\u620F\u56E2\u5E10\u7BF7"
        ],
        u: {
          u: "1f3aa",
          x: 41,
          y: 36
        }
      },
      {
        n: [
          "\u8868\u6F14\u827A\u672F"
        ],
        u: {
          u: "1f3ad",
          x: 42,
          y: 36
        }
      },
      {
        n: [
          "\u5E26\u56FE\u7247\u7684\u6846\u67B6"
        ],
        u: {
          u: "1f5bc",
          x: 43,
          y: 36
        }
      },
      {
        n: [
          "\u827A\u672F\u5BB6\u8C03\u8272\u677F",
          "\u827A\u672F"
        ],
        u: {
          u: "1f3a8",
          x: 44,
          y: 36
        }
      },
      {
        n: [
          "\u8001\u864E\u673A"
        ],
        u: {
          u: "1f3b0",
          x: 45,
          y: 36
        }
      },
      {
        n: [
          "\u84B8\u6C7D\u673A\u8F66"
        ],
        u: {
          u: "1f682",
          x: 46,
          y: 36
        }
      },
      {
        n: [
          "\u94C1\u8DEF\u8F66\u8F86"
        ],
        u: {
          u: "1f683",
          x: 47,
          y: 36
        }
      },
      {
        n: [
          "\u9AD8\u901F\u5217\u8F66",
          "bullettrain\u4FA7"
        ],
        u: {
          u: "1f684",
          x: 48,
          y: 36
        }
      },
      {
        n: [
          "\u5F39\u5934\u9AD8\u901F\u5217\u8F66",
          "bullettrain\u524D\u90E8"
        ],
        u: {
          u: "1f685",
          x: 49,
          y: 36
        }
      },
      {
        n: [
          "\u706B\u8F66",
          "\u5217\u8F662"
        ],
        u: {
          u: "1f686",
          x: 0,
          y: 37
        }
      },
      {
        n: [
          "\u5730\u94C1"
        ],
        u: {
          u: "1f687",
          x: 1,
          y: 37
        }
      },
      {
        n: [
          "\u8F7B\u8F68"
        ],
        u: {
          u: "1f688",
          x: 2,
          y: 37
        }
      },
      {
        n: [
          "\u706B\u8F66\u7AD9"
        ],
        u: {
          u: "1f689",
          x: 3,
          y: 37
        }
      },
      {
        n: [
          "\u6709\u8F68\u7535\u8F66"
        ],
        u: {
          u: "1f68a",
          x: 4,
          y: 37
        }
      },
      {
        n: [
          "\u5355\u8F68\u94C1\u8DEF"
        ],
        u: {
          u: "1f69d",
          x: 5,
          y: 37
        }
      },
      {
        n: [
          "\u5C71\u533A\u94C1\u8DEF"
        ],
        u: {
          u: "1f69e",
          x: 6,
          y: 37
        }
      },
      {
        n: [
          "\u6709\u8F68\u7535\u8F66",
          "\u706B\u8F66"
        ],
        u: {
          u: "1f68b",
          x: 7,
          y: 37
        }
      },
      {
        n: [
          "\u516C\u5171\u6C7D\u8F66"
        ],
        u: {
          u: "1f68c",
          x: 8,
          y: 37
        }
      },
      {
        n: [
          "\u8FCE\u9762\u800C\u6765\u7684\u516C\u5171\u6C7D\u8F66"
        ],
        u: {
          u: "1f68d",
          x: 9,
          y: 37
        }
      },
      {
        n: [
          "\u65E0\u8F68\u7535\u8F66"
        ],
        u: {
          u: "1f68e",
          x: 10,
          y: 37
        }
      },
      {
        n: [
          "\u5C0F\u578B\u5DF4\u58EB"
        ],
        u: {
          u: "1f690",
          x: 11,
          y: 37
        }
      },
      {
        n: [
          "\u6551\u62A4\u8F66"
        ],
        u: {
          u: "1f691",
          x: 12,
          y: 37
        }
      },
      {
        n: [
          "\u6D88\u9632\u8F66"
        ],
        u: {
          u: "1f692",
          x: 13,
          y: 37
        }
      },
      {
        n: [
          "\u8B66\u8F66"
        ],
        u: {
          u: "1f693",
          x: 14,
          y: 37
        }
      },
      {
        n: [
          "\u8FCE\u9762\u800C\u6765\u7684\u8B66\u8F66"
        ],
        u: {
          u: "1f694",
          x: 15,
          y: 37
        }
      },
      {
        n: [
          "\u51FA\u79DF\u8F66"
        ],
        u: {
          u: "1f695",
          x: 16,
          y: 37
        }
      },
      {
        n: [
          "\u8FCE\u9762\u800C\u6765\u7684\u51FA\u79DF\u8F66"
        ],
        u: {
          u: "1f696",
          x: 17,
          y: 37
        }
      },
      {
        n: [
          "\u6C7D\u8F66",
          "\u6C7D\u8F66",
          "\u7EA2\u8272\u6C7D\u8F66"
        ],
        u: {
          u: "1f697",
          x: 18,
          y: 37
        }
      },
      {
        n: [
          "\u8FCE\u9762\u800C\u6765\u7684\u6C7D\u8F66"
        ],
        u: {
          u: "1f698",
          x: 19,
          y: 37
        }
      },
      {
        n: [
          "\u4F11\u95F2\u8F66",
          "\u84DD\u8272\u6C7D\u8F66"
        ],
        u: {
          u: "1f699",
          x: 20,
          y: 37
        }
      },
      {
        n: [
          "\u9001\u8D27\u8F66",
          "\u5361\u8F66"
        ],
        u: {
          u: "1f69a",
          x: 21,
          y: 37
        }
      },
      {
        n: [
          "\u94F0\u63A5\u5F0F\u8D27\u8F66"
        ],
        u: {
          u: "1f69b",
          x: 22,
          y: 37
        }
      },
      {
        n: [
          "\u62D6\u62C9\u673A"
        ],
        u: {
          u: "1f69c",
          x: 23,
          y: 37
        }
      },
      {
        n: [
          "\u81EA\u884C\u8F66",
          "\u81EA\u884C\u8F66"
        ],
        u: {
          u: "1f6b2",
          x: 24,
          y: 37
        }
      },
      {
        n: [
          "\u5C0F\u578B\u6469\u6258\u8F66"
        ],
        u: {
          u: "1f6f4",
          x: 25,
          y: 37
        }
      },
      {
        n: [
          "\u7535\u52A8\u6ED1\u677F\u8F66"
        ],
        u: {
          u: "1f6f5",
          x: 26,
          y: 37
        }
      },
      {
        n: [
          "\u516C\u4EA4\u7AD9",
          "\u516C\u5171\u6C7D\u8F66\u7AD9"
        ],
        u: {
          u: "1f68f",
          x: 27,
          y: 37
        }
      },
      {
        n: [
          "\u9AD8\u901F\u516C\u8DEF"
        ],
        u: {
          u: "1f6e3",
          x: 28,
          y: 37
        }
      },
      {
        n: [
          "\u94C1\u8DEF\u8F68\u9053"
        ],
        u: {
          u: "1f6e4",
          x: 29,
          y: 37
        }
      },
      {
        n: [
          "\u71C3\u6CB9\u6CF5",
          "\u71C3\u6CB9\u6CF5"
        ],
        u: {
          u: "26fd",
          x: 30,
          y: 37
        }
      },
      {
        n: [
          "\u8B66\u8F66\u65CB\u8F6C\u706F",
          "\u65CB\u8F6C\u706F"
        ],
        u: {
          u: "1f6a8",
          x: 31,
          y: 37
        }
      },
      {
        n: [
          "\u6C34\u5E73\u4EA4\u901A\u706F",
          "\u4EA4\u901A\u706F"
        ],
        u: {
          u: "1f6a5",
          x: 32,
          y: 37
        }
      },
      {
        n: [
          "\u5782\u76F4\u4EA4\u901A\u706F"
        ],
        u: {
          u: "1f6a6",
          x: 33,
          y: 37
        }
      },
      {
        n: [
          "\u65BD\u5DE5\u6807\u5FD7",
          "\u5EFA\u8BBE"
        ],
        u: {
          u: "1f6a7",
          x: 34,
          y: 37
        }
      },
      {
        n: [
          "\u516B\u89D2\u5F62\u7B26\u53F7"
        ],
        u: {
          u: "1f6d1",
          x: 35,
          y: 37
        }
      },
      {
        n: [
          "\u951A"
        ],
        u: {
          u: "2693",
          x: 36,
          y: 37
        }
      },
      {
        n: [
          "\u5E06\u8239",
          "\u8239"
        ],
        u: {
          u: "26f5",
          x: 37,
          y: 37
        }
      },
      {
        n: [
          "\u76AE\u5212\u8247"
        ],
        u: {
          u: "1f6f6",
          x: 38,
          y: 37
        }
      },
      {
        n: [
          "\u5FEB\u8247"
        ],
        u: {
          u: "1f6a4",
          x: 39,
          y: 37
        }
      },
      {
        n: [
          "\u5BA2\u8239"
        ],
        u: {
          u: "1f6f3",
          x: 40,
          y: 37
        }
      },
      {
        n: [
          "\u6E21\u8239"
        ],
        u: {
          u: "26f4",
          x: 41,
          y: 37
        }
      },
      {
        n: [
          "\u6469\u6258\u8247"
        ],
        u: {
          u: "1f6e5",
          x: 42,
          y: 37
        }
      },
      {
        n: [
          "\u8239"
        ],
        u: {
          u: "1f6a2",
          x: 43,
          y: 37
        }
      },
      {
        n: [
          "\u98DE\u673A"
        ],
        u: {
          u: "2708",
          x: 44,
          y: 37
        }
      },
      {
        n: [
          "\u5C0F\u578B\u98DE\u673A"
        ],
        u: {
          u: "1f6e9",
          x: 45,
          y: 37
        }
      },
      {
        n: [
          "\u98DE\u673A\u8D77\u98DE"
        ],
        u: {
          u: "1f6eb",
          x: 46,
          y: 37
        }
      },
      {
        n: [
          "\u98DE\u673A\u5230\u8FBE"
        ],
        u: {
          u: "1f6ec",
          x: 47,
          y: 37
        }
      },
      {
        n: [
          "\u5EA7\u4F4D"
        ],
        u: {
          u: "1f4ba",
          x: 48,
          y: 37
        }
      },
      {
        n: [
          "\u76F4\u5347\u673A"
        ],
        u: {
          u: "1f681",
          x: 49,
          y: 37
        }
      },
      {
        n: [
          "\u60AC\u7D22\u94C1\u8DEF"
        ],
        u: {
          u: "1f69f",
          x: 0,
          y: 38
        }
      },
      {
        n: [
          "\u5C71\u5730\u7D22\u9053"
        ],
        u: {
          u: "1f6a0",
          x: 1,
          y: 38
        }
      },
      {
        n: [
          "\u67B6\u7A7A\u7F06\u8F66"
        ],
        u: {
          u: "1f6a1",
          x: 2,
          y: 38
        }
      },
      {
        n: [
          "\u4EBA\u9020\u536B\u661F"
        ],
        u: {
          u: "1f6f0",
          x: 3,
          y: 38
        }
      },
      {
        n: [
          "\u706B\u7BAD"
        ],
        u: {
          u: "1f680",
          x: 4,
          y: 38
        }
      },
      {
        n: [
          "\u98DE\u789F"
        ],
        u: {
          u: "1f6f8",
          x: 5,
          y: 38
        }
      },
      {
        n: [
          "\u884C\u674E\u5458\u949F\u697C"
        ],
        u: {
          u: "1f6ce",
          x: 6,
          y: 38
        }
      },
      {
        n: [
          "\u95E8"
        ],
        u: {
          u: "1f6aa",
          x: 7,
          y: 38
        }
      },
      {
        n: [
          "\u5E8A"
        ],
        u: {
          u: "1f6cf",
          x: 8,
          y: 38
        }
      },
      {
        n: [
          "\u6C99\u53D1\u548C\u53F0\u706F"
        ],
        u: {
          u: "1f6cb",
          x: 9,
          y: 38
        }
      },
      {
        n: [
          "\u5750\u4FBF\u5668"
        ],
        u: {
          u: "1f6bd",
          x: 10,
          y: 38
        }
      },
      {
        n: [
          "\u6DCB\u6D74\u5668"
        ],
        u: {
          u: "1f6bf",
          x: 11,
          y: 38
        }
      },
      {
        n: [
          "\u6D74\u76C6"
        ],
        u: {
          u: "1f6c1",
          x: 12,
          y: 38
        }
      },
      {
        n: [
          "\u6C99\u6F0F"
        ],
        u: {
          u: "231b",
          x: 13,
          y: 38
        }
      },
      {
        n: [
          "\u6D41\u6C99\u6C99\u6F0F",
          "\u6C99\u6F0F\u6D41\u6C99"
        ],
        u: {
          u: "23f3",
          x: 14,
          y: 38
        }
      },
      {
        n: [
          "\u770B"
        ],
        u: {
          u: "231a",
          x: 15,
          y: 38
        }
      },
      {
        n: [
          "\u95F9\u949F"
        ],
        u: {
          u: "23f0",
          x: 16,
          y: 38
        }
      },
      {
        n: [
          "\u79D2\u8868"
        ],
        u: {
          u: "23f1",
          x: 17,
          y: 38
        }
      },
      {
        n: [
          "\u8BA1\u65F6\u5668\u65F6\u949F"
        ],
        u: {
          u: "23f2",
          x: 18,
          y: 38
        }
      },
      {
        n: [
          "\u58C1\u7089\u67B6\u949F"
        ],
        u: {
          u: "1f570",
          x: 19,
          y: 38
        }
      },
      {
        n: [
          "\u949F\u9762\u5341\u4E8C\u70B9\u949F",
          "\u65F6\u949F12"
        ],
        u: {
          u: "1f55b",
          x: 20,
          y: 38
        }
      },
      {
        n: [
          "\u949F\u9762\u5341\u4E8C\u70B9\u4E09\u5341\u5206",
          "\u65F6\u949F1230"
        ],
        u: {
          u: "1f567",
          x: 21,
          y: 38
        }
      },
      {
        n: [
          "\u949F\u9762\u4E00\u70B9\u949F",
          "\u65F6\u949F1"
        ],
        u: {
          u: "1f550",
          x: 22,
          y: 38
        }
      },
      {
        n: [
          "\u949F\u9762\u4E00\u70B9\u534A",
          "\u65F6\u949F130"
        ],
        u: {
          u: "1f55c",
          x: 23,
          y: 38
        }
      },
      {
        n: [
          "\u949F\u9762\u4E24\u70B9\u949F",
          "\u65F6\u949F2"
        ],
        u: {
          u: "1f551",
          x: 24,
          y: 38
        }
      },
      {
        n: [
          "\u949F\u9762\u4E8C\u70B9\u4E09\u5341\u5206",
          "\u65F6\u949F230"
        ],
        u: {
          u: "1f55d",
          x: 25,
          y: 38
        }
      },
      {
        n: [
          "\u949F\u9762\u4E09\u70B9\u949F",
          "\u65F6\u949F3"
        ],
        u: {
          u: "1f552",
          x: 26,
          y: 38
        }
      },
      {
        n: [
          "\u949F\u9762\u4E09\u70B9\u534A",
          "\u65F6\u949F330"
        ],
        u: {
          u: "1f55e",
          x: 27,
          y: 38
        }
      },
      {
        n: [
          "\u949F\u9762\u56DB\u70B9\u9501",
          "\u65F6\u949F4"
        ],
        u: {
          u: "1f553",
          x: 28,
          y: 38
        }
      },
      {
        n: [
          "\u949F\u9762\u56DB\u70B9\u4E09\u5341\u5206",
          "\u65F6\u949F430"
        ],
        u: {
          u: "1f55f",
          x: 29,
          y: 38
        }
      },
      {
        n: [
          "\u949F\u9762\u4E94\u70B9\u949F",
          "\u65F6\u949F5"
        ],
        u: {
          u: "1f554",
          x: 30,
          y: 38
        }
      },
      {
        n: [
          "\u949F\u9762\u4E94\u70B9\u534A",
          "\u65F6\u949F530"
        ],
        u: {
          u: "1f560",
          x: 31,
          y: 38
        }
      },
      {
        n: [
          "\u949F\u9762\u516D\u70B9\u949F",
          "\u65F6\u949F6"
        ],
        u: {
          u: "1f555",
          x: 32,
          y: 38
        }
      },
      {
        n: [
          "\u949F\u9762\u516D\u70B9\u534A",
          "\u65F6\u949F630"
        ],
        u: {
          u: "1f561",
          x: 33,
          y: 38
        }
      },
      {
        n: [
          "\u949F\u9762\u4E03\u70B9\u949F",
          "\u65F6\u949F7"
        ],
        u: {
          u: "1f556",
          x: 34,
          y: 38
        }
      },
      {
        n: [
          "\u949F\u9762\u4E03\u70B9\u4E09\u5341\u5206",
          "\u65F6\u949F730"
        ],
        u: {
          u: "1f562",
          x: 35,
          y: 38
        }
      },
      {
        n: [
          "\u949F\u9762\u516B\u70B9\u949F",
          "\u65F6\u949F8"
        ],
        u: {
          u: "1f557",
          x: 36,
          y: 38
        }
      },
      {
        n: [
          "\u949F\u9762\u516B\u70B9\u4E09\u5341\u5206",
          "\u65F6\u949F830"
        ],
        u: {
          u: "1f563",
          x: 37,
          y: 38
        }
      },
      {
        n: [
          "\u949F\u9762\u4E5D\u70B9\u949F",
          "\u65F6\u949F9"
        ],
        u: {
          u: "1f558",
          x: 38,
          y: 38
        }
      },
      {
        n: [
          "\u949F\u9762\u4E5D\u70B9\u534A",
          "\u65F6\u949F930"
        ],
        u: {
          u: "1f564",
          x: 39,
          y: 38
        }
      },
      {
        n: [
          "\u949F\u9762\u5341\u70B9\u949F",
          "\u65F6\u949F10"
        ],
        u: {
          u: "1f559",
          x: 40,
          y: 38
        }
      },
      {
        n: [
          "\u949F\u9762\u5341\u70B9\u4E09\u5341\u5206",
          "\u65F6\u949F1030"
        ],
        u: {
          u: "1f565",
          x: 41,
          y: 38
        }
      },
      {
        n: [
          "\u949F\u9762\u5341\u4E00\u70B9\u949F",
          "\u65F6\u949F11"
        ],
        u: {
          u: "1f55a",
          x: 42,
          y: 38
        }
      },
      {
        n: [
          "\u949F\u9762\u5341\u4E00\u70B9\u4E09\u5341\u5206",
          "\u65F6\u949F1130"
        ],
        u: {
          u: "1f566",
          x: 43,
          y: 38
        }
      },
      {
        n: [
          "\u65B0\u6708\u7B26\u53F7",
          "\u65B0\u6708"
        ],
        u: {
          u: "1f311",
          x: 44,
          y: 38
        }
      },
      {
        n: [
          "\u8721\u6708\u7B26\u53F7",
          "\u5A25\u7709\u6708"
        ],
        u: {
          u: "1f312",
          x: 45,
          y: 38
        }
      },
      {
        n: [
          "\u7B2C\u4E00\u5B63\u6708\u4EAE\u7B26\u53F7",
          "\u7B2C\u4E00\u5B63\u6708\u4EAE"
        ],
        u: {
          u: "1f313",
          x: 46,
          y: 38
        }
      },
      {
        n: [
          "\u4E0A\u8721\u51F8\u6708\u7B26\u53F7",
          "\u6708\u7403",
          "\u4E0A\u8721\u51F8\u6708"
        ],
        u: {
          u: "1f314",
          x: 47,
          y: 38
        }
      },
      {
        n: [
          "\u6EE1\u6708\u7B26\u53F7",
          "\u6EE1\u6708"
        ],
        u: {
          u: "1f315",
          x: 48,
          y: 38
        }
      },
      {
        n: [
          "\u6708\u7F3A\u51F8\u51FA\u7B26\u53F7",
          "\u6708\u7F3A"
        ],
        u: {
          u: "1f316",
          x: 49,
          y: 38
        }
      },
      {
        n: [
          "\u6700\u540E\u56DB\u5206\u4E4B\u4E00\u6708\u4EAE\u7B26\u53F7",
          "\u6700\u540E\u56DB\u5206\u4E4B\u4E00\u6708"
        ],
        u: {
          u: "1f317",
          x: 0,
          y: 39
        }
      },
      {
        n: [
          "\u6708\u5706\u7B26\u53F7",
          "\u6B8B\u6708"
        ],
        u: {
          u: "1f318",
          x: 1,
          y: 39
        }
      },
      {
        n: [
          "\u65B0\u6708"
        ],
        u: {
          u: "1f319",
          x: 2,
          y: 39
        }
      },
      {
        n: [
          "\u6709\u8138\u7684\u65B0\u6708"
        ],
        u: {
          u: "1f31a",
          x: 3,
          y: 39
        }
      },
      {
        n: [
          "\u6709\u8138\u7684\u7B2C\u4E00\u5B63\u6708\u4EAE"
        ],
        u: {
          u: "1f31b",
          x: 4,
          y: 39
        }
      },
      {
        n: [
          "\u6709\u8138\u7684\u6700\u540E\u56DB\u5206\u4E4B\u4E00\u6708\u4EAE"
        ],
        u: {
          u: "1f31c",
          x: 5,
          y: 39
        }
      },
      {
        n: [
          "\u6E29\u5EA6\u8BA1"
        ],
        u: {
          u: "1f321",
          x: 6,
          y: 39
        }
      },
      {
        n: [
          "\u6709\u5149\u7EBF\u7684\u9ED1\u592A\u9633",
          "\u6674\u6717\u7684"
        ],
        u: {
          u: "2600",
          x: 7,
          y: 39
        }
      },
      {
        n: [
          "\u6EE1\u6708\u6709\u8138"
        ],
        u: {
          u: "1f31d",
          x: 8,
          y: 39
        }
      },
      {
        n: [
          "\u6709\u8138\u7684\u592A\u9633"
        ],
        u: {
          u: "1f31e",
          x: 9,
          y: 39
        }
      },
      {
        n: [
          "\u767D\u8272\u4E2D\u661F\u5F62",
          "\u660E\u661F"
        ],
        u: {
          u: "2b50",
          x: 10,
          y: 39
        }
      },
      {
        n: [
          "\u53D1\u5149\u7684\u6052\u661F",
          "star2"
        ],
        u: {
          u: "1f31f",
          x: 11,
          y: 39
        }
      },
      {
        n: [
          "\u6D41\u661F\u961F",
          "\u661F\u661F"
        ],
        u: {
          u: "1f320",
          x: 12,
          y: 39
        }
      },
      {
        n: [
          "\u4E91"
        ],
        u: {
          u: "2601",
          x: 13,
          y: 39
        }
      },
      {
        n: [
          "\u4E91\u540E\u7684\u592A\u9633",
          "\u90E8\u5206\u6674\u6717"
        ],
        u: {
          u: "26c5",
          x: 14,
          y: 39
        }
      },
      {
        n: [
          "\u96F7\u96E8\u4E91"
        ],
        u: {
          u: "26c8",
          x: 15,
          y: 39
        }
      },
      {
        n: [
          "\u5927\u90E8\u5206\u65F6\u95F4\u9633\u5149\u660E\u5A9A",
          "\u592A\u9633\u5C0F\u4E91"
        ],
        u: {
          u: "1f324",
          x: 16,
          y: 39
        }
      },
      {
        n: [
          "\u51E0\u4E4E\u6CA1\u6709\u9633\u5149",
          "\u4E91\u540E\u7684\u592A\u9633"
        ],
        u: {
          u: "1f325",
          x: 17,
          y: 39
        }
      },
      {
        n: [
          "\u90E8\u5206\u6674\u96E8",
          "\u96E8\u4E91\u80CC\u540E\u7684\u592A\u9633"
        ],
        u: {
          u: "1f326",
          x: 18,
          y: 39
        }
      },
      {
        n: [
          "\u96E8\u4E91"
        ],
        u: {
          u: "1f327",
          x: 19,
          y: 39
        }
      },
      {
        n: [
          "\u96EA\u4E91"
        ],
        u: {
          u: "1f328",
          x: 20,
          y: 39
        }
      },
      {
        n: [
          "\u95EA\u7535",
          "\u95EA\u7535\u4E91"
        ],
        u: {
          u: "1f329",
          x: 21,
          y: 39
        }
      },
      {
        n: [
          "\u9F99\u5377\u98CE",
          "\u9F99\u5377\u98CE\u4E91"
        ],
        u: {
          u: "1f32a",
          x: 22,
          y: 39
        }
      },
      {
        n: [
          "\u96FE"
        ],
        u: {
          u: "1f32b",
          x: 23,
          y: 39
        }
      },
      {
        n: [
          "\u98CE\u5439\u9762"
        ],
        u: {
          u: "1f32c",
          x: 24,
          y: 39
        }
      },
      {
        n: [
          "\u6C14\u65CB"
        ],
        u: {
          u: "1f300",
          x: 25,
          y: 39
        }
      },
      {
        n: [
          "\u8679"
        ],
        u: {
          u: "1f308",
          x: 26,
          y: 39
        }
      },
      {
        n: [
          "\u5C01\u95ED\u5F0F\u96E8\u4F1E"
        ],
        u: {
          u: "1f302",
          x: 27,
          y: 39
        }
      },
      {
        n: [
          "\u96E8\u4F1E"
        ],
        u: {
          u: "2602",
          x: 28,
          y: 39
        }
      },
      {
        n: [
          "\u96E8\u70B9\u96E8\u4F1E"
        ],
        u: {
          u: "2614",
          x: 29,
          y: 39
        }
      },
      {
        n: [
          "\u5730\u9762\u4E0A\u7684\u96E8\u4F1E"
        ],
        u: {
          u: "26f1",
          x: 30,
          y: 39
        }
      },
      {
        n: [
          "\u9AD8\u538B\u6807\u5FD7",
          "\u624E\u666E"
        ],
        u: {
          u: "26a1",
          x: 31,
          y: 39
        }
      },
      {
        n: [
          "\u96EA\u82B1"
        ],
        u: {
          u: "2744",
          x: 32,
          y: 39
        }
      },
      {
        n: [
          "\u96EA\u4EBA"
        ],
        u: {
          u: "2603",
          x: 33,
          y: 39
        }
      },
      {
        n: [
          "\u6CA1\u6709\u96EA\u7684\u96EA\u4EBA"
        ],
        u: {
          u: "26c4",
          x: 34,
          y: 39
        }
      },
      {
        n: [
          "\u5F57\u661F"
        ],
        u: {
          u: "2604",
          x: 35,
          y: 39
        }
      },
      {
        n: [
          "\u706B"
        ],
        u: {
          u: "1f525",
          x: 36,
          y: 39
        }
      },
      {
        n: [
          "\u6DB2\u6EF4"
        ],
        u: {
          u: "1f4a7",
          x: 37,
          y: 39
        }
      },
      {
        n: [
          "\u6C34\u6CE2",
          "\u5927\u6D77"
        ],
        u: {
          u: "1f30a",
          x: 38,
          y: 39
        }
      }
    ],
    u: "1f698",
    title: "\u65C5\u884C\u548C\u5730\u70B9",
    key: "travel_places"
  },
  {
    emojis: [
      {
        n: [
          "\u5E26\u53D6\u6D88\u884C\u7A0B\u7684\u626C\u58F0\u5668",
          "\u6C89\u9ED8\u7684"
        ],
        u: {
          u: "1f507",
          x: 39,
          y: 39
        }
      },
      {
        n: [
          "\u53D1\u8A00\u8005"
        ],
        u: {
          u: "1f508",
          x: 40,
          y: 39
        }
      },
      {
        n: [
          "\u5E26\u4E00\u4E2A\u58F0\u6CE2\u7684\u626C\u58F0\u5668",
          "\u58F0\u97F3"
        ],
        u: {
          u: "1f509",
          x: 41,
          y: 39
        }
      },
      {
        n: [
          "\u4E09\u58F0\u6CE2\u626C\u58F0\u5668",
          "\u54CD\u4EAE\u7684\u58F0\u97F3"
        ],
        u: {
          u: "1f50a",
          x: 42,
          y: 39
        }
      },
      {
        n: [
          "\u516C\u5171\u5E7F\u64AD\u626C\u58F0\u5668",
          "\u626C\u58F0\u5668"
        ],
        u: {
          u: "1f4e2",
          x: 43,
          y: 39
        }
      },
      {
        n: [
          "\u6B22\u547C\u6269\u97F3\u5668",
          "\u767E\u4E07"
        ],
        u: {
          u: "1f4e3",
          x: 44,
          y: 39
        }
      },
      {
        n: [
          "\u90AE\u653F\u53F7\u89D2"
        ],
        u: {
          u: "1f4ef",
          x: 45,
          y: 39
        }
      },
      {
        n: [
          "\u949F"
        ],
        u: {
          u: "1f514",
          x: 46,
          y: 39
        }
      },
      {
        n: [
          "\u5E26\u53D6\u6D88\u884C\u7A0B\u7684\u949F",
          "\u6CA1\u6709\u94C3\u58F0"
        ],
        u: {
          u: "1f515",
          x: 47,
          y: 39
        }
      },
      {
        n: [
          "\u4E50\u8C31"
        ],
        u: {
          u: "1f3bc",
          x: 48,
          y: 39
        }
      },
      {
        n: [
          "\u97F3\u7B26"
        ],
        u: {
          u: "1f3b5",
          x: 49,
          y: 39
        }
      },
      {
        n: [
          "\u591A\u4E2A\u97F3\u7B26",
          "\u7B14\u8BB0"
        ],
        u: {
          u: "1f3b6",
          x: 0,
          y: 40
        }
      },
      {
        n: [
          "\u5F55\u97F3\u5BA4\u8BDD\u7B52"
        ],
        u: {
          u: "1f399",
          x: 1,
          y: 40
        }
      },
      {
        n: [
          "\u6C34\u5E73\u6ED1\u5757"
        ],
        u: {
          u: "1f39a",
          x: 2,
          y: 40
        }
      },
      {
        n: [
          "\u63A7\u5236\u65CB\u94AE"
        ],
        u: {
          u: "1f39b",
          x: 3,
          y: 40
        }
      },
      {
        n: [
          "\u9EA6\u514B\u98CE"
        ],
        u: {
          u: "1f3a4",
          x: 4,
          y: 40
        }
      },
      {
        n: [
          "\u8033\u673A",
          "\u8033\u673A"
        ],
        u: {
          u: "1f3a7",
          x: 5,
          y: 40
        }
      },
      {
        n: [
          "\u65E0\u7EBF\u7535\u5E7F\u64AD"
        ],
        u: {
          u: "1f4fb",
          x: 6,
          y: 40
        }
      },
      {
        n: [
          "\u8428\u514B\u65AF\u7BA1"
        ],
        u: {
          u: "1f3b7",
          x: 7,
          y: 40
        }
      },
      {
        n: [
          "\u5409\u4ED6"
        ],
        u: {
          u: "1f3b8",
          x: 8,
          y: 40
        }
      },
      {
        n: [
          "\u97F3\u4E50\u952E\u76D8"
        ],
        u: {
          u: "1f3b9",
          x: 9,
          y: 40
        }
      },
      {
        n: [
          "\u5C0F\u53F7"
        ],
        u: {
          u: "1f3ba",
          x: 10,
          y: 40
        }
      },
      {
        n: [
          "\u5C0F\u63D0\u7434"
        ],
        u: {
          u: "1f3bb",
          x: 11,
          y: 40
        }
      },
      {
        n: [
          "\u9F13\u69CC\u9F13"
        ],
        u: {
          u: "1f941",
          x: 12,
          y: 40
        }
      },
      {
        n: [
          "\u624B\u673A",
          "\u82F9\u679C\u624B\u673A"
        ],
        u: {
          u: "1f4f1",
          x: 13,
          y: 40
        }
      },
      {
        n: [
          "\u5DE6\u4FA7\u5E26\u5411\u53F3\u7BAD\u5934\u7684\u624B\u673A",
          "\u4F7F\u547D\u611F"
        ],
        u: {
          u: "1f4f2",
          x: 14,
          y: 40
        }
      },
      {
        n: [
          "\u9ED1\u8272\u7535\u8BDD",
          "\u7535\u8BDD",
          "\u7535\u8BDD"
        ],
        u: {
          u: "260e",
          x: 15,
          y: 40
        }
      },
      {
        n: [
          "\u7535\u8BDD\u542C\u7B52"
        ],
        u: {
          u: "1f4de",
          x: 16,
          y: 40
        }
      },
      {
        n: [
          "\u5BFB\u547C\u673A"
        ],
        u: {
          u: "1f4df",
          x: 17,
          y: 40
        }
      },
      {
        n: [
          "\u4F20\u771F\u673A",
          "\u4F20\u771F"
        ],
        u: {
          u: "1f4e0",
          x: 18,
          y: 40
        }
      },
      {
        n: [
          "\u7535\u6C60"
        ],
        u: {
          u: "1f50b",
          x: 19,
          y: 40
        }
      },
      {
        n: [
          "\u7535\u63D2\u5934"
        ],
        u: {
          u: "1f50c",
          x: 20,
          y: 40
        }
      },
      {
        n: [
          "\u4E2A\u4EBA\u7535\u8111",
          "\u8BA1\u7B97\u673A"
        ],
        u: {
          u: "1f4bb",
          x: 21,
          y: 40
        }
      },
      {
        n: [
          "\u53F0\u5F0F\u8BA1\u7B97\u673A"
        ],
        u: {
          u: "1f5a5",
          x: 22,
          y: 40
        }
      },
      {
        n: [
          "\u6253\u5370\u673A"
        ],
        u: {
          u: "1f5a8",
          x: 23,
          y: 40
        }
      },
      {
        n: [
          "\u952E\u76D8"
        ],
        u: {
          u: "2328",
          x: 24,
          y: 40
        }
      },
      {
        n: [
          "\u4E09\u6309\u94AE\u9F20\u6807"
        ],
        u: {
          u: "1f5b1",
          x: 25,
          y: 40
        }
      },
      {
        n: [
          "\u8F68\u8FF9\u7403"
        ],
        u: {
          u: "1f5b2",
          x: 26,
          y: 40
        }
      },
      {
        n: [
          "\u8FF7\u4F60\u5149\u76D8"
        ],
        u: {
          u: "1f4bd",
          x: 27,
          y: 40
        }
      },
      {
        n: [
          "\u8F6F\u76D8"
        ],
        u: {
          u: "1f4be",
          x: 28,
          y: 40
        }
      },
      {
        n: [
          "\u5149\u76D8",
          "\u5149\u76D8"
        ],
        u: {
          u: "1f4bf",
          x: 29,
          y: 40
        }
      },
      {
        n: [
          "\u6570\u5B57\u5316\u89C6\u9891\u5149\u76D8"
        ],
        u: {
          u: "1f4c0",
          x: 30,
          y: 40
        }
      },
      {
        n: [
          "\u7535\u5F71\u6444\u5F71\u673A"
        ],
        u: {
          u: "1f3a5",
          x: 31,
          y: 40
        }
      },
      {
        n: [
          "\u80F6\u7247\u6846\u67B6"
        ],
        u: {
          u: "1f39e",
          x: 32,
          y: 40
        }
      },
      {
        n: [
          "\u7535\u5F71\u653E\u6620\u673A"
        ],
        u: {
          u: "1f4fd",
          x: 33,
          y: 40
        }
      },
      {
        n: [
          "\u9694\u677F",
          "\u5FEB\u677F"
        ],
        u: {
          u: "1f3ac",
          x: 34,
          y: 40
        }
      },
      {
        n: [
          "\u7535\u89C6\u673A",
          "\u7535\u89C6"
        ],
        u: {
          u: "1f4fa",
          x: 35,
          y: 40
        }
      },
      {
        n: [
          "\u7167\u76F8\u673A"
        ],
        u: {
          u: "1f4f7",
          x: 36,
          y: 40
        }
      },
      {
        n: [
          "\u5E26\u95EA\u5149\u706F\u7684\u7167\u76F8\u673A"
        ],
        u: {
          u: "1f4f8",
          x: 37,
          y: 40
        }
      },
      {
        n: [
          "\u6444\u50CF\u673A"
        ],
        u: {
          u: "1f4f9",
          x: 38,
          y: 40
        }
      },
      {
        n: [
          "\u5F55\u50CF\u5E26",
          "vhs"
        ],
        u: {
          u: "1f4fc",
          x: 39,
          y: 40
        }
      },
      {
        n: [
          "\u5DE6\u6307\u653E\u5927\u955C",
          "mag\u516C\u53F8"
        ],
        u: {
          u: "1f50d",
          x: 40,
          y: 40
        }
      },
      {
        n: [
          "\u53F3\u6307\u653E\u5927\u955C",
          "mag\u53F3"
        ],
        u: {
          u: "1f50e",
          x: 41,
          y: 40
        }
      },
      {
        n: [
          "\u663E\u5FAE\u955C"
        ],
        u: {
          u: "1f52c",
          x: 42,
          y: 40
        }
      },
      {
        n: [
          "\u671B\u8FDC\u955C"
        ],
        u: {
          u: "1f52d",
          x: 43,
          y: 40
        }
      },
      {
        n: [
          "\u536B\u661F\u5929\u7EBF"
        ],
        u: {
          u: "1f4e1",
          x: 44,
          y: 40
        }
      },
      {
        n: [
          "\u8721\u70DB"
        ],
        u: {
          u: "1f56f",
          x: 45,
          y: 40
        }
      },
      {
        n: [
          "\u7535\u706F\u6CE1",
          "\u7535\u706F\u6CE1"
        ],
        u: {
          u: "1f4a1",
          x: 46,
          y: 40
        }
      },
      {
        n: [
          "\u624B\u7535\u7B52",
          "\u624B\u7535\u7B52"
        ],
        u: {
          u: "1f526",
          x: 47,
          y: 40
        }
      },
      {
        n: [
          "izakaya\u706F\u7B3C",
          "\u706F\u7B3C"
        ],
        u: {
          u: "1f3ee",
          x: 48,
          y: 40
        }
      },
      {
        n: [
          "\u5E26\u88C5\u9970\u76D6\u7684\u7B14\u8BB0\u672C"
        ],
        u: {
          u: "1f4d4",
          x: 49,
          y: 40
        }
      },
      {
        n: [
          "\u95ED\u5377"
        ],
        u: {
          u: "1f4d5",
          x: 0,
          y: 41
        }
      },
      {
        n: [
          "\u4E00\u76EE\u4E86\u7136\u7684\u4E8B",
          "\u4E66"
        ],
        u: {
          u: "1f4d6",
          x: 1,
          y: 41
        }
      },
      {
        n: [
          "\u7EFF\u76AE\u4E66"
        ],
        u: {
          u: "1f4d7",
          x: 2,
          y: 41
        }
      },
      {
        n: [
          "\u84DD\u76AE\u4E66"
        ],
        u: {
          u: "1f4d8",
          x: 3,
          y: 41
        }
      },
      {
        n: [
          "\u6A59\u8272\u4E66"
        ],
        u: {
          u: "1f4d9",
          x: 4,
          y: 41
        }
      },
      {
        n: [
          "\u4E66"
        ],
        u: {
          u: "1f4da",
          x: 5,
          y: 41
        }
      },
      {
        n: [
          "\u7B14\u8BB0\u672C"
        ],
        u: {
          u: "1f4d3",
          x: 6,
          y: 41
        }
      },
      {
        n: [
          "\u5206\u7C7B\u8D26\u7C3F"
        ],
        u: {
          u: "1f4d2",
          x: 7,
          y: 41
        }
      },
      {
        n: [
          "\u5E26\u5377\u66F2\u7684\u9875\u9762"
        ],
        u: {
          u: "1f4c3",
          x: 8,
          y: 41
        }
      },
      {
        n: [
          "\u7EB8\u5377"
        ],
        u: {
          u: "1f4dc",
          x: 9,
          y: 41
        }
      },
      {
        n: [
          "\u9875\u9762\u6B63\u9762\u671D\u4E0A"
        ],
        u: {
          u: "1f4c4",
          x: 10,
          y: 41
        }
      },
      {
        n: [
          "\u62A5\u7EB8"
        ],
        u: {
          u: "1f4f0",
          x: 11,
          y: 41
        }
      },
      {
        n: [
          "\u5377\u8D77\u7684\u62A5\u7EB8"
        ],
        u: {
          u: "1f5de",
          x: 12,
          y: 41
        }
      },
      {
        n: [
          "\u4E66\u7B7E\u9009\u9879\u5361"
        ],
        u: {
          u: "1f4d1",
          x: 13,
          y: 41
        }
      },
      {
        n: [
          "\u4E66\u7B7E"
        ],
        u: {
          u: "1f516",
          x: 14,
          y: 41
        }
      },
      {
        n: [
          "\u6807\u7B7E"
        ],
        u: {
          u: "1f3f7",
          x: 15,
          y: 41
        }
      },
      {
        n: [
          "\u94B1\u888B",
          "\u94B1\u888B"
        ],
        u: {
          u: "1f4b0",
          x: 16,
          y: 41
        }
      },
      {
        n: [
          "\u5E26\u65E5\u5143\u7B26\u53F7\u7684\u949E\u7968",
          "\u65E5\u5143"
        ],
        u: {
          u: "1f4b4",
          x: 17,
          y: 41
        }
      },
      {
        n: [
          "\u5E26\u7F8E\u5143\u7B26\u53F7\u7684\u949E\u7968",
          "\u7F8E\u5143"
        ],
        u: {
          u: "1f4b5",
          x: 18,
          y: 41
        }
      },
      {
        n: [
          "\u5E26\u6B27\u5143\u7B26\u53F7\u7684\u949E\u7968",
          "\u6B27\u5143"
        ],
        u: {
          u: "1f4b6",
          x: 19,
          y: 41
        }
      },
      {
        n: [
          "\u5E26\u82F1\u9551\u7B26\u53F7\u7684\u949E\u7968",
          "\u82F1\u9551"
        ],
        u: {
          u: "1f4b7",
          x: 20,
          y: 41
        }
      },
      {
        n: [
          "\u6709\u7FC5\u8180\u7684\u94B1"
        ],
        u: {
          u: "1f4b8",
          x: 21,
          y: 41
        }
      },
      {
        n: [
          "\u4FE1\u7528\u5361"
        ],
        u: {
          u: "1f4b3",
          x: 22,
          y: 41
        }
      },
      {
        n: [
          "\u5E26\u4E0A\u5347\u8D8B\u52BF\u548C\u65E5\u5143\u7B26\u53F7\u7684\u56FE\u8868",
          "\u56FE\u8868"
        ],
        u: {
          u: "1f4b9",
          x: 23,
          y: 41
        }
      },
      {
        n: [
          "\u8D27\u5E01\u5151\u6362"
        ],
        u: {
          u: "1f4b1",
          x: 24,
          y: 41
        }
      },
      {
        n: [
          "\u91CD\u7F8E\u5143\u7B26\u53F7"
        ],
        u: {
          u: "1f4b2",
          x: 25,
          y: 41
        }
      },
      {
        n: [
          "\u4FE1\u5C01",
          "\u7535\u5B50\u90AE\u4EF6"
        ],
        u: {
          u: "2709",
          x: 26,
          y: 41
        }
      },
      {
        n: [
          "\u7535\u5B50\u90AE\u4EF6\u7B26\u53F7",
          "\u7535\u5B50\u90AE\u4EF6"
        ],
        u: {
          u: "1f4e7",
          x: 27,
          y: 41
        }
      },
      {
        n: [
          "\u4F20\u5165\u4FE1\u5C01"
        ],
        u: {
          u: "1f4e8",
          x: 28,
          y: 41
        }
      },
      {
        n: [
          "\u4E0A\u65B9\u5E26\u6709\u5411\u4E0B\u7BAD\u5934\u7684\u4FE1\u5C01",
          "\u5E26\u7BAD\u5934\u7684\u4FE1\u5C01"
        ],
        u: {
          u: "1f4e9",
          x: 29,
          y: 41
        }
      },
      {
        n: [
          "\u53D1\u4EF6\u7BB1\u6258\u76D8"
        ],
        u: {
          u: "1f4e4",
          x: 30,
          y: 41
        }
      },
      {
        n: [
          "\u6536\u4EF6\u7BB1\u6258\u76D8"
        ],
        u: {
          u: "1f4e5",
          x: 31,
          y: 41
        }
      },
      {
        n: [
          "\u5305\u88F9"
        ],
        u: {
          u: "1f4e6",
          x: 32,
          y: 41
        }
      },
      {
        n: [
          "\u5DF2\u5173\u95ED\u5E26\u6709\u63D0\u5347\u6807\u5FD7\u7684\u90AE\u7BB1",
          "\u90AE\u7BB1"
        ],
        u: {
          u: "1f4eb",
          x: 33,
          y: 41
        }
      },
      {
        n: [
          "\u5DF2\u5173\u95ED\u5E26\u6709\u964D\u4F4E\u6807\u5FD7\u7684\u90AE\u7BB1",
          "\u90AE\u7BB1\u5DF2\u5173\u95ED"
        ],
        u: {
          u: "1f4ea",
          x: 34,
          y: 41
        }
      },
      {
        n: [
          "\u6253\u5F00\u5E26\u6709\u63D0\u5347\u6807\u5FD7\u7684\u90AE\u7BB1",
          "\u5305\u542B\u90AE\u4EF6\u7684\u90AE\u7BB1"
        ],
        u: {
          u: "1f4ec",
          x: 35,
          y: 41
        }
      },
      {
        n: [
          "\u4F7F\u7528\u964D\u4F4E\u7684\u6807\u5FD7\u6253\u5F00\u90AE\u7BB1",
          "\u6CA1\u6709\u90AE\u4EF6\u7684\u90AE\u7BB1"
        ],
        u: {
          u: "1f4ed",
          x: 36,
          y: 41
        }
      },
      {
        n: [
          "\u4FE1\u7BB1"
        ],
        u: {
          u: "1f4ee",
          x: 37,
          y: 41
        }
      },
      {
        n: [
          "\u5E26\u9009\u7968\u7684\u6295\u7968\u7BB1"
        ],
        u: {
          u: "1f5f3",
          x: 38,
          y: 41
        }
      },
      {
        n: [
          "\u94C5\u7B14",
          "\u94C5\u7B142"
        ],
        u: {
          u: "270f",
          x: 39,
          y: 41
        }
      },
      {
        n: [
          "\u9ED1\u8272\u7B14\u5C16"
        ],
        u: {
          u: "2712",
          x: 40,
          y: 41
        }
      },
      {
        n: [
          "\u5DE6\u4E0B\u81EA\u6765\u6C34\u7B14"
        ],
        u: {
          u: "1f58b",
          x: 41,
          y: 41
        }
      },
      {
        n: [
          "\u5DE6\u4E0B\u5706\u73E0\u7B14"
        ],
        u: {
          u: "1f58a",
          x: 42,
          y: 41
        }
      },
      {
        n: [
          "\u5DE6\u4E0B\u6F06\u5237"
        ],
        u: {
          u: "1f58c",
          x: 43,
          y: 41
        }
      },
      {
        n: [
          "\u5DE6\u4E0B\u8721\u7B14"
        ],
        u: {
          u: "1f58d",
          x: 44,
          y: 41
        }
      },
      {
        n: [
          "\u5907\u5FD8\u5F55",
          "\u94C5\u7B14"
        ],
        u: {
          u: "1f4dd",
          x: 45,
          y: 41
        }
      },
      {
        n: [
          "\u516C\u6587\u5305"
        ],
        u: {
          u: "1f4bc",
          x: 46,
          y: 41
        }
      },
      {
        n: [
          "\u6587\u4EF6\u6587\u4EF6\u5939"
        ],
        u: {
          u: "1f4c1",
          x: 47,
          y: 41
        }
      },
      {
        n: [
          "\u6253\u5F00\u6587\u4EF6\u6587\u4EF6\u5939"
        ],
        u: {
          u: "1f4c2",
          x: 48,
          y: 41
        }
      },
      {
        n: [
          "\u5361\u7247\u7D22\u5F15\u5206\u9694\u7B26"
        ],
        u: {
          u: "1f5c2",
          x: 49,
          y: 41
        }
      },
      {
        n: [
          "\u65E5\u5386",
          "\u65E5\u671F"
        ],
        u: {
          u: "1f4c5",
          x: 0,
          y: 42
        }
      },
      {
        n: [
          "\u6495\u4E0B\u65E5\u5386",
          "\u65E5\u5386"
        ],
        u: {
          u: "1f4c6",
          x: 1,
          y: 42
        }
      },
      {
        n: [
          "\u87BA\u65CB\u5F62\u8BB0\u4E8B\u672C"
        ],
        u: {
          u: "1f5d2",
          x: 2,
          y: 42
        }
      },
      {
        n: [
          "\u87BA\u65CB\u65E5\u5386\u57AB"
        ],
        u: {
          u: "1f5d3",
          x: 3,
          y: 42
        }
      },
      {
        n: [
          "\u5361\u7247\u7D22\u5F15"
        ],
        u: {
          u: "1f4c7",
          x: 4,
          y: 42
        }
      },
      {
        n: [
          "\u6709\u4E0A\u5347\u8D8B\u52BF\u7684\u56FE\u8868"
        ],
        u: {
          u: "1f4c8",
          x: 5,
          y: 42
        }
      },
      {
        n: [
          "\u5411\u4E0B\u8D8B\u52BF\u56FE"
        ],
        u: {
          u: "1f4c9",
          x: 6,
          y: 42
        }
      },
      {
        n: [
          "\u6761\u5F62\u56FE"
        ],
        u: {
          u: "1f4ca",
          x: 7,
          y: 42
        }
      },
      {
        n: [
          "\u526A\u8D34\u677F"
        ],
        u: {
          u: "1f4cb",
          x: 8,
          y: 42
        }
      },
      {
        n: [
          "\u56FE\u9489"
        ],
        u: {
          u: "1f4cc",
          x: 9,
          y: 42
        }
      },
      {
        n: [
          "\u5706\u5F62\u56FE\u9489"
        ],
        u: {
          u: "1f4cd",
          x: 10,
          y: 42
        }
      },
      {
        n: [
          "\u56DE\u5F62\u9488"
        ],
        u: {
          u: "1f4ce",
          x: 11,
          y: 42
        }
      },
      {
        n: [
          "\u94FE\u63A5\u7684\u56DE\u5F62\u9488"
        ],
        u: {
          u: "1f587",
          x: 12,
          y: 42
        }
      },
      {
        n: [
          "\u76F4\u5C3A"
        ],
        u: {
          u: "1f4cf",
          x: 13,
          y: 42
        }
      },
      {
        n: [
          "\u4E09\u89D2\u5C3A"
        ],
        u: {
          u: "1f4d0",
          x: 14,
          y: 42
        }
      },
      {
        n: [
          "\u9ED1\u8272\u526A\u5200",
          "\u526A\u5200"
        ],
        u: {
          u: "2702",
          x: 15,
          y: 42
        }
      },
      {
        n: [
          "\u5361\u7247\u6587\u4EF6\u76D2"
        ],
        u: {
          u: "1f5c3",
          x: 16,
          y: 42
        }
      },
      {
        n: [
          "\u6587\u4EF6\u67DC"
        ],
        u: {
          u: "1f5c4",
          x: 17,
          y: 42
        }
      },
      {
        n: [
          "\u5E9F\u7EB8\u7BD3"
        ],
        u: {
          u: "1f5d1",
          x: 18,
          y: 42
        }
      },
      {
        n: [
          "\u9501"
        ],
        u: {
          u: "1f512",
          x: 19,
          y: 42
        }
      },
      {
        n: [
          "\u6253\u5F00\u9501",
          "\u89E3\u9501"
        ],
        u: {
          u: "1f513",
          x: 20,
          y: 42
        }
      },
      {
        n: [
          "\u7528\u58A8\u6C34\u7B14\u9501\u5B9A"
        ],
        u: {
          u: "1f50f",
          x: 21,
          y: 42
        }
      },
      {
        n: [
          "\u7528\u94A5\u5319\u9501\u7D27"
        ],
        u: {
          u: "1f510",
          x: 22,
          y: 42
        }
      },
      {
        n: [
          "\u94A5\u5319"
        ],
        u: {
          u: "1f511",
          x: 23,
          y: 42
        }
      },
      {
        n: [
          "\u65E7\u5BC6\u94A5"
        ],
        u: {
          u: "1f5dd",
          x: 24,
          y: 42
        }
      },
      {
        n: [
          "\u9524\u5B50"
        ],
        u: {
          u: "1f528",
          x: 25,
          y: 42
        }
      },
      {
        n: [
          "\u9009\u62E9"
        ],
        u: {
          u: "26cf",
          x: 26,
          y: 42
        }
      },
      {
        n: [
          "\u9524\u548C\u9550"
        ],
        u: {
          u: "2692",
          x: 27,
          y: 42
        }
      },
      {
        n: [
          "\u9524\u5B50\u548C\u6273\u624B"
        ],
        u: {
          u: "1f6e0",
          x: 28,
          y: 42
        }
      },
      {
        n: [
          "\u5315\u9996\u5200"
        ],
        u: {
          u: "1f5e1",
          x: 29,
          y: 42
        }
      },
      {
        n: [
          "\u4EA4\u53C9\u7684\u5251"
        ],
        u: {
          u: "2694",
          x: 30,
          y: 42
        }
      },
      {
        n: [
          "\u624B\u67AA",
          "\u67AA"
        ],
        u: {
          u: "1f52b",
          x: 31,
          y: 42
        }
      },
      {
        n: [
          "\u5F13\u7BAD"
        ],
        u: {
          u: "1f3f9",
          x: 32,
          y: 42
        }
      },
      {
        n: [
          "\u76FE"
        ],
        u: {
          u: "1f6e1",
          x: 33,
          y: 42
        }
      },
      {
        n: [
          "\u6273\u624B"
        ],
        u: {
          u: "1f527",
          x: 34,
          y: 42
        }
      },
      {
        n: [
          "\u87BA\u6BCD\u548C\u87BA\u6813"
        ],
        u: {
          u: "1f529",
          x: 35,
          y: 42
        }
      },
      {
        n: [
          "\u6392\u6321"
        ],
        u: {
          u: "2699",
          x: 36,
          y: 42
        }
      },
      {
        n: [
          "\u538B\u7F29"
        ],
        u: {
          u: "1f5dc",
          x: 37,
          y: 42
        }
      },
      {
        n: [
          "\u963F\u52D2\u59C6\u6BD4\u5947"
        ],
        u: {
          u: "2697",
          x: 38,
          y: 42
        }
      },
      {
        n: [
          "\u89C4\u6A21"
        ],
        u: {
          u: "2696",
          x: 39,
          y: 42
        }
      },
      {
        n: [
          "\u94FE\u63A5\u7B26\u53F7",
          "\u94FE\u63A5"
        ],
        u: {
          u: "1f517",
          x: 40,
          y: 42
        }
      },
      {
        n: [
          "\u94FE"
        ],
        u: {
          u: "26d3",
          x: 41,
          y: 42
        }
      },
      {
        n: [
          "\u6CE8\u5C04\u5668"
        ],
        u: {
          u: "1f489",
          x: 42,
          y: 42
        }
      },
      {
        n: [
          "\u836F\u4E38"
        ],
        u: {
          u: "1f48a",
          x: 43,
          y: 42
        }
      },
      {
        n: [
          "\u5438\u70DF\u6807\u5FD7",
          "\u5438\u70DF"
        ],
        u: {
          u: "1f6ac",
          x: 44,
          y: 42
        }
      },
      {
        n: [
          "\u68FA\u6750"
        ],
        u: {
          u: "26b0",
          x: 45,
          y: 42
        }
      },
      {
        n: [
          "\u846C\u793C\u74EE"
        ],
        u: {
          u: "26b1",
          x: 46,
          y: 42
        }
      },
      {
        n: [
          "\u83AB\u8036\u4F0A"
        ],
        u: {
          u: "1f5ff",
          x: 47,
          y: 42
        }
      },
      {
        n: [
          "\u6CB9\u6876\uFF0C\u6CB9\u6876"
        ],
        u: {
          u: "1f6e2",
          x: 48,
          y: 42
        }
      },
      {
        n: [
          "\u6C34\u6676\u7403"
        ],
        u: {
          u: "1f52e",
          x: 49,
          y: 42
        }
      },
      {
        n: [
          "\u8D2D\u7269\u8F66"
        ],
        u: {
          u: "1f6d2",
          x: 0,
          y: 43
        }
      }
    ],
    u: "1f4a1",
    title: "\u7269\u4F53",
    key: "objects"
  },
  {
    emojis: [
      {
        n: [
          "\u81EA\u52A8\u53D6\u6B3E\u673A",
          "\u81EA\u52A8\u53D6\u6B3E\u673A"
        ],
        u: {
          u: "1f3e7",
          x: 1,
          y: 43
        }
      },
      {
        n: [
          "\u5C06\u5783\u573E\u653E\u7F6E\u5230\u4F4D\u7B26\u53F7",
          "\u628A\u5783\u573E\u653E\u56DE\u539F\u5904"
        ],
        u: {
          u: "1f6ae",
          x: 2,
          y: 43
        }
      },
      {
        n: [
          "\u996E\u7528\u6C34\u7B26\u53F7",
          "\u996E\u7528\u6C34"
        ],
        u: {
          u: "1f6b0",
          x: 3,
          y: 43
        }
      },
      {
        n: [
          "\u8F6E\u6905\u7B26\u53F7",
          "\u8F6E\u6905"
        ],
        u: {
          u: "267f",
          x: 4,
          y: 43
        }
      },
      {
        n: [
          "\u7537\u5F0F\u6807\u5FD7",
          "\u7537\u58EB"
        ],
        u: {
          u: "1f6b9",
          x: 5,
          y: 43
        }
      },
      {
        n: [
          "\u5973\u6027\u6807\u5FD7",
          "\u5973\u6027"
        ],
        u: {
          u: "1f6ba",
          x: 6,
          y: 43
        }
      },
      {
        n: [
          "\u536B\u751F\u95F4"
        ],
        u: {
          u: "1f6bb",
          x: 7,
          y: 43
        }
      },
      {
        n: [
          "\u5A74\u513F\u7B26\u53F7"
        ],
        u: {
          u: "1f6bc",
          x: 8,
          y: 43
        }
      },
      {
        n: [
          "\u62BD\u6C34\u9A6C\u6876",
          "\u5395\u6240"
        ],
        u: {
          u: "1f6be",
          x: 9,
          y: 43
        }
      },
      {
        n: [
          "\u62A4\u7167\u68C0\u67E5"
        ],
        u: {
          u: "1f6c2",
          x: 10,
          y: 43
        }
      },
      {
        n: [
          "\u6D77\u5173"
        ],
        u: {
          u: "1f6c3",
          x: 11,
          y: 43
        }
      },
      {
        n: [
          "\u884C\u674E\u8BA4\u9886\u5904"
        ],
        u: {
          u: "1f6c4",
          x: 12,
          y: 43
        }
      },
      {
        n: [
          "\u9057\u7559\u884C\u674E"
        ],
        u: {
          u: "1f6c5",
          x: 13,
          y: 43
        }
      },
      {
        n: [
          "\u8B66\u544A\u6807\u5FD7",
          "\u8B66\u544A"
        ],
        u: {
          u: "26a0",
          x: 14,
          y: 43
        }
      },
      {
        n: [
          "\u513F\u7AE5\u7A7F\u8D8A"
        ],
        u: {
          u: "1f6b8",
          x: 15,
          y: 43
        }
      },
      {
        n: [
          "\u7981\u6B62\u5165\u5185"
        ],
        u: {
          u: "26d4",
          x: 16,
          y: 43
        }
      },
      {
        n: [
          "\u7981\u6B62\u8FDB\u5165\u6807\u5FD7"
        ],
        u: {
          u: "1f6ab",
          x: 17,
          y: 43
        }
      },
      {
        n: [
          "\u7981\u6B62\u9A91\u81EA\u884C\u8F66"
        ],
        u: {
          u: "1f6b3",
          x: 18,
          y: 43
        }
      },
      {
        n: [
          "\u7981\u6B62\u5438\u70DF\u6807\u5FD7",
          "\u7981\u6B62\u5438\u70DF"
        ],
        u: {
          u: "1f6ad",
          x: 19,
          y: 43
        }
      },
      {
        n: [
          "\u8BF7\u52FF\u4E71\u6254\u7B26\u53F7",
          "\u8BF7\u52FF\u4E71\u6254\u5783\u573E"
        ],
        u: {
          u: "1f6af",
          x: 20,
          y: 43
        }
      },
      {
        n: [
          "\u975E\u996E\u7528\u6C34\u7B26\u53F7",
          "\u975E\u996E\u7528\u6C34"
        ],
        u: {
          u: "1f6b1",
          x: 21,
          y: 43
        }
      },
      {
        n: [
          "\u7981\u6B62\u884C\u4EBA\u901A\u884C"
        ],
        u: {
          u: "1f6b7",
          x: 22,
          y: 43
        }
      },
      {
        n: [
          "\u6CA1\u6709\u624B\u673A"
        ],
        u: {
          u: "1f4f5",
          x: 23,
          y: 43
        }
      },
      {
        n: [
          "\u5341\u516B\u5C81\u4EE5\u4E0B\u7684\u4EBA\u90FD\u4E0D\u53EF\u4EE5symbol",
          "\u672A\u6210\u5E74\u4EBA"
        ],
        u: {
          u: "1f51e",
          x: 24,
          y: 43
        }
      },
      {
        n: [
          "\u653E\u5C04\u6027\u6807\u5FD7"
        ],
        u: {
          u: "2622",
          x: 25,
          y: 43
        }
      },
      {
        n: [
          "\u751F\u7269\u5371\u5BB3\u6807\u5FD7"
        ],
        u: {
          u: "2623",
          x: 26,
          y: 43
        }
      },
      {
        n: [
          "\u5411\u4E0A\u9ED1\u8272\u7BAD\u5934",
          "\u5411\u4E0A\u7BAD\u5934"
        ],
        u: {
          u: "2b06",
          x: 27,
          y: 43
        }
      },
      {
        n: [
          "\u4E1C\u5317\u7BAD\u5934",
          "\u53F3\u4E0A\u7BAD\u5934"
        ],
        u: {
          u: "2197",
          x: 28,
          y: 43
        }
      },
      {
        n: [
          "\u9ED1\u8272\u5411\u53F3\u7BAD\u5934",
          "\u5411\u53F3\u7BAD\u5934"
        ],
        u: {
          u: "27a1",
          x: 29,
          y: 43
        }
      },
      {
        n: [
          "\u4E1C\u5357\u7BAD\u5934",
          "\u53F3\u4E0B\u7BAD\u5934"
        ],
        u: {
          u: "2198",
          x: 30,
          y: 43
        }
      },
      {
        n: [
          "\u5411\u4E0B\u9ED1\u8272\u7BAD\u5934",
          "\u5411\u4E0B\u7BAD\u5934"
        ],
        u: {
          u: "2b07",
          x: 31,
          y: 43
        }
      },
      {
        n: [
          "\u897F\u5357\u7BAD\u5934",
          "\u5DE6\u4E0B\u7BAD\u5934"
        ],
        u: {
          u: "2199",
          x: 32,
          y: 43
        }
      },
      {
        n: [
          "\u5411\u5DE6\u9ED1\u8272\u7BAD\u5934",
          "\u5411\u5DE6\u7BAD\u5934"
        ],
        u: {
          u: "2b05",
          x: 33,
          y: 43
        }
      },
      {
        n: [
          "\u897F\u5317\u7BAD\u5934",
          "\u5DE6\u4E0A\u7BAD\u5934"
        ],
        u: {
          u: "2196",
          x: 34,
          y: 43
        }
      },
      {
        n: [
          "\u4E0A\u4E0B\u7BAD\u5934",
          "\u4E0A\u4E0B\u7BAD\u5934"
        ],
        u: {
          u: "2195",
          x: 35,
          y: 43
        }
      },
      {
        n: [
          "\u5DE6\u53F3\u7BAD\u5934"
        ],
        u: {
          u: "2194",
          x: 36,
          y: 43
        }
      },
      {
        n: [
          "\u5E26\u6302\u94A9\u7684\u5411\u5DE6\u7BAD\u5934"
        ],
        u: {
          u: "21a9",
          x: 37,
          y: 43
        }
      },
      {
        n: [
          "\u5E26\u6302\u94A9\u7684\u5411\u53F3\u7BAD\u5934",
          "\u7BAD\u5934\u53F3\u94A9"
        ],
        u: {
          u: "21aa",
          x: 38,
          y: 43
        }
      },
      {
        n: [
          "\u5411\u53F3\u7136\u540E\u5411\u4E0A\u5F2F\u66F2\u7684\u7BAD\u5934",
          "\u5411\u4E0A\u7BAD\u5934"
        ],
        u: {
          u: "2934",
          x: 39,
          y: 43
        }
      },
      {
        n: [
          "\u5411\u53F3\u7136\u540E\u5411\u4E0B\u5F2F\u66F2\u7684\u7BAD\u5934",
          "\u5411\u4E0B\u7BAD\u5934"
        ],
        u: {
          u: "2935",
          x: 40,
          y: 43
        }
      },
      {
        n: [
          "\u987A\u65F6\u9488\u5411\u4E0B\u548C\u5411\u4E0A\u6253\u5F00\u5706\u7BAD\u5934",
          "\u987A\u65F6\u9488\u7BAD\u5934"
        ],
        u: {
          u: "1f503",
          x: 41,
          y: 43
        }
      },
      {
        n: [
          "\u9006\u65F6\u9488\u5411\u4E0B\u548C\u5411\u4E0A\u6253\u5F00\u5706\u7BAD\u5934",
          "\u9006\u65F6\u9488\u7BAD\u5934"
        ],
        u: {
          u: "1f504",
          x: 42,
          y: 43
        }
      },
      {
        n: [
          "\u80CC\u9762\u4E0A\u65B9\u6709\u5411\u5DE6\u7BAD\u5934",
          "\u8FD4\u56DE"
        ],
        u: {
          u: "1f519",
          x: 43,
          y: 43
        }
      },
      {
        n: [
          "\u4EE5\u4E0A\u65B9\u5411\u5DE6\u7BAD\u5934\u7ED3\u675F",
          "\u7EC8\u6B62"
        ],
        u: {
          u: "1f51a",
          x: 44,
          y: 43
        }
      },
      {
        n: [
          "\u4E0A\u5E26\u611F\u53F9\u53F7\u548C\u5DE6\u53F3\u7BAD\u5934",
          "\u5728\u2026\u4E0A"
        ],
        u: {
          u: "1f51b",
          x: 45,
          y: 43
        }
      },
      {
        n: [
          "\u5F88\u5FEB\uFF0C\u4E0A\u9762\u6709\u5411\u53F3\u7BAD\u5934",
          "\u5F88\u5FEB"
        ],
        u: {
          u: "1f51c",
          x: 46,
          y: 43
        }
      },
      {
        n: [
          "\u4E0A\u65B9\u5E26\u6709\u5411\u4E0A\u7BAD\u5934\u7684\u9876\u90E8",
          "\u9876\u90E8"
        ],
        u: {
          u: "1f51d",
          x: 47,
          y: 43
        }
      },
      {
        n: [
          "\u793C\u62DC\u573A\u6240"
        ],
        u: {
          u: "1f6d0",
          x: 48,
          y: 43
        }
      },
      {
        n: [
          "\u539F\u5B50\u7B26\u53F7"
        ],
        u: {
          u: "269b",
          x: 49,
          y: 43
        }
      },
      {
        n: [
          "om\u7B26\u53F7"
        ],
        u: {
          u: "1f549",
          x: 0,
          y: 44
        }
      },
      {
        n: [
          "\u5927\u536B\u4E4B\u661F"
        ],
        u: {
          u: "2721",
          x: 1,
          y: 44
        }
      },
      {
        n: [
          "\u6CD5\u8F6E"
        ],
        u: {
          u: "2638",
          x: 2,
          y: 44
        }
      },
      {
        n: [
          "\u9634\u9633"
        ],
        u: {
          u: "262f",
          x: 3,
          y: 44
        }
      },
      {
        n: [
          "\u62C9\u4E01\u5341\u5B57\u67B6"
        ],
        u: {
          u: "271d",
          x: 4,
          y: 44
        }
      },
      {
        n: [
          "\u6B63\u7EDF\u5341\u5B57\u67B6"
        ],
        u: {
          u: "2626",
          x: 5,
          y: 44
        }
      },
      {
        n: [
          "\u661F\u5F62\u548C\u65B0\u6708\u5F62"
        ],
        u: {
          u: "262a",
          x: 6,
          y: 44
        }
      },
      {
        n: [
          "\u548C\u5E73\u6807\u5FD7"
        ],
        u: {
          u: "262e",
          x: 7,
          y: 44
        }
      },
      {
        n: [
          "\u7C73\u8BFA\u62C9\u6709\u4E5D\u4E2A\u5206\u652F"
        ],
        u: {
          u: "1f54e",
          x: 8,
          y: 44
        }
      },
      {
        n: [
          "\u5E26\u4E2D\u95F4\u70B9\u7684\u516D\u89D2\u661F",
          "\u516D\u89D2\u661F"
        ],
        u: {
          u: "1f52f",
          x: 9,
          y: 44
        }
      },
      {
        n: [
          "\u767D\u7F8A\u5EA7"
        ],
        u: {
          u: "2648",
          x: 10,
          y: 44
        }
      },
      {
        n: [
          "\u91D1\u725B\u5EA7"
        ],
        u: {
          u: "2649",
          x: 11,
          y: 44
        }
      },
      {
        n: [
          "\u53CC\u5B50\u5EA7"
        ],
        u: {
          u: "264a",
          x: 12,
          y: 44
        }
      },
      {
        n: [
          "\u5DE8\u87F9\u5EA7"
        ],
        u: {
          u: "264b",
          x: 13,
          y: 44
        }
      },
      {
        n: [
          "\u72EE\u5B50\u5EA7"
        ],
        u: {
          u: "264c",
          x: 14,
          y: 44
        }
      },
      {
        n: [
          "\u5904\u5973\u5EA7"
        ],
        u: {
          u: "264d",
          x: 15,
          y: 44
        }
      },
      {
        n: [
          "\u5929\u79E4\u5EA7"
        ],
        u: {
          u: "264e",
          x: 16,
          y: 44
        }
      },
      {
        n: [
          "\u5929\u874E\u5EA7"
        ],
        u: {
          u: "264f",
          x: 17,
          y: 44
        }
      },
      {
        n: [
          "\u5C04\u624B\u5EA7"
        ],
        u: {
          u: "2650",
          x: 18,
          y: 44
        }
      },
      {
        n: [
          "\u6469\u7FAF\u5EA7"
        ],
        u: {
          u: "2651",
          x: 19,
          y: 44
        }
      },
      {
        n: [
          "\u5B9D\u74F6\u5EA7"
        ],
        u: {
          u: "2652",
          x: 20,
          y: 44
        }
      },
      {
        n: [
          "\u53CC\u9C7C\u5EA7"
        ],
        u: {
          u: "2653",
          x: 21,
          y: 44
        }
      },
      {
        n: [
          "\u86C7\u592B\u5EA7"
        ],
        u: {
          u: "26ce",
          x: 22,
          y: 44
        }
      },
      {
        n: [
          "\u5411\u53F3\u626D\u66F2\u7BAD\u5934"
        ],
        u: {
          u: "1f500",
          x: 23,
          y: 44
        }
      },
      {
        n: [
          "\u987A\u65F6\u9488\u5411\u53F3\u548C\u5411\u5DE6\u5F00\u653E\u5706\u7BAD\u5934",
          "\u91CD\u590D"
        ],
        u: {
          u: "1f501",
          x: 24,
          y: 44
        }
      },
      {
        n: [
          "\u987A\u65F6\u9488\u5411\u53F3\u548C\u5411\u5DE6\u5F00\u653E\u5706\u7BAD\u5934\uFF0C\u5E26\u5706\u5708\u7684\u4E00\u4E2A\u8986\u76D6",
          "\u91CD\u590D\u4E00\u6B21"
        ],
        u: {
          u: "1f502",
          x: 25,
          y: 44
        }
      },
      {
        n: [
          "\u9ED1\u8272\u76F4\u89D2\u4E09\u89D2\u5F62",
          "\u5411\u524D\u7BAD\u5934"
        ],
        u: {
          u: "25b6",
          x: 26,
          y: 44
        }
      },
      {
        n: [
          "\u9ED1\u8272\u53F3\u6307\u53CC\u4E09\u89D2\u5F62",
          "\u5FEB\u8FDB"
        ],
        u: {
          u: "23e9",
          x: 27,
          y: 44
        }
      },
      {
        n: [
          "\u5E26\u7AD6\u6761\u7684\u9ED1\u8272\u53F3\u6307\u53CC\u4E09\u89D2\u5F62"
        ],
        u: {
          u: "23ed",
          x: 28,
          y: 44
        }
      },
      {
        n: [
          "\u5E26\u53CC\u7AD6\u6761\u7684\u9ED1\u8272\u76F4\u89D2\u4E09\u89D2\u5F62"
        ],
        u: {
          u: "23ef",
          x: 29,
          y: 44
        }
      },
      {
        n: [
          "\u9ED1\u8272\u5DE6\u6307\u4E09\u89D2\u5F62",
          "\u5411\u540E\u7BAD\u5934"
        ],
        u: {
          u: "25c0",
          x: 30,
          y: 44
        }
      },
      {
        n: [
          "\u9ED1\u8272\u5DE6\u6307\u53CC\u4E09\u89D2\u5F62",
          "\u91CD\u7ED5"
        ],
        u: {
          u: "23ea",
          x: 31,
          y: 44
        }
      },
      {
        n: [
          "\u5E26\u7AD6\u6761\u7684\u9ED1\u8272\u5DE6\u6307\u53CC\u4E09\u89D2\u5F62"
        ],
        u: {
          u: "23ee",
          x: 32,
          y: 44
        }
      },
      {
        n: [
          "\u5411\u4E0A\u7684\u7EA2\u8272\u5C0F\u4E09\u89D2\u5F62",
          "\u5411\u4E0A\u7BAD\u5934-\u5C0F"
        ],
        u: {
          u: "1f53c",
          x: 33,
          y: 44
        }
      },
      {
        n: [
          "\u9ED1\u8272\u4E0A\u6307\u53CC\u4E09\u89D2\u5F62",
          "\u5411\u4E0A\u7BAD\u5934"
        ],
        u: {
          u: "23eb",
          x: 34,
          y: 44
        }
      },
      {
        n: [
          "\u5411\u4E0B\u6307\u5411\u7684\u7EA2\u8272\u5C0F\u4E09\u89D2\u5F62",
          "\u5411\u4E0B\u7BAD\u5934\u5C0F\u5199"
        ],
        u: {
          u: "1f53d",
          x: 35,
          y: 44
        }
      },
      {
        n: [
          "\u9ED1\u8272\u4E0B\u6307\u53CC\u4E09\u89D2\u5F62",
          "\u5411\u4E0B\u53CC\u7BAD\u5934"
        ],
        u: {
          u: "23ec",
          x: 36,
          y: 44
        }
      },
      {
        n: [
          "\u53CC\u7AD6\u6761"
        ],
        u: {
          u: "23f8",
          x: 37,
          y: 44
        }
      },
      {
        n: [
          "\u9ED1\u8272\u65B9\u5757\u8868\u793A\u505C\u6B62"
        ],
        u: {
          u: "23f9",
          x: 38,
          y: 44
        }
      },
      {
        n: [
          "\u8BB0\u5F55\u7528\u9ED1\u5708"
        ],
        u: {
          u: "23fa",
          x: 39,
          y: 44
        }
      },
      {
        n: [
          "\u5F39\u51FA"
        ],
        u: {
          u: "23cf",
          x: 40,
          y: 44
        }
      },
      {
        n: [
          "\u7535\u5F71\u9662"
        ],
        u: {
          u: "1f3a6",
          x: 41,
          y: 44
        }
      },
      {
        n: [
          "\u4F4E\u4EAE\u5EA6\u7B26\u53F7",
          "\u4F4E\u4EAE\u5EA6"
        ],
        u: {
          u: "1f505",
          x: 42,
          y: 44
        }
      },
      {
        n: [
          "\u9AD8\u4EAE\u5EA6\u7B26\u53F7",
          "\u9AD8\u4EAE\u5EA6"
        ],
        u: {
          u: "1f506",
          x: 43,
          y: 44
        }
      },
      {
        n: [
          "\u5E26\u6746\u5929\u7EBF",
          "\u4FE1\u53F7\u5F3A\u5EA6"
        ],
        u: {
          u: "1f4f6",
          x: 44,
          y: 44
        }
      },
      {
        n: [
          "\u632F\u52A8\u6A21\u5F0F"
        ],
        u: {
          u: "1f4f3",
          x: 45,
          y: 44
        }
      },
      {
        n: [
          "\u624B\u673A\u5173\u95ED"
        ],
        u: {
          u: "1f4f4",
          x: 46,
          y: 44
        }
      },
      {
        n: [
          "\u5973\u6027\u6807\u5FD7"
        ],
        u: {
          u: "2640",
          x: 47,
          y: 44
        }
      },
      {
        n: [
          "\u7537\u6027\u6807\u5FD7"
        ],
        u: {
          u: "2642",
          x: 48,
          y: 44
        }
      },
      {
        n: [
          "\u533B\u5B66\u7B26\u53F7",
          "\u57C3\u65AF\u5E93\u62C9\u76AE\u4E4C\u65AF\u6559\u804C\u5458"
        ],
        u: {
          u: "2695",
          x: 49,
          y: 44
        }
      },
      {
        n: [
          "\u9ED1\u8272\u901A\u7528\u56DE\u6536\u7B26\u53F7",
          "\u56DE\u6536\u5229\u7528"
        ],
        u: {
          u: "267b",
          x: 0,
          y: 45
        }
      },
      {
        n: [
          "\u767E\u5408\u82B1\u9970"
        ],
        u: {
          u: "269c",
          x: 1,
          y: 45
        }
      },
      {
        n: [
          "\u4E09\u53C9\u621F\u5FBD\u7AE0",
          "\u4E09\u53C9\u621F"
        ],
        u: {
          u: "1f531",
          x: 2,
          y: 45
        }
      },
      {
        n: [
          "\u59D3\u540D\u5FBD\u7AE0"
        ],
        u: {
          u: "1f4db",
          x: 3,
          y: 45
        }
      },
      {
        n: [
          "\u65E5\u8BED\u521D\u5B66\u8005\u7B26\u53F7",
          "\u65B0\u624B"
        ],
        u: {
          u: "1f530",
          x: 4,
          y: 45
        }
      },
      {
        n: [
          "\u91CD\u578B\u5927\u5706\u5708",
          "o"
        ],
        u: {
          u: "2b55",
          x: 5,
          y: 45
        }
      },
      {
        n: [
          "\u767D\u8272\u91CD\u578B\u590D\u9009\u6807\u8BB0",
          "\u767D\u8272\u590D\u9009\u6807\u8BB0"
        ],
        u: {
          u: "2705",
          x: 6,
          y: 45
        }
      },
      {
        n: [
          "\u5E26\u652F\u7968\u7684\u6295\u7968\u7BB1"
        ],
        u: {
          u: "2611",
          x: 7,
          y: 45
        }
      },
      {
        n: [
          "\u91CD\u590D\u9009\u6807\u8BB0"
        ],
        u: {
          u: "2714",
          x: 8,
          y: 45
        }
      },
      {
        n: [
          "\u91CD\u4E58\u6CD5x"
        ],
        u: {
          u: "2716",
          x: 9,
          y: 45
        }
      },
      {
        n: [
          "\u5341\u5B57\u8BB0\u53F7",
          "\u5341\u3001"
        ],
        u: {
          u: "274c",
          x: 10,
          y: 45
        }
      },
      {
        n: [
          "\u8D1F\u65B9\u5F62\u5341\u5B57\u6807\u8BB0"
        ],
        u: {
          u: "274e",
          x: 11,
          y: 45
        }
      },
      {
        n: [
          "\u91CD\u578B\u52A0\u53F7"
        ],
        u: {
          u: "2795",
          x: 12,
          y: 45
        }
      },
      {
        n: [
          "\u91CD\u51CF\u53F7"
        ],
        u: {
          u: "2796",
          x: 13,
          y: 45
        }
      },
      {
        n: [
          "\u91CD\u9664\u6CD5\u6807\u5FD7"
        ],
        u: {
          u: "2797",
          x: 14,
          y: 45
        }
      },
      {
        n: [
          "\u5377\u66F2\u73AF"
        ],
        u: {
          u: "27b0",
          x: 15,
          y: 45
        }
      },
      {
        n: [
          "\u53CC\u5377\u66F2\u73AF",
          "\u73AF"
        ],
        u: {
          u: "27bf",
          x: 16,
          y: 45
        }
      },
      {
        n: [
          "\u96F6\u4EF6\u66F4\u6362\u6807\u8BB0"
        ],
        u: {
          u: "303d",
          x: 17,
          y: 45
        }
      },
      {
        n: [
          "\u516B\u8F90\u661F\u53F7"
        ],
        u: {
          u: "2733",
          x: 18,
          y: 45
        }
      },
      {
        n: [
          "\u516B\u89D2\u9ED1\u661F"
        ],
        u: {
          u: "2734",
          x: 19,
          y: 45
        }
      },
      {
        n: [
          "\u95EA\u70C1"
        ],
        u: {
          u: "2747",
          x: 20,
          y: 45
        }
      },
      {
        n: [
          "\u53CC\u611F\u53F9\u53F7",
          "\u90A6\u90A6"
        ],
        u: {
          u: "203c",
          x: 21,
          y: 45
        }
      },
      {
        n: [
          "\u611F\u53F9\u53F7\u95EE\u53F7",
          "interrobang\u516C\u53F8"
        ],
        u: {
          u: "2049",
          x: 22,
          y: 45
        }
      },
      {
        n: [
          "\u9ED1\u8272\u95EE\u53F7\u88C5\u9970",
          "\u95EE\u9898"
        ],
        u: {
          u: "2753",
          x: 23,
          y: 45
        }
      },
      {
        n: [
          "\u767D\u8272\u95EE\u53F7\u88C5\u9970",
          "\u7070\u8272\u95EE\u9898"
        ],
        u: {
          u: "2754",
          x: 24,
          y: 45
        }
      },
      {
        n: [
          "\u767D\u8272\u611F\u53F9\u53F7\u88C5\u9970",
          "\u7070\u8272\u611F\u53F9\u53F7"
        ],
        u: {
          u: "2755",
          x: 25,
          y: 45
        }
      },
      {
        n: [
          "\u91CD\u611F\u53F9\u53F7\u7B26\u53F7",
          "\u611F\u53F9\u53F7",
          "\u91CD\u611F\u53F9\u53F7"
        ],
        u: {
          u: "2757",
          x: 26,
          y: 45
        }
      },
      {
        n: [
          "\u6CE2\u6D6A\u5F62\u7834\u6298\u53F7"
        ],
        u: {
          u: "3030",
          x: 27,
          y: 45
        }
      },
      {
        n: [
          "\u7248\u6743\u6807\u5FD7",
          "\u7248\u6743"
        ],
        u: {
          u: "00a9",
          x: 28,
          y: 45
        }
      },
      {
        n: [
          "\u6CE8\u518C\u6807\u5FD7",
          "\u6CE8\u518C\u7684"
        ],
        u: {
          u: "00ae",
          x: 29,
          y: 45
        }
      },
      {
        n: [
          "\u5546\u6807\u6807\u5FD7",
          "\u5546\u6807"
        ],
        u: {
          u: "2122",
          x: 30,
          y: 45
        }
      },
      {
        n: [
          "\u6563\u5217\u952E",
          "\u641E\u7838"
        ],
        u: {
          u: "0023-20e3",
          x: 31,
          y: 45
        }
      },
      {
        n: [
          "\u952E\u5E3D\u661F\u5F62"
        ],
        u: {
          u: "002a-20e3",
          x: 32,
          y: 45
        }
      },
      {
        n: [
          "\u952E\u5E3D0",
          "\u96F6"
        ],
        u: {
          u: "0030-20e3",
          x: 33,
          y: 45
        }
      },
      {
        n: [
          "\u952E\u5E3D1",
          "\u4E00"
        ],
        u: {
          u: "0031-20e3",
          x: 34,
          y: 45
        }
      },
      {
        n: [
          "\u952E\u5E3D2",
          "\u4E8C"
        ],
        u: {
          u: "0032-20e3",
          x: 35,
          y: 45
        }
      },
      {
        n: [
          "\u952E\u5E3D3",
          "\u4E09"
        ],
        u: {
          u: "0033-20e3",
          x: 36,
          y: 45
        }
      },
      {
        n: [
          "\u952E\u5E3D4",
          "\u56DB"
        ],
        u: {
          u: "0034-20e3",
          x: 37,
          y: 45
        }
      },
      {
        n: [
          "\u952E\u5E3D5",
          "\u4E94"
        ],
        u: {
          u: "0035-20e3",
          x: 38,
          y: 45
        }
      },
      {
        n: [
          "\u952E\u5E3D6",
          "\u516D"
        ],
        u: {
          u: "0036-20e3",
          x: 39,
          y: 45
        }
      },
      {
        n: [
          "\u952E\u5E3D7",
          "\u4E03"
        ],
        u: {
          u: "0037-20e3",
          x: 40,
          y: 45
        }
      },
      {
        n: [
          "\u952E\u5E3D8",
          "\u516B"
        ],
        u: {
          u: "0038-20e3",
          x: 41,
          y: 45
        }
      },
      {
        n: [
          "\u952E\u5E3D9",
          "\u4E5D"
        ],
        u: {
          u: "0039-20e3",
          x: 42,
          y: 45
        }
      },
      {
        n: [
          "\u952E\u5E3D10"
        ],
        u: {
          u: "1f51f",
          x: 43,
          y: 45
        }
      },
      {
        n: [
          "\u767E\u70B9\u7B26\u53F7",
          "100"
        ],
        u: {
          u: "1f4af",
          x: 44,
          y: 45
        }
      },
      {
        n: [
          "\u62C9\u4E01\u6587\u5927\u5199\u5B57\u6BCD\u7684\u8F93\u5165\u7B26\u53F7",
          "\u5927\u5199abcd"
        ],
        u: {
          u: "1f520",
          x: 45,
          y: 45
        }
      },
      {
        n: [
          "\u62C9\u4E01\u6587\u5C0F\u5199\u5B57\u6BCD\u7684\u8F93\u5165\u7B26\u53F7",
          "abcd"
        ],
        u: {
          u: "1f521",
          x: 46,
          y: 45
        }
      },
      {
        n: [
          "\u6570\u5B57\u8F93\u5165\u7B26\u53F7",
          "1234"
        ],
        u: {
          u: "1f522",
          x: 47,
          y: 45
        }
      },
      {
        n: [
          "\u7B26\u53F7\u7684\u8F93\u5165\u7B26\u53F7",
          "\u7B26\u53F7"
        ],
        u: {
          u: "1f523",
          x: 48,
          y: 45
        }
      },
      {
        n: [
          "\u62C9\u4E01\u5B57\u6BCD\u7684\u8F93\u5165\u7B26\u53F7",
          "abc"
        ],
        u: {
          u: "1f524",
          x: 49,
          y: 45
        }
      },
      {
        n: [
          "\u8D1F\u5E73\u65B9\u62C9\u4E01\u6587\u5927\u5199\u5B57\u6BCDa",
          "A."
        ],
        u: {
          u: "1f170",
          x: 0,
          y: 46
        }
      },
      {
        n: [
          "\u8D1F\u5E73\u65B9ab",
          "ab"
        ],
        u: {
          u: "1f18e",
          x: 1,
          y: 46
        }
      },
      {
        n: [
          "\u8D1F\u5E73\u65B9\u62C9\u4E01\u6587\u5927\u5199\u5B57\u6BCDb",
          "B"
        ],
        u: {
          u: "1f171",
          x: 2,
          y: 46
        }
      },
      {
        n: [
          "\u5E73\u65B9cl",
          "\u6C2F"
        ],
        u: {
          u: "1f191",
          x: 3,
          y: 46
        }
      },
      {
        n: [
          "\u65B9\u5F62\u51B7\u5374",
          "\u51C9\u7684"
        ],
        u: {
          u: "1f192",
          x: 4,
          y: 46
        }
      },
      {
        n: [
          "\u5E73\u65B9\u81EA\u7531",
          "\u81EA\u7531\u7684"
        ],
        u: {
          u: "1f193",
          x: 5,
          y: 46
        }
      },
      {
        n: [
          "\u4FE1\u606F\u6E90"
        ],
        u: {
          u: "2139",
          x: 6,
          y: 46
        }
      },
      {
        n: [
          "\u5E73\u65B9id",
          "\u8EAB\u4EFD\u8BC1\u4EF6"
        ],
        u: {
          u: "1f194",
          x: 7,
          y: 46
        }
      },
      {
        n: [
          "\u5E26\u5706\u5708\u62C9\u4E01\u6587\u5927\u5199\u5B57\u6BCDm",
          "M"
        ],
        u: {
          u: "24c2",
          x: 8,
          y: 46
        }
      },
      {
        n: [
          "\u65B9\u5F62\u65B0",
          "\u65B0"
        ],
        u: {
          u: "1f195",
          x: 9,
          y: 46
        }
      },
      {
        n: [
          "\u5E73\u65B9ng",
          "ng"
        ],
        u: {
          u: "1f196",
          x: 10,
          y: 46
        }
      },
      {
        n: [
          "\u8D1F\u5E73\u65B9\u62C9\u4E01\u6587\u5927\u5199\u5B57\u6BCDo",
          "\u6C27\u6C14"
        ],
        u: {
          u: "1f17e",
          x: 11,
          y: 46
        }
      },
      {
        n: [
          "\u65B9\u5F62ok",
          "\u597D\u554A"
        ],
        u: {
          u: "1f197",
          x: 12,
          y: 46
        }
      },
      {
        n: [
          "\u8D1F\u5E73\u65B9\u62C9\u4E01\u6587\u5927\u5199\u5B57\u6BCDp",
          "\u505C\u8F66"
        ],
        u: {
          u: "1f17f",
          x: 13,
          y: 46
        }
      },
      {
        n: [
          "\u65B9\u5F62sos",
          "sos\u7CFB\u7EDF"
        ],
        u: {
          u: "1f198",
          x: 14,
          y: 46
        }
      },
      {
        n: [
          "\u4E0E\u611F\u53F9\u53F7\u5BF9\u9F50",
          "\u5411\u4E0A\u7684"
        ],
        u: {
          u: "1f199",
          x: 15,
          y: 46
        }
      },
      {
        n: [
          "\u5E73\u65B9vs",
          "vs\u516C\u53F8"
        ],
        u: {
          u: "1f19a",
          x: 16,
          y: 46
        }
      },
      {
        n: [
          "\u65B9\u5F62\u7247\u5047\u540Dkoko",
          "\u79D1\u79D1"
        ],
        u: {
          u: "1f201",
          x: 17,
          y: 46
        }
      },
      {
        n: [
          "\u65B9\u5F62\u7247\u5047\u540Dsa",
          "\u5357\u975E"
        ],
        u: {
          u: "1f202",
          x: 18,
          y: 46
        }
      },
      {
        n: [
          "\u65B9\u5F62\u4E2D\u65E5\u97E9\u7EDF\u4E00\u8C61\u5F62\u6587\u5B576708",
          "u6708"
        ],
        u: {
          u: "1f237",
          x: 19,
          y: 46
        }
      },
      {
        n: [
          "\u65B9\u5F62\u4E2D\u65E5\u97E9\u7EDF\u4E00\u8C61\u5F62\u6587\u5B576709",
          "u6709"
        ],
        u: {
          u: "1f236",
          x: 20,
          y: 46
        }
      },
      {
        n: [
          "\u65B9\u5F62\u4E2D\u65E5\u97E9\u7EDF\u4E00\u8C61\u5F62\u6587\u5B576307",
          "u6307"
        ],
        u: {
          u: "1f22f",
          x: 21,
          y: 46
        }
      },
      {
        n: [
          "\u5E26\u5706\u5708\u8C61\u5F62\u6587\u5B57\u4F18\u52BF",
          "\u8C61\u5F62\u6587\u5B57\u4F18\u52BF"
        ],
        u: {
          u: "1f250",
          x: 22,
          y: 46
        }
      },
      {
        n: [
          "\u65B9\u5F62\u4E2D\u65E5\u97E9\u7EDF\u4E00\u8C61\u5F62\u6587\u5B575272",
          "u5272"
        ],
        u: {
          u: "1f239",
          x: 23,
          y: 46
        }
      },
      {
        n: [
          "\u65B9\u5F62\u4E2D\u65E5\u97E9\u7EDF\u4E00\u8C61\u5F62\u6587\u5B577121",
          "u7121"
        ],
        u: {
          u: "1f21a",
          x: 24,
          y: 46
        }
      },
      {
        n: [
          "\u65B9\u5F62\u4E2D\u65E5\u97E9\u7EDF\u4E00\u8C61\u5F62\u6587\u5B577981",
          "u7981"
        ],
        u: {
          u: "1f232",
          x: 25,
          y: 46
        }
      },
      {
        n: [
          "\u5E26\u5706\u5708\u8C61\u5F62\u6587\u5B57\u63A5\u53D7",
          "\u63A5\u53D7"
        ],
        u: {
          u: "1f251",
          x: 26,
          y: 46
        }
      },
      {
        n: [
          "\u65B9\u5F62\u4E2D\u65E5\u97E9\u7EDF\u4E00\u8C61\u5F62\u6587\u5B577533",
          "u7533"
        ],
        u: {
          u: "1f238",
          x: 27,
          y: 46
        }
      },
      {
        n: [
          "\u65B9\u5F62\u4E2D\u65E5\u97E9\u7EDF\u4E00\u8C61\u5F62\u6587\u5B575408",
          "u5408"
        ],
        u: {
          u: "1f234",
          x: 28,
          y: 46
        }
      },
      {
        n: [
          "\u65B9\u5F62\u4E2D\u65E5\u97E9\u7EDF\u4E00\u8C61\u5F62\u6587\u5B577a7a",
          "u7a7a"
        ],
        u: {
          u: "1f233",
          x: 29,
          y: 46
        }
      },
      {
        n: [
          "\u5E26\u5706\u5708\u8C61\u5F62\u6587\u5B57\u795D\u8D3A",
          "\u795D\u8D3A"
        ],
        u: {
          u: "3297",
          x: 30,
          y: 46
        }
      },
      {
        n: [
          "\u5E26\u5706\u5708\u8C61\u5F62\u6587\u5B57\u673A\u5BC6",
          "\u79D8\u5BC6"
        ],
        u: {
          u: "3299",
          x: 31,
          y: 46
        }
      },
      {
        n: [
          "\u65B9\u5F62\u4E2D\u65E5\u97E9\u7EDF\u4E00\u8C61\u5F62\u6587\u5B5755b6",
          "u55b6"
        ],
        u: {
          u: "1f23a",
          x: 32,
          y: 46
        }
      },
      {
        n: [
          "\u65B9\u5F62\u4E2D\u65E5\u97E9\u7EDF\u4E00\u8C61\u5F62\u6587\u5B576e80",
          "u6e80"
        ],
        u: {
          u: "1f235",
          x: 33,
          y: 46
        }
      },
      {
        n: [
          "\u9ED1\u8272\u5C0F\u6B63\u65B9\u5F62"
        ],
        u: {
          u: "25aa",
          x: 34,
          y: 46
        }
      },
      {
        n: [
          "\u767D\u8272\u5C0F\u6B63\u65B9\u5F62"
        ],
        u: {
          u: "25ab",
          x: 35,
          y: 46
        }
      },
      {
        n: [
          "\u767D\u8272\u4E2D\u65B9\u5F62"
        ],
        u: {
          u: "25fb",
          x: 36,
          y: 46
        }
      },
      {
        n: [
          "\u9ED1\u8272\u4E2D\u65B9\u5F62"
        ],
        u: {
          u: "25fc",
          x: 37,
          y: 46
        }
      },
      {
        n: [
          "\u767D\u8272\u4E2D\u5C0F\u578B\u65B9\u5F62"
        ],
        u: {
          u: "25fd",
          x: 38,
          y: 46
        }
      },
      {
        n: [
          "\u9ED1\u8272\u4E2D\u5C0F\u578B\u65B9\u5F62"
        ],
        u: {
          u: "25fe",
          x: 39,
          y: 46
        }
      },
      {
        n: [
          "\u9ED1\u8272\u5927\u6B63\u65B9\u5F62"
        ],
        u: {
          u: "2b1b",
          x: 40,
          y: 46
        }
      },
      {
        n: [
          "\u767D\u8272\u5927\u6B63\u65B9\u5F62"
        ],
        u: {
          u: "2b1c",
          x: 41,
          y: 46
        }
      },
      {
        n: [
          "\u5DE8\u5927\u7684\u6A59\u8272\u94BB\u77F3"
        ],
        u: {
          u: "1f536",
          x: 42,
          y: 46
        }
      },
      {
        n: [
          "\u84DD\u8272\u5927\u94BB\u77F3"
        ],
        u: {
          u: "1f537",
          x: 43,
          y: 46
        }
      },
      {
        n: [
          "\u5C0F\u6A59\u8272\u94BB\u77F3"
        ],
        u: {
          u: "1f538",
          x: 44,
          y: 46
        }
      },
      {
        n: [
          "\u84DD\u8272\u5C0F\u94BB\u77F3"
        ],
        u: {
          u: "1f539",
          x: 45,
          y: 46
        }
      },
      {
        n: [
          "\u6307\u5411\u4E0A\u7684\u7EA2\u8272\u4E09\u89D2\u5F62",
          "\u7EA2\u8272\u5C0F\u4E09\u89D2\u5F62"
        ],
        u: {
          u: "1f53a",
          x: 46,
          y: 46
        }
      },
      {
        n: [
          "\u5411\u4E0B\u6307\u5411\u7684\u7EA2\u8272\u4E09\u89D2\u5F62",
          "\u5C0F\u7EA2\u8272\u4E09\u89D2\u5F62\u5411\u4E0B"
        ],
        u: {
          u: "1f53b",
          x: 47,
          y: 46
        }
      },
      {
        n: [
          "\u5185\u90E8\u6709\u70B9\u7684\u83F1\u5F62"
        ],
        u: {
          u: "1f4a0",
          x: 48,
          y: 46
        }
      },
      {
        n: [
          "\u5355\u9009\u6309\u94AE"
        ],
        u: {
          u: "1f518",
          x: 49,
          y: 46
        }
      },
      {
        n: [
          "\u9ED1\u8272\u65B9\u5F62\u6309\u94AE"
        ],
        u: {
          u: "1f532",
          x: 0,
          y: 47
        }
      },
      {
        n: [
          "\u767D\u8272\u65B9\u5F62\u6309\u94AE"
        ],
        u: {
          u: "1f533",
          x: 1,
          y: 47
        }
      },
      {
        n: [
          "\u4E2D\u767D\u8272\u5706\u5708",
          "\u767D\u5708"
        ],
        u: {
          u: "26aa",
          x: 2,
          y: 47
        }
      },
      {
        n: [
          "\u4E2D\u9ED1\u8272\u5706\u5708",
          "\u9ED1\u5708"
        ],
        u: {
          u: "26ab",
          x: 3,
          y: 47
        }
      },
      {
        n: [
          "\u5927\u7EA2\u8272\u5706\u5708",
          "\u7EA2\u8272\u5706\u5708"
        ],
        u: {
          u: "1f534",
          x: 4,
          y: 47
        }
      },
      {
        n: [
          "\u84DD\u8272\u5927\u5706\u5708"
        ],
        u: {
          u: "1f535",
          x: 5,
          y: 47
        }
      }
    ],
    u: "1f523",
    title: "\u7B26\u53F7",
    key: "symbols"
  },
  {
    emojis: [
      {
        n: [
          "\u9ED1\u767D\u65B9\u683C\u65D7",
          "\u65B9\u683C\u65D7"
        ],
        u: {
          u: "1f3c1",
          x: 6,
          y: 47
        }
      },
      {
        n: [
          "\u67F1\u4E0A\u4E09\u89D2\u65D7"
        ],
        u: {
          u: "1f6a9",
          x: 7,
          y: 47
        }
      },
      {
        n: [
          "\u4EA4\u53C9\u6807\u5FD7"
        ],
        u: {
          u: "1f38c",
          x: 8,
          y: 47
        }
      },
      {
        n: [
          "\u6325\u821E\u7740\u7684\u9ED1\u65D7"
        ],
        u: {
          u: "1f3f4",
          x: 9,
          y: 47
        }
      },
      {
        n: [
          "\u6325\u821E\u7740\u767D\u65D7"
        ],
        u: {
          u: "1f3f3",
          x: 10,
          y: 47
        }
      },
      {
        n: [
          "\u5F69\u8679\u65D7"
        ],
        u: {
          u: "1f3f3-fe0f-200d-1f308",
          x: 11,
          y: 47
        }
      },
      {
        n: [
          "\u963F\u68EE\u677E\u5C9B\u56FD\u65D7",
          "\u6807\u5FD7ac"
        ],
        u: {
          u: "1f1e6-1f1e8",
          x: 12,
          y: 47
        }
      },
      {
        n: [
          "\u5B89\u9053\u5C14\u56FD\u65D7",
          "\u6807\u5FD7\u5E7F\u544A"
        ],
        u: {
          u: "1f1e6-1f1e9",
          x: 13,
          y: 47
        }
      },
      {
        n: [
          "\u963F\u62C9\u4F2F\u8054\u5408\u914B\u957F\u56FD\u56FD\u65D7",
          "\u6807\u5FD7ae"
        ],
        u: {
          u: "1f1e6-1f1ea",
          x: 14,
          y: 47
        }
      },
      {
        n: [
          "\u963F\u5BCC\u6C57\u56FD\u65D7",
          "\u6807\u5FD7af"
        ],
        u: {
          u: "1f1e6-1f1eb",
          x: 15,
          y: 47
        }
      },
      {
        n: [
          "\u5B89\u63D0\u74DC\u5DF4\u5E03\u8FBE\u56FD\u65D7",
          "\u6807\u5FD7ag"
        ],
        u: {
          u: "1f1e6-1f1ec",
          x: 16,
          y: 47
        }
      },
      {
        n: [
          "\u5B89\u572D\u62C9\u65D7",
          "\u6807\u5FD7ai"
        ],
        u: {
          u: "1f1e6-1f1ee",
          x: 17,
          y: 47
        }
      },
      {
        n: [
          "\u963F\u5C14\u5DF4\u5C3C\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7al"
        ],
        u: {
          u: "1f1e6-1f1f1",
          x: 18,
          y: 47
        }
      },
      {
        n: [
          "\u4E9A\u7F8E\u5C3C\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7am"
        ],
        u: {
          u: "1f1e6-1f1f2",
          x: 19,
          y: 47
        }
      },
      {
        n: [
          "\u5B89\u54E5\u62C9\u56FD\u65D7",
          "\u6807\u5FD7ao"
        ],
        u: {
          u: "1f1e6-1f1f4",
          x: 20,
          y: 47
        }
      },
      {
        n: [
          "\u5357\u6781\u6D32\u56FD\u65D7",
          "\u6807\u5FD7aq"
        ],
        u: {
          u: "1f1e6-1f1f6",
          x: 21,
          y: 47
        }
      },
      {
        n: [
          "\u963F\u6839\u5EF7\u56FD\u65D7",
          "\u65D7\u8230\u673A"
        ],
        u: {
          u: "1f1e6-1f1f7",
          x: 22,
          y: 47
        }
      },
      {
        n: [
          "\u7F8E\u5C5E\u8428\u6469\u4E9A\u56FD\u65D7",
          "\u65D7\u53F7\u4E3A"
        ],
        u: {
          u: "1f1e6-1f1f8",
          x: 23,
          y: 47
        }
      },
      {
        n: [
          "\u5965\u5730\u5229\u56FD\u65D7",
          "\u6807\u5FD7\u4F4D\u4E8E"
        ],
        u: {
          u: "1f1e6-1f1f9",
          x: 24,
          y: 47
        }
      },
      {
        n: [
          "\u6FB3\u5927\u5229\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7au"
        ],
        u: {
          u: "1f1e6-1f1fa",
          x: 25,
          y: 47
        }
      },
      {
        n: [
          "\u963F\u9C81\u5DF4\u56FD\u65D7",
          "\u6807\u5FD7aw"
        ],
        u: {
          u: "1f1e6-1f1fc",
          x: 26,
          y: 47
        }
      },
      {
        n: [
          "\xE5\u9646\u5730\u5C9B\u5C7F\u65D7",
          "\u6807\u5FD7ax"
        ],
        u: {
          u: "1f1e6-1f1fd",
          x: 27,
          y: 47
        }
      },
      {
        n: [
          "\u963F\u585E\u62DC\u7586\u56FD\u65D7",
          "\u6807\u5FD7az"
        ],
        u: {
          u: "1f1e6-1f1ff",
          x: 28,
          y: 47
        }
      },
      {
        n: [
          "\u6CE2\u65AF\u5C3C\u4E9A\u548C\u9ED1\u585E\u54E5\u7EF4\u90A3\u56FD\u65D7",
          "\u6807\u5FD7ba"
        ],
        u: {
          u: "1f1e7-1f1e6",
          x: 29,
          y: 47
        }
      },
      {
        n: [
          "\u5DF4\u5DF4\u591A\u65AF\u56FD\u65D7",
          "\u6807\u5FD7bb"
        ],
        u: {
          u: "1f1e7-1f1e7",
          x: 30,
          y: 47
        }
      },
      {
        n: [
          "\u5B5F\u52A0\u62C9\u56FD\u56FD\u65D7",
          "\u6807\u5FD7bd"
        ],
        u: {
          u: "1f1e7-1f1e9",
          x: 31,
          y: 47
        }
      },
      {
        n: [
          "\u6BD4\u5229\u65F6\u56FD\u65D7",
          "\u6807\u5FD7be"
        ],
        u: {
          u: "1f1e7-1f1ea",
          x: 32,
          y: 47
        }
      },
      {
        n: [
          "\u5E03\u57FA\u7EB3\u6CD5\u7D22\u56FD\u65D7",
          "\u6807\u5FD7bf"
        ],
        u: {
          u: "1f1e7-1f1eb",
          x: 33,
          y: 47
        }
      },
      {
        n: [
          "\u4FDD\u52A0\u5229\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7bg"
        ],
        u: {
          u: "1f1e7-1f1ec",
          x: 34,
          y: 47
        }
      },
      {
        n: [
          "\u5DF4\u6797\u56FD\u65D7",
          "\u6807\u5FD7bh"
        ],
        u: {
          u: "1f1e7-1f1ed",
          x: 35,
          y: 47
        }
      },
      {
        n: [
          "\u5E03\u9686\u8FEA\u56FD\u65D7",
          "\u6807\u5FD7bi"
        ],
        u: {
          u: "1f1e7-1f1ee",
          x: 36,
          y: 47
        }
      },
      {
        n: [
          "\u8D1D\u5B81\u56FD\u65D7",
          "\u6807\u5FD7bj"
        ],
        u: {
          u: "1f1e7-1f1ef",
          x: 37,
          y: 47
        }
      },
      {
        n: [
          "\u5723\u5DF4\u585E\u52D2\u7C73\u56FD\u65D7",
          "\u6807\u5FD7bl"
        ],
        u: {
          u: "1f1e7-1f1f1",
          x: 38,
          y: 47
        }
      },
      {
        n: [
          "\u767E\u6155\u5927\u56FD\u65D7",
          "\u6807\u5FD7bm"
        ],
        u: {
          u: "1f1e7-1f1f2",
          x: 39,
          y: 47
        }
      },
      {
        n: [
          "\u6587\u83B1\u56FD\u65D7",
          "\u6807\u5FD7bn"
        ],
        u: {
          u: "1f1e7-1f1f3",
          x: 40,
          y: 47
        }
      },
      {
        n: [
          "\u73BB\u5229\u7EF4\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7bo"
        ],
        u: {
          u: "1f1e7-1f1f4",
          x: 41,
          y: 47
        }
      },
      {
        n: [
          "\u52A0\u52D2\u6BD4\u6D77\u8377\u5170\u56FD\u65D7",
          "\u6807\u5FD7bq"
        ],
        u: {
          u: "1f1e7-1f1f6",
          x: 42,
          y: 47
        }
      },
      {
        n: [
          "\u5DF4\u897F\u56FD\u65D7",
          "\u6807\u5FD7br"
        ],
        u: {
          u: "1f1e7-1f1f7",
          x: 43,
          y: 47
        }
      },
      {
        n: [
          "\u5DF4\u54C8\u9A6C\u56FD\u65D7",
          "\u6807\u5FD7bs"
        ],
        u: {
          u: "1f1e7-1f1f8",
          x: 44,
          y: 47
        }
      },
      {
        n: [
          "\u4E0D\u4E39\u56FD\u65D7",
          "\u6807\u5FD7bt"
        ],
        u: {
          u: "1f1e7-1f1f9",
          x: 45,
          y: 47
        }
      },
      {
        n: [
          "bouvet\u5C9B\u56FD\u65D7",
          "\u6807\u5FD7bv"
        ],
        u: {
          u: "1f1e7-1f1fb",
          x: 46,
          y: 47
        }
      },
      {
        n: [
          "\u535A\u8328\u74E6\u7EB3\u56FD\u65D7",
          "\u6807\u5FD7bw"
        ],
        u: {
          u: "1f1e7-1f1fc",
          x: 47,
          y: 47
        }
      },
      {
        n: [
          "\u767D\u4FC4\u7F57\u65AF\u56FD\u65D7",
          "\u6807\u8BB0\u4F9D\u636E"
        ],
        u: {
          u: "1f1e7-1f1fe",
          x: 48,
          y: 47
        }
      },
      {
        n: [
          "\u4F2F\u5229\u5179\u56FD\u65D7",
          "\u6807\u5FD7bz"
        ],
        u: {
          u: "1f1e7-1f1ff",
          x: 49,
          y: 47
        }
      },
      {
        n: [
          "\u52A0\u62FF\u5927\u56FD\u65D7",
          "\u6807\u5FD7ca"
        ],
        u: {
          u: "1f1e8-1f1e6",
          x: 0,
          y: 48
        }
      },
      {
        n: [
          "\u79D1\u79D1\u65AF\uFF08\u57FA\u6797\uFF09\u7FA4\u5C9B\u56FD\u65D7",
          "\u6807\u5FD7cc"
        ],
        u: {
          u: "1f1e8-1f1e8",
          x: 1,
          y: 48
        }
      },
      {
        n: [
          "\u521A\u679C-\u91D1\u6C99\u8428\u56FD\u65D7",
          "\u6807\u8BB0cd"
        ],
        u: {
          u: "1f1e8-1f1e9",
          x: 2,
          y: 48
        }
      },
      {
        n: [
          "\u4E2D\u975E\u5171\u548C\u56FD\u56FD\u65D7",
          "\u6807\u5FD7cf"
        ],
        u: {
          u: "1f1e8-1f1eb",
          x: 3,
          y: 48
        }
      },
      {
        n: [
          "\u521A\u679C-\u5E03\u62C9\u67F4\u7EF4\u5C14\u56FD\u65D7",
          "\u6807\u5FD7cg"
        ],
        u: {
          u: "1f1e8-1f1ec",
          x: 4,
          y: 48
        }
      },
      {
        n: [
          "\u745E\u58EB\u56FD\u65D7",
          "\u6807\u5FD7ch"
        ],
        u: {
          u: "1f1e8-1f1ed",
          x: 5,
          y: 48
        }
      },
      {
        n: [
          "\u79D1\u7279\u8FEA\u74E6\u56FD\u65D7",
          "\u6807\u5FD7ci"
        ],
        u: {
          u: "1f1e8-1f1ee",
          x: 6,
          y: 48
        }
      },
      {
        n: [
          "\u5E93\u514B\u7FA4\u5C9B\u56FD\u65D7",
          "\u6807\u8BB0ck"
        ],
        u: {
          u: "1f1e8-1f1f0",
          x: 7,
          y: 48
        }
      },
      {
        n: [
          "\u667A\u5229\u56FD\u65D7",
          "\u6807\u5FD7cl"
        ],
        u: {
          u: "1f1e8-1f1f1",
          x: 8,
          y: 48
        }
      },
      {
        n: [
          "\u5580\u9EA6\u9686\u56FD\u65D7",
          "\u6807\u5FD7cm"
        ],
        u: {
          u: "1f1e8-1f1f2",
          x: 9,
          y: 48
        }
      },
      {
        n: [
          "\u4E2D\u56FD\u56FD\u65D7",
          "cn",
          "\u6807\u5FD7cn"
        ],
        u: {
          u: "1f1e8-1f1f3",
          x: 10,
          y: 48
        }
      },
      {
        n: [
          "\u54E5\u4F26\u6BD4\u4E9A\u56FD\u65D7",
          "\u65D7\u516C\u53F8"
        ],
        u: {
          u: "1f1e8-1f1f4",
          x: 11,
          y: 48
        }
      },
      {
        n: [
          "\u514B\u5229\u73C0\u987F\u5C9B\u56FD\u65D7",
          "\u6807\u5FD7cp"
        ],
        u: {
          u: "1f1e8-1f1f5",
          x: 12,
          y: 48
        }
      },
      {
        n: [
          "\u54E5\u65AF\u8FBE\u9ECE\u52A0\u56FD\u65D7",
          "\u6807\u5FD7cr"
        ],
        u: {
          u: "1f1e8-1f1f7",
          x: 13,
          y: 48
        }
      },
      {
        n: [
          "\u53E4\u5DF4\u56FD\u65D7",
          "\u6807\u5FD7cu"
        ],
        u: {
          u: "1f1e8-1f1fa",
          x: 14,
          y: 48
        }
      },
      {
        n: [
          "\u4F5B\u5F97\u89D2\u56FD\u65D7",
          "\u6807\u5FD7cv"
        ],
        u: {
          u: "1f1e8-1f1fb",
          x: 15,
          y: 48
        }
      },
      {
        n: [
          "\u5E93\u62C9\u7D22\u65D7",
          "\u6807\u5FD7cw"
        ],
        u: {
          u: "1f1e8-1f1fc",
          x: 16,
          y: 48
        }
      },
      {
        n: [
          "\u5723\u8BDE\u5C9B\u56FD\u65D7",
          "\u6807\u5FD7cx"
        ],
        u: {
          u: "1f1e8-1f1fd",
          x: 17,
          y: 48
        }
      },
      {
        n: [
          "\u585E\u6D66\u8DEF\u65AF\u56FD\u65D7",
          "\u6807\u5FD7cy"
        ],
        u: {
          u: "1f1e8-1f1fe",
          x: 18,
          y: 48
        }
      },
      {
        n: [
          "\u6377\u514B\u56FD\u65D7",
          "\u6807\u5FD7cz"
        ],
        u: {
          u: "1f1e8-1f1ff",
          x: 19,
          y: 48
        }
      },
      {
        n: [
          "\u5FB7\u56FD\u56FD\u65D7",
          "de\u516C\u53F8",
          "\u6807\u5FD7de"
        ],
        u: {
          u: "1f1e9-1f1ea",
          x: 20,
          y: 48
        }
      },
      {
        n: [
          "\u8FED\u6208\u52A0\u897F\u4E9A\u65D7",
          "\u6807\u5FD7dg"
        ],
        u: {
          u: "1f1e9-1f1ec",
          x: 21,
          y: 48
        }
      },
      {
        n: [
          "\u5409\u5E03\u63D0\u56FD\u65D7",
          "\u6807\u5FD7dj"
        ],
        u: {
          u: "1f1e9-1f1ef",
          x: 22,
          y: 48
        }
      },
      {
        n: [
          "\u4E39\u9EA6\u56FD\u65D7",
          "\u6807\u5FD7dk"
        ],
        u: {
          u: "1f1e9-1f1f0",
          x: 23,
          y: 48
        }
      },
      {
        n: [
          "\u591A\u7C73\u5C3C\u52A0\u56FD\u65D7",
          "\u6807\u5FD7dm"
        ],
        u: {
          u: "1f1e9-1f1f2",
          x: 24,
          y: 48
        }
      },
      {
        n: [
          "\u591A\u7C73\u5C3C\u52A0\u5171\u548C\u56FD\u56FD\u65D7",
          "\u65D7\u624B"
        ],
        u: {
          u: "1f1e9-1f1f4",
          x: 25,
          y: 48
        }
      },
      {
        n: [
          "\u963F\u5C14\u53CA\u5229\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7dz"
        ],
        u: {
          u: "1f1e9-1f1ff",
          x: 26,
          y: 48
        }
      },
      {
        n: [
          "ceuta melilla\u65D7",
          "\u6807\u5FD7ea"
        ],
        u: {
          u: "1f1ea-1f1e6",
          x: 27,
          y: 48
        }
      },
      {
        n: [
          "\u5384\u74DC\u591A\u5C14\u56FD\u65D7",
          "\u6807\u5FD7ec"
        ],
        u: {
          u: "1f1ea-1f1e8",
          x: 28,
          y: 48
        }
      },
      {
        n: [
          "\u7231\u6C99\u5C3C\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7ee"
        ],
        u: {
          u: "1f1ea-1f1ea",
          x: 29,
          y: 48
        }
      },
      {
        n: [
          "\u57C3\u53CA\u56FD\u65D7",
          "\u6807\u5FD7eg"
        ],
        u: {
          u: "1f1ea-1f1ec",
          x: 30,
          y: 48
        }
      },
      {
        n: [
          "\u897F\u6492\u54C8\u62C9\u56FD\u65D7",
          "\u6807\u5FD7eh"
        ],
        u: {
          u: "1f1ea-1f1ed",
          x: 31,
          y: 48
        }
      },
      {
        n: [
          "\u5384\u7ACB\u7279\u91CC\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7er"
        ],
        u: {
          u: "1f1ea-1f1f7",
          x: 32,
          y: 48
        }
      },
      {
        n: [
          "\u897F\u73ED\u7259\u56FD\u65D7",
          "es\u516C\u53F8",
          "\u6807\u5FD7es"
        ],
        u: {
          u: "1f1ea-1f1f8",
          x: 33,
          y: 48
        }
      },
      {
        n: [
          "\u57C3\u585E\u4FC4\u6BD4\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7et"
        ],
        u: {
          u: "1f1ea-1f1f9",
          x: 34,
          y: 48
        }
      },
      {
        n: [
          "\u6B27\u76DF\u56FD\u65D7",
          "\u6807\u5FD7eu"
        ],
        u: {
          u: "1f1ea-1f1fa",
          x: 35,
          y: 48
        }
      },
      {
        n: [
          "\u82AC\u5170\u56FD\u65D7",
          "\u6807\u5FD7fi"
        ],
        u: {
          u: "1f1eb-1f1ee",
          x: 36,
          y: 48
        }
      },
      {
        n: [
          "\u6590\u6D4E\u56FD\u65D7",
          "\u6807\u5FD7fj"
        ],
        u: {
          u: "1f1eb-1f1ef",
          x: 37,
          y: 48
        }
      },
      {
        n: [
          "\u798F\u514B\u5170\u7FA4\u5C9B\u56FD\u65D7",
          "\u6807\u5FD7fk"
        ],
        u: {
          u: "1f1eb-1f1f0",
          x: 38,
          y: 48
        }
      },
      {
        n: [
          "\u5BC6\u514B\u7F57\u5C3C\u897F\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7fm"
        ],
        u: {
          u: "1f1eb-1f1f2",
          x: 39,
          y: 48
        }
      },
      {
        n: [
          "\u6CD5\u7F57\u7FA4\u5C9B\u56FD\u65D7",
          "\u6807\u5FD7fo"
        ],
        u: {
          u: "1f1eb-1f1f4",
          x: 40,
          y: 48
        }
      },
      {
        n: [
          "\u6CD5\u56FD\u56FD\u65D7",
          "fr\u516C\u53F8",
          "\u6807\u5FD7fr"
        ],
        u: {
          u: "1f1eb-1f1f7",
          x: 41,
          y: 48
        }
      },
      {
        n: [
          "\u52A0\u84EC\u56FD\u65D7",
          "\u6807\u5FD7ga"
        ],
        u: {
          u: "1f1ec-1f1e6",
          x: 42,
          y: 48
        }
      },
      {
        n: [
          "\u82F1\u56FD\u56FD\u65D7",
          "gb",
          "\u82F1\u56FD",
          "\u6807\u5FD7gb"
        ],
        u: {
          u: "1f1ec-1f1e7",
          x: 43,
          y: 48
        }
      },
      {
        n: [
          "\u683C\u6797\u7EB3\u8FBE\u56FD\u65D7",
          "\u6807\u5FD7gd"
        ],
        u: {
          u: "1f1ec-1f1e9",
          x: 44,
          y: 48
        }
      },
      {
        n: [
          "\u683C\u9C81\u5409\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7ge"
        ],
        u: {
          u: "1f1ec-1f1ea",
          x: 45,
          y: 48
        }
      },
      {
        n: [
          "\u6CD5\u5C5E\u572D\u4E9A\u90A3\u56FD\u65D7",
          "\u6807\u5FD7gf"
        ],
        u: {
          u: "1f1ec-1f1eb",
          x: 46,
          y: 48
        }
      },
      {
        n: [
          "\u6839\u897F\u5C9B\u56FD\u65D7",
          "\u6807\u5FD7gg"
        ],
        u: {
          u: "1f1ec-1f1ec",
          x: 47,
          y: 48
        }
      },
      {
        n: [
          "\u52A0\u7EB3\u56FD\u65D7",
          "\u6807\u5FD7gh"
        ],
        u: {
          u: "1f1ec-1f1ed",
          x: 48,
          y: 48
        }
      },
      {
        n: [
          "\u76F4\u5E03\u7F57\u9640\u56FD\u65D7",
          "\u6807\u5FD7gi"
        ],
        u: {
          u: "1f1ec-1f1ee",
          x: 49,
          y: 48
        }
      },
      {
        n: [
          "\u683C\u9675\u5170\u56FD\u65D7",
          "\u6807\u5FD7gl"
        ],
        u: {
          u: "1f1ec-1f1f1",
          x: 0,
          y: 49
        }
      },
      {
        n: [
          "\u5188\u6BD4\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7gm"
        ],
        u: {
          u: "1f1ec-1f1f2",
          x: 1,
          y: 49
        }
      },
      {
        n: [
          "\u51E0\u5185\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7gn"
        ],
        u: {
          u: "1f1ec-1f1f3",
          x: 2,
          y: 49
        }
      },
      {
        n: [
          "\u74DC\u5FB7\u7F57\u666E\u5C9B\u56FD\u65D7",
          "\u6807\u5FD7\u603B\u6210"
        ],
        u: {
          u: "1f1ec-1f1f5",
          x: 3,
          y: 49
        }
      },
      {
        n: [
          "\u8D64\u9053\u51E0\u5185\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7gq"
        ],
        u: {
          u: "1f1ec-1f1f6",
          x: 4,
          y: 49
        }
      },
      {
        n: [
          "\u5E0C\u814A\u56FD\u65D7",
          "\u6807\u5FD7gr"
        ],
        u: {
          u: "1f1ec-1f1f7",
          x: 5,
          y: 49
        }
      },
      {
        n: [
          "\u5357\u4E54\u6CBB\u4E9A-\u5357\u6851\u5A01\u5947\u7FA4\u5C9B\u56FD\u65D7",
          "\u6807\u5FD7gs"
        ],
        u: {
          u: "1f1ec-1f1f8",
          x: 6,
          y: 49
        }
      },
      {
        n: [
          "\u5371\u5730\u9A6C\u62C9\u56FD\u65D7",
          "\u6807\u5FD7gt"
        ],
        u: {
          u: "1f1ec-1f1f9",
          x: 7,
          y: 49
        }
      },
      {
        n: [
          "\u5173\u5C9B\u56FD\u65D7",
          "\u6807\u5FD7gu"
        ],
        u: {
          u: "1f1ec-1f1fa",
          x: 8,
          y: 49
        }
      },
      {
        n: [
          "\u51E0\u5185\u4E9A\u6BD4\u7ECD\u56FD\u65D7",
          "\u6807\u5FD7gw"
        ],
        u: {
          u: "1f1ec-1f1fc",
          x: 9,
          y: 49
        }
      },
      {
        n: [
          "\u572D\u4E9A\u90A3\u56FD\u65D7",
          "\u6807\u5FD7gy"
        ],
        u: {
          u: "1f1ec-1f1fe",
          x: 10,
          y: 49
        }
      },
      {
        n: [
          "\u9999\u6E2F\u7279\u522B\u884C\u653F\u533A\u56FD\u65D7",
          "\u9999\u6E2F\u56FD\u65D7"
        ],
        u: {
          u: "1f1ed-1f1f0",
          x: 11,
          y: 49
        }
      },
      {
        n: [
          "\u542C\u8BF4\u9EA6\u5F53\u52B3\u7FA4\u5C9B\u56FD\u65D7",
          "\u6807\u5FD7hm"
        ],
        u: {
          u: "1f1ed-1f1f2",
          x: 12,
          y: 49
        }
      },
      {
        n: [
          "\u6D2A\u90FD\u62C9\u65AF\u56FD\u65D7",
          "\u6807\u5FD7hn"
        ],
        u: {
          u: "1f1ed-1f1f3",
          x: 13,
          y: 49
        }
      },
      {
        n: [
          "\u514B\u7F57\u5730\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7hr"
        ],
        u: {
          u: "1f1ed-1f1f7",
          x: 14,
          y: 49
        }
      },
      {
        n: [
          "\u6D77\u5730\u56FD\u65D7",
          "\u6807\u5FD7ht"
        ],
        u: {
          u: "1f1ed-1f1f9",
          x: 15,
          y: 49
        }
      },
      {
        n: [
          "\u5308\u7259\u5229\u56FD\u65D7",
          "\u80E1\u65D7"
        ],
        u: {
          u: "1f1ed-1f1fa",
          x: 16,
          y: 49
        }
      },
      {
        n: [
          "\u52A0\u90A3\u5229\u7FA4\u5C9B\u56FD\u65D7",
          "\u6807\u5FD7ic"
        ],
        u: {
          u: "1f1ee-1f1e8",
          x: 17,
          y: 49
        }
      },
      {
        n: [
          "\u5370\u5EA6\u5C3C\u897F\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7id"
        ],
        u: {
          u: "1f1ee-1f1e9",
          x: 18,
          y: 49
        }
      },
      {
        n: [
          "\u7231\u5C14\u5170\u56FD\u65D7",
          "\u6807\u5FD7ie"
        ],
        u: {
          u: "1f1ee-1f1ea",
          x: 19,
          y: 49
        }
      },
      {
        n: [
          "\u4EE5\u8272\u5217\u56FD\u65D7",
          "\u6807\u5FD7il"
        ],
        u: {
          u: "1f1ee-1f1f1",
          x: 20,
          y: 49
        }
      },
      {
        n: [
          "\u9A6C\u6069\u5C9B\u56FD\u65D7",
          "\u6807\u8BB0im"
        ],
        u: {
          u: "1f1ee-1f1f2",
          x: 21,
          y: 49
        }
      },
      {
        n: [
          "\u5370\u5EA6\u56FD\u65D7",
          "\u52A0\u5165"
        ],
        u: {
          u: "1f1ee-1f1f3",
          x: 22,
          y: 49
        }
      },
      {
        n: [
          "\u82F1\u5C5E\u5370\u5EA6\u6D0B\u9886\u571F\u65D7",
          "\u6807\u5FD7io"
        ],
        u: {
          u: "1f1ee-1f1f4",
          x: 23,
          y: 49
        }
      },
      {
        n: [
          "\u4F0A\u62C9\u514B\u56FD\u65D7",
          "\u6807\u5FD7iq"
        ],
        u: {
          u: "1f1ee-1f1f6",
          x: 24,
          y: 49
        }
      },
      {
        n: [
          "\u4F0A\u6717\u56FD\u65D7",
          "\u6807\u5FD7ir"
        ],
        u: {
          u: "1f1ee-1f1f7",
          x: 25,
          y: 49
        }
      },
      {
        n: [
          "\u51B0\u5C9B\u56FD\u65D7",
          "\u6807\u5FD7\u4E3A"
        ],
        u: {
          u: "1f1ee-1f1f8",
          x: 26,
          y: 49
        }
      },
      {
        n: [
          "\u610F\u5927\u5229\u56FD\u65D7",
          "\u4FE1\u606F\u6280\u672F",
          "\u6807\u8BB0\u5B83"
        ],
        u: {
          u: "1f1ee-1f1f9",
          x: 27,
          y: 49
        }
      },
      {
        n: [
          "\u6CFD\u897F\u5C9B\u56FD\u65D7",
          "\u6807\u5FD7je"
        ],
        u: {
          u: "1f1ef-1f1ea",
          x: 28,
          y: 49
        }
      },
      {
        n: [
          "\u7259\u4E70\u52A0\u56FD\u65D7",
          "\u6807\u5FD7jm"
        ],
        u: {
          u: "1f1ef-1f1f2",
          x: 29,
          y: 49
        }
      },
      {
        n: [
          "\u7EA6\u65E6\u56FD\u65D7",
          "\u6807\u5FD7jo"
        ],
        u: {
          u: "1f1ef-1f1f4",
          x: 30,
          y: 49
        }
      },
      {
        n: [
          "\u65E5\u672C\u56FD\u65D7",
          "\u65E5\u672C",
          "\u6807\u5FD7jp"
        ],
        u: {
          u: "1f1ef-1f1f5",
          x: 31,
          y: 49
        }
      },
      {
        n: [
          "\u80AF\u5C3C\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7ke"
        ],
        u: {
          u: "1f1f0-1f1ea",
          x: 32,
          y: 49
        }
      },
      {
        n: [
          "\u5409\u5C14\u5409\u65AF\u65AF\u5766\u56FD\u65D7",
          "\u6807\u5FD7kg"
        ],
        u: {
          u: "1f1f0-1f1ec",
          x: 33,
          y: 49
        }
      },
      {
        n: [
          "\u67EC\u57D4\u5BE8\u56FD\u65D7",
          "\u6807\u5FD7kh"
        ],
        u: {
          u: "1f1f0-1f1ed",
          x: 34,
          y: 49
        }
      },
      {
        n: [
          "\u57FA\u91CC\u5DF4\u65AF\u56FD\u65D7",
          "\u6807\u5FD7ki"
        ],
        u: {
          u: "1f1f0-1f1ee",
          x: 35,
          y: 49
        }
      },
      {
        n: [
          "\u79D1\u6469\u7F57\u56FD\u65D7",
          "\u6807\u5FD7\u516C\u91CC\u6570"
        ],
        u: {
          u: "1f1f0-1f1f2",
          x: 36,
          y: 49
        }
      },
      {
        n: [
          "\u5723\u57FA\u8328\u548C\u5C3C\u7EF4\u65AF\u56FD\u65D7",
          "\u6807\u5FD7kn"
        ],
        u: {
          u: "1f1f0-1f1f3",
          x: 37,
          y: 49
        }
      },
      {
        n: [
          "\u671D\u9C9C\u56FD\u65D7",
          "\u6807\u5FD7kp"
        ],
        u: {
          u: "1f1f0-1f1f5",
          x: 38,
          y: 49
        }
      },
      {
        n: [
          "\u97E9\u56FD\u56FD\u65D7",
          "\u97E9\u5143",
          "\u6807\u5FD7kr"
        ],
        u: {
          u: "1f1f0-1f1f7",
          x: 39,
          y: 49
        }
      },
      {
        n: [
          "\u79D1\u5A01\u7279\u56FD\u65D7",
          "\u6807\u5FD7kw"
        ],
        u: {
          u: "1f1f0-1f1fc",
          x: 40,
          y: 49
        }
      },
      {
        n: [
          "\u5F00\u66FC\u7FA4\u5C9B\u56FD\u65D7",
          "\u6807\u5FD7ky"
        ],
        u: {
          u: "1f1f0-1f1fe",
          x: 41,
          y: 49
        }
      },
      {
        n: [
          "\u54C8\u8428\u514B\u65AF\u5766\u56FD\u65D7",
          "\u6807\u5FD7kz"
        ],
        u: {
          u: "1f1f0-1f1ff",
          x: 42,
          y: 49
        }
      },
      {
        n: [
          "\u8001\u631D\u56FD\u65D7",
          "\u6807\u5FD7la"
        ],
        u: {
          u: "1f1f1-1f1e6",
          x: 43,
          y: 49
        }
      },
      {
        n: [
          "\u9ECE\u5DF4\u5AE9\u56FD\u65D7",
          "\u6807\u5FD7lb"
        ],
        u: {
          u: "1f1f1-1f1e7",
          x: 44,
          y: 49
        }
      },
      {
        n: [
          "\u5723\u5362\u897F\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7lc"
        ],
        u: {
          u: "1f1f1-1f1e8",
          x: 45,
          y: 49
        }
      },
      {
        n: [
          "\u5217\u652F\u6566\u58EB\u767B\u56FD\u65D7",
          "\u6807\u5FD7li"
        ],
        u: {
          u: "1f1f1-1f1ee",
          x: 46,
          y: 49
        }
      },
      {
        n: [
          "\u65AF\u91CC\u5170\u5361\u56FD\u65D7",
          "\u6807\u5FD7lk"
        ],
        u: {
          u: "1f1f1-1f1f0",
          x: 47,
          y: 49
        }
      },
      {
        n: [
          "\u5229\u6BD4\u91CC\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7lr"
        ],
        u: {
          u: "1f1f1-1f1f7",
          x: 48,
          y: 49
        }
      },
      {
        n: [
          "\u83B1\u7D22\u6258\u56FD\u65D7",
          "\u6807\u5FD7ls"
        ],
        u: {
          u: "1f1f1-1f1f8",
          x: 49,
          y: 49
        }
      },
      {
        n: [
          "\u7ACB\u9676\u5B9B\u56FD\u65D7",
          "\u6807\u5FD7lt"
        ],
        u: {
          u: "1f1f1-1f1f9",
          x: 0,
          y: 50
        }
      },
      {
        n: [
          "\u5362\u68EE\u5821\u56FD\u65D7",
          "\u6807\u5FD7lu"
        ],
        u: {
          u: "1f1f1-1f1fa",
          x: 1,
          y: 50
        }
      },
      {
        n: [
          "\u62C9\u8131\u7EF4\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7lv"
        ],
        u: {
          u: "1f1f1-1f1fb",
          x: 2,
          y: 50
        }
      },
      {
        n: [
          "\u5229\u6BD4\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7ly"
        ],
        u: {
          u: "1f1f1-1f1fe",
          x: 3,
          y: 50
        }
      },
      {
        n: [
          "\u6469\u6D1B\u54E5\u56FD\u65D7",
          "\u6807\u5FD7ma"
        ],
        u: {
          u: "1f1f2-1f1e6",
          x: 4,
          y: 50
        }
      },
      {
        n: [
          "\u6469\u7EB3\u54E5\u56FD\u65D7",
          "\u6807\u8BB0mc"
        ],
        u: {
          u: "1f1f2-1f1e8",
          x: 5,
          y: 50
        }
      },
      {
        n: [
          "\u6469\u5C14\u591A\u74E6\u56FD\u65D7",
          "\u6807\u5FD7md"
        ],
        u: {
          u: "1f1f2-1f1e9",
          x: 6,
          y: 50
        }
      },
      {
        n: [
          "\u9ED1\u5C71\u56FD\u65D7",
          "\u6807\u8BB0\u6211"
        ],
        u: {
          u: "1f1f2-1f1ea",
          x: 7,
          y: 50
        }
      },
      {
        n: [
          "\u5723\u9A6C\u4E01\u65D7",
          "\u6807\u5FD7mf"
        ],
        u: {
          u: "1f1f2-1f1eb",
          x: 8,
          y: 50
        }
      },
      {
        n: [
          "\u9A6C\u8FBE\u52A0\u65AF\u52A0\u56FD\u65D7",
          "\u6807\u5FD7mg"
        ],
        u: {
          u: "1f1f2-1f1ec",
          x: 9,
          y: 50
        }
      },
      {
        n: [
          "\u9A6C\u7ECD\u5C14\u7FA4\u5C9B\u56FD\u65D7",
          "\u6807\u5FD7mh"
        ],
        u: {
          u: "1f1f2-1f1ed",
          x: 10,
          y: 50
        }
      },
      {
        n: [
          "\u9A6C\u5176\u987F\u56FD\u65D7",
          "\u6807\u5FD7mk"
        ],
        u: {
          u: "1f1f2-1f1f0",
          x: 11,
          y: 50
        }
      },
      {
        n: [
          "\u9A6C\u91CC\u56FD\u65D7",
          "\u6807\u5FD7ml"
        ],
        u: {
          u: "1f1f2-1f1f1",
          x: 12,
          y: 50
        }
      },
      {
        n: [
          "\u7F05\u7538\uFF08\u7F05\u7538\uFF09\u56FD\u65D7",
          "\u6807\u5FD7mm"
        ],
        u: {
          u: "1f1f2-1f1f2",
          x: 13,
          y: 50
        }
      },
      {
        n: [
          "\u8499\u53E4\u56FD\u65D7",
          "\u6807\u8BB0mn"
        ],
        u: {
          u: "1f1f2-1f1f3",
          x: 14,
          y: 50
        }
      },
      {
        n: [
          "\u6FB3\u95E8\u7279\u522B\u884C\u653F\u533A\u4E2D\u56FD\u56FD\u65D7",
          "\u6807\u5FD7mo"
        ],
        u: {
          u: "1f1f2-1f1f4",
          x: 15,
          y: 50
        }
      },
      {
        n: [
          "\u5317\u9A6C\u91CC\u4E9A\u7EB3\u7FA4\u5C9B\u56FD\u65D7",
          "\u6807\u5FD7mp"
        ],
        u: {
          u: "1f1f2-1f1f5",
          x: 16,
          y: 50
        }
      },
      {
        n: [
          "\u9A6C\u63D0\u5C3C\u514B\u56FD\u65D7",
          "\u6807\u5FD7mq"
        ],
        u: {
          u: "1f1f2-1f1f6",
          x: 17,
          y: 50
        }
      },
      {
        n: [
          "\u6BDB\u91CC\u5854\u5C3C\u4E9A\u56FD\u65D7",
          "\u6807\u8BB0mr"
        ],
        u: {
          u: "1f1f2-1f1f7",
          x: 18,
          y: 50
        }
      },
      {
        n: [
          "\u8499\u7279\u585E\u62C9\u7279\u56FD\u65D7",
          "\u6807\u5FD7ms"
        ],
        u: {
          u: "1f1f2-1f1f8",
          x: 19,
          y: 50
        }
      },
      {
        n: [
          "\u9A6C\u8033\u4ED6\u56FD\u65D7",
          "\u6807\u8BB0mt"
        ],
        u: {
          u: "1f1f2-1f1f9",
          x: 20,
          y: 50
        }
      },
      {
        n: [
          "\u6BDB\u91CC\u6C42\u65AF\u56FD\u65D7",
          "\u6807\u5FD7mu"
        ],
        u: {
          u: "1f1f2-1f1fa",
          x: 21,
          y: 50
        }
      },
      {
        n: [
          "\u9A6C\u5C14\u4EE3\u592B\u56FD\u65D7",
          "\u6807\u5FD7mv"
        ],
        u: {
          u: "1f1f2-1f1fb",
          x: 22,
          y: 50
        }
      },
      {
        n: [
          "\u9A6C\u62C9\u7EF4\u56FD\u65D7",
          "\u6807\u5FD7mw"
        ],
        u: {
          u: "1f1f2-1f1fc",
          x: 23,
          y: 50
        }
      },
      {
        n: [
          "\u58A8\u897F\u54E5\u56FD\u65D7",
          "\u6807\u8BB0mx"
        ],
        u: {
          u: "1f1f2-1f1fd",
          x: 24,
          y: 50
        }
      },
      {
        n: [
          "\u9A6C\u6765\u897F\u4E9A\u56FD\u65D7",
          "\u6807\u8BB0\u6211\u7684"
        ],
        u: {
          u: "1f1f2-1f1fe",
          x: 25,
          y: 50
        }
      },
      {
        n: [
          "\u83AB\u6851\u6BD4\u514B\u56FD\u65D7",
          "\u6807\u5FD7mz"
        ],
        u: {
          u: "1f1f2-1f1ff",
          x: 26,
          y: 50
        }
      },
      {
        n: [
          "\u7EB3\u7C73\u6BD4\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7na"
        ],
        u: {
          u: "1f1f3-1f1e6",
          x: 27,
          y: 50
        }
      },
      {
        n: [
          "\u65B0\u5580\u91CC\u591A\u5C3C\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7nc"
        ],
        u: {
          u: "1f1f3-1f1e8",
          x: 28,
          y: 50
        }
      },
      {
        n: [
          "\u5C3C\u65E5\u5C14\u56FD\u65D7",
          "\u6807\u5FD7ne"
        ],
        u: {
          u: "1f1f3-1f1ea",
          x: 29,
          y: 50
        }
      },
      {
        n: [
          "\u8BFA\u798F\u514B\u5C9B\u56FD\u65D7",
          "\u6807\u5FD7nf"
        ],
        u: {
          u: "1f1f3-1f1eb",
          x: 30,
          y: 50
        }
      },
      {
        n: [
          "\u5C3C\u65E5\u5229\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7ng"
        ],
        u: {
          u: "1f1f3-1f1ec",
          x: 31,
          y: 50
        }
      },
      {
        n: [
          "\u5C3C\u52A0\u62C9\u74DC\u56FD\u65D7",
          "\u6807\u5FD7ni"
        ],
        u: {
          u: "1f1f3-1f1ee",
          x: 32,
          y: 50
        }
      },
      {
        n: [
          "\u8377\u5170\u56FD\u65D7",
          "\u6807\u5FD7nl"
        ],
        u: {
          u: "1f1f3-1f1f1",
          x: 33,
          y: 50
        }
      },
      {
        n: [
          "\u632A\u5A01\u56FD\u65D7",
          "\u6807\u5FD7\u7F16\u53F7"
        ],
        u: {
          u: "1f1f3-1f1f4",
          x: 34,
          y: 50
        }
      },
      {
        n: [
          "\u5C3C\u6CCA\u5C14\u56FD\u65D7",
          "\u6807\u5FD7np"
        ],
        u: {
          u: "1f1f3-1f1f5",
          x: 35,
          y: 50
        }
      },
      {
        n: [
          "\u7459\u9C81\u56FD\u65D7",
          "\u6807\u5FD7\u7F16\u53F7"
        ],
        u: {
          u: "1f1f3-1f1f7",
          x: 36,
          y: 50
        }
      },
      {
        n: [
          "\u7EBD\u57C3\u56FD\u65D7",
          "\u6807\u5FD7nu"
        ],
        u: {
          u: "1f1f3-1f1fa",
          x: 37,
          y: 50
        }
      },
      {
        n: [
          "\u65B0\u897F\u5170\u56FD\u65D7",
          "\u65B0\u897F\u5170\u56FD\u65D7"
        ],
        u: {
          u: "1f1f3-1f1ff",
          x: 38,
          y: 50
        }
      },
      {
        n: [
          "\u963F\u66FC\u56FD\u65D7",
          "\u6807\u5FD7om"
        ],
        u: {
          u: "1f1f4-1f1f2",
          x: 39,
          y: 50
        }
      },
      {
        n: [
          "\u5DF4\u62FF\u9A6C\u56FD\u65D7",
          "\u6807\u5FD7pa"
        ],
        u: {
          u: "1f1f5-1f1e6",
          x: 40,
          y: 50
        }
      },
      {
        n: [
          "\u79D8\u9C81\u56FD\u65D7",
          "\u6807\u5FD7pe"
        ],
        u: {
          u: "1f1f5-1f1ea",
          x: 41,
          y: 50
        }
      },
      {
        n: [
          "\u6CD5\u5C5E\u6CE2\u5229\u5C3C\u897F\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7pf"
        ],
        u: {
          u: "1f1f5-1f1eb",
          x: 42,
          y: 50
        }
      },
      {
        n: [
          "\u5DF4\u5E03\u4E9A\u65B0\u51E0\u5185\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7pg"
        ],
        u: {
          u: "1f1f5-1f1ec",
          x: 43,
          y: 50
        }
      },
      {
        n: [
          "\u83F2\u5F8B\u5BBE\u56FD\u65D7",
          "\u6807\u5FD7ph\u503C"
        ],
        u: {
          u: "1f1f5-1f1ed",
          x: 44,
          y: 50
        }
      },
      {
        n: [
          "\u5DF4\u57FA\u65AF\u5766\u56FD\u65D7",
          "\u6807\u5FD7pk"
        ],
        u: {
          u: "1f1f5-1f1f0",
          x: 45,
          y: 50
        }
      },
      {
        n: [
          "\u6CE2\u5170\u56FD\u65D7",
          "\u65D7\u5E1Cpl"
        ],
        u: {
          u: "1f1f5-1f1f1",
          x: 46,
          y: 50
        }
      },
      {
        n: [
          "\u5723\u76AE\u57C3\u5C14\xB7\u7C73\u514B\u9686\u65D7",
          "\u6807\u5FD7pm"
        ],
        u: {
          u: "1f1f5-1f1f2",
          x: 47,
          y: 50
        }
      },
      {
        n: [
          "\u76AE\u7279\u51EF\u6069\u7FA4\u5C9B\u56FD\u65D7",
          "\u6807\u5FD7pn"
        ],
        u: {
          u: "1f1f5-1f1f3",
          x: 48,
          y: 50
        }
      },
      {
        n: [
          "\u6CE2\u591A\u9ECE\u5404\u56FD\u65D7",
          "\u6807\u5FD7pr"
        ],
        u: {
          u: "1f1f5-1f1f7",
          x: 49,
          y: 50
        }
      },
      {
        n: [
          "\u5DF4\u52D2\u65AF\u5766\u9886\u571F\u56FD\u65D7",
          "\u6807\u5FD7ps"
        ],
        u: {
          u: "1f1f5-1f1f8",
          x: 0,
          y: 51
        }
      },
      {
        n: [
          "\u8461\u8404\u7259\u56FD\u65D7",
          "\u6807\u5FD7pt"
        ],
        u: {
          u: "1f1f5-1f1f9",
          x: 1,
          y: 51
        }
      },
      {
        n: [
          "\u5E15\u52B3\u56FD\u65D7",
          "\u6807\u5FD7pw"
        ],
        u: {
          u: "1f1f5-1f1fc",
          x: 2,
          y: 51
        }
      },
      {
        n: [
          "\u5DF4\u62C9\u572D\u56FD\u65D7",
          "\u6807\u5FD7py"
        ],
        u: {
          u: "1f1f5-1f1fe",
          x: 3,
          y: 51
        }
      },
      {
        n: [
          "\u5361\u5854\u5C14\u56FD\u65D7",
          "\u6807\u8BB0qa"
        ],
        u: {
          u: "1f1f6-1f1e6",
          x: 4,
          y: 51
        }
      },
      {
        n: [
          "r\xE9union\u6807\u5FD7",
          "\u6807\u5FD7re"
        ],
        u: {
          u: "1f1f7-1f1ea",
          x: 5,
          y: 51
        }
      },
      {
        n: [
          "\u7F57\u9A6C\u5C3C\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7ro"
        ],
        u: {
          u: "1f1f7-1f1f4",
          x: 6,
          y: 51
        }
      },
      {
        n: [
          "\u585E\u5C14\u7EF4\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7rs"
        ],
        u: {
          u: "1f1f7-1f1f8",
          x: 7,
          y: 51
        }
      },
      {
        n: [
          "\u4FC4\u7F57\u65AF\u56FD\u65D7",
          "\u4FC4\u7F57\u65AF",
          "\u6807\u5FD7ru"
        ],
        u: {
          u: "1f1f7-1f1fa",
          x: 8,
          y: 51
        }
      },
      {
        n: [
          "\u5362\u65FA\u8FBE\u56FD\u65D7",
          "\u6807\u8BB0rw"
        ],
        u: {
          u: "1f1f7-1f1fc",
          x: 9,
          y: 51
        }
      },
      {
        n: [
          "\u6C99\u7279\u963F\u62C9\u4F2F\u56FD\u65D7",
          "\u6807\u5FD7sa"
        ],
        u: {
          u: "1f1f8-1f1e6",
          x: 10,
          y: 51
        }
      },
      {
        n: [
          "\u6240\u7F57\u95E8\u7FA4\u5C9B\u56FD\u65D7",
          "\u6807\u8BB0\u67D0\u4EBA"
        ],
        u: {
          u: "1f1f8-1f1e7",
          x: 11,
          y: 51
        }
      },
      {
        n: [
          "\u585E\u820C\u5C14\u56FD\u65D7",
          "\u6807\u5FD7sc"
        ],
        u: {
          u: "1f1f8-1f1e8",
          x: 12,
          y: 51
        }
      },
      {
        n: [
          "\u82CF\u4E39\u56FD\u65D7",
          "\u6807\u5FD7sd"
        ],
        u: {
          u: "1f1f8-1f1e9",
          x: 13,
          y: 51
        }
      },
      {
        n: [
          "\u745E\u5178\u56FD\u65D7",
          "\u6807\u5FD7se"
        ],
        u: {
          u: "1f1f8-1f1ea",
          x: 14,
          y: 51
        }
      },
      {
        n: [
          "\u65B0\u52A0\u5761\u56FD\u65D7",
          "\u6807\u5FD7sg"
        ],
        u: {
          u: "1f1f8-1f1ec",
          x: 15,
          y: 51
        }
      },
      {
        n: [
          "\u5723\u8D6B\u52D2\u62FF\u56FD\u65D7",
          "\u65D7\u5B50"
        ],
        u: {
          u: "1f1f8-1f1ed",
          x: 16,
          y: 51
        }
      },
      {
        n: [
          "\u65AF\u6D1B\u6587\u5C3C\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7si"
        ],
        u: {
          u: "1f1f8-1f1ee",
          x: 17,
          y: 51
        }
      },
      {
        n: [
          "\u65AF\u74E6\u5C14\u5DF4\u7279\u626C\u9A6C\u5EF6\u65D7",
          "\u6807\u5FD7sj"
        ],
        u: {
          u: "1f1f8-1f1ef",
          x: 18,
          y: 51
        }
      },
      {
        n: [
          "\u65AF\u6D1B\u4F10\u514B\u56FD\u65D7",
          "\u6807\u5FD7sk"
        ],
        u: {
          u: "1f1f8-1f1f0",
          x: 19,
          y: 51
        }
      },
      {
        n: [
          "\u585E\u62C9\u5229\u6602\u56FD\u65D7",
          "\u6807\u5FD7sl"
        ],
        u: {
          u: "1f1f8-1f1f1",
          x: 20,
          y: 51
        }
      },
      {
        n: [
          "\u5723\u9A6C\u529B\u8BFA\u56FD\u65D7",
          "\u6807\u5FD7sm"
        ],
        u: {
          u: "1f1f8-1f1f2",
          x: 21,
          y: 51
        }
      },
      {
        n: [
          "\u585E\u5185\u52A0\u5C14\u56FD\u65D7",
          "\u6807\u5FD7\u5E8F\u53F7"
        ],
        u: {
          u: "1f1f8-1f1f3",
          x: 22,
          y: 51
        }
      },
      {
        n: [
          "\u7D22\u9A6C\u91CC\u56FD\u65D7",
          "\u6807\u8BB0so"
        ],
        u: {
          u: "1f1f8-1f1f4",
          x: 23,
          y: 51
        }
      },
      {
        n: [
          "\u82CF\u91CC\u5357\u56FD\u65D7",
          "\u6807\u5FD7sr"
        ],
        u: {
          u: "1f1f8-1f1f7",
          x: 24,
          y: 51
        }
      },
      {
        n: [
          "\u5357\u82CF\u4E39\u56FD\u65D7",
          "\u6807\u5FD7ss"
        ],
        u: {
          u: "1f1f8-1f1f8",
          x: 25,
          y: 51
        }
      },
      {
        n: [
          "\u5723\u6258\u7F8E\xB7\u666E\u6797\u897F\u6BD4\u56FD\u65D7",
          "\u6807\u5FD7st"
        ],
        u: {
          u: "1f1f8-1f1f9",
          x: 26,
          y: 51
        }
      },
      {
        n: [
          "\u8428\u5C14\u74E6\u591A\u56FD\u65D7",
          "\u6807\u5FD7sv"
        ],
        u: {
          u: "1f1f8-1f1fb",
          x: 27,
          y: 51
        }
      },
      {
        n: [
          "\u5723\u9A6C\u4E01\u65D7",
          "\u6807\u5FD7sx"
        ],
        u: {
          u: "1f1f8-1f1fd",
          x: 28,
          y: 51
        }
      },
      {
        n: [
          "\u53D9\u5229\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7sy"
        ],
        u: {
          u: "1f1f8-1f1fe",
          x: 29,
          y: 51
        }
      },
      {
        n: [
          "\u65AF\u5A01\u58EB\u5170\u56FD\u65D7",
          "\u6807\u5FD7sz"
        ],
        u: {
          u: "1f1f8-1f1ff",
          x: 30,
          y: 51
        }
      },
      {
        n: [
          "\u7279\u91CC\u65AF\u5766-\u8FBE\u5E93\u5C3C\u4E9A\u65D7",
          "\u6807\u5FD7ta"
        ],
        u: {
          u: "1f1f9-1f1e6",
          x: 31,
          y: 51
        }
      },
      {
        n: [
          "\u7279\u514B\u65AF\u51EF\u79D1\u65AF\u7FA4\u5C9B\u56FD\u65D7",
          "\u6807\u5FD7tc"
        ],
        u: {
          u: "1f1f9-1f1e8",
          x: 32,
          y: 51
        }
      },
      {
        n: [
          "\u4E4D\u5F97\u56FD\u65D7",
          "\u6807\u8BB0td"
        ],
        u: {
          u: "1f1f9-1f1e9",
          x: 33,
          y: 51
        }
      },
      {
        n: [
          "\u6CD5\u56FD\u5357\u90E8\u9886\u571F\u56FD\u65D7",
          "\u6807\u5FD7tf"
        ],
        u: {
          u: "1f1f9-1f1eb",
          x: 34,
          y: 51
        }
      },
      {
        n: [
          "\u591A\u54E5\u56FD\u65D7",
          "\u6807\u8BB0tg"
        ],
        u: {
          u: "1f1f9-1f1ec",
          x: 35,
          y: 51
        }
      },
      {
        n: [
          "\u6CF0\u56FD\u56FD\u65D7",
          "\u6807\u5FD7th"
        ],
        u: {
          u: "1f1f9-1f1ed",
          x: 36,
          y: 51
        }
      },
      {
        n: [
          "\u5854\u5409\u514B\u65AF\u5766\u56FD\u65D7",
          "\u6807\u5FD7tj"
        ],
        u: {
          u: "1f1f9-1f1ef",
          x: 37,
          y: 51
        }
      },
      {
        n: [
          "\u6258\u514B\u52B3\u56FD\u65D7",
          "\u6807\u5FD7tk"
        ],
        u: {
          u: "1f1f9-1f1f0",
          x: 38,
          y: 51
        }
      },
      {
        n: [
          "\u4E1C\u5E1D\u6C76\u56FD\u65D7",
          "\u6807\u5FD7tl"
        ],
        u: {
          u: "1f1f9-1f1f1",
          x: 39,
          y: 51
        }
      },
      {
        n: [
          "\u571F\u5E93\u66FC\u65AF\u5766\u56FD\u65D7",
          "\u6807\u5FD7tm"
        ],
        u: {
          u: "1f1f9-1f1f2",
          x: 40,
          y: 51
        }
      },
      {
        n: [
          "\u7A81\u5C3C\u65AF\u56FD\u65D7",
          "\u6807\u5FD7tn"
        ],
        u: {
          u: "1f1f9-1f1f3",
          x: 41,
          y: 51
        }
      },
      {
        n: [
          "\u6C64\u52A0\u56FD\u65D7",
          "\u6807\u8BB0\u4E3A"
        ],
        u: {
          u: "1f1f9-1f1f4",
          x: 42,
          y: 51
        }
      },
      {
        n: [
          "\u571F\u8033\u5176\u56FD\u65D7",
          "\u6807\u5FD7tr"
        ],
        u: {
          u: "1f1f9-1f1f7",
          x: 43,
          y: 51
        }
      },
      {
        n: [
          "\u7279\u7ACB\u5C3C\u8FBE-\u591A\u5DF4\u54E5\u56FD\u65D7",
          "\u6807\u5FD7tt"
        ],
        u: {
          u: "1f1f9-1f1f9",
          x: 44,
          y: 51
        }
      },
      {
        n: [
          "\u56FE\u74E6\u5362\u56FD\u65D7",
          "\u6807\u5FD7\u7535\u89C6"
        ],
        u: {
          u: "1f1f9-1f1fb",
          x: 45,
          y: 51
        }
      },
      {
        n: [
          " ",
          "\u6807\u5FD7tw"
        ],
        u: {
          u: "1f1f9-1f1fc",
          x: 46,
          y: 51
        }
      },
      {
        n: [
          "\u5766\u6851\u5C3C\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7tz"
        ],
        u: {
          u: "1f1f9-1f1ff",
          x: 47,
          y: 51
        }
      },
      {
        n: [
          "\u4E4C\u514B\u5170\u56FD\u65D7",
          "\u6807\u5FD7ua"
        ],
        u: {
          u: "1f1fa-1f1e6",
          x: 48,
          y: 51
        }
      },
      {
        n: [
          "\u4E4C\u5E72\u8FBE\u56FD\u65D7",
          "\u6807\u5FD7ug"
        ],
        u: {
          u: "1f1fa-1f1ec",
          x: 49,
          y: 51
        }
      },
      {
        n: [
          "u\u3001 \u7F8E\u56FD\u79BB\u5C9B\u56FD\u65D7",
          "\u6807\u5FD7um"
        ],
        u: {
          u: "1f1fa-1f1f2",
          x: 0,
          y: 52
        }
      },
      {
        n: [
          "\u8054\u5408\u56FD\u56FD\u65D7",
          "\u6807\u5FD7un"
        ],
        u: {
          u: "1f1fa-1f1f3",
          x: 1,
          y: 52
        }
      },
      {
        n: [
          "\u7F8E\u56FD\u56FD\u65D7",
          "\u6211\u4EEC",
          "\u6807\u8BB0\u6211\u4EEC"
        ],
        u: {
          u: "1f1fa-1f1f8",
          x: 2,
          y: 52
        }
      },
      {
        n: [
          "\u4E4C\u62C9\u572D\u56FD\u65D7",
          "\u6807\u5FD7uy"
        ],
        u: {
          u: "1f1fa-1f1fe",
          x: 3,
          y: 52
        }
      },
      {
        n: [
          "\u4E4C\u5179\u522B\u514B\u65AF\u5766\u56FD\u65D7",
          "\u6807\u5FD7uz"
        ],
        u: {
          u: "1f1fa-1f1ff",
          x: 4,
          y: 52
        }
      },
      {
        n: [
          "\u68B5\u8482\u5188\u57CE\u65D7",
          "\u6807\u5FD7va"
        ],
        u: {
          u: "1f1fb-1f1e6",
          x: 5,
          y: 52
        }
      },
      {
        n: [
          "\u5723\u6587\u68EE\u7279\u683C\u6797\u7EB3\u4E01\u65AF\u56FD\u65D7",
          "\u6807\u5FD7vc"
        ],
        u: {
          u: "1f1fb-1f1e8",
          x: 6,
          y: 52
        }
      },
      {
        n: [
          "\u59D4\u5185\u745E\u62C9\u56FD\u65D7",
          "\u65D7\u5E1C"
        ],
        u: {
          u: "1f1fb-1f1ea",
          x: 7,
          y: 52
        }
      },
      {
        n: [
          "\u82F1\u5C5E\u7EF4\u5C14\u4EAC\u7FA4\u5C9B\u56FD\u65D7",
          "\u6807\u5FD7vg"
        ],
        u: {
          u: "1f1fb-1f1ec",
          x: 8,
          y: 52
        }
      },
      {
        n: [
          "u\u3001 \u7F8E\u5C5E\u7EF4\u5C14\u4EAC\u7FA4\u5C9B\u56FD\u65D7",
          "\u6807\u5FD7vi"
        ],
        u: {
          u: "1f1fb-1f1ee",
          x: 9,
          y: 52
        }
      },
      {
        n: [
          "\u8D8A\u5357\u56FD\u65D7",
          "\u6807\u5FD7vn"
        ],
        u: {
          u: "1f1fb-1f1f3",
          x: 10,
          y: 52
        }
      },
      {
        n: [
          "\u74E6\u52AA\u963F\u56FE\u56FD\u65D7",
          "\u6807\u5FD7vu"
        ],
        u: {
          u: "1f1fb-1f1fa",
          x: 11,
          y: 52
        }
      },
      {
        n: [
          "\u6C83\u5229\u65AF\u5BCC\u56FE\u7EB3\u65D7",
          "\u6807\u5FD7wf"
        ],
        u: {
          u: "1f1fc-1f1eb",
          x: 12,
          y: 52
        }
      },
      {
        n: [
          "\u8428\u6469\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7ws"
        ],
        u: {
          u: "1f1fc-1f1f8",
          x: 13,
          y: 52
        }
      },
      {
        n: [
          "\u79D1\u7D22\u6C83\u56FD\u65D7",
          "\u6807\u5FD7xk"
        ],
        u: {
          u: "1f1fd-1f1f0",
          x: 14,
          y: 52
        }
      },
      {
        n: [
          "\u4E5F\u95E8\u56FD\u65D7",
          "\u6807\u5FD7ye"
        ],
        u: {
          u: "1f1fe-1f1ea",
          x: 15,
          y: 52
        }
      },
      {
        n: [
          "\u9A6C\u7EA6\u7279\u65D7",
          "\u6807\u5FD7yt"
        ],
        u: {
          u: "1f1fe-1f1f9",
          x: 16,
          y: 52
        }
      },
      {
        n: [
          "\u5357\u975E\u56FD\u65D7",
          "\u6807\u5FD7za"
        ],
        u: {
          u: "1f1ff-1f1e6",
          x: 17,
          y: 52
        }
      },
      {
        n: [
          "\u8D5E\u6BD4\u4E9A\u56FD\u65D7",
          "\u6807\u5FD7zm"
        ],
        u: {
          u: "1f1ff-1f1f2",
          x: 18,
          y: 52
        }
      },
      {
        n: [
          "\u6D25\u5DF4\u5E03\u97E6\u56FD\u65D7",
          "\u6807\u5FD7zw"
        ],
        u: {
          u: "1f1ff-1f1fc",
          x: 19,
          y: 52
        }
      },
      {
        n: [
          "\u82F1\u56FD\u56FD\u65D7",
          "\u82F1\u56FD\u56FD\u65D7"
        ],
        u: {
          u: "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
          x: 20,
          y: 52
        }
      },
      {
        n: [
          "\u82CF\u683C\u5170\u56FD\u65D7",
          "\u82CF\u683C\u5170\u56FD\u65D7"
        ],
        u: {
          u: "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
          x: 21,
          y: 52
        }
      },
      {
        n: [
          "\u5A01\u5C14\u58EB\u56FD\u65D7",
          "\u5A01\u5C14\u58EB\u56FD\u65D7"
        ],
        u: {
          u: "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
          x: 22,
          y: 52
        }
      }
    ],
    u: "1f6a9",
    title: "\u65D7\u5E1C",
    key: "flags"
  }
];
const search_placeholder$1 = "search emojis";
const clear_button$1 = "clear all";
const no_results$1 = "No emoji has been found!";
var textInfoEn = {
  search_placeholder: search_placeholder$1,
  clear_button: clear_button$1,
  no_results: no_results$1
};
const search_placeholder = "\u641C\u7D22\u8868\u60C5\u7B26\u53F7";
const clear_button = "\u6E05\u9664\u5168\u90E8";
const no_results = "\u6CA1\u6709\u627E\u5230\u5BF9\u5E94\u7684\u8868\u60C5!";
var textInfoZhCn = {
  search_placeholder,
  clear_button,
  no_results
};
function useStore(options) {
  const defaultOptions = {
    locals: "zh_CN",
    native: false,
    hasSearch: true,
    hasGroupIcons: true,
    hasGroupNames: true,
    hasSkinTones: true,
    stickyGroupNames: true,
    recentRecords: true,
    imgSrc: "/node_modules/vue3-twemoji-picker-final/dist/img/",
    disabledGroups: []
  };
  options = __spreadValues(__spreadValues({}, defaultOptions), options);
  const staticText = options.locals === "zh_CN" ? textInfoZhCn : textInfoEn;
  let emojiGroups = options.locals === "zh_CN" ? emojiGroupsZhCN : emojiGroupsEn;
  if (options.recentRecords) {
    const str = localStorage.getItem("recentEmojis");
    const recentEmojis = JSON.parse(str || "[]");
    emojiGroups[0].emojis = recentEmojis;
  } else {
    emojiGroups = emojiGroups.slice(1);
  }
  const state = reactive({
    emojiGroups,
    search: "",
    activeGroup: "",
    currentEmoji: DEFAULT_EMOJI,
    skinTone: "neutral",
    staticText,
    options
  });
  const updateSearch = (value) => {
    state.search = value;
    if (state.search === "") {
      if (state.emojiGroups[0].emojis.length > 0)
        state.activeGroup = state.emojiGroups[0].key;
      else
        state.activeGroup = state.emojiGroups[1].key;
    }
  };
  const updateEmoji = (value) => {
    state.currentEmoji = value;
  };
  const updateActiveGroup = (group) => {
    state.activeGroup = group;
  };
  const updateCurrentEmojiSkinTone = (skinTone) => {
    var _a;
    let result = state.currentEmoji.u;
    if (skinTone !== SKIN_TONE_NEUTRAL && Array.isArray(state.currentEmoji.v)) {
      const v_index = ((_a = state.currentEmoji.v) == null ? void 0 : _a.findIndex((v) => v.u.includes(skinTone))) || -1;
      if (v_index !== -1 && state.currentEmoji.v)
        result = state.currentEmoji.v[v_index];
    }
    state.currentEmoji.r = result;
  };
  const updateSkinTone = (tone = SKIN_TONE_NEUTRAL) => {
    state.skinTone = tone;
    updateCurrentEmojiSkinTone(tone);
  };
  const updateOptions = (options2) => {
    state.options = Object.assign(state.options, options2);
  };
  const clearRecentEmoji = () => {
    state.emojiGroups[0].emojis = [];
    localStorage.setItem("recentEmojis", JSON.stringify(state.emojiGroups[0].emojis));
    if (state.activeGroup === state.emojiGroups[0].key)
      state.activeGroup = state.emojiGroups[1].key;
  };
  const saveRecentEmoji = (emoji) => {
    if (!options.recentRecords)
      return;
    const recentEmojis = state.emojiGroups[0].emojis.filter((e) => {
      return e.r.u !== emoji.r.u;
    });
    state.emojiGroups[0].emojis = recentEmojis;
    state.emojiGroups[0].emojis.unshift(emoji);
    localStorage.setItem("recentEmojis", JSON.stringify(state.emojiGroups[0].emojis));
  };
  return {
    state: readonly(state),
    updateSearch,
    updateEmoji,
    updateActiveGroup,
    updateSkinTone,
    updateOptions,
    saveRecentEmoji,
    clearRecentEmoji
  };
}
var EmojiPicker_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1 = {
  ref: "picker",
  class: "emoji-picker"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  props: {
    options: null
  },
  emits: ["select"],
  setup(__props, { emit: emits }) {
    const props = __props;
    function onSelect(emoji) {
      emits("select", emoji);
    }
    const store = useStore((props == null ? void 0 : props.options) || {});
    provide(STORE_KEY, store);
    return (_ctx, _cache) => {
      const _component_EmojiHeader = __unplugin_components_0;
      const _component_EmojiBody = __unplugin_components_1;
      const _component_EmojiFooter = __unplugin_components_2;
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createVNode(_component_EmojiHeader),
        createVNode(_component_EmojiBody, { onSelect }),
        createVNode(_component_EmojiFooter)
      ], 512);
    };
  }
});
var EmojiPicker = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-d15cf044"]]);
var __uno = "";
EmojiPicker.name = "emoji-picker";
const install = (app) => {
  app.component(EmojiPicker.name, EmojiPicker);
};
var index = {
  install
};
export { EmojiPicker, index as default };
